/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf0862c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf0862c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"ccdf818b-57ed-43ea-9cfe-fa22c6b6db50","title":"Historique des modifications","link":"change-history.html","desc":"Janvier 2023 Ajout d'informations sur","descFull":"Janvier 2023 Ajout d'informations sur la configuration  Markvision  Enterprise (MVE) et le flux de travail pour ADFS. Mise à jour des informations sur l'accès au tableau de bord de sécurité. Ajout du chapitre dédié à l'accès aux bases de données. Août 2022 Ajout d'informations sur les éléments suivants : Inscription via le protocole de transport sécurisé (EST) tel que défini dans RFC 7030 Tableau de bord de sécurité Attribution automatique de mots clés lors de la recherche Prise en charge des e-mails via SSL/TLS Prise en charge de Windows Server 2022 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Gestion des certificats à l'aide de la CA Microsoft via les Services Web Inscription de certificats Microsoft (MSCEWS) Configuration du serveur d'autorité de certification OpenXPKI racine Gestion des configurations MVE Mars 2022 Mise à jour des informations sur les modèles d'imprimantes pris en charge. Ajout d'informations sur la création d'un certificat client. Mai 2021 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Gestion de l'autorité de certification (CA) Microsoft Configuration de MVE pour la gestion automatisée des certificats Configuration de la CA Microsoft d'entreprise avec le Network Device Enrollment Service (NDES) Ajout d'informations sur les éléments suivants : Gestion des certificats à l'aide de la CA Microsoft via les Services Web Inscription de certificats Microsoft (MSCEWS) Création d'un certificat SSL pour les serveurs CEP (service Web Stratégie d'inscription de certificats) et CES (service Web Inscription de certificats) Méthodes d'authentification pour le CEP et le CES Certificat de périphérique nommé Novembre 2020 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Bases de données prises en charge Ajout d'informations sur les éléments suivants : Gestion et déploiement des configurations Sauvegarde et restauration de la base de données Gestion des certificats à l'aide de l'autorité de certification OpenXPKI et Microsoft Ajout de prise en charge pour les éléments suivants : Gestion et déploiement de configurations dans un groupe de modèles d'imprimante Création de noms de base de données personnalisés Février 2020 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Serveurs pris en charge Bases de données prises en charge Ordre de mise à niveau MVE valide Ajout d'informations sur les éléments suivants : Instructions relatives aux meilleures pratiques Instructions relatives à la gestion des certificats automatisés Composants de sécurité avancée par défaut et leurs paramètres Autres méthodes de sécurisation des imprimantes Exemples de scénarios Juin 2019 Mise à jour des informations sur les éléments suivants : Notes de bas de page ajoutées aux modèles d'imprimante exigeant des certificats Attribution de droits dbo lors de la configuration de la base de données Chemin de mise à niveau valide lors de la mise à niveau vers la version 3.4 Fichiers nécessaires lors de la sauvegarde et de la restauration de la base de données Paramètres d'authentification du serveur LDAP L'état de validité du certificat, les dates et le fuseau horaire sont ajoutés aux paramètres de la règle de recherche Configuration des autorisations et des contrôles d'accès aux fonctions dans les paramètres de sécurité de l'imprimante Sélection d'un fichier de microcode à partir de la bibliothèque de ressources lors de la mise à jour du microcode de l'imprimante Sélection de la date de début, de l'heure de début et de pause et des jours de la semaine pour la mise à jour du microcode de l'imprimante Gestion des configurations Ajout d'informations sur les éléments suivants : Présentation des états de sécurité de l'imprimante Configuration des composants de sécurité avancée Création d'un composant de sécurité avancée à partir d'une imprimante Génération d'une version imprimable des paramètres de configuration Téléchargement d'une autorité de certification pour le parc d'imprimantes Suppression des références et des informations utilisateur Présentation des autorisations et des contrôles d'accès aux fonctions Etapes de dépannage lors de l'application des configurations avec plusieurs échecs d'applications Etapes de dépannage lorsque l'utilisateur  Admin  a oublié son mot de passe Août 2018 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Configuration de la base de données Mise à niveau vers MVE 3.3 Questions fréquemment posées Création d'une action Création d'une programmation Ajout d'informations sur les éléments suivants : Configuration d'une exécution en tant que compte d'utilisateur de domaine Exportation de journaux Etapes de dépannage lorsque MVE ne reconnaît pas les imprimantes sécurisées Juillet 2018 Mise à jour des informations sur la mise à niveau vers MVE 3.2. Avril 2018 Mise à jour des informations sur les éléments suivants : Modèles d'imprimante pris en charge Configuration de la base de données Sauvegarde et restauration des fichiers de bases de données URL d'accès à MVE Présentation des paramètres de variable Ajout d'informations sur les éléments suivants : Configuration des certificats d'imprimante Arrêt des tâches Mise à jour du microcode de l'imprimante Septembre 2017 Mise à jour des informations sur les éléments suivants : Configuration requise Communication entre MVE et les modèles d'imprimantes  Lexmark  Forms 2580, 2581, 2590 et 2591 Suppression manuelle des bases de données Microsoft SQL Server Sauvegarde et restauration des fichiers de bases de données Paramètres de sécurité requis pour les contrôles d'accès aux fonctions lors du déploiement du microcode et des fichiers de solution sur des imprimantes Prise en charge des licences lors du déploiement d'applications Alertes d'imprimante et actions qui leur sont associées Récupération automatique de l'état de l'imprimante Attribution des événements et des mots clés Juin 2017 Version initiale du document pour MVE 3.0. historique des modifications"},{"UUID":"3e61d5b9-90f0-4128-aa28-afd904a2b92e","title":"Aperçu","link":"overview-chapter.html","desc":"Comprendre  Markvision  Enterprise","descFull":"Comprendre  Markvision  Enterprise Markvision  Enterprise (MVE) est un utilitaire de gestion d'imprimantes avec interface Web, destiné aux services informatiques. Grâce à MVE, vous pouvez gérer efficacement un grand parc d'imprimantes dans un environnement d'entreprise en effectuant les opérations suivantes : Recherche, organisation et suivi d'un ensemble d'imprimantes. Vous pouvez auditer une imprimante pour collecter ces données, par exemple état, paramètres et consommables. Création de configurations et attributions de ces dernières à des imprimantes. Déploiement du microcode, des certificats d'imprimante, de l'autorité de certification (CA) et des applications sur les imprimantes. Surveillance des événements et des alertes d'imprimante. Ce document fournit des informations sur la configuration, l'utilisation et le dépannage de l'application. Ce document est destiné aux administrateurs. aperçu Markvision Enterprise Markvision Enterprise présentation"},{"UUID":"7d9434dd-c528-4f96-a9ba-9d18cf6b6cac","title":"Mise en route","link":"best-practices-topic.html","desc":"Meilleures pratiques Cette rubrique décrit","descFull":"Meilleures pratiques Cette rubrique décrit les étapes d'utilisation de MVE recommandées afin de gérer efficacement votre parc. Installez MVE dans votre environnement. Créez un serveur à l'aide de l'environnement Windows Server le plus récent. Contenu associé : Configuration requise pour le serveur Web Créez un compte d'utilisateur de domaine ne disposant pas d'un accès administrateur. Contenu associé : Configuration d'une exécution en tant qu'utilisateur Créez une base de données Microsoft SQL Server, configurez le chiffrement, puis octroyez au nouveau compte d'utilisateur l'accès aux bases de données. Contenu associé : Configuration requise pour la base de données Configuration de la base de données Installez MVE à l'aide du compte d'utilisateur de domaine et du serveur SQL avec authentification Windows. Contenu associé : Installation de MVE Configurez MVE, puis détectez et organisez votre parc. Signez le certificat du serveur. Contenu associé : Signature du certificat MVE Configuration de MVE pour gérer automatiquement les certificats Configurez les paramètres LDAP. Contenu associé : Activation de l'authentification de serveur LDAP Installation des certificats LDAP Connectez-vous au serveur de messagerie. Contenu associé : Configuration des paramètres de courrier électronique Détectez votre parc. Contenu associé : Détection des imprimantes Planifiez les audits et les mises à jour d'état. Contenu associé : Audit d'imprimantes Mise à jour de l'état de l'imprimante Configurez les paramètres de base, tels que les noms de contact, les emplacements, les identifications de propriété et les fuseaux horaires. Organisez votre parc. Utilisez des mots-clés, tels que les emplacements, pour classer les imprimantes. Contenu associé : Attribution de mots-clés aux imprimantes Création d'une recherche enregistrée Sécurisez votre parc. Sécurisez l'accès à l'imprimante à l'aide des composants de sécurité avancée par défaut. Contenu associé : Sécurisation des imprimantes à l'aide des configurations par défaut Présentation des autorisations et des contrôles d'accès aux fonctions Autres méthodes de sécurisation de vos imprimantes Créez une configuration sécurisée qui inclut des certificats. Contenu associé : Création d'une configuration Importation de fichiers vers la bibliothèque de ressources Appliquez la configuration à votre parc actuel. Contenu associé : Attribution de configurations à des imprimantes Mise en œuvre de configurations Planifiez des mises en œuvre et des contrôles de conformité. Contenu associé : Création d'une programmation Ajoutez des configurations aux profils de détection pour sécuriser les nouvelles imprimantes. Contenu associé : Création d'un profil de recherche Signez les certificats d'imprimante. Contenu associé : Signature du certificat MVE Actualisez votre microcode. Contenu associé : Mise à jour du microcode de l'imprimante Installez et configurez les applications. Contenu associé : Création d'une configuration Importation de fichiers vers la bibliothèque de ressources Surveillez votre parc. Contenu associé : Création d'une recherche enregistrée meilleures pratiques"},{"UUID":"4e0ccb9d-237f-4554-9474-38b886e07035","title":"Mise en route","link":"system-requirements-topic.html","desc":"Configuration requise MVE est installé","descFull":"Configuration requise MVE est installé en tant que serveur Web et est accessible à partir d'un navigateur Web sur n'importe quel ordinateur du réseau. MVE utilise également une base de données pour stocker des informations sur le parc d'imprimantes. La liste suivante répertorie la configuration requise pour le serveur Web, la base de données et le système de l'utilisateur : Configuration requise pour le serveur Web Configuration requise Processeur Processeur double cœur d'au moins 2 GHz utilisant la technologie Hyper-Threading (HTT) Mémoire vive Au moins 4 Go Disque dur Au moins 60 Go MVE, Lexmark Document Distributor (LDD) et l'Utilitaire de déploiement des périphériques ne peuvent pas être exécutés sur le même serveur. Serveurs pris en charge Windows Server 2022 Edition Standard Windows Server 2019 Windows Server 2016 Edition Standard Windows Server 2012 Edition Standard Windows Server 2012 R2 MVE prend en charge la virtualisation pour les serveurs pris en charge dans un environnement sur site. Configuration requise pour la base de données Bases de données prises en charge Firebird  base de données (intégrée) Microsoft SQL Server 2019 Microsoft SQL Server 2017 Microsoft SQL Server 2016 Microsoft SQL Server 2014 Microsoft SQL Server 2012 La taille minimale recommandée pour les bases de données est de 60 Go, afin d'attribuer 20 Mo pour FRAMEWORK et 4,5 Mo pour MONITOR et QUARTZ. Pour plus d'informations, reportez-vous à la section  . Configuration requise pour l'utilisateur Navigateurs Web pris en charge Microsoft Edge Mozilla Firefox (dernière version) Google Chrome  (dernière version) Apple Safari (dernière version) Résolution de l'écran Au moins 1 280 x 768 pixels configuration requise pour le serveur Web serveur Web configuration requise configuration requise pour la base de données base de données configuration requise configuration requise pour l'utilisateur système de l'utilisateur configuration requise systèmes d'exploitation pris en charge navigateurs Web pris en charge bases de données prises en charge serveurs pris en charge"},{"UUID":"ef218a1b-82af-4f59-a310-a6b9f9cca9c7","title":"Mise en route","link":"supported-languages-topic.html","desc":"Langues prises en charge Portugais","descFull":"Langues prises en charge Portugais brésilien Anglais Français Allemand Italien Chinois simplifié Espagnol langues prises en charge langues prise en charge"},{"UUID":"16b4d201-5e05-47a1-8913-d19dbd54606d","title":"Mise en route","link":"supported-printer-models-topic.html","desc":"Modèles d'imprimante pris en charge","descFull":"Modèles d'imprimante pris en charge Lexmark 6500 Lexmark B2236 2 Lexmark B2338 2 , B2442 2 , B2546 2 , B2650 2 , B2865 1 Lexmark B3440 2 , B3442 2 Lexmark C2132 Lexmark C2240 2 , C2325 2 , C2425 2 , C2535 2 Lexmark C2335 2 Lexmark C3224 2 Lexmark C3326 2 Lexmark C3426 2 Lexmark C4150 2 , C6160 2 , C9235 2 Lexmark C4342 2 , C4352 2 Lexmark C746, C748 Lexmark C792 Lexmark C925 1 , C950 Lexmark CS310, CS410, CS510 Lexmark CS317, CS417, CS517 Lexmark CS331 2 Lexmark CS421 2 , CS521 2 , CS622 2 Lexmark CS431 2 Lexmark CS531 2 , CS632 2 Lexmark CS720 2 , CS725 2 Lexmark CS727 2 , CS728 2 Lexmark CS730 2 Lexmark CS735 2 Lexmark CS820 2 , CS827 2 Lexmark CS921 2 , CS923 2 , CS927 2 Lexmark CS943 2 Lexmark CX310, CX410, CX510 Lexmark CX317, CX417, CX517 Lexmark CX331 2 Lexmark CX421 2 , CX522 2 , CX622 2 , CX625 2 Lexmark CX431 2 Lexmark CX532 2 Lexmark CX625 2 Lexmark CX635 2 Lexmark CX725 2 Lexmark CX728 2 Lexmark CX730 2 Lexmark CX735 2 Lexmark CX820 2 , CX825 2 , CX827 2 , CX860 2 Lexmark CX920 2 , CX921 2 , CX922 2 , CX923 2 , CX924 2 , CX927 2 Lexmark CX930 2 , CX931 2 Lexmark CX942 2 , CX943 2 , CX944 2 Imprimante Lexmark Forms 2580 4 , 2581 4 , 2590 4 , 2591 4 Lexmark M1140, M1145, M3150 Lexmark M1242 2 , M1246 2 , M3250 2 , M5255 2 , M5265 2 , M5270 2 Lexmark M3350 2 Lexmark M5155, M5163, M5170 Lexmark M5255 2 , M5265 2 , M5270 2 Lexmark MB2236 2 Lexmark MB2338 2 , MB2442 2 , MB2546 2 , MB2650 2 , MB2770 2 Lexmark MB3442 2 Lexmark MC2325 2 , MC2425 2 , MC2535 2 , MC2640 2 Lexmark MC3224 2 Lexmark MC3326 2 Lexmark MC3426 2 Lexmark MS310, MS312, MS315, MS410, MS415, MS510, MS610 Lexmark MS317, MS417, MS517 Lexmark MS321 2 , MS421 2 , MS521 2 , MS621 2 , MS622 2 Lexmark MS331 2 , MS431 2 Lexmark MS531 2 , MS631 2 , MS632 2 Lexmark MS617, MS817, MS818 Lexmark MS710, MS711, MS810, MS811, MS812 Lexmark MS725 2 , MS821 2 , MS822 2 , MS823 2 , MS824 2 , MS825 2 , MS826 2 Lexmark MS911 Lexmark MX310, MX410, MX510, MX511, MX610, MX611 Lexmark MX317, MX417, MX517 Lexmark MX321 2 , MX421 2 , MX521 2 , MX522 2 , MX622 2 Lexmark MX331 2 , MX431 2 Lexmark MX432 2 Lexmark MX532 2 , MX632 2 Lexmark MX617, MX717, MX718 Lexmark MX6500 Lexmark MX710, MX711, MX810, MX811, MX812 Lexmark MX721 2 , MX722 2 , MX725 2 , MX822 2 , MX824 2 , MX826 2 Lexmark MX910, MX911, MX912 Lexmark MX931 2 Lexmark T650 1 , T652 1 , T654 1 , T656 1 Lexmark X651 1 , X652 1 , X654 1 , X656 1 , X658 1 , XS651 1 , XS652 1 , XS654 1 , XS658 1 Lexmark X746, X748, X792 Lexmark X850 1 , X852 1 , X854 1 , X860 1 , X862 1 , X864 1 , XS864 1 Lexmark X925, X950, X952, X954 Lexmark XC2130, XC2132 Lexmark XC2235 2 , XC2240 2 , XC4240 2 Lexmark XC2335 2 Lexmark XC4140 2 , XC4150 2 , XC6152 2 , XC8155 2 , XC8160 2 Lexmark XC9225 2 , XC9235 2 , XC9245 2 , XC9255 2 , XC9265 2 Lexmark XC9325 2 , XC9335 2 Lexmark XC9445 2 , XC9455 2 , XC9465 2 Lexmark XM1135, XM1140, XM1145, XM3150 Lexmark XM1242 2 , XM1246 2 , XM3250 2 Lexmark XM3142 2 Lexmark XM3350 2 Lexmark XM5163, XM5170, XM5263, XM5270 Lexmark XM5365 2 , XM5370 2 Lexmark XM7155, XM7163, XM7170, XM7263, XM7270 Lexmark XM7355 2 , MX7365 2 , MX7370 2 Lexmark XM9145, XM9155, XM9165 Lexmark XM9335 2 Lexmark XC2326 Lexmark XC2326 Lexmark XC4342 2 , XC4352 2 1  Une mise à jour du certificat d'imprimante est requise. Dans cette version, les mises à jour de sécurité et de performances de la plateforme Java suppriment la prise en charge de certains algorithmes de signature de certificat, comme MD5 et SHA1. Cette modification empêche le fonctionnement de MVE avec certaines imprimantes. Pour plus d'informations, consultez la  documentation d'aide . 2  La prise en charge de SNMPv3 doit être activée sur l'imprimante. 3  Si un mot de passe de sécurité avancé est défini sur l'imprimante, MVE ne peut pas la prendre en charge. 4  MVE ne peut pas communiquer avec les modèles d'imprimante Lexmark Forms 2580, 2581, 2590 ou 2591 dont l'état est Non prêt. La communication fonctionne uniquement lorsque MVE a déjà communiqué avec l'imprimante lorsque son état était Prêt. L'état de l'imprimante peut être Non prêt s'il existe des erreurs ou des avertissements, par exemple en cas de consommables épuisés. Pour modifier l'état, résolvez l'erreur ou l'avertissement, puis appuyez sur  Prêt . modèles d'imprimante pris en charge modèles d'imprimante pris en charge"},{"UUID":"a6e53ac1-edcc-46d7-a13e-f9039f7a8c9e","title":"Mise en route","link":"setting-up-database-topic.html","desc":"Configuration de la base de","descFull":"Configuration de la base de données Vous pouvez utiliser Firebird ou Microsoft SQL Server comme base de données principale. Le tableau suivant peut vous aider à décider quelle base de données utiliser. Firebird Microsoft SQL Server Installation du serveur Doit être installé sur le même serveur que MVE. Peut être exécuté à partir de n'importe quel serveur. Communication Verrouillé sur localhost uniquement. Communique via un port statique ou une instance nommée dynamique. La communication SSL/TLS avec un serveur Microsoft SQL sécurisé est prise en charge. Performances Affiche des problèmes de performances avec les grands parcs. Affiche les meilleures performances pour les grands parcs. Taille de la base de données Les tailles par défaut des bases de données sont de 6 Mo pour FRAMEWORK et de 1 Mo pour MONITOR et QUARTZ. La table FRAMEWORK passe à une capacité de 1 Ko pour chaque enregistrement d'imprimante ajouté. Les tailles par défaut des bases de données sont de 20 Mo pour FRAMEWORK et de 4,5 Mo pour MONITOR et QUARTZ. La table FRAMEWORK passe à une capacité de 1 Ko pour chaque enregistrement d'imprimante ajouté. Configuration Configuré automatiquement pendant l'installation. Nécessite une configuration pré-installation. Si vous utilisez Firebird, le programme d'installation de MVE installe et configure Firebird sans qu'aucune autre configuration ne soit requise. Si vous utilisez Microsoft SQL Server, effectuez les opérations suivantes avant d'installer MVE : Autorisez l'application à s'exécuter automatiquement. Configurez les bibliothèques réseau de sorte qu'elles utilisent des sockets TCP/IP. Créez les bases de données suivantes : Les noms de base de données par défaut sont les suivants. Vous pouvez également fournir des noms de base de données personnalisés. FRAMEWORK MONITOR QUARTZ Si vous utilisez une instance nommée, configurez le service Microsoft SQL Server Browser pour que celui-ci démarre automatiquement. Dans le cas contraire, configurez un port statique sur les sockets TCP/IP. Créez un compte d'utilisateur disposant des droits de propriétaire de base de données (dbowner) pour les trois bases de données que MVE utilise pour se connecter à et configurer la base de données. Si l'utilisateur détient un compte Microsoft SQL Server, activez les modes d'authentification Microsoft SQL Server et Windows sur Microsoft SQL Server. La désinstallation d'une instance de MVE configurée pour l'utilisation de Microsoft SQL Server n'entraîne pas la suppression des tables et des bases de données qui ont été créées. Après la désinstallation, vous devez supprimer manuellement les bases de données FRAMEWORK, MONITOR et QUARTZ. Attribuez les droits dbo à l'utilisateur de la base de données, puis définissez le schéma dbo comme le schéma par défaut. configuration de la base de données base de données configuration Base de données Firebird Microsoft SQL Server"},{"UUID":"6b806a59-57cb-460d-ac85-d27a22909a79","title":"Mise en route","link":"setting-mve-run-as-user-topic.html","desc":"Configuration d'une exécution en tant","descFull":"Configuration d'une exécution en tant qu'utilisateur Pendant l'installation, vous pouvez spécifier MVE pour qu'il s'exécute en tant que compte système local ou en tant que compte d'utilisateur de domaine. L'exécution de MVE en tant que compte d'utilisateur de domaine offre une installation plus sécurisée. Le compte d'utilisateur de domaine dispose de privilèges limités par rapport à un compte système local. Exécuter en tant que compte d'utilisateur de domaine Exécuter en tant que système local Autorisations de système local Classez tous les accès en fonction de ce qui suit : $MVE_INSTALL /tomcat/logs $MVE_INSTALL /tomcat/temp $MVE_INSTALL /tomcat/work $MVE_INSTALL /apps/library $MVE_INSTALL /apps/dm-mve/picture $MVE_INSTALL /../mve_truststore* $MVE_INSTALL /jre/lib/security/cacerts $MVE_INSTALL /apps/dm-mve/WEB-INF/ldap $MVE_INSTALL /apps/dm-mve/download Où  $MVE_INSTALL  est le répertoire d'installation. Privilèges Windows : LOGON_AS_A_SERVICE Autorisations d'administrateur Authentification de connexion à la base de données Authentification Windows avec Microsoft SQL Server Authentification SQL Authentification SQL Configuration Un utilisateur de domaine doit être configuré avant l'installation. Configuré automatiquement pendant l'installation Si vous avez configuré MVE en tant que compte d'utilisateur de domaine d'exécution, alors créez l'utilisateur sur le même domaine que le serveur MVE. exécution en tant qu'utilisateur configuration réglage de MVE comme exécution en tant qu'utilisateur"},{"UUID":"1960c244-12c6-4a2c-95e0-befc7eaf98fd","title":"Mise en route","link":"installing-markvision-topic.html","desc":"Installation de MVE Téléchargez le","descFull":"Installation de MVE Téléchargez le fichier exécutable dans un chemin ne contenant aucun espace. Exécutez le fichier en tant qu'administrateur et suivez les instructions qui s'affichent sur l'écran de l'ordinateur. Les mots de passe sont hachés et stockés en toute sécurité. Assurez-vous de bien retenir vos mots de passe, ou de les stocker dans un emplacement sécurisé car ils ne peuvent pas être déchiffrés une fois stockés. Si vous vous connectez à Microsoft SQL Server via l'authentification Windows, aucune vérification de connexion n'a lieu pendant l'installation. Vérifiez que l'utilisateur désigné pour exécuter le service Windows MVE possède un compte correspondant dans l'instance Microsoft SQL Server. L'utilisateur désigné doit disposer des droits de propriétaire de base de données (dbowner) pour les bases de données FRAMEWORK, MONITOR et QUARTZ. MVE installation installation de MVE"},{"UUID":"575c883c-c715-4ed6-8f91-bcc619a2a71e","title":"Mise en route","link":"installing-mve-silently-topic.html","desc":"Installation silencieuse de MVE Paramètres","descFull":"Installation silencieuse de MVE Paramètres de base de données pour une installation silencieuse Paramètre Description Valeur --help Affiche la liste des options valides. --version Affiche les informations sur le produit. --unattendedmodeui <unattendedmodeui> L'interface utilisateur pour le mode automatique. Par défaut :  sans Autorisé : sans minimum minimalWithDialogs --optionfile <optionfile> Le fichier des options d'installation. Par défaut : --debuglevel <debuglevel> Le niveau de verbosité des informations de débogage. Par défaut :  2 Autorisé : 0 1 2 3 4 --mode <mode> Le mode d'installation. Par défaut :  win32 Autorisé : win32 automatique --debugtrace <debugtrace> Le nom du fichier de débogage. Par défaut : --installer-language <installer-language> La sélection de la langue. Par défaut :  fr Autorisé : fr es de fr it pt_BR zh_CN --encryptionKey <encryptionKey> La clé de cryptage. Clé de cryptage : Par défaut : --prefix <prefix> Le répertoire d'installation. Par défaut :  C:\\Program Files --mveLexmark_runas <mveLexmark_runas> Les options de l'exécution en tant qu'utilisateur. Par défaut :  LOCAL_SYSTEM Autorisé : LOCAL_SYSTEM SPECIFIC_USER --serviceRunAsUsername <serviceRunAsUsername> Le nom de l'exécution en tant qu'utilisateur. Nom d'utilisateur : Par défaut : --serviceRunAsPassword <serviceRunAsPassword> Le mot de passe de l'exécution en tant qu'utilisateur. Mot de passe : Par défaut : --mveLexmark_database <mveLexmark_database> Le type de base de données. Par défaut : Autorisé : FIREBIRD SQL_SERVER --firebirdUsername <firebirdUsername> Le nom d'utilisateur de la base de données Firebird. Nom d'utilisateur : Par défaut : --firebirdPassword <firebirdPassword> Le mot de passe de la base de données Firebird. Mot de passe : Par défaut : --firebirdFWDbName <firebirdFWDbName> Le nom de la base de données Firebird pour FRAMEWORK. Noms de bases de données : Par défaut :  FRAMEWORK --firebirdMNDbName <firebirdMNDbName> Le nom de la base de données Firebird pour MONITOR. Par défaut :  MONITOR --firebirdQZDbName <firebirdQZDbName> Le nom de la base de données Firebird pour QUARTZ. Par défaut :  QUARTZ --databaseIPAddress <databaseIPAddress> L'adresse IP ou le nom de l'hôte de la base de données. Adresse IP ou nom d'hôte : Par défaut : --databasePort <databasePort> Le numéro de port de la base de données. Numéro du port : Par défaut : --instanceName <instanceName> Le nom de l'instance. Nom de l'instance : Par défaut : --instanceIdentifier <instanceIdentifier> L'instance. Par défaut :  databasePort Autorisé : databasePort instanceName --databaseUsername <databaseUsername> Le nom d'utilisateur de la base de données. Nom d'utilisateur : Par défaut : --databasePassword <databasePassword> Le mot de passe de la base de données. Mot de passe : Par défaut : --sqlServerAuthenticationMethod <sqlServerAuthenticationMethod> La méthode d'authentification Microsoft SQL Server. Par défaut :  sqlServerDbAuthentication Autorisé : sqlServerDbAuthentication sqlServerWindowsAuthentication --fWDbName <fWDbName> Le nom de la base de données pour FRAMEWORK. Noms de bases de données : Par défaut :  FRAMEWORK --mNDbName <mNDbName> Le nom de la base de données pour MONITOR. Par défaut :  MONITOR --qZDbName <qZDbName> Le nom de la base de données pour QUARTZ. Par défaut :  QUARTZ --mveAdminUsername <mveAdminUsername> Le nom d'utilisateur de l'administrateur. Nom d'utilisateur : Par défaut :  admin --mveAdminPassword <mveAdminPassword> Le mot de passe administrateur. Mot de passe : Par défaut : installation silencieuse de MVE installation silencieuse de MVE installation silencieuse MVE"},{"UUID":"b99b2b01-0555-4978-a193-99d33b8ef3dd","title":"Mise en route","link":"accessing-mve-topic.html","desc":"Accès à MVE Pour accéder","descFull":"Accès à MVE Pour accéder à MVE, utilisez les informations de connexion que vous avez créées pendant l'installation. Vous pouvez également configurer d'autres méthodes de connexion, comme LDAP, Kerberos ou d'autres comptes locaux. Pour plus d'informations, reportez-vous à la section  . Ouvrez un navigateur Web et saisissez  https:// SERVEUR_MVE /mve/ , où  SERVEUR_MVE  est le nom d'hôte ou l'adresse IP du serveur hébergeant MVE. Le cas échéant, acceptez la clause de non-responsabilité. Saisissez vos informations d'authentification. Cliquez sur  Se connecter . Après la connexion, assurez-vous de modifier le mot de passe administrateur par défaut qui a été utilisé pendant l'installation. Pour plus d'informations, reportez-vous à la section  . Si MVE est inactif pendant plus de 30 minutes, l'utilisateur est automatiquement déconnecté. MVE accès accès à MVE"},{"UUID":"0d71db26-ec18-4395-95db-9cb1f93e4959","title":"Mise en route","link":"changing-language-topic.html","desc":"Modification de la langue Ouvrez","descFull":"Modification de la langue Ouvrez un navigateur Web et saisissez  https:// SERVEUR_MVE /mve/ , où  SERVEUR_MVE  est le nom d'hôte ou l'adresse IP du serveur hébergeant MVE. Le cas échéant, acceptez la clause de non-responsabilité. Dans le coin supérieur droit de la page, sélectionnez la langue. modification de la langue langue modification"},{"UUID":"68ea9990-ad3a-4cab-9456-091ff76db43e","title":"Mise en route","link":"changing-your-password-topic.html","desc":"Modification de votre mot de","descFull":"Modification de votre mot de passe Ouvrez un navigateur Web et saisissez  https:// SERVEUR_MVE /mve/ , où  SERVEUR_MVE  est le nom d'hôte ou l'adresse IP du serveur hébergeant MVE. Le cas échéant, acceptez la clause de non-responsabilité. Saisissez vos informations d'authentification. Cliquez sur  Se connecter . Dans le coin supérieur droit de la page, cliquez sur votre nom d'utilisateur, puis sur  Modifier le mot de passe . Changez le mot de passe. mot de passe modification modification de votre mot de passe"},{"UUID":"cd026c32-bffa-4ba2-86a8-42e8e49beffc","title":"Maintenance de l'application","link":"upgrading-to-latest-version-topic.html","desc":"Mise à niveau vers MVE 4.3","descFull":"Mise à niveau vers MVE 4.3 Avant de commencer la mise à niveau, effectuez les opérations suivantes : Sauvegardez les fichiers de base de données, d'application et de propriété. Pour plus d'informations, reportez-vous à la section  . Si nécessaire, indiquez des noms de base de données personnalisés. En cas de mise à niveau depuis la version 1.x, effectuez d'abord la mise à niveau vers la version 2.0, puis vers les versions 3.3 et 4.0 respectivement avant d'effectuer la mise à niveau vers la version 4.3. Le processus de migration des stratégies est exécuté uniquement lors de la mise à niveau vers MVE 2.0. Exemple Ordre de mise à niveau valide 3.3  vers  4.0  vers  4.3 Ordre de mise à niveau non valide 1.6.x  vers  4.3 2.0  vers  4.3 Sauvegardez vos fichiers de base de données et d'application. Toute mise à niveau ou désinstallation crée un risque de perte de données irrémédiable. Vous pouvez utiliser les fichiers de sauvegarde pour restaurer l'état précédent de l'application en cas d'échec de la mise à niveau. Lorsque vous mettez à niveau MVE, la base de données est modifiée. Ne restaurez pas la sauvegarde d'une base de données créée à partir d'une version précédente. Pour plus d'informations, reportez-vous à la section  . Téléchargez le fichier exécutable vers un emplacement temporaire. Exécutez le programme d'installation en tant qu'administrateur et suivez les instructions qui s'affichent sur l'écran de l'ordinateur. Lorsque vous effectuez la mise à niveau vers MVE 2.0, les stratégies associées aux imprimantes migrent dans une configuration unique pour chaque modèle d'imprimante. Par exemple, si des stratégies de télécopie, de copie, de papier et d'impression sont associées à une imprimante X792, elles seront consolidées dans une configuration X792. Ce processus ne s'applique qu'aux stratégies associées à des imprimantes. MVE génère un fichier journal qui confirme que les stratégies ont effectivement migré dans une configuration. Pour plus d'informations, reportez-vous à la section  . Une fois la mise à niveau terminée, assurez-vous de vider le cache du navigateur avant d'accéder de nouveau à l'application. Lorsque vous mettez à niveau MVE vers la version 3.5 ou une version ultérieure, les composants de sécurité avancée sont exclus des configurations dans lesquelles ils se trouvent. Si un ou plusieurs composants de sécurité avancée sont identiques, ils sont combinés en un seul composant. Le composant de sécurité avancée créé est automatiquement ajouté à la bibliothèque de composants de sécurité avancée. mise à niveau vers la dernière version de MVE MVE mises à niveau"},{"UUID":"931f368b-5fa0-410f-9d60-8e62931c1264","title":"Maintenance de l'application","link":"backing-up-and-restoring-database-topic.html","desc":"Sauvegarde et restauration de la","descFull":"Sauvegarde et restauration de la base de données Il existe un risque de perte de données lors de l'exécution des procédures de sauvegarde et de restauration. Assurez-vous d'effectuer les étapes correctement. Sauvegarde des fichiers de base de données et d'application Nous vous recommandons de sauvegarder régulièrement votre base de données. Arrêtez les services Firebird et Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Firebird Guardian - DefaultInstance , puis cliquez sur  Arrêter . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Arrêter . Accédez au dossier dans lequel Markvision Enterprise est installé. Par exemple,  C:\\Program Files\\ Sauvegardez les fichiers d'application et de base de données. Sauvegarde des fichiers d'application Copiez les fichiers suivants dans un référentiel sûr : Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Assurez-vous que ces fichiers sont correctement stockés. Sans les clés de cryptage du fichier mve_encryption.jceks, les données stockées dans un format crypté dans la base de données et sur le système de fichiers ne peuvent pas être récupérées. Sauvegarde des fichiers de la base de données Effectuez l'une des opérations suivantes : Les fichiers suivants utilisent les noms de base de données par défaut. Ces instructions s'appliquent également aux noms de base de données personnalisés. Si vous utilisez une base de données Firebird, copiez les fichiers suivants dans un référentiel sécurisé. Sauvegardez régulièrement ces fichiers pour éviter toute perte de données. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Si vous utilisez des noms de base de données personnalisés, mettez à jour les éléments suivants : Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Si vous utilisez Microsoft SQL Server, créez une sauvegarde pour FRAMEWORK, MONITOR et QUARTZ. Pour plus d'informations, contactez votre administrateur Microsoft SQL Server. Redémarrez les services Firebird et Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Firebird Guardian - DefaultInstance , puis cliquez sur  Redémarrer . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Redémarrer . Restauration des fichiers de base de données et d'application Lorsque vous mettez à niveau MVE, la base de données peut être modifiée. Ne restaurez pas la sauvegarde d'une base de données créée à partir d'une version précédente. Arrêtez le service Markvision Enterprise. Pour plus d'informations, reportez-vous à la section   de  . Accédez au dossier dans lequel Markvision Enterprise est installé. Par exemple,  C:\\Program Files\\ Restaurez les fichiers d'application. Remplacez les fichiers suivants par les fichiers que vous avez enregistrés durant le processus de sauvegarde : Lexmark\\mve_encryption.jceks Lexmark\\mve_truststore.p12 Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\platform.properties Lexmark\\Markvision Enterprise\\apps\\library Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\encryption.properties Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml Vous pouvez restaurer une sauvegarde de base de données sur une nouvelle installation MVE uniquement si la version de ladite installation est la même. Restaurez les fichiers de base de données. Effectuez l'une des opérations suivantes : Si vous utilisez une base de données Firebird, alors remplacez les fichiers suivants que vous avez enregistrés pendant le processus de sauvegarde : Les fichiers suivants utilisent les noms de base de données par défaut. Cette instruction s'applique également aux noms de base de données personnalisés. Lexmark\\Markvision Enterprise\\firebird\\security2.fdb Si vous utilisez des noms de base de données personnalisés, les fichiers suivants sont également restaurés : Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service\\WEB-INF\\classes\\database.properties Lexmark\\Markvision Enterprise\\apps\\mve-data-service/WEB-INF\\classes\\application.yml Lexmark\\Markvision Enterprise\\firebird\\aliases.conf Lexmark\\Markvision Enterprise\\firebird\\data\\QUARTZ.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\MONITOR.FDB Lexmark\\Markvision Enterprise\\firebird\\data\\FRAMEWORK.FDB Si vous utilisez Microsoft SQL Server, contactez votre administrateur Microsoft SQL Server. Redémarrez le service Markvision Enterprise. Pour plus d'informations, reportez-vous à la section   de  . base de données sauvegarde base de données restauration sauvegarde et restauration de la base de données"},{"UUID":"47d48a22-6931-49c5-ac57-251c6de811d5","title":"Maintenance de l'application","link":"changing-installer-settings-topic.html","desc":"Mise à jour des paramètres","descFull":"Mise à jour des paramètres du programme d'installation après l'installation L'utilitaire de mot de passe Markvision Enterprise vous permet de mettre à jour les paramètres de Microsoft SQL Server qui ont été configurés lors de l'installation, mais durant laquelle la réinstallation de MVE n'a pas été effectuée. L'utilitaire vous permet également de mettre à jour les informations d'identification du compte de domaine relatives à l'exécution en tant qu'utilisateur, telles que le nom et le mot de passe d'utilisateur. Vous pouvez également utiliser cet utilitaire pour créer un autre utilisateur administrateur si vous avez oublié vos informations d'identification d'utilisateur administrateur précédentes. Accédez au dossier dans lequel Markvision Enterprise est installé. Par exemple,  C:\\Program Files\\ Lancez le fichier  mvepwdutility-windows.exe  dans le répertoire Lexmark\\Markvision Enterprise\\. Sélectionnez une langue, puis cliquez sur  OK Suivant . Suivez les instructions qui s'affichent sur l'écran de l'ordinateur. modification des paramètres du programme d'installation après l'installation paramètres du programme d'installation modification"},{"UUID":"e2f1ac81-363d-49cb-978f-ebc470a837ac","title":"Configuration de l'accès utilisateur","link":"setting-up-user-access-overview-topic.html","desc":"Aperçu MVE vous permet d'ajouter","descFull":"Aperçu MVE vous permet d'ajouter des utilisateurs internes directement au serveur MVE ou d'utiliser les comptes utilisateur enregistrés sur un serveur LDAP. Pour plus d'informations sur l'ajout d'utilisateurs externes, reportez-vous à la section  . Pour plus d'informations sur l'utilisation de comptes utilisateur, reportez-vous à la section  . Lors de l'ajout d'utilisateurs, les rôles doivent être attribués. Pour plus d'informations, reportez-vous à la section  . Lors de l'authentification, le système vérifie les informations d'identification des utilisateurs internes présents dans le serveur MVE. Si MVE ne parvient pas à authentifier l'utilisateur, il tente son authentification sur le serveur LDAP. Si le nom d'utilisateur existe dans le serveur MVE et le serveur LDAP, le mot de passe présent sur le serveur MVE est utilisé. configuration de l'aperçu de l'accès utilisateur aperçu configuration de l'accès utilisateur"},{"UUID":"2cf47798-b549-42fa-a29d-cf70b4755f48","title":"Configuration de l'accès utilisateur","link":"understanding-user-roles-topic.html","desc":"Présentation des rôles utilisateur Il","descFull":"Présentation des rôles utilisateur Il est possible d'attribuer les utilisateurs MVE à un ou plusieurs rôles. Selon le rôle, les utilisateurs peuvent effectuer les tâches suivantes : Administrateur  : accès aux tâches de tous les menus et exécution de celles-ci. Un administrateur dispose également de droits administratifs, par exemple l'ajout d'utilisateurs au système ou la configuration des paramètres du système. Seuls les utilisateurs bénéficiant d'un rôle Admin peuvent arrêter n'importe quelle tâche en cours, quel que soit le type d'utilisateur l'ayant lancée. Imprimantes gestion des profils de recherche, réglage des états d'imprimante, réalisation d'audits, gestion des catégories et des mots clés, programmation d'audits, exportation de données et détection d'imprimantes. Configurations gestion des configurations, notamment l'importation et l'exportation des fichiers de configuration, téléchargement de fichiers vers la bibliothèque de ressources, attribution de configurations aux imprimantes et leur mise en œuvre, programmation d'un contrôle de conformité et de mises en œuvre de configurations. Déployer des fichiers sur les imprimantes. Mettre à jour le micrologiciel de l'imprimante. Générer les demandes de signature de certificat d'imprimante. Télécharger les demandes de signature de certificat d'imprimante. Gestionnaire des événements gestion des actions et des événements, attribution d'événements aux imprimantes, test d'actions. Service Desk mise à jour de l'état de l'imprimante, redémarrage des imprimantes, exécution d'un contrôle de conformité, mise en œuvre de configurations sur les imprimantes. Tous les utilisateurs MVE peuvent afficher la page des informations de l'imprimante, ainsi que gérer les recherches enregistrées et les affichages. Pour plus d'informations sur l'attribution des rôles utilisateur, voir la section  . rôles utilisateurs présentation présentation des rôles utilisateur"},{"UUID":"ea422474-4781-4e33-9fe7-73c3b1414377","title":"Configuration de l'accès utilisateur","link":"managing-users-topic.html","desc":"Gestion des utilisateurs Dans le","descFull":"Gestion des utilisateurs Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Utilisateur , puis effectuez l'une des opérations suivantes : Ajout d'un utilisateur Cliquez sur  Créer . Saisissez le nom d'utilisateur, l'ID utilisateur et le mot de passe. Sélectionnez les rôles. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Créer un utilisateur . Modifier un utilisateur Sélectionnez un ID utilisateur. Configurez les paramètres. Cliquez sur  Enregistrer les modifications . Suppression d'utilisateurs Sélectionnez un ou plusieurs utilisateurs. Cliquez sur  Supprimer , puis confirmez la suppression. Un compte utilisateur est bloqué après trois tentatives de connexion échouées. Seul un utilisateur administrateur peut réactiver le compte utilisateur. Si l'utilisateur administrateur est bloqué, le système le réactive automatiquement au bout de cinq minutes. gestion des utilisateurs utilisateurs gestion utilisateurs ajout utilisateurs modification utilisateurs suppression"},{"UUID":"32621bcb-2659-4ecb-a011-158c756e5581","title":"Configuration de l'accès utilisateur","link":"enabling-ldap-server-authentication-topic.html","desc":"Activation de l'authentification de serveur LDAP","descFull":"Activation de l'authentification de serveur LDAP Le LDAP est un protocole extensible de plate-forme croisée basé sur des normes, qui s'exécute directement sur TCP/IP. Il est utilisé pour accéder à des bases de données spécialisées, appelées répertoires. Pour éviter de gérer plusieurs ensembles d'informations d'identification utilisateur, vous pouvez utiliser le serveur LDAP de l'entreprise pour authentifier les ID et mots de passe des utilisateurs. Pour cela, le serveur LDAP doit contenir des groupes d'utilisateurs correspondant aux rôles d'utilisateur requis. Pour plus d'informations, reportez-vous à la section  . Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  LDAP , puis sélectionnez  Activer l'authentification LDAP . Dans le champ  Nom d'hôte du serveur LDAP , saisissez l'adresse IP ou le nom de l'hôte du serveur LDAP sur lequel l'authentification est effectuée. Si vous souhaitez utiliser la communication chiffrée entre le serveur MVE et le serveur LDAP, utilisez le nom de domaine complet (FQDN). Indiquez le numéro de port selon le protocole de chiffrement sélectionné. Sélectionnez le protocole de chiffrement. Aucune TLS  : protocole de sécurité commun utilisant le chiffrement des données et l'authentification par certificat pour protéger la communication entre un serveur et un client. Si cette option est sélectionnée, une commande START_TLS est envoyée au serveur LDAP une fois la connexion établie. Utilisez ce paramètre si vous souhaitez une communication sécurisée sur le port 389. SSL/TLS  : protocole de sécurité utilisant la cryptographie de clé publique pour authentifier les communications entre un serveur et un client. Utilisez cette option si vous souhaitez une communication sécurisée à partir du début de la liaison LDAP. Cette option est généralement utilisée pour le port 636 ou d'autres ports LDAP sécurisés. Sélectionnez le type de liaison. Simple  : le serveur MVE produit les informations d'identification spécifiées pour le serveur LDAP afin que ce dernier utilise ses fonctionnalités de recherche. Saisissez le nom d'utilisateur de la liaison. Saisissez le mot de passe de liaison, puis confirmez-le en le saisissant une nouvelle fois. Kerberos  : pour configurer les paramètres, procédez comme suit : Saisissez le nom d'utilisateur de la liaison. Saisissez le mot de passe de liaison, puis confirmez-le en le saisissant une nouvelle fois. Cliquez sur  Sélectionner un fichier , puis localisez le fichier krb5.conf. SPNEGO  : pour configurer les paramètres, procédez comme suit : Saisissez le nom principal de service. Cliquez sur  Sélectionner un fichier , puis localisez le fichier krb5.conf. Cliquez sur  Sélectionner un fichier , puis localisez le fichier keytab Kerberos. Cette option est utilisée uniquement pour configurer le mécanisme de négociation GSSAPI simple et protégé (SPNEGO) afin de prendre en charge la fonctionnalité d'authentification unique. Dans la section  Options avancées , configurez les éléments suivants : Base de recherche  : nom unique (DN) du nœud racine. Dans la hiérarchie du serveur de communauté LDAP, ce nœud doit être l'ancêtre du nœud d'utilisateur et du nœud de groupe. Par exemple,  dc=mvetest,dc=com . Lorsque vous spécifiez le nom unique de la racine, assurez-vous que seuls  dc  et  o  font partie du nom unique de la racine. Si  ou  ou  cn  est l'ancêtre des nœuds d'utilisateur et de groupe, utilisez  ou  ou  cn  dans les bases de recherche des utilisateurs et des groupes. Base de recherche d'utilisateurs  : nœud du serveur de communauté LDAP dans lequel l'objet utilisateur existe. Ce nœud se trouve sous le nom unique de la racine, où tous les nœuds des utilisateurs sont répertoriés. Par exemple,  ou=people . Filtre de recherche d'utilisateurs  : paramètre de localisation d'un objet utilisateur dans le serveur de communauté LDAP. Par exemple,  (uid={0}) . Exemples de conditions multiples et d'expressions complexes autorisées Connexion avec Dans le champ  Filtre de recherche d'utilisateurs , saisissez Nom commun (CN={0}) Nom de connexion (sAMAccountName={0}) Nom principal de l'utilisateur (userPrincipalName={0}) Numéro de téléphone (telephoneNumber={0}) Nom de connexion ou nom commun (|(sAMAccountName={0})(CN={0})) Seuls les modèles  {0}  et  {1}  peuvent être utilisés. Si  {0}  est utilisé, MVE recherche le nom unique de l'utilisateur LDAP. Si  {1}  est utilisé, MVE recherche le nom de connexion de l'utilisateur MVE. Rechercher un objet dans la base d'utilisateurs et l'ensemble de la sous-arborescence  : le système recherche tous les nœuds sous la base de recherche des utilisateurs. Base de recherche de groupes  : nœud du serveur de communauté LDAP qui contient les groupes d'utilisateurs correspondant aux rôles MVE. Ce nœud se trouve sous le nom unique de la racine, où tous les nœuds de groupe sont répertoriés. Par exemple,  ou=group . Filtre de recherche de groupes  : paramètre de localisation permettant de rechercher un utilisateur dans un groupe correspondant à un rôle dans MVE. Le seul modèle valide est  {0} , ce qui signifie que MVE recherche le nom de connexion de l'utilisateur MVE. Attribut de rôle de groupe  : saisissez l'attribut LDAP pour le nom complet du groupe. Un attribut LDAP a une signification spécifique et définit une correspondance entre l'attribut et un nom de champ. Par exemple, l'attribut LDAP  cn  est associé au champ  Nom complet . L'attribut LDAP  commonname  est également associé au champ  Nom complet . En général, cet attribut doit conserver la valeur par défaut  cn . Rechercher un objet dans la base d'utilisateurs et l'ensemble de la sous-arborescence  : le système recherche tous les nœuds sous la base de recherche des groupes. Dans la section  Mappage des rôles des groupes LDAP vers MVE , saisissez les noms des groupes LDAP correspondant aux rôles MVE. Pour plus d'informations, reportez-vous à la section  . Vous pouvez attribuer un groupe LDAP à plusieurs rôles MVE. Vous pouvez également saisir plusieurs groupes LDAP dans un champ de rôle, en utilisant la barre verticale ( | ) pour séparer plusieurs groupes. Par exemple, pour inclure les groupes  admin  et  assets  pour le rôle  Admin , saisissez  admin|assets  dans le champ du rôle  Groupes LDAP pour l'administrateur . Si vous souhaitez utiliser uniquement le rôle  Admin  et non les autres rôles MVE, laissez les champs vides. Cliquez sur  Enregistrer les modifications . serveur LDAP activer l'authentification activation de l'authentification de serveur LDAP"},{"UUID":"93695081-26a1-4ec9-bb82-a6ae65bd8327","title":"Configuration de l'accès utilisateur","link":"installing-ldap-server-certificates-topic.html","desc":"Installation de certificats de serveur","descFull":"Installation de certificats de serveur LDAP Pour établir une communication chiffrée entre le serveur MVE et le serveur LDAP, MVE doit approuver le certificat du serveur LDAP. Dans l'architecture MVE, lorsque MVE procède à l'authentification au moyen d'un serveur LDAP, MVE est le client et le serveur LDAP est le pair. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  LDAP , puis configurez les paramètres LDAP. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Tester LDAP . Saisissez un nom et un mot de passe d'utilisateur LDAP valides, puis cliquez sur  Démarrer le test . Analysez le certificat pour confirmer sa validité, puis acceptez-le. installation de certificats de serveur LDAP certificats de serveur LDAP installation"},{"UUID":"a17538d1-dbd4-4049-9de8-f63abcfae424","title":"Configuration de l'accès utilisateur","link":"adding-root-ca-certificate-java-truststore-topic.html","desc":"Ajout d'un certificat CA racine","descFull":"Ajout d'un certificat CA racine dans le magasin d'approbation Java Certaines configurations LDAP MVE utilisent un modulateur d'équilibrage de charge ou une adresse IP virtuelle (VIP) pour rediriger les demandes LDAPS. Dans ce cas, le certificat CA racine du domaine doit être installé et approuvé dans le magasin d'approbation Java MVE. Importez le certificat CA racine, puis assurez-vous que le certificat est approuvé. Sauvegardez vos fichiers de base de données et d'application. Arrêtez le service MVE. Exécutez l'invite de commande en tant qu'administrateur, puis saisissez les commandes suivantes : « C:\\Program Files\\Lexmark\\Markvision Enterprise\\jre\\bin\\keytool.exe\" -import -trustcacerts -alias EnterpriseRootCA -file C:\\temp\\EnterpriseRootCA.cer -keystore \"C:\\Program Files\\Lexmark\\Markvision Enterprise\\jre\\lib\\security\\cacerts » Lorsque vous êtes invité à saisir le mot de passe du référentiel, saisissez  changit . Lorsque vous êtes invité à approuver le certificat, saisissez  oui . Si le processus réussit, le message suivant s'affiche :  Le certificat a été ajouté au référentiel . Si les autorisations de niveau fichier du fichier cacerts ne vous permettent pas de mettre à jour le fichier, un message d'accès refusé s'affiche. Vous pouvez mettre à jour les autorisations du fichier ou exécuter l'invite de commande en tant qu'administrateur autorisé à mettre à jour le fichier. Redémarrez le service MVE. ajout de certificats CA racine magasin d'approbation Java"},{"UUID":"cdb1f79e-6be3-44db-be29-a5ae63229b82","title":"Détection des imprimantes","link":"creating-discovery-profile-topic.html","desc":"Création d'un profil de recherche","descFull":"Création d'un profil de recherche Utilisez un profil de recherche pour rechercher des imprimantes sur votre réseau et les ajouter au système. Dans un profil de recherche, effectuez l'une des opérations suivantes pour inclure ou exclure une liste d'adresses IP ou de noms d'hôte : Ajout d'entrées une par une Importation d'entrées à l'aide d'un fichier TXT ou CSV Vous pouvez également attribuer et appliquer automatiquement une configuration à un modèle d'imprimante compatible. Une configuration doit contenir des paramètres d'imprimante, des applications, des licences, le microcode et les certificats d'autorité de certification qui peuvent être déployés sur les imprimantes. Dans le menu  Imprimantes , cliquez sur  Profils de recherche Créer . Dans la section  Général , saisissez un nom unique et une description pour le profil de recherche, puis configurez les options suivantes : Délai  : durée d'attente par le système d'une réponse provenant de l'imprimante. Nouvelles tentatives  : nombre de tentatives effectuées par le système pour communiquer avec une imprimante. Gérer automatiquement les imprimantes détectées  : l'état des imprimantes nouvellement détectées est automatiquement défini sur Géré et l'état Nouveau est omis lors de la détection. Dans la section  Adresses , effectuez l'une des procédures suivantes : Ajouter des adresses Sélectionnez  Inclure  ou  Exclure . Saisissez l'adresse IP, le nom de l'hôte, le sous-réseau ou la plage d'adresses IP. N'ajoutez qu'une seule entrée à la fois. Utilisez les formats suivants pour les adresses : 10.195.10.1  (adresse IPv4 unique) monimprimante.exemple.com  (nom d'hôte unique) 10.195.10.3-10.195.10.255  (plage d'adresses IPv4) 10.195.*.*  (caractères génériques) 10.195.10.1/22  (notation CIDR [IPv4 Classless Inter‑Domain Routing]) 2001:db8:0:0:0:0:2:1  (adresse IPv6 complète) 2001:db8::2:1  (adresse IPv6 réduite) Si des profils de recherche distincts sont créés pour les adresses IPv6 et IPv4 de la même imprimante, la dernière adresse détectée s'affiche. Par exemple, si une imprimante est détectée via IPv6, puis de nouveau via IPv4, seule l'adresse IPv4 s'affiche dans la liste des imprimantes. Cliquez sur  Ajouter . Importer les adresses Cliquez sur  Importer . Choisissez si vous souhaitez inclure ou exclure des adresses IP au cours de la détection. Accédez au fichier texte qui contient une liste d'adresses. Chaque entrée d'adresse doit figurer sur une ligne distincte. Exemple de fichier texte 10.195.10.1\nmyprinter.example.com\n10.195.10.3-10.195.10.255\n10.195.*.*\n10.195.10.1/22\n2001:db8:0:0:0:0:2:1\n2001:db8::2:1 Cliquez sur  Importer . Dans la section  SNMP , sélectionnez  Version 1 ,  Version 2c  ou  Version 3 , puis définissez les autorisations d'accès. Pour détecter des imprimantes à l'aide de SNMP version 3, créez un nom d'utilisateur et un mot de passe dans l'instance d'Embedded Web Server sur l'imprimante, puis redémarrez l'imprimante. Si aucune connexion ne peut être établie, relancez la détection des imprimantes. Pour obtenir plus d'informations, reportez-vous au  Guide de l’administrateur d'Embedded Web Server . Le cas échéant, dans la section  Saisir les informations d'identification , sélectionnez la méthode d'authentification que les imprimantes utilisent, puis saisissez les informations d'identification. Cette fonction vous permet d'établir une communication avec les imprimantes sécurisées pendant la détection. Les informations d'identification correctes doivent être fournies pour effectuer des tâches sur les imprimantes sécurisées, telles que l'audit, la mise à jour de l'état et la mise à jour du microcode. Si nécessaire, dans la section  Attribuer des configurations , associez une configuration à un modèle d'imprimante. Pour plus d'informations sur la création d'une configuration, reportez-vous à la section  . Si nécessaire, dans la section  Attribuer des mots-clés , associez un mot-clé à un modèle d'imprimante pendant la recherche. Pour plus d'informations sur l'attribution de mots-clés aux imprimantes, voir la section  . Toutes les imprimantes détectées via ce profil sont affectées avec les nouveaux mots-clés. Les nouveaux mots-clés sont ajoutés à la liste existante de mots-clés déjà affectés à une imprimante. Cliquez sur  Enregistrer le profil  ou  Enregistrer et exécuter le profil . Il est possible de programmer une détection pour qu'elle s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . création d'un profil de recherche profil de recherche création"},{"UUID":"7865fd0a-ac4e-45c2-a5f1-886e1dbd7d9a","title":"Détection des imprimantes","link":"managing-discovery-profiles-topic.html","desc":"Gestion des profils de recherche","descFull":"Gestion des profils de recherche Dans le menu Imprimantes, cliquez sur  Profils de recherche . Effectuez l'une des opérations suivantes : Modifier un profil Sélectionnez un profil, puis cliquez sur  Modifier . Configurez les paramètres. Cliquez sur  Enregistrer le profil  ou  Enregistrer et exécuter le profil . Copier un profil Sélectionnez un profil, puis cliquez sur  Copier . Configurez les paramètres. Ajoutez les adresses IP. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Enregistrer le profil  ou  Enregistrer et exécuter le profil . Supprimer un profil Sélectionnez un ou plusieurs profils. Cliquez sur  Supprimer , puis confirmez la suppression. Exécuter un profil Sélectionnez un ou plusieurs profils. Cliquez sur  Exécuter . Vérifiez l'état de la détection dans le menu Tâches. gestion de profils de recherche profils de recherche gestion modification de profils de recherche suppression de profils de recherche copie de profils de recherche exécution de profils de recherche profils de recherche modification profils de recherche suppression profils de recherche copie profils de recherche exécution"},{"UUID":"de96bbf7-5e07-4f9c-b6d7-bfe5616d4add","title":"Détection des imprimantes","link":"sample-scenario-discovering-printers-topic.html","desc":"Exemple de scénario : Détection des","descFull":"Exemple de scénario : Détection des imprimantes La société ABC est une grande entreprise de fabrication occupant un bâtiment de neuf étages. La société vient d'acheter 30 nouvelles imprimantes Lexmark, réparties sur les neuf étages. En tant que membre du personnel informatique, vous devez ajouter ces nouvelles imprimantes à MVE. Les imprimantes sont déjà connectées au réseau, mais vous ne connaissez pas toutes les adresses IP. Vous souhaitez sécuriser les nouvelles imprimantes suivantes du service Comptabilité. 10.194.55.60 10.194.56.77 10.194.55.71 10.194.63.27 10.194.63.10 Exemple de mise en œuvre Créez un profil de détection pour les imprimantes du service Comptabilité. Ajoutez les cinq adresses IP. Créez une configuration qui sécurise les imprimantes spécifiées. Incluez les configurations dans le profil de détection. Enregistrez et exécutez le profil. Créez un autre profil de détection pour les autres imprimantes. Incluez les adresses IP à l'aide d'un caractère générique. Utilisez le suivant :  10.194.*.* Excluez les adresses IP des cinq imprimantes du service Comptabilité. Enregistrez, puis exécutez le profil. détection des imprimantes imprimantes recherche"},{"UUID":"5ef10b65-072f-42e6-bf78-d308e7b6f848","title":"Gestion du tableau de bord de sécurité","link":"overview-security-dashboard-topic.html","desc":"Aperçu Le tableau de bord","descFull":"Aperçu Le tableau de bord de sécurité vous permet d'afficher l'intégrité des paramètres de sécurité du périphérique. Il s'agit d'une représentation visuelle de divers paramètres de sécurité, comme les ports, les protocoles, l'état du chiffrement du disque, les comptes administrateur du périphérique et l'état du certificat par défaut. Il offre une visibilité sur la sécurité de votre flotte, ce qui aide les administrateurs à identifier et corriger les paramètres qui ne sont pas conformes. présentation tableau de bord de sécurité"},{"UUID":"c8d1a2cf-cb46-4679-9a37-12f70501bd25","title":"Gestion du tableau de bord de sécurité","link":"accessing-dashboard-topic.html","desc":"Accès au tableau de bord","descFull":"Accès au tableau de bord de sécurité Dans le portail Web MVE, cliquez sur  Tableau de bord . Le tableau de bord de sécurité constitue la page d'accueil par défaut pour les utilisateurs administrateurs. Sélectionnez l'un des widgets suivants : Informations de sécurité du périphérique Vérification de conformité du périphérique Affichage ou masquage du tableau de bord de sécurité Dans le fichier platform.properties, modifiez le paramètre  dashboard.display  pour masquer ou afficher le tableau de bord de sécurité. Le fichier platform.properties se trouve à l'emplacement suivant :  \\ Installation Location \\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes , où  Installation Location  désigne le dossier d'installation de MVE. La valeur par défaut de ce paramètre est  True . Si vous saisissez une valeur incorrecte ou laissez le champ vide pour ce paramètre, le tableau de bord s'affiche. Pour désactiver le tableau de bord, la valeur du paramètre  dashboard.display  doit être  False . Une fois le paramètre modifié, redémarrez le service MVE. tableau de bord accès"},{"UUID":"12d0f835-aaf4-4b36-b7d4-84a1841ef864","title":"Gestion du tableau de bord de sécurité","link":"managing-device-security-information-topic.html","desc":"Gestion de la page ","descFull":"Gestion de la page  Informations de sécurité du périphérique Ce widget résume la vue de sécurité de la flotte. Cliquez sur n'importe quelle barre du graphique pour accéder à la fenêtre  Informations de sécurité du périphérique . Passez la souris sur les barres pour afficher les détails suivants : Numéro du port Nombre d'imprimantes associées Indique si les paramètres de l'imprimante sont ouverts/activés Cliquez sur  Imprimer  pour obtenir un format imprimable de la vue détaillée. La fenêtre Informations de sécurité du périphérique fournit à l'utilisateur une fonction d'exploration. Cliquer sur une barre du graphique permet à l'utilisateur d'accéder à une vue filtrée de la page affichant la liste des imprimantes. Pour plus d'informations, reportez-vous à la section  . Informations de sécurité du périphérique gestion"},{"UUID":"9515a30a-0320-4870-8a45-13bbd5eb6173","title":"Gestion du tableau de bord de sécurité","link":"managing-device-conformance-check-topic.html","desc":"Gestion de la page ","descFull":"Gestion de la page  Contrôle de conformité d'un périphérique Ce widget récapitule la vue détaillée du contrôle de conformité de la flotte. Cliquez sur n'importe quelle section du graphique en secteurs pour accéder à la fenêtre  Contrôle de conformité du périphérique . Dans le volet de gauche, appliquez le filtre Plage de dates . La plage par défaut est de 7 jours. Cliquez sur  Imprimer  pour obtenir un format imprimable de la vue détaillée. La fenêtre Contrôle de conformité du périphérique fournit à l'utilisateur une fonction d'exploration. Cliquez sur n'importe quelle section du graphique en secteurs pour accéder à une vue filtrée de la page affichant la liste des imprimantes. Pour plus d'informations, reportez-vous à la section  . Vérification de conformité du périphérique gestion"},{"UUID":"298a160e-f39d-45e4-ac1a-f13a47213111","title":"Affichage des imprimantes","link":"viewing-printer-list-topic.html","desc":"Affichage de la liste des","descFull":"Affichage de la liste des imprimantes La page Listes des imprimantes est la page d'accueil par défaut lorsque vous accédez à MVE. Le tableau suivant présente la liste des imprimantes qui sont ajoutées dans MVE. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Dans la page  Listes des imprimantes , effectuez l'une des opérations suivantes : Pour rechercher des imprimantes spécifiques, procédez de l'une des manières suivantes : Utilisez la zone de recherche pour rechercher une adresse IP, un nom d'hôte, un nom de système ou un numéro de série. Modifiez la vue Listes des imprimantes. Pour plus d'informations, reportez-vous à la section  . Si vous utilisez la zone de recherche, la recherche porte sur toutes les imprimantes du système. Les filtres sélectionnés et les recherches enregistrées sont ignorés. Si vous exécutez une recherche enregistrée, les critères indiqués dans celle-ci sont utilisés. Les filtres sélectionnés et l'adresse IP ou le nom d'hôte saisi dans le champ de recherche sont ignorés. Vous pouvez également utiliser les filtres pour affiner les résultats de la recherche actuelle. Utilisez les filtres. Exécutez une recherche enregistrée. Pour plus d'informations, reportez-vous à la section  . Pour trier les imprimantes, cliquez sur un en-tête de colonne dans le tableau de la liste des imprimantes. Les imprimantes sont triées en fonction de l'en-tête de colonne sélectionné. Pour afficher plus d'informations sur les imprimantes, redimensionnez les colonnes. Placez votre curseur sur la bordure verticale de l'en-tête de la colonne, puis faites glisser la bordure vers la gauche ou vers la droite. affichage de la liste d'imprimantes liste d'imprimantes affichage"},{"UUID":"494a861f-c3bb-446f-b7a1-58453fb4981f","title":"Affichage des imprimantes","link":"viewing-device-information-topic.html","desc":"Affichage des informations de l'imprimante","descFull":"Affichage des informations de l'imprimante Pour voir la liste complète des informations, vérifiez qu'un audit de l'imprimante est effectué. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Cliquez sur l'adresse IP de l'imprimante. Consultez les informations suivantes : Etat  : état de l'imprimante. Consommables  : détails et pourcentage restant des consommables. Identification  : informations d'identification réseau de l'imprimante. Les informations du fuseau horaire sont disponibles uniquement sur certains modèles d'imprimante. Dates  : date d'ajout de l'imprimante au système, date de détection et date de la dernière vérification. Microcode  : propriétés et niveaux de code du microcode de l'imprimante. Fonctionnalité  : fonctions de l'imprimante. Options mémoire  : taille du disque dur et espace libre sur la ou les cartes flash utilisateur. Options d'entrée  : paramètres des tiroirs disponibles. Options de sortie  : paramètres des réceptacles disponibles. Applications eSF  : informations sur les applications Embedded Solutions Framework (eSF) installées sur l'imprimante. Statistiques imprimante  : valeurs spécifiques à chacune des propriétés de l'imprimante. Détails des modifications  : informations sur les modifications apportées à l'imprimante. Ces informations s'appliquent uniquement aux imprimantes dont l'état est Géré (Modifié). Pour plus d'informations, reportez-vous à la section  . Informations d'identification de l'imprimante  : informations d'identification utilisées dans la configuration attribuée à l'imprimante. Certificat de l'imprimante  : propriétés des certificats de l'imprimante suivants : Par défaut HTTPS 802.1x IPSec Cette information est disponible uniquement sur certains modèles d'imprimante. Un état de validité  Va bientôt expirer  indique la date d'expiration, telle qu'elle est définie dans la section  Autorité de certification  sous  Configuration du système . Propriétés de la configuration  : propriétés de la configuration attribuée à l'imprimante. Alertes actives  : alertes de l'imprimante en attente d'effacement. Evénements attribués  : événements attribués à l'imprimante. affichage des informations de l'imprimante informations sur l'imprimante affichage"},{"UUID":"46606ace-a11c-4afb-b588-bdd7aef82f32","title":"Affichage des imprimantes","link":"exporting-data-topic.html","desc":"Exportation des données de l'imprimante","descFull":"Exportation des données de l'imprimante MVE vous permet d'exporter les informations de l'imprimante qui sont disponibles dans l'affichage actuel. Sur le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Imprimante Exporter des données . Les données exportées sont enregistrées dans un fichier CSV. Il est possible de programmer l’exportation des données pour qu'elle s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . exportation des données de l'imprimante données de l'imprimante exportation"},{"UUID":"218cf99e-c464-482f-a721-a511e46c2317","title":"Affichage des imprimantes","link":"managing-views-topic.html","desc":"Gestion des vues Les ","descFull":"Gestion des vues Les  Vues  vous permettent de personnaliser les informations qui s'affichent sur la page Liste des imprimantes. Dans le menu  Imprimantes , cliquez sur  Vues . Effectuez l'une des opérations suivantes : Créer une vue Cliquez sur  Créer . Saisissez un nom unique pour la vue, ainsi que sa description. Dans la section  Afficher les colonnes , dans le menu  Colonne 1 , sélectionnez la colonne des identificateurs. Dans la section  Colonnes possibles , développez une catégorie, sélectionnez les informations que vous souhaitez afficher sous forme de colonne, puis cliquez sur  > . Fonctionnalités  : indique si les fonctions sélectionnées sont prises en charge sur l'imprimante. Certificat  : affiche la date de création du certificat d'imprimante, l'état de l'inscription, la date d'expiration, la date de renouvellement, le numéro de révision, l'objet du certificat, la validité et l'état de la signature. Informations de configuration  : affiche les informations de l'imprimante relatives à la configuration, comme la conformité, le nom de la configuration et l'état. Dates  : affiche la dernière vérification, le dernier contrôle de conformité, la dernière détection et la date de l'ajout de l'imprimante au système. Evénements  : affiche les informations relatives aux événements de l'imprimante. Microcode  : affiche les informations relatives au microcode, comme sa version. Identification  : affiche des informations sur l'imprimante, comme l'adresse IP, le nom de l'hôte et le numéro de série. Options d'entrée  : affiche des informations sur les options d'entrée, comme le format du tiroir et le type de support. Options  : affiche des informations sur les options de l'imprimante, comme le disque dur et le lecteur flash. Statistiques imprimante  : affiche des informations sur l'utilisation de l'imprimante, comme le nombre de pages imprimées ou numérisées et le nombre total de travaux de télécopie envoyés. Solutions  : affiche les applications eSF installées sur l'imprimante et leurs numéros de version. Etat  : affiche l'état de l'imprimante et des consommables. Consommables  : affiche les informations liées aux consommables. Ports d'imprimante  : affiche les informations relatives aux ports. Une option  Inconnue  dans la valeur du port signifie que le port n'existe pas sur l'imprimante ou que MVE ne peut pas récupérer le port. Options de sécurité de l'imprimante  : affiche les informations TLS et de chiffrement. Cliquez sur  Créer une vue . Modifier une vue Sélectionnez une vue. Cliquez sur  Modifier , puis modifiez les paramètres. Cliquez sur  Enregistrer les modifications . Copier une vue Sélectionnez une vue. Cliquez sur  Copier , puis configurez les paramètres. Cliquez sur  Créer une vue . Supprimer des vues Sélectionnez une ou plusieurs vues. Cliquez sur  Supprimer , puis confirmez la suppression. Définir une vue par défaut Sélectionnez une vue. Cliquez sur  Définir par défaut . Les vues suivantes sont générées par le système et ne peuvent être ni modifiées, ni supprimées : Configuration Liste d'imprimantes Evénement Sécurité Service Desk Tiroir gestion des vues modification de vues copie de vues suppression de vues définition d'une vue par défaut vues gestion vues modification vues copie vues suppression"},{"UUID":"134e1a21-23d2-4f2c-99bc-960a4e406361","title":"Affichage des imprimantes","link":"changing-printer-listing-view-topic.html","desc":"Modification de la vue Liste","descFull":"Modification de la vue Liste des imprimantes Pour plus d'informations, reportez-vous à la section  . Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Cliquez sur  Vues , puis sélectionnez une vue. modification de la vue liste des imprimantes vue liste des imprimantes modification"},{"UUID":"72a815d7-cbd0-4d63-9e4c-53e9d6c256b2","title":"Affichage des imprimantes","link":"filtering-printers-using-search-bar-topic.html","desc":"Filtrage des imprimantes via la","descFull":"Filtrage des imprimantes via la barre de recherche Notez les informations suivantes lorsque vous utilisez la barre de recherche pour rechercher des imprimantes. Pour rechercher une adresse IP, assurez-vous de saisir l'adresse ou la plage IP complète. Par exemple : 10.195.10.1 10.195.10.3-10.195.10.255 10.195.*.* 2001:db8:0:0:0:0:2:1 Si la chaîne de recherche ne correspond pas à une adresse IP complète, les imprimantes sont recherchées en fonction de leur nom d'hôte, de système ou de leur numéro de série. Le trait de soulignement ( _ ) peut être utilisé comme caractère générique. filtrage des imprimantes via la barre de recherche barre de recherche filtrage des imprimantes imprimantes filtrage"},{"UUID":"69cb31cb-b161-4169-8d52-01a641b8f5ce","title":"Affichage des imprimantes","link":"managing-keywords-topic.html","desc":"Gestion des mots clés Les","descFull":"Gestion des mots clés Les mots clés permettent de créer des étiquettes personnalisées et de les attribuer aux imprimantes. Dans le menu  Imprimantes , cliquez sur  Mots clés . Effectuez l'une des opérations suivantes : Ajoutez, modifiez ou supprimez une catégorie. Les catégories regroupent les mots clés entre eux. Ajoutez, modifiez ou supprimez un mot clé. Pour plus d'informations sur l'attribution de mots clés aux imprimantes, voir la section  . gestion des mots clés mots clés gestion création de mots clés modification de mots clés suppression de mots clés mots clés création mots clés modification mots clés suppression"},{"UUID":"c5cefb65-d46b-433e-9942-df8340b33bcd","title":"Utilisation des recherches enregistrées","link":"understanding-device-life-cycle-states-topic.html","desc":"Présentation des états du cycle","descFull":"Présentation des états du cycle de vie de l'imprimante Les recherches enregistrées générées par le système affichent les états du cycle de vie suivants pour les imprimantes : Toutes les imprimantes  : toutes les imprimantes du système. Imprimantes gérées  : les états des imprimantes affichées peuvent être les suivants : Géré (Normal) Géré (Modifié) Géré (Manquant) Géré (Trouvé) Imprimantes gérées (Modifiées)  : imprimantes du système dont les propriétés suivantes ont été modifiées à la dernière vérification : Identifiant de l'imprimante Nom de l'hôte Nom du contact Emplacement du contact Taille de la mémoire Recto verso Fournitures (sauf niveaux) Options d'entrée Options de sortie Applications eSF Certificat de l'imprimante par défaut Imprimantes gérées (Trouvées)  : imprimantes qui ont été signalées comme manquantes, mais qui ont été trouvées depuis. Imprimantes gérées (Manquantes)  : imprimantes avec lesquelles le système n'a pas pu communiquer. Imprimantes gérées (Normales)  : imprimantes du système dont les propriétés sont restées les mêmes depuis la dernière vérification. Nouvelles imprimantes  : imprimantes récemment détectées et non définies automatiquement sur l'état Géré. Imprimantes retirées  : imprimantes qui ne sont plus actives dans le système. Imprimantes non gérées  : imprimantes manuellement exclues des opérations exécutées par le système. Etat d'origine Etat résultant Transition 1  Le paramètre  Gérer automatiquement les imprimantes détectées  est activé dans le profil de recherche. 2  Le paramètre  Gérer automatiquement les imprimantes détectées  est désactivé dans le profil de recherche. Démarrer Normal Détecté. 1 Démarrer Nouveau Détecté. 2 Toute Normal, Non géré ou Retiré Manuel (Manquant ne devient pas Normal). Retiré Normal Détecté. 1 Retiré Nouveau Détecté. 2 Normal, Manquant ou Trouvé Modifié Nouvelle adresse lors de la détection. Normal Modifié Les propriétés d'audit ne correspondent pas à celles présentes dans la base de données. Normal, Modifié ou Trouvé Manquant Introuvable à l'audit ou la mise à jour. Modifié Normal Les propriétés d'audit correspondent à celles présentes dans la base de données. Manquant Trouvé Détectée à l'audit ou la mise à jour. Trouvé Normal Détectée à l'audit ou la mise à jour. états du cycle de vie de l'imprimante présentation présentation des états du cycle de vie de l'imprimante"},{"UUID":"5affa94a-4d85-45ca-b61f-cb80797dbb17","title":"Utilisation des recherches enregistrées","link":"understanding-device-life-cycle-states-topic.html","desc":"Exécution d'une recherche enregistrée Une","descFull":"Exécution d'une recherche enregistrée Une recherche enregistrée est un ensemble enregistré de paramètres qui renvoie les dernières informations d'imprimante correspondant aux paramètres. Vous pouvez créer et exécuter une recherche enregistrée personnalisée ou exécuter les recherches enregistrées par défaut générées par le système. Les recherches enregistrées générées par le système affichent les états du cycle de vie des imprimantes. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Dans le menu déroulant, sélectionnez une recherche enregistrée. exécution d'une recherche enregistrée recherches enregistrées exécution"},{"UUID":"927355f8-95f8-4c52-bac3-701063c7641d","title":"Utilisation des recherches enregistrées","link":"understanding-device-life-cycle-states-topic.html","desc":"Création d'une recherche enregistrée Utilisation","descFull":"Création d'une recherche enregistrée Utilisation des filtres Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . A gauche de la page, sélectionnez les filtres. les filtres sélectionnés sont répertoriés au-dessus de l'en-tête des résultats de recherche. Cliquez sur  Enregistrer , puis saisissez un nom unique pour la recherche enregistrée ainsi que sa description. Cliquez sur  Créer une recherche enregistrée . Utilisation de la page Recherche enregistrée Dans le menu  Imprimantes , cliquez sur  Recherches enregistrées Créer . Dans la section  Général , saisissez un nom unique pour la recherche enregistrée ainsi que sa description. Dans la section  Règles et groupes de règles  du menu  Correspondance , indiquez si les résultats de recherche doivent correspondre à toutes les règles ou uniquement à certaines de ces règles. Effectuez l'une des opérations suivantes : Ajouter une règle Cliquez sur  Ajouter une règle . Spécifiez le paramètre, l'opération et la valeur de la règle de recherche. Pour plus d'informations, reportez-vous à la section  . Ajouter un groupe de règles Un groupe de règles contient une combinaison de règles. Si  N'IMPORTE quel(le) règle ou groupe de règles  est activé dans le menu  Correspondance , le système recherche les imprimantes satisfaisant toutes les règles dans le groupe de règles. Si  TOUTES les règles et TOUS les groupes de règles  est activé dans le menu  Correspondance , le système recherche les imprimantes satisfaisant au moins une règle dans le groupe de règles. Cliquez sur  Ajouter un groupe de règles . Spécifiez le paramètre, l'opération et la valeur de la règle de recherche. Pour plus d'informations, reportez-vous à la section  . Pour ajouter une autre règle, cliquez sur  Ajouter une règle . Cliquez sur  Créer une recherche enregistrée  ou  Créer et exécuter une recherche enregistrée . création d'une recherche enregistrée personnalisée recherche enregistrée personnalisée création"},{"UUID":"df8e789c-2fa7-446e-9f3b-28aa0d509803","title":"Utilisation des recherches enregistrées","link":"understanding-device-life-cycle-states-topic.html","desc":"Présentation des paramètres de règles","descFull":"Présentation des paramètres de règles de recherche Recherchez des imprimantes à l'aide d'un ou plusieurs des paramètres suivants : Paramètre Description Identification de propriété Valeur du paramètre d'identification de propriété sur l'imprimante. Date de création du certificat 1 Date à laquelle le certificat a été créé. Etat de l'inscription du certificat 1 Etat de l'inscription du certificat. Date d'expiration du certificat 1 Date à laquelle le certificat expire. Date de renouvellement du certificat 1 Date à laquelle le certificat est renouvelé. Numéro de révision du certificat 1 Numéro de révision du certificat. Etat de signature du certificat 1 Etat du certificat. Etat de validité du certificat 1 Validité du certificat. Un état  Va bientôt expirer  indique que le certificat expire dans 30 jours. Fonction de couleur L'imprimante imprime en couleur ou en noir et blanc. Configuration Nom de la configuration attribuée à l'imprimante. Conformité de la configuration Etat de conformité de l'imprimante par rapport à la configuration attribuée. Emplacement du contact Valeur du paramètre d'emplacement du contact sur l'imprimante. Nom du contact Valeur du paramètre de nom du contact sur l'imprimante. Copie L'imprimante prend en charge la fonction de copie. Date : Ajouté au système Date d'ajout de l'imprimante au système. Date : Dernier audit Date du dernier audit de l'imprimante. Date : Dernière vérification de conformité Date de la dernière vérification de conformité de la configuration de l'imprimante. Date : Dernière détection Date de la dernière détection de l'imprimante. Chiffrement du disque L'imprimante est configurée pour le chiffrement du disque dur. Effacement du disque L'imprimante est configurée pour l'effacement du disque. Recto verso L'imprimante prend en charge l'impression recto verso. Fonction eSF L'imprimante prend en charge la gestion des applications eSF. Informations eSF Informations relatives à l'application eSF installée sur l'imprimante, comme le nom, l'état et la version. Nom de l'événement Nom des événements attribués. Nom du télécopieur Valeur du paramètre de nom du télécopieur sur l'imprimante. N° de télécopieur Valeur du paramètre du numéro de télécopie sur l'imprimante. Réception de télécopie L'imprimante prend en charge la réception des télécopies. Informations sur le microcode Informations sur le microcode installé sur l'imprimante. Nom  : nom du microcode. Par exemple,  Base  ou  Noyau . Version  : version du microcode de l'imprimante. Nom d'hôte Nom de l'hôte de l'imprimante. Adresse IP Adresse IP de l'imprimante. Vous pouvez utiliser un astérisque à la place des trois derniers octets pour rechercher plusieurs entrées. Par exemple :  123.123.123.* ,  123.123.*.* ,  123.*.*.* ,  2001:db8::2:1  et  2001:db8:0:0:0:0:2:1 . Mot clé Mots clés attribués. Historique du nombre de pages Nombre total de pages de l'imprimante. Adresse MAC Adresse MAC de l'imprimante. Compteur de maintenance Valeur du compteur de maintenance de l'imprimante. Fabricant Nom du fabricant de l'imprimante. Technologie de marquage Technologie de marquage prise en charge par l'imprimante. Fonction MFP L'imprimante est un produit multifonction (MFP). Modèle Nom du modèle d'imprimante. Numéro de série modulaire Le numéro de série modulaire. Etat de l'imprimante Etat de l'imprimante. Par exemple :  Prêt ,  Bourrage papier ,  Tiroir 1 manquant . Gravité de l'état de l'imprimante Valeur de l'état de gravité le plus important de l'imprimante. Par exemple,  Inconnu ,  Prêt ,  Avertissement  ou  Erreur . Profil L'imprimante prend en charge les profils. Numériser vers un email L'imprimante prend en charge la numérisation vers un courrier électronique. Numériser vers télécopie L'imprimante prend en charge la numérisation vers une télécopie. Numériser vers le réseau L'imprimante prend en charge la numérisation vers le réseau. Etat de la communication sécurisée Etat de sécurité ou d'authentification de l'imprimante. Numéro de série Numéro de série de l'imprimante. Etat Etat actuel de l'imprimante dans la base de données. Etat des consommables Etat des consommables de l'imprimante. Gravité de l'état des consommables Valeur de l'état de gravité le plus important des consommables de l'imprimante. Par exemple,  Inconnu ,  OK ,  Avertissement  ou  Erreur . Nom du système Nom du système de l'imprimante. Fuseau horaire Fuseau horaire de la région dans laquelle l'imprimante se trouve. TLI Valeur du paramètre TLI sur l'imprimante. 1 Les paramètres relatifs aux certificats sont applicables aux certificats de périphériques suivants : Par défaut HTTPS 802.1x IPSec Utilisez les opérateurs suivants lorsque vous recherchez des imprimantes : Correspond exactement à  : un paramètre est égal à une valeur spécifiée. N'est pas  : un paramètre n'est pas égal à une valeur spécifiée. Contient  : un paramètre contient une valeur spécifiée. Ne contient pas  : un paramètre ne contient pas une valeur spécifiée. Commence par  : un paramètre commence par une valeur spécifiée. Se termine par  : un paramètre se termine par une valeur spécifiée. Date Plus ancien que  : un paramètre permettant de rechercher les jours précédant les jours indiqués. Au cours des derniers  : un paramètre permettant de rechercher dans les jours indiqués avant la date du jour. Au cours des prochains  : un paramètre permettant de rechercher dans les jours indiqués après la date du jour. Pour rechercher les imprimantes dont les paramètres possèdent des valeurs vides, utilisez  _EMPTY_OR_NULL_ . Par exemple, pour rechercher les imprimantes dont le champ  Valeur  pour  Nom du télécopieur  est vide, saisissez  _EMPTY_OR_NULL_ . paramètres des règles de recherche présentation règles de recherche paramètres règles de recherche opérateurs"},{"UUID":"bfe1c0e1-9366-440a-afa6-7f55a5291130","title":"Utilisation des recherches enregistrées","link":"understanding-device-life-cycle-states-topic.html","desc":"Gestion des recherches enregistrées Dans","descFull":"Gestion des recherches enregistrées Dans le menu Imprimantes, cliquez sur  Recherches enregistrées . Effectuez l'une des opérations suivantes : Modifier une recherche enregistrée Sélectionnez une recherche enregistrée, puis cliquez sur  Modifier . Les recherches enregistrées générées par le système ne peuvent pas être modifiées. Pour plus d'informations, reportez-vous à la section  . Configurez les paramètres. Cliquez sur  Enregistrer les modifications  ou  Enregistrer et Exécuter . Copier une recherche enregistrée Sélectionnez une recherche enregistrée, puis cliquez sur  Copier . Configurez les paramètres. Cliquez sur  Créer une recherche enregistrée  ou  Créer et exécuter une recherche enregistrée . Supprimer des recherches enregistrées Sélectionnez une ou plusieurs recherches enregistrées. Les recherches enregistrées générées par le système ne peuvent pas être supprimées. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Supprimer , puis confirmez la suppression. gestion des recherches enregistrées recherches enregistrées gestion modification de recherches enregistrées copie de recherches enregistrées suppression de recherches enregistrées recherches enregistrées modification recherches enregistrées copie recherches enregistrées suppression"},{"UUID":"8d50ebbd-7296-4078-842a-3ce797193e49","title":"Affichage des imprimantes","link":"sample-scenario-monitor-fleet-topic.html","desc":"Exemple de scénario : Surveillance des","descFull":"Exemple de scénario : Surveillance des niveaux de toner de votre parc En tant que membre du personnel informatique de la société ABC, vous devez organiser le parc d'imprimantes pour le surveiller facilement. Vous souhaitez surveiller l'utilisation du toner des imprimantes pour déterminer si les fournitures doivent être remplacées. Exemple de mise en œuvre Créez une recherche enregistrée qui récupère les imprimantes dont les fournitures présentent des erreurs ou des avertissements. Exemple de règle pour votre recherche enregistrée Paramètre :  Gravité de l'état des fournitures Opération :  N'est pas Valeur :  Fournitures OK Créez une vue qui indique l'état, la capacité et le niveau des fournitures de chaque imprimante. Exemple de colonnes à afficher dans la vue Fournitures Etat des fournitures Capacité de la cartouche noir Niveau de la cartouche noir Capacité de la cartouche cyan Niveau de la cartouche cyan Capacité de la cartouche magenta Niveau de la cartouche magenta Capacité de la cartouche jaune Niveau de la cartouche jaune Exécutez la recherche enregistrée lors de l'utilisation de la vue. Les informations affichées dans la vue Listes des imprimantes sont basées sur le dernier audit. Effectuez un audit et une mise à jour de l'état pour obtenir l'état actuel de l'imprimante. surveillance des imprimantes"},{"UUID":"b85b1286-2dae-4cc4-b90c-52e408a08c37","title":"Sécurisation des communications avec l'imprimante","link":"understanding-security-status-topic.html","desc":"Présentation des états de sécurité","descFull":"Présentation des états de sécurité de l'imprimante Pendant la détection, l'imprimante peut se trouver dans l'un des états de sécurité suivants : Non sécurisé  : MVE ne nécessite pas d'informations d'identification pour communiquer avec le périphérique. Sécurisé  : MVE a besoin d'informations d'identification sécurisées et celles-ci ont été fournies. Informations d'authentification manquantes  : MVE nécessite des informations d'identification, mais elles n'ont pas été fournies. Informations d'authentification non valides  : MVE nécessite des informations d'identification, mais celles fournies sont incorrectes. Une imprimante est dans l'état  Informations d'authentification non valides  lorsque les informations d'identification ne sont pas valides pendant la détection, l'audit, la mise à jour de l'état, le contrôle de conformité ou l'application de la configuration. L'imprimante se trouve dans un état  Non sécurisé  uniquement lorsqu'elle ne nécessite pas d'informations d'identification durant la détection. Pour modifier l'état de  Non sécurisé  à  Sécurisé , appliquez une configuration sécurisée. Pour modifier l'état d'une imprimante  Informations d'authentification manquantes  ou  Informations d'authentification non valides , saisissez les informations d'identification dans MVE manuellement ou créez un fichier de configuration à partir de l'imprimante. états de sécurité de l'imprimante présentation"},{"UUID":"200b4207-a501-4fdd-9793-20db8cfd295b","title":"Sécurisation des communications avec l'imprimante","link":"securing-printers-using-default-config-topic.html","desc":"Sécurisation des imprimantes à l'aide","descFull":"Sécurisation des imprimantes à l'aide des configurations par défaut Certains modèles d'imprimante ne nécessitent pas d'utilisateur administrateur par défaut. L'utilisateur invité dispose d'un accès ouvert et n'est pas connecté. Cette configuration permet à l'utilisateur d'accéder à toutes les autorisations et à tous les contrôles d'accès de l'imprimante. MVE gère ce risque par le biais de configurations par défaut. Après une nouvelle installation, deux composants de sécurité avancée sont automatiquement créés. Chaque composant contient les paramètres de sécurité par défaut et un compte d'administrateur local préconfiguré. Vous pouvez utiliser ces composants de sécurité lorsque vous créez une configuration, puis déployer et appliquer la configuration aux nouvelles imprimantes. Dans le menu  Configurations , cliquez sur  Tous les composants de sécurité avancée . Authentification simple basée sur un compte Ce composant de sécurité contient un  Compte local Nom d'utilisateur/Mot de passe  appelé  admin . Le compte  admin  est membre du groupe Admin, dont les autorisations incluent des contrôles d'accès aux fonctions et des autorisations de sécurisation de l'imprimante et de restriction de l'accès public. Pour plus d'informations, reportez-vous à la section  . Avant d'ajouter ce composant à une configuration, assurez-vous de définir le mot de passe  admin  et les informations d'identification de l'imprimante. Authentification simple basée sur un modèle Ce composant de sécurité contient un modèle de sécurité appelé  Protégé par mot de passe Admin  qui est configuré avec un  Mot de passe compte local . Ce modèle de sécurité est appliqué aux contrôles d'accès suivants : Mises à jour du microcode Gestion à distance Menu Sécurité  à distance Les contrôles d'accès restants sont définis sur  Pas de sécurité . Cependant, vous pouvez toujours configurer les autres menus d'administration de l'imprimante de sorte qu'ils utilisent le modèle de sécurité, pour une protection accrue. Pour plus d'informations sur les contrôles d'accès, reportez-vous à la section  . Avant d'ajouter ce composant à une configuration, assurez-vous de définir le mot de passe et les informations d'identification de l'imprimante. sécurisation des imprimantes à l'aide des configurations par défaut imprimantes sécurisation configurations par défaut"},{"UUID":"db395d77-e921-46fd-ac29-e424490b32e4","title":"Sécurisation des communications avec l'imprimante","link":"understanding-fac-permissions-topic.html","desc":"Présentation des autorisations et des","descFull":"Présentation des autorisations et des contrôles d'accès aux fonctions Les imprimantes peuvent être configurées pour restreindre l'accès public à des menus administrateur et à des fonctionnalités de gestion des périphériques. Dans les modèles d'imprimante plus récents, les autorisations nécessaires pour accéder aux fonctions de l'imprimante peuvent être sécurisées grâce à différents types de méthodes d'authentification. Dans les anciens modèles d'imprimante, un modèle de sécurité peut être appliqué à un contrôle d'accès aux fonctions (FAC). Pour communiquer avec ces imprimantes sécurisées et les gérer, MVE nécessite certaines autorisations ou FAC, selon le modèle d'imprimante. Le tableau suivant présente les fonctions de gestion de l'imprimante pouvant être gérées dans MVE et les autorisations ou FAC nécessaires. Notez que MVE nécessite l'authentification lorsque la  gestion à distance  est sécurisée. Si d'autres menus administrateur et des autorisations de gestion des périphériques ou FAC sont sécurisés, la  gestion à distance  doit également être sécurisée. Dans le cas contraire, MVE ne peut pas exécuter les fonctions. Ces autorisations et contrôles d'accès aux fonctions sont prédéfinis dans MVE en tant que composants de sécurité avancée par défaut et peuvent facilement être utilisés dans une configuration. Pour plus d'informations, reportez-vous à la section  . Si vous n'utilisez pas les composants de sécurité avancée par défaut, assurez-vous que ces autorisations et contrôles d'accès aux fonctions sont configurés manuellement dans l'imprimante. Pour plus d'informations, reportez-vous à la section  . Autorisations ou FAC Description Gestion à distance Possibilité de lire et d'écrire les paramètres à distance. Si aucune autre autorisation ou FAC répertorié dans ce tableau n'est sécurisé, la  gestion à distance  doit également être sécurisée. Mises à jour du microcode Possibilité de mettre à jour le microcode avec n'importe quelle méthode. Configuration des applications Possibilité d'installer ou de supprimer des applications de l'imprimante et d'envoyer des fichiers de paramètres d'application vers l'imprimante. Importer / Exporter tous les paramètres ou sur Importation/exportation du fichier de configuration Possibilité d'envoyer des fichiers de configuration vers l'imprimante. Menu Sécurité ou sur Menu Sécurité à distance Possibilité de gérer des méthodes de connexion et de configurer les options de sécurité de l'imprimante. Pour sécuriser les modèles d'imprimante plus récents dans MVE, désactivez l'accès public pour la  gestion à distance  et les autorisations du  menu Sécurité . Pour les anciens modèles d'imprimante, appliquez un modèle de sécurité au FAC de la  gestion à distance . contrôles d'accès aux fonctions présentation autorisations présentation"},{"UUID":"fad103b8-8ac4-4630-b0e2-89b5a4d65d61","title":"Sécurisation des communications avec l'imprimante","link":"configuring-device-security-topic.html","desc":"Configuration de la sécurité d'une","descFull":"Configuration de la sécurité d'une imprimante Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Cliquez sur l'adresse IP de l'imprimante, puis sur  Ouvrir Embedded Web Server . Cliquez sur  Paramètres  ou sur  Configuration . Selon votre modèle d'imprimante, effectuez l'une des opérations suivantes : Cliquez sur  Sécurité Méthodes de connexion , puis procédez comme suit : Pour les modèles d'imprimante plus récents Dans la section  Sécurité , créez une méthode de connexion. Cliquez sur  Gérer les groupes/les autorisations  ou  Gestion des autorisations  en regard de la méthode de connexion. Développez  Menus administrateur , puis sélectionnez  Menu Sécurité . Développez  Gestion des périphériques , puis sélectionnez les autorisations suivantes : Gestion à distance Mises à jour du microcode Configuration des applications Importer / Exporter tous les paramètres Cliquez sur  Enregistrer . Dans la secti\ton  Public , cliquez sur  Gestion des autorisations . Développez  Menus administrateur , puis décochez  Menu Sécurité . Développez  Gestion des périphériques , puis décochez  Gestion à distance . Cliquez sur  Enregistrer . Cliquez sur  Sécurité Configuration de la sécurité  ou  Modifier la configuration de sécurité , puis effectuez les opérations suivantes : Pour les anciens modèles d'imprimante Dans la section  Configuration de sécurité avancée , créez un bloc fonctionnel et un modèle de sécurité. Cliquez sur  Contrôles d'accès , puis développez  Menus administrateur . Dans le menu  Menu Sécurité à distance , sélectionnez le modèle de sécurité. Développez  Gestion , puis sélectionnez le modèle de sécurité pour les contrôles d'accès aux fonctions suivants : Configuration des applications Gestion à distance Mises à jour du microcode Importation/exportation du fichier de configuration Cliquez sur  Envoyer . configuration de la sécurité d'une imprimante sécurité de l'imprimante configuration"},{"UUID":"bf84b0b9-bc69-4044-8fab-8782fcd6454c","title":"Sécurisation des communications avec l'imprimante","link":"securing-printer-communications-on-your-fleet-topic.html","desc":"Sécurisation des communications avec les","descFull":"Sécurisation des communications avec les imprimantes de votre parc Détectez une imprimante sécurisée. Pour plus d'informations, reportez-vous à la section  . Une imprimante est sécurisée lorsque l'icône   apparaît en regard de celle-ci. Pour plus d'informations sur la sécurisation d'une imprimante, reportez-vous  au document d'aide . Pour plus d'informations sur les états de sécurité de l'imprimante, reportez-vous à la section  . Créez une configuration à partir d'une imprimante. Pour plus d'informations, reportez-vous à la section  . Attribuez la configuration à votre parc. Pour plus d'informations, reportez-vous à la section  . Mettez en œuvre la configuration. Pour plus d'informations, reportez-vous à la section  . Un symbole représentant un cadenas s'affiche en regard de l'imprimante sécurisée. sécurisation des communications avec les imprimantes de votre parc communications avec l'imprimante sécurisation"},{"UUID":"c7083772-c2e8-47ee-bb79-3be9b8556ac0","title":"Sécurisation des communications avec l'imprimante","link":"securing-printers-topic.html","desc":"Autres méthodes de sécurisation de","descFull":"Autres méthodes de sécurisation de vos imprimantes Pour plus d'informations sur la configuration des paramètres de sécurité de l'imprimante, reportez-vous au  Guide de l'administrateur d'Embedded Web Server  pour votre imprimante. Vérifiez les paramètres suivants sur vos imprimantes : Le chiffrement du disque est activé. Les ports suivants sont restreints : TCP 79 (Finger) TCP 21 (FTP) UDP 69 (TFTP) TCP 5001 (IPDS) TCP 9600 (IPDS) TCP 10000 (Telnet) La liste de chiffrement par défaut est la chaîne de chiffrement OWASP ‘B'. sécurisation des imprimantes imprimantes sécurisation"},{"UUID":"59fb0eb9-85ba-4410-aad5-99ccf8b1f3d7","title":"Gestion des imprimantes","link":"restarting-printer-topic.html","desc":"Redémarrage de l'imprimante Sur le","descFull":"Redémarrage de l'imprimante Sur le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Cliquez sur l'adresse IP de l'imprimante. Cliquez sur  Redémarrer l'imprimante . redémarrage de l'imprimante imprimante redémarrage"},{"UUID":"71a1534a-64be-46f0-8260-1fa00c8a9654","title":"Gestion des imprimantes","link":"viewing-ews-topic.html","desc":"Affichage de l'Embedded Web Server","descFull":"Affichage de l'Embedded Web Server de l'imprimante L'Embedded Web Server est un logiciel intégré à l'imprimante comprenant un panneau de commandes utilisé pour configurer l'appareil à partir de n'importe quel navigateur Web. Dans le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Cliquez sur l'adresse IP de l'imprimante. Cliquez sur  Ouvrir l'Embedded Web Server . affichage de l'Embedded Web Server de l'imprimante Embedded Web Server affichage"},{"UUID":"10f6818a-2198-47ea-9968-b41ac642ad13","title":"Gestion des imprimantes","link":"auditing-devices-topic.html","desc":"Audit d'imprimantes La fonction d'audit","descFull":"Audit d'imprimantes La fonction d'audit permet de recueillir les informations de n'importe quelle imprimante du réseau dont l'état est Géré, puis de stocker ces informations dans le système. Un audit régulier permet d'assurer que les informations du système sont à jour. Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Imprimante Audit . Il est possible de programmer un audit pour qu'il s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . audit d'imprimantes imprimantes audit"},{"UUID":"710b1d57-1ddb-42c5-b68b-3a9b9b618f6f","title":"Gestion des imprimantes","link":"updating-printer-status-topic.html","desc":"Mise à jour de l'état","descFull":"Mise à jour de l'état de l'imprimante La fonction Mettre à jour l'état permet de mettre à jour l'état de l'imprimante et les informations sur les fournitures. Pour vous assurer que l'état de l'imprimante et les informations sur les fournitures sont à jour, actualisez régulièrement l'état. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Imprimante Mettre à jour l'état . Il est possible de programmer une mise à jour d'état pour qu'elle s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . mise à jour de l'état de l'imprimante état de l'imprimante mise à jour"},{"UUID":"acf967f3-1993-40c1-b177-9ca6af0eb390","title":"Gestion des imprimantes","link":"setting-device-state-topic.html","desc":"Réglage de l'état de l'imprimante","descFull":"Réglage de l'état de l'imprimante Pour plus d'informations sur les états d'imprimante, reportez-vous à la section  . Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Imprimante , puis sélectionnez l'une des options suivantes : Définir l'état sur géré  : l'imprimante est incluse dans toutes les activités effectuées au sein du système. Définir l'état sur non géré  : l'imprimante est exclue de toutes les activités effectuées au sein du système. Définir l'état sur retiré  : l'imprimante est supprimée du réseau. Le système conserve les informations de l'imprimante mais ne s'attend pas à la détecter de nouveau sur le réseau. état de l'imprimante configuration réglage de l'état de l'imprimante"},{"UUID":"ab3eae4d-ed52-4d66-a807-0bdd99691d9a","title":"Gestion des imprimantes","link":"assigning-configurations-to-devices-topic.html","desc":"Attribution de configurations à des","descFull":"Attribution de configurations à des imprimantes Avant de commencer, assurez-vous que la configuration de l'imprimante a été créée. L'attribution d'une configuration à une imprimante permet au système d'exécuter des contrôles de conformité et des mises en œuvre. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Attribuer les configurations . Dans la section  Configuration , sélectionnez une configuration. Si le système est défini sur  Utiliser Markvision pour gérer les certificats de périphérique , sélectionnez  Approuver les périphériques sélectionnés . Cette confirmation permet à l'utilisateur de vérifier que les imprimantes sont des périphériques réels et non falsifiés. Cliquez sur  Attribuer les configurations . attribution de configurations à des imprimantes configurations attribution"},{"UUID":"8abd8bc1-9fe4-4ff5-bd13-87915addfbba","title":"Gestion des imprimantes","link":"unassigning-configurations-topic.html","desc":"Annulation de l'attribution de configurations","descFull":"Annulation de l'attribution de configurations Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Annuler l'attribution des configurations . Cliquez sur  Annuler l'attribution des configurations . annuler l'attribution de configurations configurations annulation d'attribution"},{"UUID":"e5652a43-5b25-4127-a952-cf22c500982c","title":"Gestion des imprimantes","link":"enforcing-configurations-topic.html","desc":"Mise en œuvre de configurations","descFull":"Mise en œuvre de configurations MVE exécute un contrôle de conformité pour l'imprimante. Si certains paramètres ne sont pas conformes, MVE les modifie sur l'imprimante. MVE effectue ensuite un contrôle de conformité final. Il est possible que les mises à jour nécessitant le redémarrage de l'imprimante, comme les mises à jour du micrologiciel, requièrent l'exécution d'une seconde mise en œuvre. Avant de commencer, assurez-vous qu'une configuration est attribuée à l'imprimante. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Mettre en œuvre des configurations . Si l'imprimante indique une erreur, certains paramètres peuvent ne pas être mis à jour. Pour que MVE puisse déployer le micrologiciel et les fichiers de solution sur une imprimante, le contrôle d'accès de la fonction Mises à jour du micrologiciel doit être défini sur  Pas de sécurité . Si une option de sécurité a été appliquée, le contrôle d'accès de la fonction Mises à jour du micrologiciel doit utiliser le même modèle de sécurité que le contrôle d'accès de la fonction Gestion à distance. Pour plus d'informations, reportez-vous à la section  . Il est possible de programmer une mise en œuvre pour qu'elle s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . mise en œuvre de configurations configurations mise en œuvre"},{"UUID":"935be414-566d-46c0-b8a9-dbb4c4333bd0","title":"Gestion des imprimantes","link":"checking-device-conformance-topic.html","desc":"Vérification de la conformité d'une","descFull":"Vérification de la conformité d'une imprimante avec une configuration Lors d'un contrôle de conformité, MVE vérifie les paramètres d'imprimante et s'ils correspondent à la configuration attribuée. MVE n'apporte aucune modification à l'imprimante pendant cette opération. Avant de commencer, assurez-vous qu'une configuration est attribuée à l'imprimante. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Vérifier la conformité . vous pouvez consulter les résultats dans la page d'état de la tâche. Il est possible de programmer une vérification de la conformité pour qu'elle s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . vérification de la conformité d'une imprimante avec une configuration conformité vérification imprimante conformité et perforation conformité"},{"UUID":"60f7a5d8-ff1a-4682-8752-d7a3faaf8232","title":"Gestion des imprimantes","link":"deploying-files-to-printers-topic.html","desc":"Déploiement de fichiers sur des","descFull":"Déploiement de fichiers sur des imprimantes Vous pouvez déployer les fichiers suivants sur l'imprimante : Certificats CA  : fichiers  .cer  ou  .pem  qui sont ajoutés au magasin de certificats de l'imprimante. Bundle de configuration  : fichiers  .zip  exportés à partir d'une imprimante prise en charge ou obtenus directement auprès de Lexmark. Mise à jour du micrologiciel  : fichier  .fls  flashé sur l'imprimante. Fichier générique  : n'importe quel fichier que vous souhaitez envoyer à l'imprimante. Socket brut  : envoyé sur le port 9100. L'imprimante le traite comme les autres données d'impression. FTP  : fichier envoyé par FTP. Cette méthode de déploiement n'est pas prise en charge sur les imprimantes sécurisées. Certificat de l'imprimante  : certificat signé installé sur l'imprimante en tant que certificat par défaut. Fichier de configuration Universel (UCF)  : fichier de configuration exporté à partir d'une imprimante. Service Web  : le service Web HTTPS est utilisé lorsque le modèle d'imprimante le prend en charge. Dans le cas contraire, l'imprimante utilise le service Web HTTP. FTP  : fichier envoyé par FTP. Cette méthode de déploiement n'est pas prise en charge sur les imprimantes sécurisées. Dans le menu  Imprimantes,  cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Déployer un fichier sur des imprimantes . Cliquez sur  Sélectionner un fichier , puis localisez le fichier. Sélectionnez un type de fichier, puis une méthode de déploiement. Cliquez sur  Déployer le fichier . Pour que MVE puisse déployer le micrologiciel et les fichiers de solution sur une imprimante, le contrôle d'accès de la fonction Mises à jour du micrologiciel doit être défini sur  Pas de sécurité . Si une option de sécurité a été appliquée, le contrôle d'accès de la fonction Mises à jour du micrologiciel doit utiliser le même modèle de sécurité que le contrôle d'accès de la fonction Gestion à distance. Il est possible de programmer un déploiement de fichier pour qu'il s'exécute à intervalle régulier. Pour plus d'informations, reportez-vous à la section  . déploiement de fichiers sur des imprimantes fichiers déploiement imprimantes déploiement de fichiers"},{"UUID":"ba50d35b-919f-456e-87dc-f33a3ff75818","title":"Gestion des imprimantes","link":"updating-printer-firmware-topic.html","desc":"Mise à jour du microcode","descFull":"Mise à jour du microcode de l'imprimante Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Mettre à jour le microcode sur les imprimantes . Sélectionnez un fichier de microcode dans la bibliothèque de ressources, ou cliquez sur  Choisir un fichier , puis accédez au fichier de microcode. Pour plus d'informations sur l'ajout de fichiers de microcode à la bibliothèque, reportez-vous à la section  . Le cas échéant, pour planifier la mise à jour, sélectionnez  Définir la fenêtre de mise à jour , puis sélectionnez l'heure de début, l'heure de pause et les jours de la semaine. Le microcode est envoyé aux imprimantes entre l'heure de début et l'heure de pause. La tâche est suspendue à l'heure de pause, puis reprend à l'heure de début suivante jusqu'à ce qu'elle se termine. Cliquez sur  Mettre à jour le microcode . Pour que MVE puisse mettre à jour le microcode de l'imprimante, le contrôle d'accès à la fonction Mises à jour du microcode doit être défini sur  Pas de sécurité . Si une option de sécurité a été appliquée, le contrôle d'accès à la fonction  Mises à jour du microcode  doit utiliser le même modèle de sécurité que le contrôle d'accès à la fonction  Gestion à distance . Dans ce cas, MVE doit gérer l'imprimante en toute sécurité. Pour plus d'informations, reportez-vous à la section  . mise à jour du microcode de l'imprimante microcode de l'imprimante mise à jour"},{"UUID":"e224cd8e-7fb4-429e-a8fd-36897ed33dd6","title":"Gestion des imprimantes","link":"uninstalling-applications-from-devices-topic.html","desc":"Désinstallation d'applications présentes sur les","descFull":"Désinstallation d'applications présentes sur les imprimantes MVE peut uniquement désinstaller les applications qui ont été ajoutées au système au format Créateur de package. Pour plus d'informations sur le téléchargement d'applications sur le système, voir  . Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Désinstaller des applications des imprimantes . Sélectionnez les applications. Cliquez sur  Désinstaller les applications . désinstallation d'applications présentes sur les imprimantes applications désinstallation"},{"UUID":"53af59c6-b2fa-4d88-9bbf-e22880aebaff","title":"Gestion des imprimantes","link":"assigning-events-to-device-topic.html","desc":"Attribution d'événements à des imprimantes","descFull":"Attribution d'événements à des imprimantes L'attribution d'événements à des imprimantes permet à MVE d'effectuer l'action associée dès que l'une des alertes associées est déclenchée sur l'imprimante attribuée. Pour plus d'informations sur la création d'événements, reportez-vous à  . Les événements peuvent être uniquement attribués aux imprimantes non sécurisées. Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Attribuer Evénements . Sélectionnez un ou plusieurs événements. Si l'événement a déjà été attribué à certaines des imprimantes sélectionnées, un tiret s'affiche dans la case à cocher. Si vous conservez le tiret, l'événement n'est pas modifié. Si vous cochez la case, l'événement sera attribué à toutes les imprimantes sélectionnées. Si vous décochez la case, l'événement sera désattribué des imprimantes auxquelles il était attribué. Cliquez sur  Attribuer les événements . attribution d'événements à des imprimantes événements attribution imprimantes événements"},{"UUID":"3e528568-0131-4bb8-a712-b23c690ac52e","title":"Gestion des imprimantes","link":"assigning-keyword-topic.html","desc":"Attribution de mots-clés aux imprimantes","descFull":"Attribution de mots-clés aux imprimantes L'attribution de mots-clés aux imprimantes vous permet d'organiser les imprimantes. Pour plus d'informations sur la création de mots-clés, reportez-vous à  . Dans le menu Imprimantes, cliquez sur  Liste des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Attribuer Mots clés . Si nécessaire, dans le menu Affichage, sélectionnez une catégorie. Sélectionnez un ou plusieurs mots-clés. Les mots-clés sont répertoriés en fonction d'une catégorie. Si un mot-clé a déjà été attribué à certaines des imprimantes sélectionnées, un tiret s'affiche dans la case à cocher. Si vous laissez le tiret, le mot-clé ne sera ni attribué, ni désattribué aux imprimantes sélectionnées. Si vous cochez la case, le mot-clé sera attribué à toutes les imprimantes sélectionnées. Si vous décochez la case, le mot-clé sera désattribué des imprimantes auxquelles il était attribué. Cliquez sur  Attribuer les mots clés . attribution d'un mot clé mot clé attribution"},{"UUID":"e951b2f5-6b36-4a17-991e-932268c05d9b","title":"Gestion des imprimantes","link":"entering-credentials-secured-printers-topic.html","desc":"Saisie des informations d'identification pour","descFull":"Saisie des informations d'identification pour les imprimantes sécurisées Les imprimantes sécurisées peuvent être détectées et enregistrées. Pour communiquer avec ces imprimantes, vous pouvez soit appliquer une configuration, soit saisir les informations d'identification directement dans MVE. Une imprimante est sécurisée lorsque l'icône   apparaît en regard de celle-ci. Pour saisir les informations d'identification, procédez comme suit : Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes sécurisées. Cliquez sur  Sécurité Saisir les informations d'identification . Sélectionnez la méthode d'authentification, puis saisissez les informations d'identification. Cliquez sur  Saisir les informations d'identification . Les imprimantes enregistrées qui sont sécurisées, mais qui ne disposent pas d'informations d'identification appropriées dans MVE, sont marquées comme  Informations d'authentification manquantes  sous le filtre  Communications . Une fois les informations d'identification correctes saisies, les imprimantes sont marquées comme  Sécurisées . saisie des informations d'identification pour les imprimantes sécurisées informations d'identification saisie imprimantes sécurisées authentification"},{"UUID":"73886bca-0f1b-483a-8b2f-f6b73105a38f","title":"Gestion des imprimantes","link":"configuring-printer-certificates-manually-topic.html","desc":"Configuration manuelle des certificats d'imprimante","descFull":"Configuration manuelle des certificats d'imprimante par défaut Lorsqu'il n'utilise pas la fonction de gestion automatisée des certificats, MVE peut simplifier le processus de signature du certificat d'imprimante par défaut dans un parc d'imprimantes. MVE rassemble les demandes de signature de certificat depuis le parc, puis déploie les certificats signés sur les imprimantes adéquates. En tant qu'administrateur système, effectuez les opérations suivantes : Générez les demandes de signature de certificat d'imprimante. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Sécurité Générer les demandes de signature de certificat d'imprimante . Vous pouvez sélectionner une ou plusieurs imprimantes lors de la génération des demandes de signature de certificat, mais un seul ensemble de demandes peut exister à la fois. Pour éviter d'écraser les demandes de signature de certificat existantes, vous devez télécharger les demandes de signature de certificat avant de générer un autre ensemble. Attendez la fin de la tâche, puis téléchargez les demandes de signature de certificat d'imprimante. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Cliquez sur  Sécurité Télécharger les demandes de signature de certificat d'imprimante . Utilisez une autorité de certification approuvée pour signer les demandes de signature de certificat. Enregistrez les certificats signés dans un fichier ZIP. Tous les certificats signés doivent être enregistrés dans l'emplacement racine du fichier ZIP. Dans le cas contraire, MVE ne peut pas analyser le fichier. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Configurer Déployer un fichier sur des imprimantes . Cliquez sur  Sélectionner un fichier , puis localisez le fichier ZIP. Dans le menu  Type de fichier , sélectionnez  Certificats d'imprimante . Cliquez sur  Déployer le fichier . configuration manuelle des certificats d'imprimante certificats d'imprimante configuration manuelle"},{"UUID":"a248f206-9afe-4e83-af57-395fa74d34c6","title":"Gestion des imprimantes","link":"removing-printers-topic.html","desc":"Suppression d'imprimantes Dans le menu","descFull":"Suppression d'imprimantes Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez une ou plusieurs imprimantes. Cliquez sur  Imprimante . Si nécessaire, pour supprimer le certificat d'imprimante, sélectionnez  Supprimer le(s) certificat(s) du périphérique associé . Si MVE gère les certificats du périphérique, la suppression du certificat d'imprimante entraîne la suppression du certificat par défaut de l'imprimante. L'imprimante génère ensuite un nouveau certificat auto-signé. Effectuez l'une des opérations suivantes : Pour conserver les informations de l'imprimante, cliquez sur  Retirer l'imprimante . Pour supprimer l'imprimante du système, cliquez sur  Supprimer l'imprimante . suppression d'imprimantes imprimantes suppression"},{"UUID":"c01b796b-bde3-491a-bedb-7cc1e5351719","title":"Gestion des configurations","link":"managing-configurations-overview-topic.html","desc":"Aperçu MVE utilise des configurations","descFull":"Aperçu MVE utilise des configurations pour gérer les imprimantes de votre parc. Une configuration est un ensemble de paramètres pouvant être attribués et appliqués à une imprimante ou à un groupe de modèles d'imprimante. Dans une configuration, vous pouvez modifier les paramètres d'imprimante et déployer des applications, des licences, des microcodes et des certificats d'imprimante. Vous pouvez créer une configuration composée des éléments suivants : Paramètres de base de l'imprimante Paramètres de sécurité avancés Autorisations d'impression couleur Ce paramètre est uniquement disponible dans les configurations des imprimantes couleur prises en charge. Microcode de l'imprimante Applications Certificats d'autorité de certification Fichiers de ressources A l'aide des configurations, vous pouvez effectuer les opérations suivantes pour gérer les imprimantes : Attribuez une configuration aux imprimantes. Appliquez la configuration aux imprimantes. Les paramètres spécifiés dans la configuration sont appliqués aux imprimantes. Le microcode, les applications, le certificat d'imprimante, les fichiers d'application (.fls) et les certificats CA sont installés. Vérifiez si les imprimantes sont conformes à une configuration. Si une imprimante n'est pas conforme, la configuration peut être appliquée à l'imprimante. L'application de la configuration et la vérification de la conformité peuvent être programmées pour s'exécuter à intervalle régulier. Si l'imprimante prend en charge les paramètres de configuration, mais que les valeurs ne sont pas applicables, l'imprimante s'affiche alors comme non conforme. gestion des configurations aperçu gestion des configurations configurations gestion"},{"UUID":"72e957f4-bac1-4c05-90d8-415fff371fb9","title":"Gestion des configurations","link":"creating-configuration-topic.html","desc":"Création d'une configuration Une configuration","descFull":"Création d'une configuration Une configuration est un ensemble de paramètres pouvant être attribués et appliqués à une imprimante ou à un groupe d'imprimantes. Dans une configuration, vous pouvez modifier les paramètres d'imprimante et déployer des applications, des licences, des microcodes et des certificats CA vers les imprimantes. Dans le menu  Configurations , cliquez sur  Toutes les configurations Créer . Saisissez un nom unique pour la configuration, ainsi que sa description. Dans la liste  Paramètres , effectuez une ou plusieurs des opérations suivantes : Dans l'onglet  Basique , sélectionnez un ou plusieurs paramètres, puis définissez-en les valeurs. Si la valeur est un paramètre de variable, entourez l'en-tête de  ${} . Par exemple,  ${Contact_Name} . Pour utiliser un fichier de paramètres de variables, sélectionnez le fichier dans le menu  Utiliser le fichier de données des paramètres de variables , ou importez le fichier. Pour plus d'informations, reportez-vous à la section  . Sélectionnez un ou plusieurs paramètres, puis définissez les valeurs. Si la valeur est un paramètre de variable, entourez l'en-tête de  ${} . Par exemple,  ${Contact_Name} . Pour utiliser un fichier de paramètres de variables, sélectionnez le fichier dans le menu  Utiliser le fichier de données des paramètres de variables , ou importez le fichier. Pour plus d'informations, reportez-vous à la section  . Si un ou plusieurs certificats sont ajoutés à cette configuration, vous pouvez sélectionner l'un des certificats dans le menu déroulant  Valeur . Sous l'onglet  Sécurité avancée , sélectionnez un composant de sécurité avancée. Pour créer un composant de sécurité avancée, reportez-vous à la section  . Vous pouvez gérer les paramètres de sécurité avancée uniquement lors de la création d'une configuration à partir d'une imprimante sélectionnée. Pour plus d'informations, reportez-vous à la section  . Dans l'onglet  Autorisations d'impression couleur , configurez les paramètres. Pour plus d'informations, reportez-vous à la section  . Ce paramètre est uniquement disponible dans les configurations des imprimantes couleur prises en charge. Sélectionnez un fichier de microcode dans l'onglet  Microcode . Si plusieurs versions du même microcode sont présentes dans une configuration, seule la version la plus récente du microcode est considérée comme conforme et est appliquée. Pour importer un fichier de microcode, reportez-vous à la section  . Sélectionnez une ou plusieurs applications à déployer dans l'onglet  Applications . Pour plus d'informations, reportez-vous à la section  . MVE ne prend pas en charge le déploiement d'applications dotées de licences d'essai. Vous pouvez déployer uniquement les applications gratuites ou celles dotées de licences de production. Dans l'onglet  Certificats , sélectionnez un ou plusieurs certificats à déployer. Pour importer un fichier de certificat, reportez-vous à la section  . Sélectionnez  Utiliser Markvision pour gérer les certificats de périphérique  afin que MVE puisse évaluer les certificats manquants, non valides, révoqués et expirés, puis remplacez-les automatiquement. Sélectionnez l'une des options suivantes : Certificat de périphérique par défaut Certificat de périphérique nommé Par défaut, un utilisateur peut ajouter 10 certificats nommés par installation MVE et 5 certificats nommés par configuration MVE. Pour plus d'informations, reportez-vous à la section  . Dans l'onglet  Fichiers de ressources , sélectionnez l'un des types de fichiers suivants à déployer : Fichier d'application (.fls) Pack de configuration (.zip) Fichier de configuration universel (.ufc) Aucune option de l'onglet Ressources n'a subi de contrôle de conformité. Il est déconseillé d'utiliser plusieurs fichiers UCF et packs de configuration pour une seule et même configuration. Cette méthode ne s'applique pas aux fichiers UCF lors de la configuration de la fonction de numérisation vers le réseau sur les imprimantes existantes. Les fichiers UCF doivent être déployés par l'action  Déployer des fichiers sur les imprimantes . Cliquez sur  Créer une configuration . La liste suivante présente la séquence de déploiement dans une configuration : Certificats d'Autorité de certification Fichiers d'application Packages de solutions Sécurité avancée Certificats de périphérique Paramètres de base UCF et pack de configuration Microcode création d'une configuration configuration création"},{"UUID":"559f0c7b-4068-4d54-be46-40eed62be0d5","title":"Gestion des configurations","link":"creating-configuration-from-printer-topic.html","desc":"Création d'une configuration à partir","descFull":"Création d'une configuration à partir d'une imprimante Les composants suivants ne sont pas inclus : Microcode de l'imprimante Applications Certificats Pour ajouter le microcode, des applications et des certificats, modifiez la configuration dans MVE. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez l'imprimante, puis cliquez sur  Configurer Créer une configuration à partir de l'imprimante . Si nécessaire, sélectionnez  Inclure les paramètres de sécurité avancée  pour créer un composant de sécurité avancée à partir de l'imprimante sélectionnée. Si l'imprimante est sécurisée, sélectionnez la méthode d'authentification, puis saisissez les informations d'identification. Saisissez un nom unique pour la configuration et sa description, puis cliquez sur  Créer la configuration . Dans le menu  Configurations , cliquez sur  Toutes les configurations . Sélectionnez la configuration, puis cliquez sur  Modifier . Si nécessaire, modifiez les paramètres. Cliquez sur  Enregistrer les modifications . création d'une configuration à partir d'une imprimante configuration création"},{"UUID":"f4762755-11b9-4dc4-857b-087277aa72c2","title":"Gestion des configurations","link":"sample-scenario-cloning-configurations-topic.html","desc":"Exemple de scénario : clonage d'une","descFull":"Exemple de scénario : clonage d'une configuration Quinze imprimantes Lexmark MX812 ont été ajoutées au système après la détection. En tant que membre du personnel informatique, vous devez appliquer les paramètres des imprimantes existantes aux nouvelles imprimantes détectées. Vous pouvez également cloner une configuration à partir d'une imprimante, puis appliquer la configuration à un groupe de modèles d'imprimante. Exemple de mise en œuvre Sélectionnez une imprimante Lexmark MX812 dans la liste des imprimantes existantes. Créez une configuration à partir de l'imprimante. Pour sécuriser les imprimantes, incluez les paramètres de sécurité avancée. Attribuez, puis appliquez la configuration aux nouvelles imprimantes détectées. clonage de configurations exemple de scénario exemple de scénario pour les configurations de clonage"},{"UUID":"83cace64-2d24-455b-bd42-fa4df1b14f66","title":"Gestion des configurations","link":"creating-advanced-security-component-topic.html","desc":"Création d'un composant de sécurité","descFull":"Création d'un composant de sécurité avancée à partir d'une imprimante Créez un composant de sécurité avancée à partir d'une imprimante pour gérer les paramètres de sécurité avancée. MVE lit tous les paramètres de cette imprimante, puis crée un composant qui les inclut. Le composant peut être associé à plusieurs configurations pour les modèles d'imprimante présentant la même structure de sécurité. Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Sélectionnez l'imprimante, puis cliquez sur  Configurer Créer un composant de sécurité avancée à partir de l'imprimante . Saisissez un nom unique pour le composant, ainsi que sa description. Si l'imprimante est sécurisée, sélectionnez la méthode d'authentification, puis saisissez les informations d'identification. Cliquez sur  Créer un composant . Lorsque vous créez et appliquez une configuration avec un composant de sécurité avancée contenant des comptes locaux, ces derniers sont ajoutés aux imprimantes. Tous les comptes locaux existants préconfigurés dans l'imprimante sont conservés. création d'un composant de sécurité avancée à partir d'une imprimante composant de sécurité avancée création"},{"UUID":"d5b8cb22-2075-4c0f-b773-ac432f8ddc62","title":"Gestion des configurations","link":"generating-printable-version-topic.html","desc":"Génération d'une version imprimable des","descFull":"Génération d'une version imprimable des paramètres de configuration Modifiez une configuration ou un composant de sécurité avancée. Cliquez sur  Version imprimable . paramètres de configuration version imprimable"},{"UUID":"f059cb76-29ea-44ff-b34b-926cf6212958","title":"Gestion des configurations","link":"understanding-dynamic-settings-topic.html","desc":"Comprendre les paramètres dynamiques Ces","descFull":"Comprendre les paramètres dynamiques Ces paramètres incluent le certificat de périphérique 802.1x, le certificat de périphérique HTTPS et le certificat de périphérique IPSec qui sont répertoriés sous l'onglet  Basique  d'une configuration. Les options de chacun de ces paramètres sont renseignées avec les certificats sélectionnés dans l'onglet  Certificat . Lorsque vous clonez, exportez ou importez une configuration, les valeurs présélectionnées de ces paramètres sont effacées. Vous devez sélectionner les valeurs manuellement. paramètres dynamiques présentation"},{"UUID":"feb383f4-7b5d-44e7-8c91-1ceb3dafe4ac","title":"Gestion des configurations","link":"understanding-variable-settings-topic.html","desc":"Présentation des paramètres de variable","descFull":"Présentation des paramètres de variable Les paramètres de variable vous permettent de gérer les paramètres qui sont uniques à chaque imprimante comme le nom d'hôte ou l'identification de propriété, sur l'ensemble de votre parc. Lorsque vous créez une configuration ou que vous la modifiez, vous pouvez l'associer à un fichier CSV de votre choix. Exemple de format CSV : \nIP_ADDRESS,Contact_Name,Address,Disp_Info\n1.2.3.4,John Doe,1600 Penn. Ave., Blue\n4.3.2.1,Jane Doe,1601 Penn. Ave., Red\n2.3.6.5,\"Joe, Jane and Douglas\",1601 Penn. Ave.,Yellow\n2.3.6.7,\"Joe, Jane and Douglas\",1600 Penn. Ave.,He is 6’7” tall Sur la ligne d'en-tête du fichier de variables, la première colonne est un jeton unique d'identification de l'imprimante. Celui-ci doit correspondre à l'une des valeurs suivantes : HOSTNAME IP_ADDRESS SYSTEM_NAME SERIAL_NUMBER Chacune des colonnes qui suivent dans la ligne d'en-tête du fichier de variables est un jeton de remplacement défini par l'utilisateur. Ce jeton doit être référencé dans la configuration au format ${HEADER}. Dans les lignes suivantes, il est remplacé par les valeurs lorsque la configuration est appliquée. Vérifiez que les jetons ne contiennent aucun espace. Lorsque vous créez ou modifiez une configuration, vous pouvez importer le fichier CSV qui contient les paramètres de variable. Pour plus d'informations, reportez-vous à la section  . paramètres de variable présentation importation CSV paramètres de variable exportation CSV paramètres de variable CSV paramètres de variable"},{"UUID":"f28f0c47-521f-495b-9315-843acf6634c7","title":"Gestion des configurations","link":"configuring-color-permissions-topic.html","desc":"Configuration des autorisations d'impression couleur","descFull":"Configuration des autorisations d'impression couleur MVE vous permet de limiter les impressions couleur pour les ordinateurs hôtes et pour certains utilisateurs. Ce paramètre est uniquement disponible dans les configurations des imprimantes couleur prises en charge. Dans le menu Configurations, cliquez sur  Toutes les configurations . Créez ou modifiez une configuration. Dans l'onglet Autorisations d'impression couleur, effectuez l'une des opérations suivantes : Configurer les autorisations d'impression couleur pour les ordinateurs hôtes Dans le menu Affichage, sélectionnez  Ordinateurs hôtes , puis  Inclure des autorisations d'impression couleur pour les ordinateurs hôtes . Cliquez sur  Ajouter , puis saisissez le nom de l'ordinateur hôte. Pour permettre à l'ordinateur hôte d'imprimer en couleur, sélectionnez  Autoriser l'impression couleur . Pour permettre aux utilisateurs qui se connectent à l'ordinateur hôte d'imprimer en couleur, sélectionnez  Remplacer l'autorisation de l'utilisateur . Cliquez sur  Enregistrer et ajouter  ou  Enregistrer . Configurer les autorisations d'impression couleur pour les utilisateurs Dans le menu Affichage, sélectionnez  Utilisateurs , puis  Inclure des autorisations d'impression couleur pour les utilisateurs . Cliquez sur  Ajouter , puis saisissez le nom de l'utilisateur. Sélectionnez  Autoriser l'impression couleur . Cliquez sur  Enregistrer et ajouter  ou  Enregistrer . configuration des autorisations d'impression couleur autorisations d'impression couleur configuration"},{"UUID":"2a169262-1f5b-41d1-bd11-a1d572a038a8","title":"Gestion des configurations","link":"creating-applications-package-topic.html","desc":"Création d'un package d'applications Connectez-vous","descFull":"Création d'un package d'applications Connectez-vous au Créateur de package à l'adresse  iss.lexmark.com/cdp/package-builder . Sur la page  Packages , cliquez sur  Créer un package . Sur la page  Créer un package , saisissez le nom du package. Cliquez sur  Ajouter un produit , sélectionnez un produit, puis cliquez sur  Ajouter un produit . Si nécessaire, sélectionnez  Racheter un code d'activation pour un produit sous licence  . Cliquez sur  Créer un package . Téléchargez le package en procédant de l'une des manières suivantes : Cliquez sur le nom du package, puis cliquez sur  Télécharger . Dans la colonne  Télécharger le package , cliquez sur  Télécharger . MVE ne prend pas en charge le déploiement d'applications dotées de licences d'essai. Vous pouvez déployer uniquement les applications gratuites ou celles dotées de licences de production. Pour obtenir les codes d'activation, contactez votre représentant Lexmark. Pour ajouter des applications à une configuration, importez le package d'applications dans la bibliothèque de ressources. Pour plus d'informations, reportez-vous à la section  . création d'un package d'applications package d'applications création"},{"UUID":"fc0fca6b-05f9-4fac-9077-67c668a2c294","title":"Gestion des configurations","link":"importing-exporting-configuration-file-topic.html","desc":"Importation ou exportation d'une configuration","descFull":"Importation ou exportation d'une configuration Avant de commencer l'importation d'un fichier de configuration, vérifiez qu'il est exporté à partir de la même version de MVE. Dans le menu  Configurations , cliquez sur  Toutes les configurations . Effectuez l'une des opérations suivantes : Pour importer un fichier de configuration, cliquez sur  Importer , naviguez jusqu'au fichier de configuration, puis cliquez sur  Importer . Pour exporter un fichier de configuration, sélectionnez une configuration, puis cliquez sur  Exporter . Lorsque vous exportez une configuration, les mots de passe sont exclus. Après l'importation, ajoutez-les manuellement. Les fichiers UCF, les packs de configuration et les fichiers d'application ne font pas partie d'une configuration exportée. importation ou exportation d'une configuration configuration importation configuration exportation"},{"UUID":"0bc0779f-c5b1-415f-94cd-8b1138324197","title":"Gestion des configurations","link":"importing-files-to-resource-library-topic.html","desc":"Importation de fichiers vers la","descFull":"Importation de fichiers vers la bibliothèque de ressources La bibliothèque de ressources est un ensemble de fichiers de microcode, de certificats CA et de packages d'applications importés dans MVE. Ces fichiers peuvent être associés à une ou plusieurs configurations. Dans le menu  Configurations , cliquez sur  Bibliothèque de ressources . Cliquez sur  Importer  Sélectionner un fichier , puis localisez le fichier. Seuls des fichiers de microcode/d'application (.fls), des packs d'application ou de configuration (.zip), des certificats CA (.pem) et des fichiers de configuration universelle (.ufc) peuvent être importés. Cliquez sur  Importer ressource . importation de fichiers vers la bibliothèque de ressources bibliothèque de ressources importation de fichiers vers importation de fichiers vers une bibliothèque de ressources"},{"UUID":"ce0a4462-9038-429f-8f0a-5dd4787b4655","title":"Configuration de MVE pour gérer automatiquement les certificats","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Présentation de la fonction de","descFull":"Présentation de la fonction de gestion automatisée des certificats Vous pouvez configurer MVE de sorte que les certificats d'imprimante soient gérés automatiquement, puis installés sur les imprimantes en appliquant la configuration. Le schéma suivant décrit le processus de bout en bout relatif à la fonction de gestion automatisée des certificats. Les points de terminaison de l'autorité de certification, tels que le serveur CA et l'adresse du serveur, doivent être définis dans MVE. Les serveurs CA pris en charge sont les suivants : CA OpenXPKI  : les utilisateurs peuvent utiliser l'un des protocoles suivants : Protocole SCEP (Secure Certificate Encryption Protocol) Connecteur EST EST est le moyen recommandé de se connecter au serveur OpenXPKI. Pour plus d'informations sur la configuration de CA OpenXPKI à l'aide du protocole EST, voir la section  Pour plus d'informations sur la configuration de CA OpenXPKI à l'aide du protocole SCEP, reportez-vous à la section  CA Microsoft d'entreprise  : les utilisateurs peuvent utiliser l'un des protocoles suivants Protocole SCEP (Secure Certificate Encryption Protocol) Services Web Inscription de certificats Microsoft (MSCEWS) MSCEWS est le moyen recommandé de se connecter au serveur CA Microsoft d'entreprise. Pour plus d'informations sur la configuration de CA Microsoft à l'aide du protocole MSCEWS, reportez-vous à la section  Pour plus d'informations sur la configuration de CA Microsoft à l'aide du protocole SCEP, reportez-vous à la section  La connexion entre MVE et les serveurs CA doit être validée. Pendant la validation, MVE communique avec le serveur CA pour télécharger la chaîne de certificats et la liste de révocation des certificats (CRL). Le certificat de l'agent d'inscription ou le certificat de test est également généré. Ce certificat permet au serveur CA d'approuver MVE. Pour plus d'informations sur la définition des points de terminaison et la validation, reportez-vous à la section  . Une configuration définie pour  Utiliser Markvision pour gérer les certificats de périphérique  doit être attribuée et appliquée à l'imprimante. Pour plus d'informations, reportez-vous aux rubriques suivantes : Pendant l'application, MVE vérifie la conformité de l'imprimante. Pour le  Certificat de périphérique par défaut Le certificat est validé par rapport à la chaîne de certificats téléchargée à partir du serveur CA. Si l'imprimante n'est pas conforme, une demande de signature de certificat (CSR) est émise pour l'imprimante. Pour le  Certificat de périphérique nommé Le certificat est validé par rapport à la chaîne de certificats téléchargée à partir du serveur CA. MVE crée un certificat de périphérique nommé autosigné sur le périphérique. Si l'imprimante n'est pas conforme, une CSR est demandée pour l'imprimante. MVE communique avec le serveur CA à l'aide des protocoles configurés. Le serveur CA génère le nouveau certificat, puis MVE l'envoie à l'imprimante. Si un certificat nommé existe dans l'imprimante, aucun nouveau certificat nommé n'est créé, mais une CSR est émise pour l'imprimante. fonction de gestion automatisée des certificats gestion de certificats"},{"UUID":"508aef1d-f951-4c9b-9434-31f21a5c154a","title":"Configuration de MVE pour gérer automatiquement les certificats","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Configuration de MVE pour la","descFull":"Configuration de MVE pour la gestion automatisée des certificats Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Autorité de certification Utiliser le serveur d'autorité de certification . Le bouton  Utiliser le serveur d'autorité de certification  s'affiche uniquement lors de la configuration initiale de l'autorité de certification ou lors de la suppression du certificat. Configurez les points de terminaison du serveur. Serveur CA  : serveur de l'autorité de certification (CA) qui génère les certificats d'imprimante. Vous pouvez sélectionner l'un des éléments suivants : Certificat CA d'OpenXPKI Certificat CA Microsoft d'entreprise L'utilisateur peut également configurer un serveur CA qui prend en charge le protocole  EST  (Enrollment over Secure Transport). Le serveur CA doit implémenter le protocole EST tel que défini dans RFC 7030. Tout écart par rapport à la spécification peut entraîner une configuration non valide. EST est le protocole recommandé pour se connecter au serveur CA OpenXPKI. Le serveur Microsoft CA d'entreprise ne prend pas en charge le protocole EST. Adresse du serveur CA  : l'adresse IP ou le nom de l'hôte du serveur CA. Ce champ s'applique uniquement aux protocoles SCEP et EST. Saisissez l'un des éléments suivants : Pour le serveur MSCA (avec SCEP) : <nom d'hôte ou adresse IP du serveur>/certsrv/mscep/mscep.dll Pour le serveur OpenXPKI (avec SCEP) : <nom d'hôte ou adresse IP du serveur>/scep/scep Pour EST, saisissez l'un des éléments suivants : https://172.87.95.240 https://estserver.com estserver.com Libellé de serveur CA (facultatif)  : si l'utilisateur crée un nouveau domaine, le même nom de domaine doit être indiqué dans ce champ. Adresse de serveur CEP  : ce champ est uniquement applicable au protocole MSCEWS. Saisissez l'un des éléments suivants : Authentification par nom d'utilisateur et mot de passe : https://democep.com/ADPolicyProvider_CEP_UsernamePassword/service.svc/CEP Pour l'authentification intégrée à Windows : https://democep.com/ADPolicyProvider_CEP_Kerberos/service.svc/CEP Pour l'authentification du certificat client : https://democep.com/ADPolicyProvider_CEP_Certificate/service.svc/CEP Nom d'hôte du serveur CA  : le nom de l'hôte de votre serveur CA. Par exemple, pour le protocole MSCEWS, l'utilisateur peut sélectionner  democa.lexmark.com Nom d'hôte du serveur CES  : nom d'hôte de votre serveur CES. Par exemple, pour le protocole MSCEWS, l'utilisateur peut sélectionner  democes.lexmark.com Mot de passe de challenge  : le mot de passe de challenge est requis pour confirmer l'identité de MVE sur le serveur CA. Ce mot de passe est uniquement requis pour la CA OpenXPKI. Il n'est pas pris en charge par la CA Microsoft d'entreprise. En fonction de votre serveur CA, vous devez configurer le mode d'authentification du serveur. Effectuez l'une des opérations suivantes : Si vous sélectionnez le protocole  EST , dans le menu  Mode d'authentification du serveur CA , sélectionnez l'une des options suivantes : Authentification par nom d'utilisateur et mot de passe Authentification du certificat client Si vous sélectionnez le protocole  MSCEWS , puis dans le menu  Mode d'authentification du serveur CA , sélectionnez l'une des options suivantes : Authentification par nom d'utilisateur et mot de passe Authentification du certificat client Authentification intégrée à Windows Le protocole  SCEP  prend uniquement en charge le mode d'authentification  par mot de passe de challenge . En fonction de votre serveur CA, reportez-vous à l'une des sections suivantes : Cliquez sur  Enregistrer les modifications et valider OK . L'option Annuler les modifications  ne fonctionne que si les modifications n'ont pas encore été enregistrées, ou enregistrées et validées. L'utilisateur ne peut pas récupérer les données d'une configuration non valide, car MVE ne stocke pas le dernier état valide d'une configuration. MVE ne stocke qu'une seule configuration de certificat à la fois, qui peut être valide ou non. La connexion entre MVE et les serveurs CA doit être validée. Pendant la validation, MVE communique avec le serveur CA pour télécharger la chaîne de certificats et la liste de révocation des certificats (CRL). Le certificat de l'agent d'inscription ou le certificat de test est également généré. Ce certificat permet au serveur CA d'approuver MVE. Vous pouvez sélectionner un ou plusieurs modèles CEP lorsque vous utilisez le protocole MSCEWS. Procédez comme suit : Après avoir cliqué sur  Enregistrer les modifications et valider , la fenêtre Sélection de modèle CEP s'affiche. Sélectionnez un ou plusieurs modèles disponibles. La boîte de dialogue Utiliser le serveur d'autorité de certification extrait la liste de révocation de certificats. Une boîte de dialogue confirme que la validation du certificat a réussi. Vous pouvez voir les modèles CEP sélectionnés sur la page de configuration du serveur CA. Lorsque vous appliquez cette configuration à n'importe quel périphérique, un certificat est créé en fonction du modèle sélectionné. Revenez à la page  Configuration du système , puis vérifiez le certificat CA. Vous pouvez également télécharger ou supprimer le certificat CA. configuration de MVE pour la gestion automatisée des certificats gestion automatisée des certificats configuration"},{"UUID":"f134aac1-ae42-49a6-ad46-e9d2da2dd8de","title":"Configuration de la CA d'entreprise Microsoft avec NDES","link":"setting-up-MVE-manage-certificates-automatically-group.html","desc":"Aperçu Dans le scénario de","descFull":"Aperçu Dans le scénario de déploiement suivant, toutes les autorisations sont basées sur les autorisations définies sur les modèles de certificat publiés dans le contrôleur de domaine. Les demandes de certificat envoyées à l'autorité de certification sont basées sur des modèles de certificat. Pour cette configuration, assurez-vous que vous disposez des éléments suivants : Une machine hébergeant la CA subordonnée Une machine hébergeant le service NDES Un contrôleur de domaine Utilisateurs requis Créez les utilisateurs suivants dans le contrôleur de domaine : Administrateur de service Nommé  SCEPAdmin Doit être membre des groupes  administrateur local  et  administrateur d'entreprise Doit être connecté localement lorsque l'installation du rôle NDES est déclenchée Dispose de  l'autorisation Inscrire  pour les modèles de certificat Dispose de  l'autorisation Ajouter un modèle  sur l'autorité de certification Compte de service Nommé  SCEPSvc Doit être membre du groupe  IIS_IUSRS  local Doit être un utilisateur de domaine et dispose d'autorisations de  lecture  et d' inscription  sur les modèles configurés Dispose de l'autorisation de  demande  sur l'autorité de certification Administrateur de la CA d'entreprise Nommé  CAAdmin Membre du groupe  Admin d'entreprise Doit faire partie du groupe  admin local configuration de la CA d'entreprise Microsoft avec NDES aperçu CA d'entreprise Microsoft avec NDES configuration"},{"UUID":"5009b616-fa6e-49b6-85f9-406441c472b7","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Aperçu Le serveur CA racine","descFull":"Aperçu Le serveur CA racine est le serveur d'autorité de certification principal de toute organisation et est le premier de l'infrastructure PKI. L'autorité de certification racine authentifie le serveur CA subordonné. Ce serveur est généralement maintenu en mode hors ligne pour empêcher toute intrusion et sécuriser la clé privée. Pour configurer le serveur CA racine, procédez comme suit : Vérifiez que le serveur CA racine est installé. Pour plus d'informations, reportez-vous à la section  . Configurez les paramètres du point de distribution de la certification et de l'accès aux informations d'autorité. Pour plus d'informations, reportez-vous à la section  . Configurez l'accessibilité CRL. Pour plus d'informations, reportez-vous à la section  . aperçu configuration du serveur CA racine présentation de la configuration du serveur CA racine"},{"UUID":"101f2baa-d9c3-477f-8092-8ff947b300ce","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Installation du serveur CA racine","descFull":"Installation du serveur CA racine Dans Server Manager, cliquez sur  Gérer  Ajouter des rôles et des fonctionnalités . Cliquez sur  Rôles du serveur , sélectionnez  Services de certificats Active Directory  et toutes ses fonctionnalités, puis cliquez sur  Suivant . Dans la section  Services de rôle AD CS , sélectionnez  Autorité de certification , puis cliquez sur  Suivant  Installer . Après l'installation, cliquez sur  Configurer les services de certificats Active Directory sur le serveur de destination . Dans la section  Services de rôle , sélectionnez  Autorité de certification  Suivant . Dans la section  Type de configuration , sélectionnez  Autorité de certification autonome , puis cliquez sur  Suivant . Dans la section  Type d'autorité de certification , sélectionnez  Autorité de certification racine , puis cliquez sur  Suivant . Sélectionnez  Créer une nouvelle clé privée , puis cliquez sur  Suivant . Dans le menu  Sélectionner un fournisseur de cryptographie , sélectionnez  RSA#Microsoft Software Key Storage Provider . Dans le menu  Longueur de clé , sélectionnez  4096 . Dans la liste des algorithmes de hachage, sélectionnez  SHA512 , puis cliquez sur  Suivant . Dans le champ  Nom commun de cette autorité de certification , saisissez le nom du serveur d'hébergement. Dans le champ  Suffixe du nom unique , saisissez le composant de domaine. Exemple de configuration du nom de l'autorité de certification Nom de domaine complet de la machine (FQDN - Fully Qualified Domain Name) :  test.dev.lexmark.com Nom commun (CN) :  TEST Suffixe du nom unique :  DC=DEV,DC=LEXMARK,DC=COM Cliquez sur  Suivant . Spécifiez la période de validité, puis cliquez sur  Suivant . En général, la période de validité est de 10 ans. Ne modifiez rien dans la fenêtre des emplacements de la base de données. Terminez l'installation. installation des serveurs CA racine serveurs CA racine installation"},{"UUID":"f8d015f2-7cbf-44a2-a153-4ad5c62967c0","title":"Configuration de la CA d'entreprise Microsoft avec NDES","link":"managing-certificates-using-SCEP-group.html","desc":"Aperçu Dans le scénario de","descFull":"Aperçu Dans le scénario de déploiement suivant, toutes les autorisations sont basées sur les autorisations définies sur les modèles de certificat publiés dans le contrôleur de domaine. Les demandes de certificat envoyées à l'autorité de certification sont basées sur des modèles de certificat. Pour cette configuration, assurez-vous que vous disposez des éléments suivants : Une machine hébergeant la CA subordonnée Une machine hébergeant le service NDES Un contrôleur de domaine Utilisateurs requis Créez les utilisateurs suivants dans le contrôleur de domaine : Administrateur de service Nommé  SCEPAdmin Doit être membre des groupes  administrateur local  et  administrateur d'entreprise Doit être connecté localement lorsque l'installation du rôle NDES est déclenchée Dispose de  l'autorisation Inscrire  pour les modèles de certificat Dispose de  l'autorisation Ajouter un modèle  sur l'autorité de certification Compte de service Nommé  SCEPSvc Doit être membre du groupe  IIS_IUSRS  local Doit être un utilisateur de domaine et dispose d'autorisations de  lecture  et d' inscription  sur les modèles configurés Dispose de l'autorisation de  demande  sur l'autorité de certification configuration de la CA d'entreprise Microsoft avec NDES aperçu CA d'entreprise Microsoft avec NDES configuration"},{"UUID":"ab683ec8-bf8f-4666-b219-025fdbae7c62","title":"Configuration du serveur CA subordonné","link":"managing-certificates-using-SCEP-group.html","desc":"Aperçu Le serveur CA subordonné","descFull":"Aperçu Le serveur CA subordonné est le serveur CA intermédiaire et est toujours en ligne. Il gère généralement la gestion des certificats. Pour configurer le serveur CA subordonné, procédez comme suit : Vérifiez que le serveur CA subordonné est installé. Pour plus d'informations, reportez-vous à la section  . Configurez les paramètres du point de distribution de la certification et de l'accès aux informations d'autorité. Pour plus d'informations, reportez-vous à la section  . Configurez l'accessibilité CRL. Pour plus d'informations, reportez-vous à la section  . aperçu configuration du serveur CA subordonné présentation de la configuration du serveur CA subordonné"},{"UUID":"db1d666f-55e5-41ea-9db9-d883f8bbee30","title":"Configuration du serveur CA subordonné","link":"managing-certificates-using-SCEP-group.html","desc":"Installation du serveur CA subordonné","descFull":"Installation du serveur CA subordonné A partir du serveur, connectez-vous en tant qu'utilisateur de domaine  CAAdmin . Dans Server Manager, cliquez sur  Gérer  Ajouter des rôles et des fonctionnalités . Cliquez sur  Rôles du serveur , sélectionnez  Services de certificats Active Directory  et toutes ses fonctionnalités, puis cliquez sur  Suivant . Dans la section  Services de rôle AD CS , sélectionnez  Autorité de certification  et  Inscription Web de l'autorité de certification , puis cliquez sur  Suivant . Vérifiez que toutes les fonctionnalités de  Inscription Web de l'autorité de certification  sont ajoutées. Dans la section  Services de rôle du rôle Serveur Web (IIS) , conservez les paramètres par défaut. Après l'installation, cliquez sur  Configurer les services de certificats Active Directory sur le serveur de destination . Dans la section  Services de rôle , sélectionnez  Autorité de certification  et  Inscription Web de l'autorité de certification , puis cliquez sur  Suivant . Dans la section  Type de configuration , sélectionnez  Autorité de certification d'entreprise , puis cliquez sur  Suivant . Dans la section  Type d'autorité de certification , sélectionnez  Autorité de certification subordonnée , puis cliquez sur  Suivant . Sélectionnez  Créer une nouvelle clé privée , puis cliquez sur  Suivant . Dans le menu  Sélectionner un fournisseur de cryptographie , sélectionnez  RSA#Microsoft Software Key Storage Provider . Dans le menu  Longueur de clé , sélectionnez  4096 . Dans la liste des algorithmes de hachage, sélectionnez  SHA512 , puis cliquez sur  Suivant . Dans le champ  Nom commun de cette autorité de certification , saisissez le nom du serveur d'hébergement. Dans le champ  Suffixe du nom unique , saisissez le composant de domaine. Exemple de configuration du nom de l'autorité de certification Nom de domaine complet de la machine (FQDN - Fully Qualified Domain Name) :  test.dev.lexmark.com Nom commun (CN) :  TEST Suffixe du nom unique :  DC=DEV,DC=LEXMARK,DC=COM Dans la boîte de dialogue  Demande de certificat , enregistrez le fichier de demande, puis cliquez sur  Suivant . Ne modifiez rien dans la fenêtre des emplacements de la base de données. Terminez l'installation. Signez la demande de l'autorité de certification racine, puis exportez le certificat signé au format PKCS7. A partir de l'autorité de certification subordonnée, ouvrez  Autorité de certification . Dans le panneau de gauche, cliquez avec le bouton droit de la souris sur l'autorité de certification, puis cliquez sur  Toutes les tâches  Installer le certificat CA . Sélectionnez le certificat signé, puis démarrez le service d'autorisation de certificat. installation des serveurs CA subordonnés serveurs CA subordonnés installation"},{"UUID":"07b8b3f9-31fd-420d-87ed-403cdb479608","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuration des paramètres du point","descFull":"Configuration des paramètres du point de distribution de la certification et de l'accès aux informations d'autorité Configurez les paramètres CDP (Certification Distribution Point, point de distribution de certification) et AIA (Authority Information Access, accès aux informations de l'autorité) pour la CRL (Certificate Revocation List, liste de révocation de certification). Dans Server Manager, cliquez sur  Outils  Autorité de certification . Dans le panneau de gauche, cliquez avec le bouton droit de la souris sur l'autorité de certification, puis cliquez sur  Propriétés  Extensions . Dans le menu  Sélectionner un poste , sélectionnez  Point de distribution CRL (CDP) . Dans la liste de révocation des certificats, sélectionnez  C:\\Windows\\system32\\ , puis procédez comme suit : Sélectionnez  Publier les CRL à cet emplacement . Désactivez  Publier les CRL à cet emplacement . Supprimez toutes les autres entrées sauf  C:\\Windows\\system32\\ . Cliquez sur  Ajouter . Dans le champ  Emplacement , ajoutez  http:// serverIP /CertEnroll/<CAName><CRLNameSuffix><DeltaCRLAllowed>.crl , où  serverIP  est l'adresse IP du serveur. Si votre serveur est accessible à l'aide du FQDN, utilisez le  <ServerDNSName>  au lieu de l'adresse IP du serveur. Cliquez sur  OK . Sélectionnez  Inclure dans l'extension CDP des certificats émis  pour l'entrée créée. Dans le menu  Sélectionner un poste , sélectionnez  Accès aux informations de l'autorité (AIA) . Supprimez toutes les autres entrées sauf  C:\\Windows\\system32\\ . Cliquez sur  Ajouter . Dans le champ  Emplacement , ajoutez  http:// serverIP /CertEnroll/<ServerDNSName>_<CAName><CertificateName>.crt , où  serverIP  est l'adresse IP du serveur. Si votre serveur est accessible à l'aide du FQDN, utilisez le  <ServerDNSName>  au lieu de l'adresse IP du serveur. Cliquez sur  OK . Sélectionnez  Inclure dans l'extension AIA des certificats émis  pour l'entrée créée. Cliquez sur  Appliquer OK . Si nécessaire, redémarrez le service de certification. Dans le volet de gauche, développez l'autorité de certification, cliquez avec le bouton droit de la souris sur  Certificats révoqués , puis cliquez sur  Propriétés . Spécifiez la valeur de  Intervalle de publication CRL  et  Intervalle de publication des CRL Delta , puis cliquez sur  Appliquer  OK . Dans le panneau de gauche, cliquez avec le bouton droit de la souris sur  Certificats révoqués , cliquez sur  Toutes les tâches , puis publiez dans la  nouvelle  CRL. configuration des paramètres du point de distribution de certification configuration des paramètres d'accès aux informations d'autorisation Point de distribution de certification configuration Accès aux informations de l'autorité configuration CDP configuration AIA configuration"},{"UUID":"7d8e196c-6da3-46ef-bee1-8ff19d7ba61e","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuration de l'accessibilité CRL Avant","descFull":"Configuration de l'accessibilité CRL Avant de commencer, assurez-vous que le gestionnaire Internet Information Services (IIS) est installé. Dans le gestionnaire IIS, développez l'autorité de certification, puis développez  Sites . Cliquez avec le bouton droit de la souris sur  Site Web par défaut , puis cliquez sur  Ajouter un répertoire virtuel . Dans le champ  Alias , saisissez  CertEnroll . Dans le champ  Chemin physique , saisissez  C:\\Windows\\System32\\CertSrv\\CertEnroll . Cliquez sur  OK . Cliquez avec le bouton droit de la souris sur  CertEnroll , puis cliquez sur  Modifier les autorisations . Dans l'onglet  Sécurité , supprimez tout accès en écriture, à l'exception du système. Cliquez sur  OK . configuration de l'accessibilité CRL accessibilité CRL configuration"},{"UUID":"4a03414b-cd6f-43d3-b96a-c61486e080cd","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP","link":"managing-certificates-using-SCEP-group.html","desc":"Configuration du serveur NDES A","descFull":"Configuration du serveur NDES A partir du serveur, connectez-vous en tant qu'utilisateur de domaine  SCEPAdmin . Dans Server Manager, cliquez sur  Gérer  Ajouter des rôles et des fonctionnalités . Cliquez sur  Rôles du serveur , sélectionnez  Services de certificats Active Directory  et toutes ses fonctionnalités, puis cliquez sur  Suivant . Dans la section  Services de rôle AD CS , désactivez  Autorité de certification . Sélectionnez  Network Device Enrollment Service  et toutes ses fonctionnalités, puis cliquez sur  Suivant . Dans la section  Services de rôle du rôle Serveur Web (IIS) , conservez les paramètres par défaut. Après l'installation, cliquez sur  Configurer les services de certificats Active Directory sur le serveur de destination . Dans la section  Services de rôle , sélectionnez  Network Device Enrollment Service , puis cliquez sur  Suivant . Sélectionnez le compte de service  SCEPSvc . Dans la section  Autorité de certification pour NDES , sélectionnez  Nom de l'autorité de certification  ou  Nom de l'ordinateur , puis cliquez sur  Suivant . Dans la section  Informations RA , spécifiez les informations, puis cliquez sur  Suivant . Dans la section  Cryptographie pour NDES , procédez comme suit : Sélectionnez les fournisseurs de signature et de clé de cryptage appropriés. Dans le menu  Longueur de la clé , sélectionnez la même longueur de clé que le serveur CA. Cliquez sur  Suivant . Terminez l'installation. Vous pouvez désormais accéder au serveur NDES à partir d'un navigateur Web en tant qu'utilisateur SCEPSvc. A partir du serveur NDES, vous pouvez afficher la miniature du certificat de l'autorité de certification, le mot de passe de challenge de l'inscription et la période de validité du mot de passe de challenge. Accès au serveur NDES Ouvrez un navigateur Web et saisissez  http:// NDESserverIP /certsrv/mscep_admin , où  NDESserverIP  correspond à l'adresse IP du serveur NDES. configuration des serveurs NDES serveurs NDES configuration configuration des serveurs Network Device Enrollment Service serveurs Network Device Enrollment Service configuration"},{"UUID":"2e5dc8ec-1721-4d2e-a931-98f3d1ea91cf","title":"Configuration de NDES pour MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Création d'un modèle de certificat","descFull":"Création d'un modèle de certificat A partir de l'autorité de certification (certserv) subordonnée, ouvrez  Autorité de certification . Dans le panneau de gauche, développez l'autorité de certification en cliquant avec le bouton droit de la souris sur  Modèles de certificat , puis sur  Gérer . Dans  Console des modèles de certificat , créez une copie de  Serveur Web . Dans l'onglet  Général , saisissez  MVEWebServer  comme nom de modèle. Dans l'onglet  Sécurité , attribuez aux utilisateurs  SCEPAdmin  et  SCEPSvc  les autorisations appropriées. Pour plus d'informations, reportez-vous à la section  . Dans l'onglet  Nom d'objet , sélectionnez  Envoyer la demande . A partir de l'autorité de certification (certserv) subordonnée, ouvrez  Autorité de certification . Dans l'onglet  Extensions , sélectionnez  Stratégies d'application  Modifier . Cliquez sur  Ajouter  Authentification client  OK . Dans le panneau de gauche, développez l'autorité de certification en cliquant avec le bouton droit de la souris sur  Modèles de certificat , puis sur  Nouveau  Modèle de certificat à fournir . Sélectionnez les nouveaux certificats créés, puis cliquez sur  OK . Vous pouvez désormais accéder aux modèles à l'aide du portail d'inscription Web de l'autorité de certification. Accès aux modèles Ouvrez un navigateur Web et saisissez  http:// CAserverIP /certsrv/certrqxt.asp , où  CAserverIP  correspond à l'adresse IP du serveur CA. Dans le menu  Modèle de certificat , affichez les modèles. création de modèles de certificat modèles de certificat création"},{"UUID":"9779db42-83e7-4c79-81b4-b627e76a7577","title":"Configuration de NDES pour MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Définition des modèles de certificat","descFull":"Définition des modèles de certificat pour NDES A partir de votre ordinateur, lancez l'éditeur de registre. Accédez à  HKEY_LOCAL_MACHINE  SOFTWARE  Microsoft   Cryptographie  MSCEP . Configurez les éléments suivants, puis définissez-les sur  MVEWebServer  : EncryptionTemplate GeneralPurposeTemplate SignatureTemplate Donnez à l'utilisateur SCEPSvc l'autorisation complète sur MSCEP. Dans le gestionnaire IIS, développez l'autorité de certification, puis cliquez sur  Pools d'applications . Dans le volet de droite, cliquez sur  Recycler  pour redémarrer le pool d'applications SCEP. Dans le gestionnaire IIS, développez l'autorité de certification, puis  Sites  Site Web par défaut . Dans le panneau de droite, cliquez sur  Redémarrer . définition des modèles de certificat pour NDES modèles de certificat pour NDES configuration"},{"UUID":"02a7e735-8ea0-4fb0-be79-6502a1949510","title":"Configuration de NDES pour MVE","link":"managing-certificates-using-SCEP-group.html","desc":"Désactivation de  Mot de","descFull":"Désactivation de  Mot de passe de challenge  sur le serveur CA de Microsoft A partir de votre ordinateur, lancez l'éditeur de registre. Accédez à  HKEY_LOCAL_MACHINE   SOFTWARE  Microsoft   Cryptographie  MSCEP . Définissez  EnforcePassword  sur  0 . Dans le gestionnaire IIS, développez l'autorité de certification, cliquez sur  Pools d'applications , puis sélectionnez  SCEP . Dans le panneau de droite, cliquez sur  Paramètres avancés . Définissez  Charger le profil utilisateur  sur  True , puis cliquez sur  OK . Dans le volet de droite, cliquez sur  Recycler  pour redémarrer le pool d'applications SCEP. Dans le gestionnaire IIS, développez l'autorité de certification, puis  Sites  Site Web par défaut . Dans le panneau de droite, cliquez sur  Redémarrer . Lors de l'ouverture de NDES à partir du navigateur Web, vous ne pouvez désormais afficher que la miniature de l'autorité de certification. désactivation de  Mot de passe de challenge  sur le serveur CA de Microsoft Mot de passe de challenge désactivation dans le serveur CA Microsoft"},{"UUID":"60def41b-66ae-4236-97c7-01eb1b008bdc","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration requise Le système d'exploitation","descFull":"Configuration requise Le système d'exploitation Windows Server 2012 R2 (et ses versions ultérieures) est utilisé pour toutes les configurations de cette section. Les exigences et capacités d'installation suivantes s'appliquent à la fois au CEP et au CES, sauf indication contraire. Créez les types de comptes suivants dans le contrôleur de domaine : Administrateur de service : nommé  CEPAdmin  et  CESAdmin Cet utilisateur doit faire partie du  groupe administrateur local  dans les serveurs CEP et CES respectifs. Cet utilisateur doit être membre du groupe  administrateur d'entreprise . Compte de service : nommé  CEPSvc  et  CESSvc Cet utilisateur doit faire partie du groupe  IIS_IUSRS local . Nécessite l'autorisation de  demande de certificats  sur la CA pour les  CEPSvc  et  CESSvc  respectifs. configuration requise système configuration requise"},{"UUID":"a6287600-259e-40ba-836f-234de513d2a8","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Exigences relatives à la connectivité","descFull":"Exigences relatives à la connectivité réseau Les exigences relatives à la connectivité réseau sont un élément clé de la planification du déploiement, en particulier pour les scénarios où les CEP et CES sont hébergés dans un réseau de périmètre. Toutes les connexions client aux deux services se produisent au sein d'une session HTTPS, de sorte que seul le trafic HTTPS est autorisé entre le client et les services Web. Le CEP communique avec AD DS (Active Directory Domain Services) à l'aide des ports LDAP (Lightweight Directory Access Protocol) et LDAPS (Secure LDAP) standard (TCP 389 et 636 respectivement). Le CES communique avec la CA à l'aide du modèle DCOM (Distributed Component Object Model). Par défaut, le DCOM utilise des ports éphémères aléatoires. La CA peut être configurée pour réserver une gamme spécifique de ports afin de simplifier la configuration du pare-feu. configuration requise connectivité réseau exigences relatives à la connectivité réseau exigences relatives à la connectivité"},{"UUID":"17ffea7d-1916-4526-8e3f-c8ddb6fcfcf9","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Création de certificats SSL pour","descFull":"Création de certificats SSL pour les serveurs CEP et CES Les CES et CEP doivent utiliser le protocole SSL (Secure Sockets Layer) pour communiquer avec les clients (via HTTPS). Chaque service doit disposer d'un certificat valide doté d'une stratégie EKU (Enhanced Key usage) d'authentification du serveur dans le magasin de certificats de l'ordinateur local. Installez le service IIS sur le serveur. Connectez-vous au serveur CEP, puis ajoutez le  Certificat CA racine  dans le magasin de l' Autorité de certification racine approuvée . Lancez la  Console du gestionnaire IIS , puis sélectionnez  Accueil du serveur . Dans la section de la vue principale, ouvrez les  Certificats de serveur . Cliquez sur  Actions Créer une requête de certificat . Dans la fenêtre  Propriétés du nom unique , fournissez les informations nécessaires, puis cliquez sur  Suivant . Dans la boîte de dialogue  Propriétés du fournisseur de services cryptographiques , sélectionnez la longueur binaire, puis cliquez sur  Suivant . Enregistrez le fichier. Obtenez le fichier signé par la CA que vous prévoyez d'utiliser pour le CEP et le CES. Assurez-vous que l'option  EKU d'authentification du serveur  est activée dans le certificat signé. Copiez de nouveau le fichier signé sur le serveur CEP. Dans la  Console du gestionnaire IIS , sélectionnez  Accueil du serveur . Dans la section  Vue principale , ouvrez les  Certificats de serveur . Cliquez sur  Actions Terminer la demande de certificat . Dans la fenêtre  Spécifier la réponse de l'autorité de certification , sélectionnez le fichier signé. Saisissez un nom, puis dans le menu  Magasin de certificats , sélectionnez  Personnel . Terminez l'installation du certificat. Dans la  Console du gestionnaire IIS , sélectionnez le site Web par défaut. Cliquez sur  Actions Liaisons . Dans la boîte de dialogue  Liaisons de site , cliquez sur  Ajouter . Dans la boîte de dialogue  Ajouter une liaison de site , définissez  Type  sur  https , puis recherchez le certificat nouvellement créé dans le certificat SSL. Dans la  Console du gestionnaire IIS , sélectionnez le  Site Web par défaut , puis ouvrez les paramètres SSL. Activez l'option  Exiger SSL  et définissez l'option  Certificats client  sur  Ignorer . Redémarrer l'IIS. Suivez la même procédure pour le serveur CES. serveurs CEP et CES création de certificats SSL création de certificats SSL serveurs CEP et CES certificats SSL création"},{"UUID":"f9e5c437-938d-4a27-8829-711e4f2837fa","title":"Gestion des certificats à l'aide de l'autorité de certification Microsoft via MSCEWS","link":"managing-certificates-using-MSCEWS-group.html","desc":"Création de modèles de certificats","descFull":"Création de modèles de certificats L'utilisateur doit créer un modèle de certificat pour l'inscription du certificat. Procédez comme suit pour copier à partir d'un modèle de certificat existant : Connectez-vous à la CA d'entreprise avec les informations d'identification de l'administrateur de la CA. Développez la CA en cliquant avec le bouton droit de la souris sur  Modèles de certificat , puis sur  Gérer . Dans la  Console des modèles de certificat , cliquez avec le bouton droit de la souris sur  Modèle de certificat de serveur Web , puis cliquez sur  Dupliquer le modèle . Dans l'onglet  Général  du modèle, nommez le modèle  MVEWebServer . Dans l'onglet  Sécurité , accordez à l'administrateur de la CA les autorisations de  Lecture , d' Ecriture  et d' Inscription . Accorder les autorisations de  Lecture  et d' Inscription  aux utilisateurs authentifiés. Dans l'onglet  Nom d'objet , sélectionnez  Envoyer  dans la demande. Dans l'onglet  Général , définissez la période de validité du certificat. Si vous prévoyez d'utiliser ce modèle de certificat pour émettre un  Certificat 802.1X  pour les imprimantes, procédez comme suit : Dans l'onglet  Extensions , sélectionnez  Stratégies d'application  dans la liste des extensions incluses dans ce modèle. Cliquez sur  Edition Ajouter . Dans la boîte de dialogue  Ajouter une stratégie d'application , sélectionnez  Authentification client . Cliquez sur  OK . Dans la boîte de dialogue  Propriétés de modèle de certificat , cliquez sur  OK . Dans la fenêtre CA, cliquez avec le bouton droit de la souris sur  Modèles de certificat , puis cliquez sur  Nouveau Modèle de certificat . Sélectionnez  MVEWebServer , puis cliquez sur  OK . modèles de certificat création de modèles de certificat"},{"UUID":"aa7c3ff5-5b3c-4a2e-8875-403d239fdc2d","title":"Comprendre les méthodes d'authentification","link":"managing-certificates-using-MSCEWS-group.html","desc":"Le CEP et le CES","descFull":"Le CEP et le CES prennent en charge les méthodes d'authentification suivantes : Authentification intégrée à Windows, également appelée  authentification Kerberos Authentification par certificat client, également appelée  authentification par certificat X.509 Authentification par nom d'utilisateur et mot de passe méthodes d'authentification"},{"UUID":"5b4d0eee-b02c-4352-9d89-1c3acbef14bb","title":"Comprendre les méthodes d'authentification","link":"managing-certificates-using-MSCEWS-group.html","desc":"Authentification intégrée à Windows L'authentification","descFull":"Authentification intégrée à Windows L'authentification intégrée à Windows utilise Kerberos pour fournir un flux d'authentification ininterrompu aux périphériques connectés au réseau interne. Cette méthode est préférée pour les déploiements internes, car elle utilise l'infrastructure Kerberos existante dans AD DS. Elle nécessite également peu de modifications sur les ordinateurs clients de certificat. Utilisez cette méthode d'authentification si vous avez besoin que les clients accèdent  uniquement  au service Web lorsqu'ils sont connectés directement à votre réseau interne. authentification intégrée à Windows authentification intégrée à Windows"},{"UUID":"44fd885d-42e6-463d-8944-049f44f0212d","title":"Comprendre les méthodes d'authentification","link":"managing-certificates-using-MSCEWS-group.html","desc":"Authentification par certificat client Cette","descFull":"Authentification par certificat client Cette méthode est préférable à l'authentification par nom d'utilisateur et mot de passe, car elle est plus sécurisée. Elle ne nécessite pas de connexion directe au réseau de l'entreprise. Utilisez cette méthode d'authentification si vous prévoyez de fournir aux clients des certificats numériques X.509 pour l'authentification. Cette méthode active les services Web disponibles sur Internet. authentification par certificat client authentification certificat client"},{"UUID":"c06d4f38-18f3-4170-9214-c3f67cbbc5de","title":"Comprendre les méthodes d'authentification","link":"managing-certificates-using-MSCEWS-group.html","desc":"Authentification par nom d'utilisateur et","descFull":"Authentification par nom d'utilisateur et mot de passe La méthode d'authentification par nom d'utilisateur et mot de passe est la forme d'authentification la plus simple. Cette méthode est généralement utilisée pour servir des clients qui ne sont pas directement connectés au réseau interne. Cette option d'authentification ne nécessite pas de fournir de certificat, mais elle est moins sécurisée que l'authentification par certificat client. Utilisez cette méthode d'authentification lorsque vous pouvez accéder au service Web sur le réseau interne ou sur Internet. authentification par nom d'utilisateur et mot de passe authentification nom d'utilisateur et mot de passe"},{"UUID":"824f1fcd-f497-4697-8ce2-1409c9788931","title":"Exigences relatives à la délégation","link":"managing-certificates-using-MSCEWS-group.html","desc":"La délégation permet à un","descFull":"La délégation permet à un service d'emprunter l'identité du compte d'un utilisateur ou d'un ordinateur pour accéder aux ressources sur l'ensemble du réseau. La délégation est requise pour le serveur CES lorsque tous les scénarios suivants s'appliquent : La CA et le CES ne résident pas sur le même ordinateur. Le CES peut traiter les demandes d'inscription initiales, au lieu de traiter uniquement les demandes de renouvellement de certificat. Le type d'authentification est défini sur  Authentification intégrée à Windows  ou  Authentification par certificat client . La délégation n'est pas nécessaire pour le serveur CES dans les scénarios suivants : La CA et le CES résident sur le même ordinateur. L'authentification par nom d'utilisateur et mot de passe est la méthode définie. Microsoft recommande d'exécuter le CEP et le CES en tant que comptes d'utilisateur de domaine. Les utilisateurs doivent créer un nom principal de service (SPN) approprié avant de configurer la délégation sur le compte d'utilisateur de domaine. délégation configuration requise exigences relatives à la délégation"},{"UUID":"f44f7d02-c6e6-47b3-95d9-267749fd9d04","title":"Exigences relatives à la délégation","link":"managing-certificates-using-MSCEWS-group.html","desc":"Activation de la délégation Pour","descFull":"Activation de la délégation Pour créer un SPN pour un compte d'utilisateur de domaine, utilisez la commande  setspn  comme suit : setspn -s http/ces.msca.com msca\\CESSvc Le nom du compte est CESSvc. Le CES s'exécute sur un ordinateur dont le nom de domaine complet (FQDN) est  ces.msca.com  dans le domaine msca.com. Ouvrez le compte utilisateur de domaine CESSvc dans le contrôleur de domaine. Dans l'onglet  Délégation , sélectionnez  Approuver cet utilisateur pour la délégation aux services spécifiés uniquement . Sélectionnez la délégation appropriée en fonction de la méthode d'authentification. Si vous sélectionnez l'authentification intégrée à Windows, configurez la délégation pour qu'elle utilise  Kerberos uniquement . Si le service utilise l'authentification par certificat client, configurez la délégation pour qu'elle utilise n'importe quel protocole d'authentification. Si vous prévoyez de configurer plusieurs méthodes d'authentification, configurez la délégation pour qu'elle utilise n'importe quel protocole d'authentification. Cliquez sur  Ajouter . Dans la boîte de dialogue  Ajouter des services , sélectionnez  Utilisateurs  ou  Ordinateurs . Saisissez le nom de l'hôte de votre serveur CA, puis cliquez sur  Vérifier les noms . Dans la boîte de dialogue  Ajouter des services , sélectionnez l'un des services suivants à déléguer : Service hôte (HOST) pour ce serveur CA RPCSS (Remote Procedure Call System Service) pour ce serveur CA Fermez la boîte de dialogue des propriétés de l'utilisateur du domaine. Pour les utilisateurs de domaine CEP utilisant l'authentification intégrée à Windows, procédez comme suit : Pour créer un SPN pour un compte d'utilisateur de domaine, utilisez la commande  setspn  comme suit : setspn -s http/cep.msca.com msca\\CEPSvc Le nom du compte est CEPSvc. Ouvrez le compte utilisateur de domaine CEPSvc dans le contrôleur de domaine. Dans l'onglet  Délégation , sélectionnez  Ne pas faire confiance à cet utilisateur pour la délégation . délégation activation"},{"UUID":"6ee8b36c-3ed2-47b9-985d-d6b97281ca09","title":"Configuration de l'authentification intégrée à Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Pour installer le CEP et","descFull":"Pour installer le CEP et le CES, utilisez Windows PowerShell. CEP installation CES installation"},{"UUID":"a3b921b1-c707-4c22-b9ed-339b68b28490","title":"Configuration de l'authentification intégrée à Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CEP L'applet de","descFull":"Configuration du CEP L'applet de commande  Install-AdcsEnrollmentPolicyWebService  configure le service Web CEP (service Web Stratégie d'inscription de certificats). Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CEP à l'aide du nom d'utilisateur  CEPAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Pol . Exécutez la commande  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Kerberos -SSLCertThumbprint \"sslCertThumbPrint\" . Remplacez < sslCertThumbPrint > par l'empreinte du certificat SSL créé pour le serveur CEP, après avoir supprimé les espaces entre les valeurs de l'empreinte. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CEP. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée,  ADPolicyProvider_CEP_Kerberos . Dans l'application virtuelle  Home , double-cliquez sur les paramètres de l'application, puis sur  FriendlyName . Saisissez un nom sous  Valeur , puis fermez la boîte de dialogue. Double-cliquez sur  URI , puis copiez la  Valeur . Si vous souhaitez configurer une autre méthode d'authentification sur le même serveur CEP, vous devez modifier l'ID. Cette URL est utilisée dans MVE ou dans n'importe quelle application client. Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentPolicyServer , puis cliquez sur  Actions Paramètres avancés  dans le volet de droite. Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CEPSvc  comme nom d'utilisateur de domaine. Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. CEP configuration configuration de CEP"},{"UUID":"5c9d1b4a-a99c-454c-8219-54dce02b8589","title":"Configuration de l'authentification intégrée à Windows","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CES L'applet de","descFull":"Configuration du CES L'applet de commande  Install-AdcsEnrollmentWebService  configure le service Web CES (service Web Stratégie inscription de certificats). Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CES à l'aide du nom d'utilisateur  CESAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Svc . Exécutez la commande  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig \"CA1.contoso.com\\contoso-CA1-CA\" -SSLCertThumbprint \"sslCertThumbPrint\" -AuthenticationType Kerberos . Remplacez < sslCertThumbPrint > par l'empreinte du certificat SSL créé pour le serveur CES, après avoir supprimé les espaces entre les valeurs de l'empreinte. Remplacez  CA1.contoso.com  par le nom de l'ordinateur de votre CA. Remplacez  contoso-CA1-CA  par le nom commun de votre CA. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CES. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée :  contoso-CA1-CA _CES_Kerberos . Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentServer , puis dans le volet de droite, cliquez sur  Actions Paramètres avancés . Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CESSvc  comme nom d'utilisateur de domaine. Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. Pour les utilisateurs du domaine CESSvc, activez la délégation. Pour plus d'informations, reportez-vous à la section  . CES configuration configuration de CES"},{"UUID":"c5bf51a5-74a2-4f4c-bfeb-44ab6d47cfa6","title":"Configuration de l'authentification par certificat client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CEP L'applet de","descFull":"Configuration du CEP L'applet de commande  Install-AdcsEnrollmentPolicyWebService  configure le CEP. Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CEP à l'aide du nom d'utilisateur  CEPAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Pol . Exécutez la commande  Install-AdcsEnrollmentPolicyWebService -AuthenticationType Certificate -SSLCertThumbprint “sslCertThumbPrint” . Remplacez < sslCertThumbPrint > par l'empreinte du certificat SSL créé pour le serveur CEP, après avoir supprimé les espaces entre les valeurs de l'empreinte. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CEP. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée :  ADPolicyProvider_CEP_Certificate . Dans l'application virtuelle  Home , double-cliquez sur les paramètres de l'application, puis sur  FriendlyName . Saisissez un nom sous  Valeur , puis fermez la boîte de dialogue. Double-cliquez sur  URI , puis copiez la  Valeur . Si vous souhaitez configurer une autre méthode d'authentification sur le même serveur CEP, vous devez modifier l'ID. Cette URL est utilisée dans MVE ou dans n'importe quelle application client. Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentPolicyServer , puis cliquez sur  Actions Paramètres avancés  dans le volet de droite. Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CEPSvc  comme nom d'utilisateur de domaine. Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. CEP configuration configuration de CEP"},{"UUID":"ac8ad8a4-4288-4dde-9a90-9b2ad6b56382","title":"Configuration de l'authentification par certificat client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CES L'applet de","descFull":"Configuration du CES L'applet de commande  Install-AdcsEnrollmentWebService  configure le service Web CES (service Web Stratégie inscription de certificats). Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CES à l'aide du nom d'utilisateur  CESAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Svc . Exécutez la commande  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType Certificate . Remplacez < sslCertThumbPrint > par l'empreinte du certificat SSL créé pour le serveur CES, après avoir supprimé les espaces entre les valeurs de l'empreinte. Remplacez  CA1.contoso.com  par le nom de l'ordinateur de votre CA. Remplacez  contoso-CA1-CA  par le nom commun de votre CA. Si vous avez déjà configuré une méthode d'authentification dans l'hôte, supprimez  ApplicationPoolIdentity  de la commande. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CEP. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée :  contoso-CA1-CA _CES_Certificate . Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentServer , puis dans le volet de droite, cliquez sur  Actions Paramètres avancés . Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CESSvc  comme nom d'utilisateur de domaine. Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. Pour l'utilisateur du domaine CESSvc, activez la délégation. Pour plus d'informations, reportez-vous à la section  . CES configuration configuration de CES"},{"UUID":"44cb06c8-a0aa-440c-ba90-1366ce269e3a","title":"Configuration de l'authentification par certificat client","link":"managing-certificates-using-MSCEWS-group.html","desc":"Création d'un certificat client A","descFull":"Création d'un certificat client A partir de n'importe quel compte d'utilisateur de domaine, ouvrez  certlm.msc . Cliquez sur  Certificats Personnel Certificats Toutes les tâches Demander un nouveau certificat . Cliquez sur  Suivant . Cliquez sur  Inscription à Active Directory Accès client . Procédez comme suit si vous ne souhaitez pas utiliser les options d' Inscription à Active Directory  : Cliquez sur  Configuré par vous Ajouter . Saisissez l'URI du serveur de stratégie d'inscription en tant qu'adresse de serveur CEP pour Nom d'utilisateur_Mot de passe ou Authentification Kerberos. Sélectionnez le type d'authentification  Intégré à Windows . Cliquez sur  Valider le serveur . Une fois la validation réussie, cliquez sur  Ajouter . Cliquez sur  Suivant . Sélectionnez un modèle. Cliquez sur  Détails Propriétés . Cliquez sur  Inscrire . Dans l'onglet Objet , indiquez un nom de domaine complet (FQDN). Dans l'onglet Clé privée , sélectionnez  Rendre la clé privée exportable . Cliquez sur  Appliquer Inscrire . Après avoir inscrit le certificat client, procédez comme suit pour exporter le certificat client au format PFX. Cliquez sur  Certificat Toutes les tâches Exporter . Cliquez sur  Suivant Oui, exporter la clé privée . Cliquez sur  Suivant . Saisissez le mot de passe fourni par le client. Cliquez sur  Suivant . Indiquez le nom du fichier dans la boîte de dialogue  Exportation du certificat . Cliquez sur  Suivant Terminer . certificat client création d'un certificat client"},{"UUID":"e50f6956-7618-446d-b401-de06185dce67","title":"Configuration de l'authentification par nom d'utilisateur-mot de passe","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CEP L'applet de","descFull":"Configuration du CEP L'applet de commande  Install-AdcsEnrollmentPolicyWebService  configure le service Web CEP (service Web Stratégie d'inscription de certificats). Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CEP à l'aide du nom d'utilisateur  CEPAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Pol . Exécutez la commande  Install-AdcsEnrollmentPolicyWebService -AuthenticationType UserName -SSLCertThumbprint “sslCertThumbPrint” . Remplacez < sslCertThumbPrint > par l'empreinte du certificat SSL créé pour le serveur CEP, après avoir supprimé les espaces entre les valeurs de l'empreinte. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CEP. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée :  ADPolicyProvider_CEP_UsernamePassword . Dans l'application virtuelle  Home , double-cliquez sur les paramètres de l'application, puis sur  FriendlyName . Saisissez un nom sous  Valeur , puis fermez la boîte de dialogue. Double-cliquez sur  URI , puis copiez la  Valeur . Si vous souhaitez configurer une autre méthode d'authentification sur le même serveur CEP, vous devez modifier l'ID. Cette URL est utilisée dans MVE ou dans n'importe quelle application client. Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentPolicyServer , puis cliquez sur  Actions Paramètres avancés  dans le volet de droite. Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CEPSvc . Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. CEP configuration configuration de CEP"},{"UUID":"cf78a955-01ed-469b-8072-b87f68203a18","title":"Configuration de l'authentification par nom d'utilisateur-mot de passe","link":"managing-certificates-using-MSCEWS-group.html","desc":"Configuration du CES L'applet de","descFull":"Configuration du CES L'applet de commande  Install-AdcsEnrollmentWebService  configure le service Web CES (service Web Stratégie inscription de certificats). Il est également utilisé pour créer d'autres instances du service au sein d'une installation existante. Connectez-vous au serveur CES à l'aide du nom d'utilisateur  CESAdmin , puis lancez PowerShell en mode administratif. Exécutez la commande  Import-module ServerManager . Exécutez la commande  Add-WindowsFeature Adcs-Enroll-Web-Svc . Exécutez la commande  Install-AdcsEnrollmentWebService -ApplicationPoolIdentity -CAConfig “CA1.contoso.com\\contoso-CA1-CA” -SSLCertThumbprint “sslCertThumbPrint” -AuthenticationType UserName . Remplacez < sslCertThumbprint > par l'empreinte du certificat SSL créé pour le serveur CES, après avoir supprimé les espaces entre les valeurs de l'empreinte. Remplacez  CA1.contoso.com  par le nom de l'ordinateur de votre CA. Remplacez  contoso-CA1-CA  par le nom commun de votre CA. Si vous avez déjà configuré une méthode d'authentification dans l'hôte, supprimez  ApplicationPoolIdentity  de la commande. Terminez l'installation en sélectionnant  Y  ou  A . Lancez la Console du gestionnaire IIS. Dans le volet  Connexions , développez le serveur Web qui héberge le CES. Développez  Sites , développez  Site Web par défaut , puis cliquez sur le nom de l'application virtuelle d'installation appropriée :  contoso-CA1-CA_CES_UsernamePassword . Dans le volet de gauche, cliquez sur  Pools d'applications . Sélectionnez  WSEnrollmentServer , puis, dans le volet de droite, cliquez sur  Actions Paramètres avancés  sous  Actions . Sélectionnez le champ d'identité sous  Modèle de processus . Dans la boîte de dialogue  Identité du pool d'applications , sélectionnez le compte personnalisé, puis saisissez  CESSvc  comme nom d'utilisateur de domaine. Fermez toutes les boîtes de dialogue, puis recyclez l'IIS à partir du volet droit de la  Console du gestionnaire IIS . Dans PowerShell, saisissez  iisreset  pour redémarrer l'IIS. CES configuration configuration de CES"},{"UUID":"2a04dfdf-0ea0-4f42-b0c5-85889746c7f1","title":"Configuration de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Installation de l'autorité de certification","descFull":"Installation de l'autorité de certification OpenXPKI Connectez la machine à l'aide de PuTTY ou d'un autre client. A partir du client, exécutez la commande  sudo su -  pour accéder à l'utilisateur racine. Saisissez le mot de passe racine. Dans  nano /etc/apt/sources.list , modifiez la source pour l'installation des mises à jour. Mettez à jour le fichier. Par exemple : #\n\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n# deb cdrom:[Debian GNU/Linux 8.11.1 _Jessie_ - Official amd64 CD Binary-1 20190211-02:10]/ jessie local main\n\ndeb http://security.debian.org/ jessie/updates main\ndeb-src http://security.debian.org/ jessie/updates main\n\n# jessie-updates, previously known as 'volatile'\n# A network mirror was not selected during install.  The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/jessie-updates main\ndeb-src http://ftp.debian.org/debian/jessie-updates main\ndeb http://ftp.us.debian.org/debian/jessie main\n Enregistrez le fichier. Exécutez les commandes suivantes : mise à jour apt-get mise à niveau apt-get Mettez à jour les listes de certificats CA du serveur à l'aide de  apt-get install ca-certificates . Installez le paramètre local  en_US.utf8 locale  à l'aide des paramètres locaux  dpkg-reconfigure locales . Sélectionnez le paramètre local  en_US.UTF-8 UTF-8 , puis définissez-le comme paramètre local par défaut pour le système. Utilisez les touches de tabulation et la barre d'espace pour sélectionner et naviguer dans le menu. Vérifiez les paramètres locaux que vous avez générés à l'aide de  locale –a . Exemple d'impression C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copiez l'empreinte du package OpenXPKI à l'aide de  nano /home/Release.key . Dans ce cas, copiez la clé dans  /home . Saisissez  9B156AD0 F0E6A6C7 86FABE7A D8363C4E 1611A2BE 2B251336 01D1CDB4 6C24BEF3  comme valeur. Exécutez la commande suivante : gpg --print-md sha256 /home/Release.key Ajoutez le package à l'aide de la commande  wget https://packages.openxpki.org/v2/debian/Release.key -O - | apt-key add - . Ajoutez le référentiel à votre liste source (jessie) à l'aide de  echo \"deb http://packages.openxpki.org/v2/debian/jessie release\" > /etc/apt/sources.list.d/openxpki.list , puis  aptitude update . Installez la liaison MySQL et Perl MySQL à l'aide de  aptitude install mysql-server libdbd-mysql-perl . Installez apache2.2-common à l'aide de  aptitude install apache2.2-common . Dans  nano /etc/apt/sources.list , installez le module fastcgi pour accélérer l'interface utilisateur. Nous vous recommandons d'utiliser  mod_fcgid . Ajoutez la ligne  deb http://http.us.debian.org/debian/jessie main  dans le fichier, puis enregistrez-la. Exécutez les commandes suivantes : mise à jour apt-get aptitude install libapache2-mod-fcgid Activez le module fastcgi à l'aide de  a2enmod fcgid . Installez le package principal OpenXPKI à l'aide de  aptitude install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Redémarrez le serveur  Apache  en utilisant le  service de redémarrage apache2 . Vérifiez si l'installation est réussie à l'aide de  openxpkiadm version . Si l'installation est réussie, le système affiche la version d'OpenXPKI installée. Par exemple,  Version (principale) : 2.5.5 . Créez la base de données vide, puis affectez l'utilisateur de la base de données à l'aide de  mysql -u root –p . Cette commande doit être saisie dans le client. Sinon, vous ne pouvez pas saisir le mot de passe. Saisissez le mot de passe pour MySQL. Pour cette instance,  root  est l'utilisateur MySQL. MySQL  est l'utilisateur sur lequel OpenXPKI est installé. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Si le service MySQL n'est pas en cours d'exécution, exécutez  /etc/init.d/mysql start  pour lancer le service. Saisissez  quit  pour quitter MySQL. Stockez les informations d'identification utilisées dans  /etc/openxpki/config.d/system/database.yaml . Exemple de contenu du fichier debug: 0\ntype: MySQL\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Modifiez les champs  user  et  passwd  pour qu'ils correspondent au nom d'utilisateur et au mot de passe MySQL. Enregistrez le fichier. Pour un schéma de base de données vide, exécutez  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mysql.sql.gz | \\mysql -u root --password --database openxpki  à partir du fichier de schéma fourni. Saisissez le mot de passe de la base de données. installation de l'autorité de certification OpenXPKI Certificat CA d'OpenXPKI installation"},{"UUID":"f6635675-7e74-4768-8941-75fa94fde228","title":"Configuration de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"configuration de l'autorité de certification","descFull":"configuration de l'autorité de certification OpenXPKI à l'aide du script par défaut Le script par défaut configure uniquement le domaine par défaut,  ca-one . Les CDP et CRL ne sont pas configurés. Décompressez l'exemple de script pour installer le certificat à l'aide de  gunzip -k /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh.gz . Exécutez le script à l'aide de  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confirmez la configuration à l'aide de  openxpkiadm alias --realm ca-one . Exemple d'impression === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Vérifiez si l'installation est réussie à l'aide de  openxpkictl start . Exemple d'impression Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Pour accéder au serveur OpenXPKI, procédez comme suit : Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Connectez-vous en tant qu' opérateur . Le mot de passe par défaut est  openxpki . La connexion Opérateur a deux comptes opérateur préconfigurés,  raop  et  raop2 . Créez une demande de certificat, puis testez-la. configuration de l'autorité de certification OpenXPKI à l'aide du script par défaut Certificat CA d'OpenXPKI configuration à l'aide du script par défaut"},{"UUID":"5e1c2628-cbb4-4f18-b11c-756d631d531a","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Aperçu Avant de commencer, assurez-vous","descFull":"Aperçu Avant de commencer, assurez-vous de disposer de connaissances de base sur la création de certificats OpenSSL. Pour configurer l'autorité de certification OpenXPKI manuellement, créez les éléments suivants : Certificat CA racine. Pour plus d'informations, reportez-vous à la section  . Certificat du signataire de l'autorité de certification, signé par l'autorité de certification racine. Pour plus d'informations, reportez-vous à la section  . Certificat du coffre de données, auto-signé. Pour plus d'informations, reportez-vous à la section  . Certificat SCEP, signé par le certificat du signataire. Lorsque vous sélectionnez le hachage de signature, utilisez SHA256 ou SHA512. La modification de la taille de la clé publique est facultative. Pour cette instance, nous utilisons le répertoire  /etc/certs/openxpki_ca-one/  pour la génération de certificats. Cependant, vous pouvez utiliser n'importe quel répertoire. configuration manuelle de l'autorité de certification OpenXPKI Certificat CA d'OpenXPKI configuration manuelle"},{"UUID":"ad9c7db0-740b-4e66-aac5-c46800f93874","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un fichier de configuration","descFull":"Création d'un fichier de configuration OpenSSL Exécutez la commande suivante : nano /etc/certs/openxpki_ca-one/openssl.conf Si votre serveur est accessible à l'aide du nom de domaine complet (FQDN), utilisez le DNS du serveur au lieu de son adresse IP. Exemple de fichier # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:stlopenxpki.lexmark.com\ncrlDistributionPoints   = URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crl\nauthorityInfoAccess     = caIssuers;URI:http://FQDN of the server/CertEnroll/MYOPENXPKI_ISSUINGCA.crt\n Modifiez l'adresse IP et le nom du certificat CA avec vos informations de configuration. Enregistrez le fichier. création d'un fichier de configuration OpenSSL fichier de configuration OpenSSL création"},{"UUID":"eea090f5-8d4c-40e0-a1d5-60f787ccc317","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un fichier de mots","descFull":"Création d'un fichier de mots de passe pour les clés de certificat Exécutez la commande suivante : nano /etc/certs/openxpki_ca-one/pd.pass Saisissez votre mot de passe. Enregistrez le fichier. création de fichiers de mots de passe pour les clés de certificat fichiers de mots de passe pour les clés de certificat création clés de certificat création de fichiers de mots de passe"},{"UUID":"bad9cc97-b890-4ea6-95b0-51b438590314","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un certificat CA racine","descFull":"Création d'un certificat CA racine Vous pouvez créer un certificat CA racine auto-signé ou générer une demande de certificat, puis le faire signer par l'autorité de certification racine. Exécutez les commandes suivantes : Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. openssl genrsa -out /etc/certs/openxpki_ca-one/ca-root-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -new -key /etc/certs/openxpki_ca-one/ca-root-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ROOTCA -out /etc/certs/openxpki_ca-one/ca-root-1.csr openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_ca_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/ca-root-1.csr -key /etc/certs/openxpki_ca-one/ca-root-1.key -out /etc/certs/openxpki_ca-one/ca-root-1.crt -sha256 création de certificats d'autorité de certification racine certificats d'autorité de certification création"},{"UUID":"35daf9f7-fa3d-484d-86ad-900d28a06171","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un certificat de signataire","descFull":"Création d'un certificat de signataire Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. Exécutez la commande suivante : openssl genrsa -out /etc/certs/openxpki_ca-one/ca-signer-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Remplacez l'objet de la demande par vos informations d'autorité de certification en utilisant  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_ca-one/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out /etc/certs/openxpki_ca-one/ca-signer-1.csr . Faites signer le certificat par l'autorité de certification racine à l'aide de  openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_ca-one/ca-signer-1.csr -CA /etc/certs/openxpki_ca-one/ca-root-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/ca-signer-1.crt -sha256 . création de certificats du signataire certificats du signataire création"},{"UUID":"734114bc-d08c-42a7-800d-62ab30c0cb5e","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un certificat de coffre","descFull":"Création d'un certificat de coffre Le certificat du coffre est auto-signé. Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. Exécutez la commande suivante : openssl genrsa -out /etc/certs/openxpki_ca-one/vault-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 Remplacez l'objet de la demande par vos informations d'autorité de certification en utilisant  openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_datavault_reqexts -new -key /etc/certs/openxpki_ca-one/vault-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/DC=STLOPENXPKI_INTERNAL/CN=MYOPENXPKI_DATAVAULT -out /etc/certs/openxpki_ca-one/vault-1.csr . Exécutez la commande suivante : openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_datavault_extensions -x509 -days 3560 -in /etc/certs/openxpki_ca-one/vault-1.csr -key /etc/certs/openxpki_ca-one/vault-1.key -out /etc/certs/openxpki_ca-one/vault-1.crt création de certificats de coffre certificats de coffre création"},{"UUID":"12b7fc73-b925-4203-bc07-100386a97d35","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création d'un certificat SCEP Le","descFull":"Création d'un certificat SCEP Le certificat SCEP est signé par le certificat du signataire. Exécutez les commandes suivantes : Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. openssl genrsa -out /etc/certs/openxpki_ca-one/scep-1.key -passout file:/etc/certs/openxpki_ca-one/pd.pass 4096 openssl req -config /etc/certs/openxpki_ca-one/openssl.conf -reqexts v3_scep_reqexts -new -key /etc/certs/openxpki_ca-one/scep-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_SCEPCA -out /etc/certs/openxpki_ca-one/scep-1.csr openssl x509 -req -extfile /etc/certs/openxpki_ca-one/openssl.conf -extensions v3_scep_extensions -days 900 -in /etc/certs/openxpki_ca-one/scep-1.csr -CA /etc/certs/openxpki_ca-one/ca-signer-1.crt -CAkey /etc/certs/openxpki_ca-one/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_ca-one/scep-1.crt -sha256 création de certificats SCEP certificats SCEP création"},{"UUID":"8d30d1df-72d7-447f-bd86-b5dae3cd7264","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copie du fichier de clés","descFull":"Copie du fichier de clés et création d'un lien symbolique Copiez les fichiers de clés dans  /etc/openxpki/ca/ca-one/ . Les fichiers de clés doivent être lisibles par OpenXPKI. cp /etc/certs/openxpki_ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/vault-1.key /etc/openxpki/ca/ca-one/\n\ncp /etc/certs/openxpki_ca-one/scep-1.key /etc/openxpki/ca/ca-one/ Créez le lien symbolique. Les liens symboliques sont des alias utilisés par la configuration par défaut. ln -s /etc/openxpki/ca/ca-one/ca-signer-1.key /etc/openxpki/ca/ca-one/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-one/scep-1.key /etc/openxpki/ca/ca-one/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-one/vault-1.key /etc/openxpki/ca/ca-one/vault-1.pem copie de fichiers de clés création de liens symboliques fichiers de clés copie liens symboliques création"},{"UUID":"76e35f84-1aff-4e3f-be82-9554c1ca95bd","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Importation des certificats Importez le","descFull":"Importation des certificats Importez le certificat racine, le certificat du signataire, le certificat du coffre et le certificat SCEP dans la base de données avec les jetons appropriés. Exécutez les commandes suivantes : openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-root-1.crt openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/ca-signer-1.crt --realm ca-one --token certsign openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/scep-1.crt --realm ca-one --token scep openxpkiadm certificate import --file /etc/certs/openxpki_ca-one/vault-1.crt --realm ca-one --token datasafe Vérifiez si l'importation est réussie à l'aide de  openxpkiadm alias --realm ca-one . Exemple d'impression === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n importation des certificats certificats importation"},{"UUID":"e2aa430b-a08e-4683-95ea-3c87609933b1","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Démarrage d'OpenXPKI Exécutez la commande","descFull":"Démarrage d'OpenXPKI Exécutez la commande  openxpkictl start . Exemple d'impression Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Pour accéder au serveur OpenXPKI, procédez comme suit : Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Vous pouvez également utiliser le FQDN du serveur à la place d' ipaddress . Connectez-vous en tant qu' opérateur . Le mot de passe par défaut est  openxpki . La connexion Opérateur a deux comptes opérateur préconfigurés,  raop  et  raop2 . Créez une demande de certificat, puis testez-la. démarrage d'OpenXPKI OpenXPKI démarrage"},{"UUID":"e9c349d3-f5f2-4b95-8b0f-a6d455d4c889","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Génération des informations CRL Si","descFull":"Génération des informations CRL Si votre serveur est accessible à l'aide du FQDN, utilisez le DNS du serveur au lieu de son adresse IP. Arrêtez le service OpenXPKI à l'aide de  Openxpkictl stop . Dans  nano /etc/openxpki/config.d/realm/ca-one/publishing.yaml , mettez à jour les éléments suivants de la section  connecteurs : cdp  : class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" Dans  nano /etc/openxpki/config.d/realm/ca-one/profile/default.yaml , mettez à jour les éléments suivants : crl_distribution_points :  Section critical: 0\nuri:\n    - http://FQDN of the server/CertEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %] authority_info_access :  Section critical: 0\nca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Modifiez l'adresse IP et le nom du certificat CA en fonction de votre serveur CA. Dans  nano /etc/openxpki/config.d/realm/ca-one/crl/default.yaml , procédez comme suit : Si nécessaire, mettez à jour  nextupdate  et  renewal . Ajoutez  ca_issuers  à la section suivante : extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: http://FQDN of the server/CertEnroll/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Modifiez l'adresse IP et le nom du certificat CA en fonction de votre serveur CA. Démarrez le service OpenXPKI à l'aide de  Openxpkictl start . génération des informations CRL informations CRL génération"},{"UUID":"e7aea9d6-d42c-404f-bdb0-6a04508d8b77","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configuration de l'accessibilité CRL Arrêtez","descFull":"Configuration de l'accessibilité CRL Arrêtez le service Apache à l'aide de  service apache2 stop . Créez un répertoire  CertEnroll  pour crl dans le répertoire  /var/www/openxpki/ . Définissez  openxpki  comme propriétaire de ce répertoire, puis configurez les autorisations pour permettre à Apache de lire et d'exécuter, et aux autres services de lire uniquement. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Ajoutez une référence au fichier de configuration alias.conf à l'aide de  nano /etc/apache2/mods-enabled/alias.conf . Après la section  <Directory \"/usr/share/apache2/icons\"> , ajoutez ce qui suit :         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Ajoutez une référence dans le fichier apache2.conf à l'aide de  nano /etc/apache2/apache2.conf . Ajoutez ce qui suit dans la section  Serveur HTTPD Apache2  :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Démarrez le service Apache à l'aide de  service apache2 start . configuration de l'accessibilité CRL accessibilité CRL configuration"},{"UUID":"e29201df-cf10-4438-8e50-3c9bec1387d2","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activation du service SCEP Arrêtez","descFull":"Activation du service SCEP Arrêtez le service OpenXPKI à l'aide de  openxpkictl stop . Installez le package openca-tools à l'aide de  aptitude install openca-tools . Démarrez le service OpenXPKI à l'aide de  openxpkictl start . Testez le service à l'aide de n'importe quel client, tel que certnanny avec SSCEP. SSCEP est un client de ligne de commande pour SCEP. Vous pouvez télécharger SSCEP depuis  https://github.com/certnanny/sscep . activation du service SCEP service SCEP activation Simple Certificate Enrollment Protocol activation"},{"UUID":"cce16401-d837-4d33-8d06-1c83ba9f9bb6","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activation du certificat du signataire","descFull":"Activation du certificat du signataire pour le compte de (agent d'inscription) Pour les demandes de certificat automatiques, nous utilisons la fonction du certificat du signataire pour le compte de d'OpenXPKI. Arrêtez le service OpenXPKI à l'aide de  openxpkictl stop . Dans  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , depuis la section  authorized_signer: , ajoutez une règle pour le nom d'objet du certificat du signataire. rule1:\n        \t\t# Full DN\n            \t\tsubject: CN=Markvision_.*\n Dans cette règle, tout certificat CN commençant par  MarkVision_  est le certificat du signataire pour le compte de. Le nom de l'objet est défini dans MVE pour la génération du certificat du signataire pour le compte de. Vérifiez l'espace et l'indentation dans le fichier de script. Si le CN est modifié dans MVE, ajoutez le CN mis à jour dans OpenXPKI. Vous ne pouvez spécifier qu'un seul certificat en tant que signataire pour le compte de, puis spécifiez le CN complet. Enregistrez le fichier. Démarrez le service OpenXPKI à l'aide de  openxpkictl start . activation des certificats de signataire pour le compte de certificats du signataire pour le compte de activation"},{"UUID":"a981566d-9d17-4723-8baf-214fbf026043","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Activation de l'approbation automatique des","descFull":"Activation de l'approbation automatique des demandes de certificat dans l'autorité de certification OpenXPKI Arrêtez le service OpenXPKI à l'aide de  openxpkictl stop . Dans  nano /etc/openxpki/config.d/realm/ca-one/scep/generic.yaml , mettez à jour les éléments  éligibles :  section : Ancien contenu eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nouveau contenu eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Vérifiez l'espace et l'indentation dans le fichier de script. Pour approuver les certificats manuellement, commentez la ligne  valeur : 1 , puis supprimez les commentaires des autres lignes commentées précédemment. Enregistrez le fichier. Démarrez le service OpenXPKI à l'aide de  openxpkictl start . activation de l'approbation automatique des demandes de certificat dans l'autorité de certification OpenXPKI approbation automatique des demandes de certificat activation dans l'autorité de certification OpenXPKI demandes de certificat dans l'autorité de certification OpenXPKI approbation automatique"},{"UUID":"a487a81e-3811-477a-9221-49987ae00128","title":"Création d'un deuxième domaine","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Copie et définition du répertoire","descFull":"Copie et définition du répertoire Copiez l'exemple d'arborescence  /etc/openxpki/config.d/realm/ca-one  dans un nouveau répertoire ( cp -avr /etc/openxpki/config.d/realm/ca-one /etc/openxpki/config.d/realm/ca-two ) dans le répertoire de domaine. Dans  etc/openxpki/config.d/system/realms.yaml , mettez à jour la section suivante : Ancien contenu # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#ca-two:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nouveau contenu # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\nca-one:\n    label: CA-ONE\n    baseurl: https://pki.example.com/openxpki/\n\nca-two:\n    label: CA-TWO\n    baseurl: https://pki.example.com/openxpki/ Enregistrez le fichier. copie du répertoire définition du répertoire"},{"UUID":"2302c605-dd09-40ee-9588-c3f62fd5e2ca","title":"Création d'un deuxième domaine","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Création de certificats Les instructions","descFull":"Création de certificats Les instructions suivantes indiquent comment générer le certificat du signataire, le certificat du coffre et le certificat SCEP. L'autorité de certification racine signe le certificat du signataire, puis le certificat du signataire signe le certificat SCEP. Le certificat du coffre est auto-signé. Générez, puis signez les certificats. Pour plus d'informations, reportez-vous à la section  . Modifiez le nom commun du certificat afin que l'utilisateur puisse facilement distinguer les différents certificats des différents domaines. Vous pouvez remplacer  DC=CA-ONE  par  DC=CA-TWO . Les fichiers de certificat sont créés dans le répertoire  /etc/certs/openxpki_ca-two/ . Copiez les fichiers de clés dans  /etc/openxpki/ca/ca-two/ . Les fichiers de clés doivent être lisibles par OpenXPKI. cp /etc/certs/openxpki_ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/vault-1.key /etc/openxpki/ca/ca-two/\n\ncp /etc/certs/openxpki_ca-two/scep-1.key /etc/openxpki/ca/ca-two/ Créez le lien symbolique. Créez également un lien symbolique pour le certificat CA racine. Les liens symboliques sont des alias utilisés par la configuration par défaut. ln -s /etc/openxpki/ca/ca-one/ca-root-1.crt /etc/openxpki/ca/ca-two/ca-root-1.crt\n\nln -s /etc/openxpki/ca/ca-two/ca-signer-1.key /etc/openxpki/ca/ca-two/ca-signer-1.pem\n\nln -s /etc/openxpki/ca/ca-two/scep-1.key /etc/openxpki/ca/ca-two/scep-1.pem\n\nln -s /etc/openxpki/ca/ca-two/vault-1.key /etc/openxpki/ca/ca-two/vault-1.pem Importez le certificat du signataire, le certificat du coffre et le certificat SCEP dans la base de données avec les jetons appropriés pour  ca-two . openxpkiadm certificate import --file /etc/certs/openxpki_ca-two/ca-signer-1.crt --realm ca-two –issuer /etc/openxpki/ca/ca-two/ca-one-1.crt --token certsign\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/scep-1.crt --realm ca-two --token scep\n\nopenxpkiadm certificate import --file /etc/certs/openxpki_ca-two/vault-1.crt --realm ca-two --token datasafe Vérifiez si l'importation est réussie à l'aide de  openxpkiadm alias --realm ca-two . Exemple d'impression === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set\n Dans ce cas, les informations de l'autorité de certification racine sont les mêmes pour  ca-one  et  ca-two . Si vous avez modifié le mot de passe de la clé de certificat lors de la création du certificat, alors mettez à jour  nano /etc/openxpki/config.d/realm/ca-two/crypto.yaml . Générez les CRL pour ce domaine. Pour plus d'informations, reportez-vous à la section  . Publier les CRL pour ce domaine. Pour plus d'informations, reportez-vous à la section  . Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . Exemple d'impression Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Pour accéder au serveur OpenXPKI, procédez comme suit : Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Connectez-vous en tant qu' opérateur . Le mot de passe par défaut est  openxpki . La connexion Opérateur a deux comptes opérateur préconfigurés,  raop  et  raop2 . création de certificats certificats création"},{"UUID":"03e6a389-a9ce-4774-8c2b-8e3408354fa5","title":"Création d'un deuxième domaine","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Configuration du point de terminaison","descFull":"Configuration du point de terminaison SCEP pour plusieurs domaines Le point de terminaison SCEP du domaine par défaut est  http://<ipaddress>/scep/scep . Si vous disposez de plusieurs domaines, configurez un point de terminaison SCEP unique (fichier de configuration différent) pour chaque domaine. Dans les instructions suivantes, nous utilisons deux domaines PKI,  ca-one  et  ca-two . Copiez le fichier de configuration par défaut dans  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-one.conf . Nommez le fichier  ca-one.conf . Dans  penxpki/scep/ca-one.conf , définissez la valeur du domaine sur  realm=ca-one . Créez un autre fichier de configuration dans  cp /etc/openxpki/scep/default.conf /etc/openxpki/scep/ca-two.conf . Nommez le fichier  ca-two.conf . Dans  nano /etc/openxpki/scep/ca-two.conf , définissez la valeur du domaine sur  realm=ca-two . Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . Les points de terminaison SCEP sont les suivants : ca‑one — http://ipaddress/scep/ca-one ca-two — http://ipaddress/scep/ca-two Si vous souhaitez faire la différence entre les informations d'identification de connexion et les modèles de certificat par défaut pour différents domaines PKI, vous aurez peut-être besoin d'une configuration avancée. configuration des points de terminaison SCEP pour plusieurs domaines points de terminaison SCEP configuration pour plusieurs domaines"},{"UUID":"59228314-a00c-4678-8528-a2f26cf6fd5b","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Autorisation de la présence de","descFull":"Autorisation de la présence de plusieurs certificats actifs à la fois ayant le même sujet Par défaut, dans OpenXPKI, un seul certificat avec le même nom d'objet peut être actif à la fois. Cependant, lorsque vous appliquez plusieurs Certificats nommés, plusieurs certificats actifs portant le même nom d'objet doivent être présents à la fois. Dans  /etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , dans la section  Politique , remplacez la valeur  1  de  max_active_certs  par  0 . REALM NAME est le nom du domaine. Par exemple,  ca‑one . Vérifiez l'espace et l'indentation dans le fichier de script. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . autorisation de plusieurs certificats actifs même objet"},{"UUID":"03beff12-517a-4a10-80d0-1f2a88e97d56","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Définition du numéro de port","descFull":"Définition du numéro de port par défaut pour l'autorité de certification OpenXPKI Par défaut, Apache écoute dans le numéro de port 80. Définissez le numéro de port par défaut de l'autorité de certification OpenXPKI pour éviter les conflits. Dans  /etc/apache2/ports.conf , ajoutez ou modifiez un port. Par exemple,  Ecouter 8080 . Dans  /etc/apache2/sites-enabled/000-default.conf , ajoutez ou modifiez la section  VirtualHost  pour mapper le nouveau port. Par exemple,  <VirtualHost *:8080> . Redémarrez le serveur Apache à l'aide de  systemctl restart apache2 . Pour vérifier l'état, exécutez  netstat -tlpn| grep apache . L'URL SCEP OpenXPKI est désormais  http://ipaddress:8080/scep/ca-one , et l'URL Web est  http://ip address:8080/openxpki . définition des numéros de port par défaut pour l'autorité de certification OpenXPKI numéro du port par défaut paramètre pour l'autorité de certification OpenXPKI"},{"UUID":"eae10a5b-e274-4223-8a1b-03d85c5f6a9f","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Rejet des demandes de certificat","descFull":"Rejet des demandes de certificat sans  Mot de passe de challenge  dans la CA OpenXPKI Par défaut, OpenXPKI accepte les demandes sans vérifier le mot de passe de challenge. La demande de certificat n'est pas rejetée et l'administrateur de l'autorité de certification et l'autorité de certification déterminent s'il faut approuver ou rejeter la demande. Pour éviter tout problème de sécurité potentiel, désactivez cette fonction afin que toute demande de certificat contenant des mots de passe non valides soit immédiatement rejetée. Dans MVE,  Mot de passe de challenge  est requis uniquement lors de la génération du certificat d'agent d'inscription. Dans  etc/openxpki/config.d/realm/REALM NAME/scep/generic.yaml , à partir de la section  Politique , remplacez la valeur  1  de  allow_man_authen  par  0 . REALM NAME est le nom du domaine. Par exemple,  ca‑one . Vérifiez l'espace et l'indentation dans le fichier de script. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . rejet des demandes de certificat sans  mot de passe de challenge  dans la CA OpenXPKI demandes de certificat sans  Mot de passe de challenge rejet dans la CA OpenXPKI"},{"UUID":"3baac853-2554-4286-9e95-8faa2a782d61","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Ajout de l'EKU d'authentification client","descFull":"Ajout de l'EKU d'authentification client dans les certificats Dans  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , depuis la section  extended_key_usage:  remplacez la valeur  client_auth:  par  1 . REALM NAME est le nom du domaine. Par exemple,  ca‑one . Vérifiez l'espace et l'indentation dans le fichier de script. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . ajout de l'EKU d'authentification client dans les certificats EKU d'authentification client ajout dans des certificats"},{"UUID":"f44be668-6d2d-4e6f-9f9a-c5ca6ccc1a24","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"obtention de l'objet de certificat","descFull":"obtention de l'objet de certificat complet lors d'une demande via SCEP Par défaut, OpenXPKI lit uniquement le CN de l'objet du certificat demandeur. Les autres informations, telles que le pays, la localité et DC, sont codées en dur. Par exemple, si un objet de certificat est  C=US ,  ST=KY ,  L=Lexington ,  O=Lexmark ,  OU=ISS ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com , alors après avoir signé le certificat via SCEP, le sujet est remplacé par  DC=Test Deployment ,  DC= OpenXPKI ,  CN=ET0021B7C34AEC.dhcp.dev.lexmark.com . REALM NAME est le nom du domaine. Par exemple,  ca‑one . Dans  /etc/openxpki/config.d/realm/REALM NAME/profile/I18N_OPENXPKI_PROFILE_TLS_SERVER.yaml , dans la section  Inscrire , modifiez la valeur  dn  comme suit : CN=[% CN.0 %][% IF OU %][% FOREACH entry = OU %],OU=[% entry %][% END %][% END %][% IF O %][% FOREACH entry = O %],O=[% entry %][% END %][% END %][% IF L %],L=[% L.0 %][% END %][% IF ST %],ST=[% ST.0 %][% END %][% IF C %],C=[% C.0 %][% END %][% IF DC %][% FOREACH entry = DC %],DC=[% entry %][% END %][% END %][% IF EMAIL %][% FOREACH entry = EMAIL %],EMAIL=[% entry %][% END %][% END %] Enregistrez le fichier. Créez un fichier intitulé  l.yaml  dans le répertoire  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Ajoutez ce qui suit : id: L\nlabel: L\ndescription: I18N_OPENXPKI_UI_PROFILE_L_DESC\npreset: L\ntype: freetext\nwidth: 60\nplaceholder: Kolkata Enregistrez le fichier. Créez un fichier intitulé  st.yaml  dans le répertoire  /etc/openxpki/config.d/realm/REALM NAME/profile/template . Ajoutez ce qui suit : id: ST\nlabel: ST\ndescription: I18N_OPENXPKI_UI_PROFILE_ST_DESC\npreset: ST\ntype: freetext\nwidth: 60\nplaceholder: WB Enregistrez le fichier. OpenXPKI doit posséder les deux fichiers et être lisible, inscriptible et exécutable. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . obtention d'objets de certificat complets lors d'une demande via SCEP objets de certificat complets demande via SCEP"},{"UUID":"e1cf5709-ca9c-48bd-8226-fef47fda8a38","title":"Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP","link":"managing-certificates-using-OpenXPKI-CA-group.html","desc":"Révocation des certificats et publication","descFull":"Révocation des certificats et publication de CRL Accédez au serveur OpenXPKI. Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Connectez-vous en tant qu' opérateur . Le mot de passe par défaut est  openxpki . La connexion Opérateur a deux comptes opérateur préconfigurés,  raop  et  raop2 . Cliquez sur  Recherche de flux Rechercher maintenant . Cliquez sur un certificat à révoquer, puis cliquez sur le lien du certificat. Dans la section  Action , cliquez sur  demande de révocation . Saisissez les valeurs appropriées, puis cliquez sur  Continuer Envoyer la demande . Sur la page suivante, approuvez la demande. La révocation du certificat attend la prochaine publication de CRL. Dans la section  Fonctionnement PKI , cliquez sur  Emettre une liste de révocation de certificat (CRL) . Cliquez sur  Appliquer la création de listes de révocation Continuer . Dans la section  Fonctionnement PKI , cliquez sur  Publier CA/CRL . Cliquez sur  Recherche de flux Rechercher maintenant . Cliquez sur le certificat révoqué de type  certificate_revocation_request_v2 . Cliquez sur  Forcer la réactivation . Dans le nouveau CRL, vous trouverez le numéro de série et le motif de révocation du certificat révoqué. révocation des certificats certificats révocation publication de CRL CRL publication"},{"UUID":"855193ce-2174-49ca-aad0-7649db219b36","title":"Configuration de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Installation de l'autorité de certification","descFull":"Installation de l'autorité de certification OpenXPKI Connectez la machine à l'aide de PuTTY ou d'un autre client. A partir du client, exécutez la commande  sudo su -  pour accéder à l'utilisateur racine. Saisissez le mot de passe racine. Dans  nano /etc/apt/sources.list , modifiez la source pour l'installation des mises à jour. Mettez à jour le fichier. Par exemple : #\n\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n# deb cdrom:[Debian GNU/Linux testing _Buster_ - Official Snapshot amd64 DVD Binary-1 20190527-04:04]/ buster contrib main\n\ndeb http://security.debian.org/debian-security buster/updates main contrib\ndeb-src http://security.debian.org/debian-security buster/updates main contrib\n\n# buster-updates, previously known as 'volatile'\n# A network mirror was not selected during install. The following entries\n# are provided as examples, but you should amend them as appropriate\n# for your mirror of choice.\n#\ndeb http://ftp.debian.org/debian/ buster-updates main\ndeb-src http://ftp.debian.org/debian/ buster-updates main\ndeb http://ftp.us.debian.org/debian/ buster main\n Enregistrez le fichier. Exécutez les commandes suivantes : mise à jour apt-get mise à niveau apt-get Mettez à jour les listes de certificats CA du serveur à l'aide de  apt-get install ca-certificates . Installez le paramètre local  en_US.utf8 locale  à l'aide des paramètres locaux  dpkg-reconfigure locales . Sélectionnez le paramètre local  en_US.UTF-8 UTF-8 , puis définissez-le comme paramètre local par défaut pour le système. Utilisez les touches de tabulation et la barre d'espace pour sélectionner et naviguer dans le menu. Vérifiez les paramètres locaux que vous avez générés à l'aide de  locale –a . Exemple d'impression C\nC.UTF-8\nen_IN\nen_IN.utf8\nen_US.utf8\nPOSIX Copiez l'empreinte du package OpenXPKI à l'aide de  nano /home/Release.key . Dans ce cas, copiez la clé dans  /home . Saisissez  55D89776 006F632B E0196E3E D2495509 BAFDDC74 22FEAAD2 F055074E 0FE3A724  comme valeur. Exécutez la commande suivante : gpg --print-md sha256 /home/Release.key Ajoutez le package à l'aide de la commande  wget https://packages.openxpki.org/v3/debian/Release.key -O - | apt-key add - . Ajoutez le référentiel à votre liste source (buster) à l'aide de  echo \" deb http://packages.openxpki.org/v3/debian/ buster release\" > /etc/apt/sources.list.d/openxpki.list , puis de  apt update . Installez la liaison MySQL et Perl MySQL à l'aide de  apt install mariadb-server libdbd-mariadb-perl . Installez apache2.2-common à l'aide de  apt install apache2 . Dans  nano /etc/apt/sources.list , installez le module fastcgi pour accélérer l'interface utilisateur. Nous vous recommandons d'utiliser  mod_fcgid . Ajoutez la ligne  deb http://http.us.debian.org/debian/ buster main  dans le fichier, puis enregistrez-la. Exécutez les commandes suivantes : mise à jour apt-get apt install libapache2-mod-fcgid Activez le module fastcgi à l'aide de  a2enmod fcgid . Installez le package principal OpenXPKI à l'aide de  apt install libopenxpki-perl openxpki-cgi-session-driver openxpki-i18n . Redémarrez le serveur  Apache  en utilisant le  service de redémarrage apache2 . Vérifiez si l'installation est réussie à l'aide de  openxpkiadm version . Si l'installation est réussie, le système affiche la version d'OpenXPKI installée. Par exemple,  Version (principale) : 3.18.2 . Créez la base de données vide, puis affectez l'utilisateur de la base de données à l'aide de  mariadb -u root -p . Cette commande doit être saisie dans le client. Sinon, vous ne pouvez pas saisir le mot de passe. Saisissez le mot de passe pour MySQL. Pour cette instance,  root  est l'utilisateur MySQL. MySQL  est l'utilisateur sur lequel OpenXPKI est installé. CREATE DATABASE openxpki CHARSET utf8; \nCREATE USER 'openxpki'@'localhost' IDENTIFIED BY 'openxpki';\nGRANT ALL ON openxpki.* TO 'openxpki'@'localhost';\nflush privileges; Si le service MySQL n'est pas en cours d'exécution, exécutez  /etc/init.d/mysql start  pour lancer le service. Saisissez  quit  pour quitter MySQL. Stockez les informations d'identification utilisées dans  /etc/openxpki/config.d/system/database.yaml . Exemple de contenu du fichier main:\ndebug: 0\ntype: MariaDB\nname: openxpki\nhost: localhost\nport: 3306\nuser: openxpki \npasswd: openxpki Modifiez les champs  user  et  passwd  pour qu'ils correspondent au nom d'utilisateur MariaDB et au mot de passe. Enregistrez le fichier. Pour un schéma de base de données vide, exécutez  zcat /usr/share/doc/libopenxpki-perl/examples/schema-mariadb.sql.gz | \\ mysql -u root --password --database openxpki  à partir du fichier de schéma fourni. Saisissez le mot de passe de la base de données. installation de l'autorité de certification OpenXPKI Certificat CA d'OpenXPKI installation"},{"UUID":"ade179fb-405f-4a7e-bc30-4d186d4cf2f4","title":"Configuration de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Configuration de l'autorité de certification","descFull":"Configuration de l'autorité de certification OpenXPKI à l'aide du script par défaut Le script par défaut configure uniquement le domaine par défaut,  ca-one . Les CDP et CRL ne sont pas configurés. Exécutez le script à l'aide de  bash /usr/share/doc/libopenxpki-perl/examples/sampleconfig.sh . Confirmez la configuration à l'aide de  openxpkiadm alias --realm democa . Exemple d'impression === functional token ===\nscep (scep):\nAlias    : scep-1\nIdentifier: YsBNZ7JYTbx89F_-Z4jn_RPFFWo\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nvault (datasafe):\nAlias    : vault-1\nIdentifier: lZILS1l6Km5aIGS6pA7P7azAJic\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2016-01-30 20:44:40\n\nca-signer (certsign):\nAlias    : ca-signer-1\nIdentifier: Sw_IY7AdoGUp28F_cFEdhbtI9pE\nNotBefore : 2015-01-30 20:44:40\nNotAfter  : 2018-01-29 20:44:40\n\n=== root ca ===\ncurrent root ca:\nAlias     : root-1\nIdentifier: fVrqJAlpotPaisOAsnxa9cglXCc\nNotBefore : 2015-01-30 20:44:39\nNotAfter  : 2020-01-30 20:44:39\n\nupcoming root ca:\n  not set Vérifiez si l'installation est réussie à l'aide de  openxpkictl start . Exemple d'impression Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Pour accéder au serveur OpenXPKI, procédez comme suit : Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Ajoutez le nom d'utilisateur et les mots de passe correspondants dans un fichier  userdb.yaml . Pour ajouter le nom d'utilisateur et le mot de passe, procédez comme suit : Extrayez vers  /home/pkiadm , puis vers  nano userdb.yaml . Collez les éléments suivants : estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator Dans ce cas, estRA fait référence au nom d'utilisateur. Pour générer le mot de passe, saisissez  openxpkiadm hashpwd . Lorsqu'un message demandant le mot de passe et un mot de passe chiffré ssha256 s'affiche, copiez-le et collez-le dans la synthèse de n'importe quel utilisateur. Les rôles disponibles dans la connexion opérateur sont opérateur RA, opérateur CA et utilisateur. Saisissez le nom d'utilisateur et le mot de passe. Créez une demande de certificat, puis testez-la. configuration de l'autorité de certification OpenXPKI à l'aide du script par défaut Certificat CA d'OpenXPKI configuration à l'aide du script par défaut"},{"UUID":"8aebee91-f977-4c61-9ab6-b25c385e70a6","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Aperçu Avant de commencer, assurez-vous","descFull":"Aperçu Avant de commencer, assurez-vous de disposer de connaissances de base sur la création de certificats OpenSSL. Pour configurer l'autorité de certification OpenXPKI manuellement, créez les éléments suivants : Certificat CA racine. Pour plus d'informations, reportez-vous à la section  . Certificat du signataire de l'autorité de certification, signé par l'autorité de certification racine. Pour plus d'informations, reportez-vous à la section  . Certificat du coffre de données, auto-signé. Pour plus d'informations, reportez-vous à la section  . Certificat Web, signé par le certificat du signataire. Pour plus d'informations, reportez-vous à la section  . Lorsque vous sélectionnez le hachage de signature, utilisez SHA256 ou SHA512. La modification de la taille de la clé publique est facultative. Pour la version 3.10 ou ultérieure, vous pouvez gérer les clés directement à l'aide de la commande d'alias openxpkiadm : Exécutez  mkdir -p /etc/openxpki/local/keys  pour créer le répertoire. L'emplacement par défaut du répertoire est  /etc/openxpki/local/keys . Exécutez  openxpkictl start  pour démarrer le serveur. Pour cette instance, nous utilisons le répertoire  /etc/certs/openxpki_democa/  pour la génération de certificats. Cependant, vous pouvez utiliser n'importe quel répertoire. configuration manuelle de l'autorité de certification OpenXPKI Certificat CA d'OpenXPKI configuration manuelle"},{"UUID":"7edb9aae-cffb-4de5-b7aa-1d4a6bd9cad7","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un fichier de configuration","descFull":"Création d'un fichier de configuration OpenSSL Le fichier de configuration OpenSSL contient des extensions X.509 pour la génération et la signature de demandes de certificat. Exécutez la commande suivante : nano /etc/certs/openxpki_democa/openssl.conf Si votre serveur est accessible à l'aide du nom de domaine complet (FQDN), utilisez le DNS du serveur au lieu de son adresse IP. Exemple de fichier # x509_extensions               = v3_ca_extensions\n# x509_extensions               = v3_issuing_extensions\n# x509_extensions               = v3_datavault_extensions\n# x509_extensions               = v3_scep_extensions\n# x509_extensions               = v3_web_extensions\n# x509_extensions               = v3_ca_reqexts # not for root self-signed, only for issuing\n## x509_extensions              = v3_datavault_reqexts # not required self-signed\n# x509_extensions               = v3_scep_reqexts\n# x509_extensions               = v3_web_reqexts\n\n[ req ]\ndefault_bits            = 4096\ndistinguished_name      = req_distinguished_name\n\n[ req_distinguished_name ]\ndomainComponent         = Domain Component\ncommonName              = Common Name\n\n[ v3_ca_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\n\n[ v3_datavault_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\n\n[ v3_scep_reqexts ]\nsubjectKeyIdentifier    = hash\n\n[ v3_web_reqexts ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\n\n[ v3_ca_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_issuing_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = digitalSignature, keyCertSign, cRLSign\nbasicConstraints        = critical,CA:TRUE\nauthorityKeyIdentifier  = keyid:always,issuer:always\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI.crl\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI.crt\n\n[ v3_datavault_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = keyEncipherment\nextendedKeyUsage        = emailProtection\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid:always,issuer\n\n[ v3_scep_extensions ]\nsubjectKeyIdentifier    = hash\nbasicConstraints        = CA:FALSE\nauthorityKeyIdentifier  = keyid,issuer\n\n[ v3_web_extensions ]\nsubjectKeyIdentifier    = hash\nkeyUsage                = critical, digitalSignature, keyEncipherment\nextendedKeyUsage        = serverAuth, clientAuth\nbasicConstraints        = critical,CA:FALSE\nsubjectAltName          = DNS:FQDN of est server\ncrlDistributionPoints   = URI:https://FQDN of your system/openxpki/CertEnroll/MYOPENXPKI_ISSUINGCA.cr\nauthorityInfoAccess     = caIssuers;URI:https://FQDN of your system/download/MYOPENXPKI_ISSUINGCA.crt\n Modifiez l'adresse IP et le nom du certificat CA avec vos informations de configuration. Enregistrez le fichier. fichier de configuration OpenSSL création"},{"UUID":"eb853347-db7d-4bf9-9362-96df6dc8a7c0","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un fichier de mots","descFull":"Création d'un fichier de mots de passe pour les clés de certificat Exécutez la commande suivante : nano /etc/certs/openxpki_democa/pd.pass Saisissez votre mot de passe. Enregistrez le fichier. fichiers de mots de passe pour les clés de certificat création clés de certificat création de fichiers de mots de passe"},{"UUID":"cf18aebe-e69a-46b5-84a9-0d440eaa1c69","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un certificat CA racine","descFull":"Création d'un certificat CA racine Vous pouvez créer un certificat CA racine auto-signé ou générer une demande de certificat, puis le faire signer par l'autorité de certification racine. Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. Exécutez la commande suivante : openssl genrsa -out /etc/certs/openxpki_democa/ca-root-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Remplacez le sujet de la demande par vos informations d'autorité de certificat à l'aide de  openssl req -new -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.csr . Obtenez le certificat signé par l'autorité de certification racine à l'aide de  openssl req -config /etc/certs/openxpki_democa/openssl.conf -extensions v3_ca_extensions - x509 -days 3560 -in /etc/certs/openxpki_democa/ca-root-1.csr -key /etc/certs/openxpki_democa/ca-root-1.key -out /etc/certs/openxpki_democa/ca-root-1.crt - sha256 . Accédez à  /etc/certs/openxpki_democa/  où  ca-root-1.crt  est enregistré. Exécutez la commande suivante : openxpkiadm certificate import --file ca-root-1.crt certificats d'autorité de certification création"},{"UUID":"f132f300-5fec-4977-87b0-007876730523","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un certificat de signataire","descFull":"Création d'un certificat de signataire Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. Exécutez la commande suivante : openssl genrsa -out /etc/certs/openxpki_democa/ca-signer-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Remplacez l'objet de la demande par vos informations d'autorité de certification en utilisant  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_ca_reqexts -new -key /etc/certs/openxpki_democa/ca-signer-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=MYOPENXPKI_ISSUINGCA -out / etc/certs/openxpki_democa/ca-signer-1.csr . Faites signer le certificat par l'autorité de certification racine à l'aide de  openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_issuing_extensions -days 3650 -in /etc/certs/openxpki_democa/ca-signer-1.csr -CA /etc/certs/openxpki_democa/ca-root-1.crt -CAkey /etc/certs/openxpki_democa/ca-root-1.key -CAcreateserial -out /etc/certs/openxpki_democa/ca-signer-1.crt -sha256 . Exécutez la commande suivante : openxpkiadm alias --realm democa --token certsign --file ca-signer-1.crt --key ca-signer-1.key certificats du signataire création"},{"UUID":"bb407839-4d05-4199-80c0-28a9a319b61e","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un certificat de coffre","descFull":"Création d'un certificat de coffre Le certificat du coffre est auto-signé. Remplacez la longueur de clé, l'algorithme de signature et le nom du certificat par les valeurs appropriées. Exécutez la commande suivante : openssl req -new -x509 -keyout vault.key -out vault.crt -days 1100 -config /etc/certs/openxpki_democa/openssl.conf Modifiez l'objet de la demande avec vos informations d'autorité de certification en utilisant  openxpkiadm certificate import --file vault.crt . Exécutez la commande suivante : openxpkiadm alias --realm democa --token datasafe --file vault.crt --key vault.key Indiquez les valeurs nécessaires, mais conservez  /CN=DataVault  comme objet. certificats de coffre création"},{"UUID":"a895a0ab-fa2d-4872-88f2-4e2441afe600","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Création d'un certificat Web Exécutez la","descFull":"Création d'un certificat Web Exécutez la commande suivante : openssl genrsa -out /etc/certs/openxpki_democa/web-1.key -passout file:/etc/certs/openxpki_democa/pd.pass 4096 Remplacez l'objet de la demande par vos informations d'autorité de certification en utilisant  openssl req -config /etc/certs/openxpki_democa/openssl.conf -reqexts v3_web_reqexts -new -key /etc/certs/openxpki_democa/web-1.key -subj /DC=COM/DC=LEXMARK/DC=DEV/DC=CA-ONE/CN=FQDN of your system -out /etc/certs/openxpki_democa/web-1.csr . Exécutez la commande suivante : openssl x509 -req -extfile /etc/certs/openxpki_democa/openssl.conf -extensions v3_web_extensions -days 900 -in /etc/certs/openxpki_democa/web-1.csr -CA /etc/certs/openxpki_democa/ca-signer-1.crt -CAkey /etc/certs/openxpki_democa/ca-signer-1.key -CAcreateserial -out /etc/certs/openxpki_democa/web-1.crt -sha256 certificat Web création"},{"UUID":"417ed221-485c-4992-aa99-e48a55c000b0","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Configuration du serveur Web Exécutez les","descFull":"Configuration du serveur Web Exécutez les commandes suivantes : a2enmod ssl rewrite headers a2ensite openxpki a2dissite 000-default default-ssl mkdir -m755 -p /etc/openxpki/tls/chain cp /etc/certs/openxpki_democa/ca-root-1.crt /etc/openxpki/tls/chain/ cp /etc/certs/openxpki_democa/ca-signer-1.crt /etc/openxpki/tls/chain/ c_rehash /etc/openxpki/tls/chain/ mkdir -m755 -p /etc/openxpki/tls/endentity mkdir -m700 -p /etc/openxpki/tls/private cp /etc/certs/openxpki_democa/web-1.crt /etc/openxpki/tls/endentity/openxpki.crt cat /etc/certs/openxpki_democa/ca-signer-1.crt >> /etc/openxpki/tls/endentity/openxpki.crt openssl rsa -in /etc/certs/openxpki_democa/web-1.key -passin file:/etc/certs/openxpki_democa/pd.pass -out /etc/openxpki/tls/private/openxpki.pem chmod 400 /etc/openxpki/tls/private/openxpki.pem Redémarrez le service Apache à l'aide de la commande  apache2 restart . Exécutez la commande suivante pour vérifier que l'importation des fichiers a bien fonctionné : openxpkiadm alias --realm democa Exemple d'impression === functional token ===\nca-signer (certsign):\n  \t\tAlias     : ca-signer-2\n  \t\tIdentifier: XjC6MPbsnyfLZkI9Poi9vm4Z5rk\n \t\t NotBefore : 2022-04-06 10:03:01\n  \t\tNotAfter  : 2032-04-03 10:03:01\n\nvault (datasafe):\n  \t\tAlias     : vault-2\n  \t\tIdentifier: G8ekluAsskGVC0N-jZhB2n9kvdM\n  \t\tNotBefore : 2022-04-06 09:53:57\n  \t\tNotAfter  : 2025-04-10 09:53:57\n\nscep (scep):\n  \t\tnot set\n\nratoken (cmcra):\n  \t\tnot set\n\n=== root ca ===\ncurrent root ca:\n  \t\tAlias     : root-2\n  \t\tIdentifier: prTHU5vCfcJuCnQWyb5wUknvXQM\n  \t\tNotBefore : 2022-04-06 09:40:27\n  \t\tNotAfter  : 2032-01-04 09:40:27\n configuration du serveur Web serveur Web configuration"},{"UUID":"d1c9a021-5ba2-4bc2-98d5-22d34872caec","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Mise à disposition du mot","descFull":"Mise à disposition du mot de passe de la clé de certificat pour OpenXPKI Modifiez la valeur dans le fichier  nano /etc/openxpki/config.d/system/crypto.yaml . Supprimez le commentaire du cache :  démon sous secret : par défaut  : secret:\n  default:\n    label: Global Secret group\n    export: 0\n    method: literal\n    value: root\n    cache: daemon mot de passe de la clé de certificat mise à la disposition d'openXPKI"},{"UUID":"f361547f-60ce-4551-ad9b-31884aecc77d","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Démarrage d'OpenXPKI Exécutez la commande","descFull":"Démarrage d'OpenXPKI Exécutez la commande  openxpkictl start . Exemple d'impression Starting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. Accédez au serveur OpenXPKI : Depuis un navigateur Web, saisissez  http://ipaddress/openxpki/ . Ajoutez les noms d'utilisateur et les mots de passe correspondants dans un fichier  userdb.yaml  : Extrayez vers  /home/pkiadm , puis vers  nano userdb.yaml . Collez les éléments suivants : estRA:  \n       digest:\"{ssha256}somePassword”\n       role: RA Operator Ici,  estRA  fait référence au nom d'utilisateur. Pour générer le mot de passe, saisissez  openxpkiadm hashpwd . Un message indiquant le mot de passe et un mot de passe chiffré ssha256 s'affiche. Copiez le mot de passe, puis collez-le dans la synthèse de n'importe quel utilisateur. La connexion opérateur dispose de deux rôles préconfigurés : opérateur RA, opérateur CA et utilisateur. Entrez le nom d'utilisateur et le mot de passe. Créez une demande de certificat, puis testez-la. OpenXPKI démarrage"},{"UUID":"42f1af4e-5f64-43e7-a1a9-e9ab09cfaad2","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Génération des informations CRL Si","descFull":"Génération des informations CRL Si votre serveur est accessible à l'aide du FQDN, utilisez le DNS du serveur au lieu de son adresse IP. Arrêtez le service OpenXPKI à l'aide de  openxpkictl stop . Dans  nano /etc/openxpki/config.d/realm/ca-one/publishing.yaml , mettez à jour les éléments suivants dans la section  connectors: cdp  : class: Connector::Builtin::File::Path\nLOCATION: /var/www/openxpki/CertEnroll/\nfile: \"[% ARGS.0 %].crl\"\ncontent: \"[% pem %]\" Dans  nano /etc/openxpki/config.d/realm/democa/profile/default.yaml , mettez à jour les éléments suivants : crl_distribution_points :  Section critical: 0\nuri:\n    - https://FQDN of the est/openxkpi/CenrtEnroll/[% ISSUER.CN.0 %].crl\n    - ldap://localhost/[% ISSUER.DN %]\n authority_info_access :  Section critical: 0\nca_issuers: http://FQDN of the est/download/MYOPENXPKI.crt\nocsp: http://ocsp.openxpki.org/ Modifiez l'adresse IP et le nom du certificat CA en fonction de votre serveur CA. Le chemin authority_info_access (AIA) est enregistré dans le dossier  Download , mais vous pouvez définir l'emplacement selon vos préférences. Dans  nano /etc/openxpki/config.d/realm/democa/crl/default.yaml , procédez comme suit : Si nécessaire, mettez à jour  nextupdate  et  renewal . Ajoutez  ca_issuers  à la section suivante : extensions:\n    \t\tauthority_info_access:\n        \t\t\tcritical: 0\n        \t\t\t# ca_issuers and ocsp can be scalar or list\n        \t\t\tca_issuers: https://FQDN of the est/download/MYOPENXPKI.crt\n       \t\t\t#ocsp: http://ocsp.openxpki.org/\n Modifiez l'adresse IP et le nom du certificat CA en fonction de votre serveur CA. Démarrez le service OpenXPKI à l'aide de  openxpkictl start . informations CRL génération"},{"UUID":"a5c0d791-04ea-47bd-9c28-ca165bc4f3b9","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Publication des informations CRL Après avoir","descFull":"Publication des informations CRL Après avoir créé les CRL, vous devez les publier pour qu'elles soient accessibles à tous. Arrêtez le service Apache à l'aide de  service apache2 stop . Créez un répertoire  CertEnroll  pour CRL dans le répertoire  /var/www/openxpki/ . Définissez  openxpki  comme propriétaire de ce répertoire, puis configurez les autorisations pour permettre à Apache de lire et d'exécuter, et aux autres services de lire uniquement. chown openxpki /var/www/openxpki/CertEnroll chmod 755 /var/www/openxpki/CertEnroll Ajoutez une référence au fichier de configuration alias.conf à l'aide de  nano /etc/apache2/mods-enabled/alias.conf . Après la section  <Directory \"/usr/share/apache2/icons\"> , ajoutez ce qui suit :         \tAlias /CertEnroll/ \"/var/www/openxpki/CertEnroll/\"\n         \t<Directory \"/var/www/openxpki/CertEnroll\">\n               Options FollowSymlinks\n               AllowOverride None\n               Require all granted\n         \t</Directory> Ajoutez une référence dans le fichier apache2.conf à l'aide de  nano /etc/apache2/apache2.conf . Ajoutez ce qui suit dans la section  Serveur HTTPD Apache2  :          \t<Directory /var/www/openxpki/CertEnroll>\n               Options FollowSymlinks\n               AllowOverride None\n               Allow from all\n         \t</Directory> Démarrez le service Apache à l'aide de  service apache2 start . informations CRL publication"},{"UUID":"834f1301-8aef-4adc-a764-8aa6ad20c5f0","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Activation de l'approbation automatique des","descFull":"Activation de l'approbation automatique des demandes de certificat dans l'autorité de certification OpenXPKI Arrêtez le service OpenXPKI à l'aide de  openxpkictl stop . Dans  /etc/openxpki/config.d/realm/democa/est/default.yaml , mettez à jour la section  eligible:   : Ancien contenu eligible:\n\t\t\tinitial:\n\t\t\t\tvalue@: connector:scep.generic.connector.initial\n       \t\targs: '[% context.cert_subject_parts.CN.0 %]'\n       \t\texpect:\n       \t\t\t- Build\n       \t\t\t- New Nouveau contenu eligible:\n\t\t\tinitial:\n\t\t\t\tvalue: 1\n\t\t\t\t# value@: connector:scep.generic.connector.initial\n\t\t\t\t# args: '[% context.cert_subject_parts.CN.0 %]'\n\t\t\t\t# expect:\n\t\t\t\t#\t- Build\n\t\t\t\t#\t- New Vérifiez l'espace et l'indentation dans le fichier de script. Pour approuver les certificats manuellement, commentez la ligne  valeur : 1 , puis supprimez les commentaires des autres lignes commentées précédemment. Enregistrez le fichier. Démarrez le service OpenXPKI à l'aide de  openxpkictl start . approbation automatique des demandes de certificat activation dans l'autorité de certification OpenXPKI demandes de certificat dans l'autorité de certification OpenXPKI approbation automatique"},{"UUID":"bc61b140-01ea-427d-a581-50b8af9cf978","title":"Configuration manuelle de l'autorité de certification OpenXPKI","link":"managing-certificates-using-EST-group.html","desc":"Modification des détails pour activer","descFull":"Modification des détails pour activer le téléchargement des certificats ca Exécutez la commande suivante : nano /usr/lib/cgi-bin/est.fcgi Remplacez  my $mime = \"application/pkcs7-mime; smime-type=certs-only\";  par  my $mime = \"application/pkcs7-mime\"; . Démarrez le service OpenXPKI à l'aide de  openxpkictl . téléchargement des certificats ca modification des détails à activer"},{"UUID":"05e740be-8945-4ee8-b607-f73b79352233","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Copie et définition du répertoire","descFull":"Copie et définition du répertoire Créez un répertoire, à savoir  democa2 , pour le deuxième domaine dans  /etc/openxpki/config.d/realm . Copiez l'exemple d'arborescence de répertoire  /etc/openxpki/config.d/realm/ca-one  dans un nouveau répertoire ( cp -r /etc/openxpki/config.d/realm.tpl/*/etc/openxpki/config.d/realm/democa2 ) au sein du répertoire du domaine. Dans  etc/openxpki/config.d/system/realms.yaml , mettez à jour la section suivante : Ancien contenu # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Verbose name of this realm\n    baseurl: https://pki.example.com/openxpki/\n\n#democa2:\n#    label: Verbose name of this realm\n#    baseurl: https://pki.acme.org/openxpki/ Nouveau contenu # This is the list of realms in this PKI\n# You only need to enable the realms which are visible on the server\n\ndemoca:\n    label: Example.org Demo CA\n    baseurl: https://pki.example.com/openxpki/\n\ndemoca2:\n    label: Example.org Demo CA2\n    baseurl: https://pki.example.com/openxpki/ Enregistrez le fichier. copie du répertoire définition du répertoire répertoire copie et paramétrage"},{"UUID":"8773ef3e-9eef-4c72-b2e2-739cc1a9d295","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Configuration du point de terminaison","descFull":"Configuration du point de terminaison EST pour plusieurs domaines Vous pouvez configurer le point de terminaison EST avec un tuple composé de la partie d'autorité de l'URI et du libellé facultatif (par exemple, www.example.com:80 et arbitraryLabel1). Dans les instructions suivantes, nous utilisons deux domaines PKI,  democa  et  democa2 . Copiez le fichier de configuration par défaut dans  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa.conf . Nommez le fichier  democa.conf . Dans  nano /etc/openxpki/est/democa.conf , définissez la valeur du domaine sur  realm=democa . En fonction de vos besoins, vous devrez peut-être annuler le commentaire des lignes correspondantes pour les sections  simpleenroll ,  simplereenroll ,  csrattrs  et  cacerts . Conservez les sections d'environnement dotées d'un commentaire. Procédez de la même manière pour  default.conf . Créez un autre fichier de configuration dans  cp /etc/openxpki/est/default.conf /etc/openxpki/est/democa2.conf . Nommez le fichier  democa2.conf . Dans  nano /etc/openxpki/est/democa2.conf , définissez la valeur du domaine sur  realm=democa2 . En fonction de vos besoins, vous devrez peut-être annuler le commentaire des lignes correspondantes pour les sections  simpleenroll ,  simplereenroll ,  csrattrs  et  cacerts . Conservez les sections d'environnement dotées d'un commentaire. Copiez le fichier  default.yaml  dans les emplacements suivants : cp /etc/openxpki/config.d/realm/democa/est/default.yaml /etc/openxpki/config.d/realm/democa/est/democa.yaml Nommez le fichier  democa.yaml . Copiez le fichier  default.yaml  dans les emplacements suivants : cp /etc/openxpki/config.d/realm/democa2/est/default.yaml /etc/openxpki/config.d/realm/democa2/est/democa2.yaml Nommez le fichier  democa2.yaml . Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . Sélectionnez les URL suivantes pour ouvrir le serveur EST correspondant à un domaine via un navigateur Web : democa — http://ipaddress/est/democa democa2 — http://ipaddress/est/democa2 Si vous souhaitez faire la différence entre les informations d'identification de connexion et les modèles de certificat par défaut pour différents domaines PKI, vous aurez peut-être besoin d'une configuration avancée. configuration des points de terminaison EST pour plusieurs domaines points de terminaison EST configuration pour plusieurs domaines"},{"UUID":"e747e72c-ab79-45f7-8574-12e10fef64c9","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Création d'un certificat de signataire","descFull":"Création d'un certificat de signataire Les instructions suivantes indiquent comment générer un certificat de signataire dans le deuxième domaine. Vous pouvez utiliser les mêmes certificats racine et de coffre-fort que ceux du premier domaine. Créez un fichier de configuration OpenSSL dans  nano /etc/certs/openxpki_democa2/openssl.conf . Modifiez le nom commun du certificat afin que l'utilisateur puisse facilement distinguer les différents certificats des différents domaines. Les fichiers de certificat sont créés dans le répertoire  /etc/certs/openxpki_democa2/ . Accédez au répertoire du certificat du coffre-fort dans le premier domaine, puis importez le certificat à partir du premier domaine. Exécutez le code suivant : openxpkiadm alias --realm democa2 --token datasafe --file vault.crt certificats création certificats du signataire création"},{"UUID":"1352d668-62a5-4ecb-8361-16a05ae42251","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Création d'un fichier de mots","descFull":"Création d'un fichier de mots de passe pour les clés de certificat Exécutez la commande suivante : nano /etc/certs/openxpki_democa2/pd.pass Saisissez votre mot de passe. Créez un certificat de signataire. Pour plus d'informations, reportez-vous à la section  . Vérifiez si l'importation est réussie avec  openxpkiadm alias --realm democa2 . Si vous avez modifié le mot de passe clé du certificat lors de la création du certificat, mettez à jour  nano /etc/openxpki/config.d/realm/democa2/crypto.yaml . Générez les CRL pour le deuxième domaine. Pour plus d'informations, reportez-vous à la section  . Veillez à utiliser le nom de certificat d'autorité de certification correct en fonction du domaine. Publier les CRL pour ce domaine. Pour plus d'informations, reportez-vous à la section  . Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . Exemple d'impression Stopping OpenXPKI\nStopping gracefully, 3 (sub)processes remaining...\nDONE.\nStarting OpenXPKI...\nOpenXPKI Server is running and accepting requests.\nDONE. création de fichiers de mots de passe pour les clés de certificat fichiers de mots de passe pour les clés de certificat création clés de certificat création de fichiers de mots de passe"},{"UUID":"ee5a8d48-6221-494b-a228-50228c567fe4","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Autorisation de la présence de","descFull":"Autorisation de la présence de plusieurs certificats actifs à la fois ayant le même sujet Par défaut, dans OpenXPKI, un seul certificat avec le même nom d'objet peut être actif à la fois. Cependant, lorsque vous appliquez plusieurs Certificats nommés, plusieurs certificats actifs portant le même nom d'objet doivent être présents à la fois. Dans  /etc/openxpki/config.d/realm/REALM NAME/est/< REALM NAME >.yaml , dans la section  policy , remplacez la valeur  1  de  max_active_certs  par  0 . REALM NAME est le nom du domaine. Par exemple,  ca‑one . Vérifiez l'espace et l'indentation dans le fichier de script. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . plusieurs certificats actifs ayant le même objet activation certificats ayant le même objet activation"},{"UUID":"e8a02816-5ef7-4bbb-91f2-c442a9e8b3f2","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Définition du numéro de port","descFull":"Définition du numéro de port par défaut pour l'autorité de certification OpenXPKI Par défaut, Apache écoute dans le numéro de port 443 pour https. Définissez le numéro de port par défaut de l'autorité de certification OpenXPKI pour éviter les conflits. Dans  /etc/apache2/ports.conf , remplacez le port 443 par n'importe quel autre port. Par exemple : Ancien contenu Listen 80\n\n<IfModule ssl_module>\n   Listen 443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 443\n</IfModule> Nouveau contenu Listen 80\n\n<IfModule ssl_module>\n   Listen 9443\n</IfModule>\n\n<IfModule mod_gnutls.c>\n  Listen 9443\n</IfModule> Dans  /etc/apache2/sites-available/openxpki.conf , ajoutez ou modifiez la section  VirtualHost  pour mapper un nouveau port. Par exemple,  <VirtualHost *:443>  to  <VirtualHost *:9443> . Dans  /etc/apache2/sites-available/default-ssl.conf , ajoutez ou modifiez la section  VirtualHost_default  pour mapper un nouveau port. Par exemple,  <VirtualHost *:443>  to  <VirtualHost *:9443> . Redémarrez le serveur Apache à l'aide de  systemctl restart apache2 . S'il vous demande la phrase de passe  SSL/TLS , saisissez le mot de passe lors de l'ajout du certificat du serveur Web TLS sur le serveur EST. Dans  tinddopenxpkiweb01.dhcp.dev.lexmark.com:9443 (RSA): , saisissez la phrase de passe des clés  SSL/TLS . Pour vérifier l'état, exécutez  netstat -tlpn| grep apache . L'URL SCEP OpenXPKI est désormais  https://ipaddress , et l'URL Web est  FQDN:9443/openxpki . numéros de port par défaut pour l'autorité de certification OpenXPKI modification numéro du port par défaut modification pour l'autorité de certification OpenXPKI Numéros de port par défaut de l'autorité de certification OpenXPKI modification"},{"UUID":"86405a5d-8736-43f3-ad14-6ef89d354dbe","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Activation de l'authentification de base","descFull":"Activation de l'authentification de base Exécutez la commande suivante : apt -y install apache2-utils Créez un compte utilisateur ayant accès au serveur. Entrez les informations suivantes : htpasswd -c /etc/apache2/.htpasswd <username>\n                New password:     \n                Re-type new password:\n                Adding password for user <username> Accédez au répertoire  cd /etc/apache2/sites-enabled/ . Dans  nano openxpki.conf , ajoutez les lignes suivantes dans  <VirtualHost *: 443 block> : #HTTPS BASIC AUTH FOR LABELS\nLocation /.well-known/est/*/simpleenroll\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location>\n    #HTTPS BASIC AUTH FOR NO LABEL\n    <Location /.well-known/est/simpleenroll>\n    AuthType Basic\n    AuthName \"estrealm\"\n    AuthUserFile /etc/apache2/.htpasswd\n    require valid-user\n    </Location> Ajoutez  ErrorDocument 401 %{unescape:%00}   avant  SSLEngine  dans le même bloc hôte virtuel. Exemple ServerAlias *\nDocumentRoot /var/www/\nErrorDocument 401 %{unescape:%00}\nSSLEngine On Redémarrez le service  apache2  à l'aide de  service apache2 restart . L'authentification de base fonctionne à l'aide du nom d'utilisateur et du mot de passe ci-dessus. activation de l'authentification de base authentification de base activation"},{"UUID":"431c2403-2660-4462-b796-02a1464dd83a","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Activation de l'authentification du certificat","descFull":"Activation de l'authentification du certificat client Accédez au répertoire suivant :  cd /etc/apache2/sites-enabled/ . Pour l'hôte requis dans  nano openxpki.conf , ajoutez  SSLVerifyClient require . Par exemple, si vous utilisez le port 443, modifiez la section  VirtualHost  par : <VirtualHost *:443>\nSSLVerifyClient require\n</VirtualHost> Supprimez la commande  SSLVerifyClient optional_no_ca . Enregistrez le fichier, puis saisissez  quit  pour quitter MySQL. Accédez au répertoire suivant :  cd /etc/openxpki/config.d/realm/democa/est . Ouvrez  default.yaml  et  democa.yaml . Si l'étiquette est différente, modifiez le fichier YAML. Exécutez la commande suivante : vi default.yaml Dans la section  authorized_signer , ajoutez les éléments suivants : authorized_signer:\nrule2:\n\t\t\tsubject: CN=,. Par exemple, si le nom du sujet de votre certificat client est  test123 , ajoutez les éléments suivants dans la section  authorized_signer  : authorized_signer:\nrule1:\n\t\t# Full DN\t\n\t\tsubject: CN=.+:pkiclient,.\nrule2:\t\n\t\tsubject: CN=test123,.* Enregistrez le fichier, puis saisissez  quit  pour quitter MySQL. Redémarrez le service OpenXPKI à l'aide de  openxpkictl restart . Démarrez le service Apache à l'aide de  service apache2 restart . authentification de base activation"},{"UUID":"6f4750e3-2217-44b5-915e-8249b7f696ef","title":"Création d'un deuxième domaine","link":"managing-certificates-using-EST-group.html","desc":"Quelles sont les causes de","descFull":"Quelles sont les causes de l'erreur de non-correspondance SAN qui empêche le système de récupérer la CRL ? L'erreur de non-correspondance SAN peut se produire lorsque vous activez les informations CRL. Cette erreur indique que l'adresse IP ou le nom d'hôte ne correspond pas à la valeur du SAN dans le certificat Web. Pour éviter cette erreur, utilisez le FQDN dans le chemin de la CRL au lieu de l'adresse IP. Vous pouvez également configurer le certificat Web et utiliser le FQDN de votre système dans le champ SAN. Pourquoi les jetons ca-signer-1 et vault-1 sont-ils hors ligne ? Si la page  Statut du système  indique que vos jetons ca-signer-1 et vault-1 sont hors ligne, procédez comme suit : Dans  /etc/openxpki/config.d/realm/realm name/crypto.yaml , modifiez la valeur de clé correspondante. Redémarrez le service OpenXPKI. questions fréquemment posées FAQ"},{"UUID":"8ee50a02-9503-418b-a6c4-b4dc0f40090a","title":"Gestion des alertes d'imprimante","link":"managing-printer-alerts-overview-topic.html","desc":"Aperçu Les alertes se déclenchent","descFull":"Aperçu Les alertes se déclenchent lorsqu'une imprimante nécessite une intervention. Les actions vous permettent d'envoyer des courriers électroniques personnalisés ou d'exécuter des scripts lorsqu'une alerte est déclenchée. Les événements définissent les actions qui s'exécutent lorsque des alertes spécifiques sont actives. Pour recevoir les alertes d'une imprimante, créez des actions, puis associez-les à un événement. Attribuez l'événement aux imprimantes que vous voulez surveiller. Cette fonction n'est pas applicable aux imprimantes sécurisées. gestion de la présentation des alertes d'imprimante aperçu gestion des alertes d'imprimante"},{"UUID":"31a70326-9d03-4e3a-8cf8-8df057b5a772","title":"Gestion des alertes d'imprimante","link":"creating-action-topic.html","desc":"Création d'une action Une action","descFull":"Création d'une action Une action est un courrier électronique de notification ou un journal d'affichage d'événements. Les actions attribuées à des événements sont déclenchées en cas d'alerte. Dans le menu  Imprimantes , cliquez sur  Evénements et actions Actions Créer . Saisissez un nom unique pour l'action, ainsi que sa description. Sélectionnez un type d'action. E‑mail Avant de commencer, vérifiez que les paramètres de courrier électronique sont configurés. Pour plus d'informations, reportez-vous à la section  . Dans le menu  Type , sélectionnez  E‑mail . Entrez les valeurs appropriées dans les champs. Vous pouvez également utiliser les espaces réservés disponibles pour l'ensemble ou une partie de l'objet du message ou pour une partie du corps du courrier électronique. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Créer une action . Evénement du journal Dans le menu  Type , sélectionnez  Evénement du journal . Saisissez les paramètres de l'événement. Vous pouvez également utiliser les espaces réservés disponibles dans le menu déroulant. Pour plus d'informations, reportez-vous à la section  . Cliquez sur  Créer une action . actions création création d'une action espaces réservés action de courrier électronique action Evénement du journal"},{"UUID":"3066ffe0-8748-40fb-8468-4784f23ecc9d","title":"Gestion des alertes d'imprimante","link":"understanding-action-placeholders-topic.html","desc":"Compréhension des espaces réservés d'action","descFull":"Compréhension des espaces réservés d'action Utilisez les espaces réservés disponibles dans l'objet ou le corps du courrier électronique. Les espaces réservés représentent des éléments variables qui sont remplacés par des valeurs réelles lorsqu'ils sont utilisés. ${eventHandler.timestamp}  : date et heure de traitement de l'événement par MVE. Par exemple,  14 mars 2017 1 :42:24 . ${eventHandler.name}  : nom de l'événement. ${configurationItem.name}  : nom du système de l'imprimante ayant déclenché l'alerte. ${configurationItem.address}  : adresse MAC de l'imprimante ayant déclenché l'alerte. ${configurationItem.ipAddress}  : adresse IP de l'imprimante ayant déclenché l'alerte. ${configurationItem.ipHostname}  : nom d'hôte de l'imprimante ayant déclenché l'alerte. ${configurationItem.model}  : nom du modèle de l'imprimante ayant déclenché l'alerte. ${configurationItem.serialNumber}  : numéro de série de l'imprimante ayant déclenché l'alerte. ${configurationItem.propertyTag}  : identifiant de l'imprimante ayant déclenché l'alerte. ${configurationItem.contactName}  : nom du contact de l'imprimante ayant déclenché l'alerte. ${configurationItem.contactLocation}  : emplacement du contact de l'imprimante ayant déclenché l'alerte. ${configurationItem.manufacturer}  : fabricant de l'imprimante ayant déclenché l'alerte. ${alert.name}  : nom de l'alerte déclenchée. ${alert.state}  : état de l'alerte. Elle peut être active ou effacée. ${alert.location}  : emplacement au sein de l'imprimante qui a déclenché l'alerte. ${alert.type}  : gravité de l'alerte déclenchée, par exemple  Avertissement  ou  Intervention requise . compréhension des espaces réservés d'action espaces réservés d'action présentation action espaces réservés"},{"UUID":"fb535e48-032e-4f65-af7f-d97c3911feaf","title":"Gestion des alertes d'imprimante","link":"managing-actions-topic.html","desc":"Gestion des actions Dans le","descFull":"Gestion des actions Dans le menu Imprimantes, cliquez sur  Evénements et actions Actions . Effectuez l'une des opérations suivantes : Modifier une action Sélectionnez une action, puis cliquez sur  Modifier . Configurez les paramètres. Cliquez sur  Enregistrer les modifications . Supprimer des actions Sélectionnez une ou plusieurs actions. Cliquez sur  Supprimer , puis confirmez la suppression. Tester une action Sélectionnez une action, puis cliquez sur  Tester . Pour vérifier les résultats du test, consultez les journaux des tâches. Pour plus d'informations, reportez-vous à la section  . Si vous testez une action E-mail, vérifiez si le courrier électronique a été envoyé au destinataire. gestion des actions actions gestion actions modification actions suppression actions test modification d'actions suppression d'actions test d'actions"},{"UUID":"91a4983f-8741-4a21-a04d-bdef64448eee","title":"Gestion des alertes d'imprimante","link":"creating-event-topic.html","desc":"Création d'un événement Vous pouvez","descFull":"Création d'un événement Vous pouvez contrôler les alertes dans votre parc d'impression. Créez un événement, puis définissez une action à exécuter lorsque certaines alertes sont déclenchées. Les événements ne sont pas pris en charge sur les imprimantes sécurisées. Dans le menu Imprimantes, cliquez sur  Evénements et actions Evénements Créer . Saisissez un nom unique pour l'événement, ainsi que sa description. Sélectionnez une ou plusieurs alertes dans la section Alertes. Pour plus d'informations, reportez-vous à la section  . Dans la section Actions, sélectionnez une ou plusieurs actions à exécuter lorsque les alertes sélectionnées sont actives. Pour plus d'informations, reportez-vous à la section  . Activez le système pour exécuter les actions sélectionnées lorsque les alertes sont effacées de l'imprimante. Définissez un délai de grâce avant d'exécuter les actions sélectionnées. si l'alerte est effacée au cours du délai de grâce, l'action n'est pas exécutée. Cliquez sur  Créer un événement . création d'un événement événement création"},{"UUID":"af00b41a-2b7b-4e82-af87-ac82c7c96d07","title":"Gestion des alertes d'imprimante","link":"understanding-printer-alerts-topic.html","desc":"Présentation des alertes d'imprimante Les","descFull":"Présentation des alertes d'imprimante Les alertes se déclenchent lorsqu'une imprimante nécessite une intervention. Les alertes suivantes peuvent être associées à un événement dans MVE : Bourrage papier dans le dispositif d'alimentation automatique de documents (DAA)  : du papier est coincé dans le DAA et doit être retiré manuellement. Bourrage à la sortie du scanner DAA Bourrage dans le chargeur du scanner DAA Bourrage du convertisseur du scanner DAA Elimination du bourrage du scanner DAA Papier manquant dans le scanner DAA Bourrage lors du pré-repérage du scanner DAA Bourrage lors du repérage du scanner DAA Alerte scanner - Replacer tous les originaux pour relancer le travail Porte ou capot ouvert  : une porte de l'imprimante est ouverte et doit être fermée. Vérifier la porte/le capot - Boîte à lettres Porte ouverte Alerte de capot Capot fermé Capot ouvert Capot ouvert ou cartouche manquante Volet recto verso ouvert Capot du scanner DDA ouvert Capot d'accès aux bourrages du scanner ouvert Format ou type de support incorrect  : un travail est en cours d'impression et nécessite le chargement d'un certain type ou format de papier dans un bac. Format d'enveloppe incorrect Alimentation manuelle incorrecte Support incorrect Format de support incorrect Charger le support Mémoire saturée ou erreur  : la mémoire de l'imprimante est faible, des modifications doivent être appliquées. Page complexe Les fichiers seront supprimés. Mémoire assemblage insuffisante Mémoire défragmentation insuffisante Mémoire télécopie insuffisante Mémoire insuffisante Mémoire insuffisante - Certains travaux suspendus pourraient être perdus Mémoire insuffisante pour économiser les ressources Mémoire saturée Mémoire PS insuffisante Pages trop nombreuses -Numérisation annulée Réduction de la résolution Dysfonctionnement d'une option  : l'état d'une option de l'imprimante indique une erreur. Les options englobent les options d'entrée, les options de sortie, les cartes de police, les cartes flash utilisateur, les disques durs et les unités de finition. Vérifier l'alignement/la connexion Vérifier la connexion recto verso Vérifier l'installation de l'unité de finition/la boîte à lettres Vérifier l'alimentation Option corrompue Option défectueuse Débranchez le périphérique Alerte recto/verso Tiroir recto verso manquant Perte de l'adaptateur de réseau externe Alerte de l'unité de finition Volet de l'unité de finition ouvert/système de blocage ouvert Plaque à papier de l'unité de finition ouverte Périphérique recto verso incompatible Périphérique d'entrée incompatible Périphérique de sortie incompatible Périphérique inconnu incompatible Installation d'option incorrecte Alerte d'entrée Erreur de configuration entrée Option Alerte Réceptacle plein Niveau maximum du réceptacle bientôt atteint Erreur de configuration de sortie Option Plein Option Manquant Mécanisme d'alimentation papier manquant Imprimer les travaux sous conditions Rebranchez le périphérique Rebranchez le périphérique de sortie Trop de périphériques d'entrée installés Trop d'options installées Trop de périphériques de sortie installés Tiroir manquant Tiroir manquant pendant la mise sous tension Erreur de détection du tiroir Entrée non étalonnée Option non formatée Option non prise en charge Rebranchez le périphérique d'entrée Bourrage papier  : du papier est coincé dans l'imprimante et doit être retiré manuellement. Bourrage papier interne Alerte bourrage Bourrage papier Erreur de scanner  : le scanner a rencontré un problème. Câble débranché à l’arrière du scanner. Transport du scanner verrouillé Nettoyer la vitre du scanner à plat/la bande de support Scanner désactivé Scanner à plat ouvert Câble débranché à l’avant du scanner Repérage du scanner non valide Erreur de fournitures  : une fourniture de l'imprimante indique une erreur. Fourniture anormale Erreur de zone cartouche Fourniture défectueuse Unité de fusion ou rouleau antiadhérent manquant(e) Cartouche de gauche non valide ou manquante Cartouche de droite non valide ou manquante Fourniture non valide Echec de l'initialisation Alerte alimentation Bourrage fournitures Fourniture manquante Poignée d'éjection de la cartouche de toner tirée Cartouche de toner mal installée Fourniture non étalonnée Fourniture sans licence Fourniture non prise en charge Fournitures ou consommable vides  : une fourniture de l'imprimante doit être remplacée. Entrée vide Durée de vie épuisée Imprimante prête pour maintenance Maintenance prévue Bourrage de la fourniture Fourniture pleine Fourniture pleine ou manquante L'alerte envoyée par l'imprimante est de type erreur et avertissement. Si l'une de ces alertes est déclenchée, son action associée s'effectue deux fois. Fournitures ou consommable faible  : le niveau d'une fourniture de l'imprimante est faible. 1er avertissement Niveau premier bas Niveau de l'entrée bas Fin durée vie Presque vide Presque bas Niveau de fourniture bas Fourniture presque pleine Alerte ou condition non catégorisée Echec de l'étalonnage des couleurs Erreur de transmission de données Echec CRC moteur Alerte externe Perte de la connexion au télécopieur Ventilateur en panne Hex actif Insérez la page recto verso et cliquez sur Reprise Alerte interne L'adaptateur de réseau interne doit être révisé Alerte de l'unité logique Hors ligne Hors ligne pour le message d'avertissement Echec de l'opération Alerte d'intervention de l'opérateur Erreur page Alerte du port Echec de la communication avec le port Port désactivé Economie énergie Mise hors tension Délai exécution PS Délai manuel PS Configuration requise Erreur de somme de contrôle SIMM Etalonnage de la fourniture Echec du sondage du toner Cause d'alerte inconnue Configuration inconnue Cause d'alerte du scanner inconnue Utilisateurs bloqués Avertissement présentation des alertes d'imprimante alertes de l'imprimante présentation"},{"UUID":"8c37214e-38a1-4d07-8316-1142c25a0d01","title":"Gestion des alertes d'imprimante","link":"managing-events-topic.html","desc":"Gestion des événements Dans le","descFull":"Gestion des événements Dans le menu Imprimantes, cliquez sur  Evénements et actions Evénements . Effectuez l'une des opérations suivantes : Modifier un événement Sélectionnez un événement, puis cliquez  Modifier . Configurez les paramètres. Cliquez sur  Enregistrer les modifications . Supprimer les événements Sélectionnez un ou plusieurs événements. Cliquez sur  Supprimer , puis confirmez la suppression. gestion des événements événements gestion événements modification événements suppression"},{"UUID":"021c52ee-264d-4be5-a256-28fc499e5f96","title":"Affichage de l'état et de l'historique d'une tâche","link":"viewing-task-status-history-overview-topic.html","desc":"Aperçu Une tâche est une","descFull":"Aperçu Une tâche est une activité de gestion d'imprimante effectuée dans MVE, par exemple la détection d'imprimante, un audit ou la mise en œuvre de configurations. La page  Etat  indique l'état de toutes les tâches en cours et des tâches exécutées au cours des dernières 72 heures. Les informations relatives aux tâches en cours sont consignées dans le journal. Les tâches de plus de 72 heures peuvent uniquement être consultées sur la page  Journal  sous forme d'entrées de journal individuelles. Il est possible de les rechercher au moyen de leurs ID de tâche. affichage de l'aperçu de l'état et de l'historique d'une tâche aperçu affichage de l'état et de l'historique d'une tâche"},{"UUID":"5d5de2a3-d981-484d-93d0-7e449452cc6c","title":"Affichage de l'état et de l'historique d'une tâche","link":"viewing-task-status-topic.html","desc":"Affichage de l'état de la","descFull":"Affichage de l'état de la tâche Cliquez sur  Etat  dans le menu Tâches. l'état de la tâche est mis à jour en temps réel. affichage de l'état de la tâche état de la tâche affichage"},{"UUID":"807977eb-d139-4407-96d2-5c02eae4c10b","title":"Affichage de l'état et de l'historique d'une tâche","link":"stopping-tasks-topic.html","desc":"Arrêt des tâches Cliquez sur","descFull":"Arrêt des tâches Cliquez sur  Etat  dans le menu Tâches. Dans la section Tâches en cours, sélectionnez une ou plusieurs tâches. Cliquez sur  Arrêter . arrêt des tâches tâches arrêt"},{"UUID":"60def18f-d328-4079-96bf-3425c64a28cf","title":"Affichage de l'état et de l'historique d'une tâche","link":"viewing-logs-topic.html","desc":"Affichage des journaux Cliquez sur","descFull":"Affichage des journaux Cliquez sur  Journaux  dans le menu Tâches. Sélectionnez des catégories de tâches, des types de tâche ou une période. Utilisez le champ de recherche pour rechercher plusieurs ID de tâche. Utilisez des virgules pour séparer plusieurs ID de tâche ou un tiret pour indiquer une plage. Par exemple :  11, 23, 30-35 . Pour exporter les résultats de recherche, cliquez sur  Exporter au format CSV . affichage des journaux journaux affichage"},{"UUID":"f78f1bdc-58e1-47c8-9f78-7bec29ee511d","title":"Affichage de l'état et de l'historique d'une tâche","link":"clearing-logs-topic.html","desc":"Effacement des journaux Cliquez sur","descFull":"Effacement des journaux Cliquez sur  Journaux  dans le menu Tâches. Cliquez sur  Effacer le journal , puis sélectionnez une date. Cliquez sur  Effacer le journal . effacement des journaux journaux effacement"},{"UUID":"bfffe8d1-de76-46c6-9cff-08da17e5060f","title":"Affichage de l'état et de l'historique d'une tâche","link":"exporting-logs-topic.html","desc":"Exporter les journaux Dans le","descFull":"Exporter les journaux Dans le menu  Tâches,  cliquez sur  Journal . Sélectionnez des catégories de tâches, des types de tâche ou une période. Cliquez sur  Exporter vers CSV . exportation de journaux journaux exportation"},{"UUID":"2b47ebbc-8115-4d11-8c7f-14dc3422d2b1","title":"Planification de tâches","link":"creating-schedule-topic.html","desc":"Création d'une programmation Dans le","descFull":"Création d'une programmation Dans le menu  Tâches , cliquez sur  Planifier Créer . Dans la section  Général , saisissez un nom unique pour les tâches planifiées ainsi que leurs descriptions. Dans la section  Tâches , effectuez l'une des actions suivantes : Programmer un audit Sélectionnez  Audit . Sélectionnez une recherche enregistrée. Programmer un contrôle de conformité Sélectionnez  Conformité . Sélectionnez une recherche enregistrée. Programmer une vérification d'état de l'imprimante Sélectionnez  Etat actuel . Sélectionnez une recherche enregistrée. Sélectionnez une action. Programmer un déploiement de configuration Sélectionnez  Déployer un fichier . Sélectionnez une recherche enregistrée. Accédez au fichier, puis sélectionnez son type. Si nécessaire, sélectionnez une méthode ou un protocole de déploiement. Programmer une recherche Sélectionnez  Détection . Sélectionnez un profil de recherche. Programmer la mise en œuvre d'une configuration Sélectionnez  Mise en œuvre . Sélectionnez une recherche enregistrée. Planifier une validation de certificat Sélectionnez  Valider le certificat . Pendant la validation, MVE communique avec le serveur CA pour télécharger la chaîne de certificats et la liste de révocation de certificats (CRL). Le certificat de l'agent d'inscription est également généré. Ce certificat permet au serveur CA d'approuver MVE. Programmer l'exportation d'un affichage Sélectionnez  Exportation d'un affichage . Sélectionnez une recherche enregistrée. Sélectionnez un modèle d'affichage. Saisissez la liste des adresses e-mail auxquelles les fichiers exportés sont envoyés. Dans la section  Planifier , réglez la date, l'heure et la fréquence de la tâche. Cliquez sur  Créer une tâche planifiée . création d'une programmation programmation création"},{"UUID":"7553d634-e264-445e-99b7-a9b11056c4d6","title":"Planification de tâches","link":"managing-schedules-topic.html","desc":"Gestion des tâches planifiées Dans","descFull":"Gestion des tâches planifiées Dans le menu  Tâches,  cliquez sur  Planifier . Effectuez l'une des opérations suivantes : Modifier une tâche planifiée Sélectionnez une tâche, puis cliquez sur  Modifier . Configurez les paramètres. Cliquez sur  Modifier la tâche planifiée . Les informations de la dernière exécution sont retirées lorsqu'une tâche planifiée est modifiée. Supprimer une tâche planifiée Sélectionnez une tâche, puis cliquez sur  Supprimer . Cliquez sur  Supprimer la tâche planifiée . gestion des programmations programmations gestion modification de programmations suppression de programmations programmations modification programmations suppression"},{"UUID":"3c26c673-b44c-47c3-a168-bfbc4c6488ea","title":"Autres tâches administratives","link":"configuring-system-settings-topic.html","desc":"Configuration des paramètres généraux Dans","descFull":"Configuration des paramètres généraux Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Général , puis sélectionnez une source de nom d'hôte. Imprimante  : le système utilise le nom d'hôte de l'imprimante. Recherche DNS inverse  : le système récupère le nom d'hôte dans la table DNS à l'aide de l'adresse IP. Définissez la fréquence d'interrogation des alertes. Il est possible que les imprimantes perdent l'état d'interrogation d'alertes en cas de modifications (par exemple, redémarrage ou mise à jour du micrologiciel). MVE tente de récupérer l'état automatiquement lors du prochain intervalle défini dans la fréquence d'interrogation. Configurez les paramètres du journal système suivants : Heure de début du nettoyage du journal système  : heure à laquelle le nettoyage des journaux système ou des journaux des tâches démarre. Période de conservation du journal système (semaines)  : nombre de semaines pendant lesquelles les journaux système sont stockés dans la base de données. Les entrées stockées dans la base de données depuis plus de 52 semaines sont supprimées. Archive du journal système  : permet au système d'archiver les journaux système et les entrées codées sur le système de fichiers. La destination et le format des fichiers d'archive sont définis dans le fichier log4j2.xml. Cliquez sur  Enregistrer les modifications . configuration des paramètres généraux paramètres généraux configuration"},{"UUID":"238ddb75-69a2-4b73-ab80-3c616064a271","title":"Autres tâches administratives","link":"configuring-email-settings-topic.html","desc":"Configuration des paramètres de courrier","descFull":"Configuration des paramètres de courrier électronique Activez la configuration SMTP de sorte que MVE puisse envoyer des fichiers d'exportation de données et des notifications d'événements par courrier électronique. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  E-mail , puis sélectionnez  Activer la configuration SMTP de l'e-mail . Saisissez le serveur de messagerie SMTP et le port. Sélectionnez le chiffrement approprié. Pour le chiffrement SSL, sélectionnez le port 465. Pour le chiffrement TLS/STARTTLS, sélectionnez le port 587. Saisissez l'adresse électronique de l'expéditeur. Si un utilisateur doit se connecter pour pouvoir envoyer un courrier électronique, sélectionnez  Connexion requise  et saisissez les informations d'authentification de l'utilisateur. Cliquez sur  Enregistrer les modifications . configuration des paramètres de courrier électronique paramètres de courrier électronique configuration"},{"UUID":"b93468ba-fd63-4437-a3c1-c32f9a4ee318","title":"Autres tâches administratives","link":"adding-login-disclaimer-topic.html","desc":"Ajout d'un avertissement de connexion","descFull":"Ajout d'un avertissement de connexion Il est possible de configurer un avertissement de connexion qui s'affiche lorsque les utilisateurs se connectent en ouvrant une nouvelle session. Les utilisateurs doivent accepter l'avertissement avant de pouvoir accéder à MVE. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Avertissement , puis sélectionnez  Activer l'avertissement de connexion . Saisissez le texte de l'avertissement. Cliquez sur  Enregistrer les modifications . ajout d'un avertissement de connexion avertissement de connexion ajout"},{"UUID":"4de860a9-897b-4f03-aec4-c510ee9dfd36","title":"Autres tâches administratives","link":"signing-mve-certificate-topic.html","desc":"Signature du certificat MVE Le protocole SSL","descFull":"Signature du certificat MVE Le protocole SSL (Secure Socket Layer) ou TLS (Transport Layer Security) est un protocole de sécurité utilisant le chiffrement des données et l'authentification par certificat pour protéger la communication entre le serveur et le client. Dans MVE, TLS est utilisé pour protéger les informations sensibles partagées entre le serveur MVE et le navigateur Web. Les informations protégées peuvent être des mots de passe d'imprimante, des stratégies de sécurité, des informations d'identification d'utilisateur MVE ou des informations d'authentification d'imprimante, comme LDAP ou Kerberos. TLS permet au serveur MVE et au navigateur Web de chiffrer ces données avant de les envoyer et de les déchiffrer une fois reçues. SSL permet également au serveur de présenter un certificat au navigateur Web qui prouve que le serveur est bien celui qu'il prétend être. Ce certificat est auto-signé ou bien signé par le biais d'une autorité de certification tierce approuvée. Par défaut, MVE est configuré pour utiliser un certificat auto-signé. Télécharger la demande de signature de certificat d'imprimante. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  TLS Télécharger . Sélectionnez  Demande de signature du certificat . La demande de signature du certificat inclut d'autres noms du sujet (SAN). Utilisez une autorité de certification approuvée pour signer la demande de signature du certificat. Installer le certificat signé par une autorité de certification. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  TLS Installer le certificat signé . Téléchargez le certificat signé par une autorité de certification, puis cliquez sur  Installer le certificat . Cliquez sur  Redémarrer le service MVE . Le redémarrage du service MVE relance le système, ce qui peut rendre le serveur indisponible pendant quelques minutes. Avant de redémarrer le service, assurez-vous qu'aucune tâche n'est en cours. signature du certificat MVE certificat MVE signature"},{"UUID":"8fbeda25-2da5-4e16-ab2d-a567253f515f","title":"Autres tâches administratives","link":"removing-user-information-topic.html","desc":"Suppression des références et des","descFull":"Suppression des références et des informations utilisateur MVE est conforme aux règles de protection des données du Règlement général sur la protection des données. MVE peut être configuré pour appliquer le droit à l'oubli et supprimer les informations utilisateur privées du système. Suppression d'utilisateurs Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Utilisateur , puis sélectionnez un ou plusieurs utilisateurs. Cliquez sur  Supprimer Supprimer des utilisateurs . Suppression des références utilisateur dans LDAP Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  LDAP . Supprimez les informations relatives à l'utilisateur dans les filtres de recherche et les paramètres de liaison. Suppression des références utilisateur dans le serveur de messagerie Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Courrier électronique . Supprimez les informations relatives à l'utilisateur, comme les informations d'identification d'utilisateur utilisées pour l'authentification avec le serveur de messagerie. Suppression des références utilisateur dans les journaux des tâches Pour plus d'informations, reportez-vous à la section  . Suppression des références utilisateur dans une configuration Dans le menu  Configurations , cliquez sur  Toutes les configurations . Cliquez sur le nom de la configuration. Dans l'onglet  Base , supprimez toutes les valeurs associées à l'utilisateur des paramètres de l'imprimante, comme le nom du contact et l'emplacement du contact. Suppression des références utilisateur dans un composant de sécurité avancée Dans le menu  Configurations , cliquez sur  Tous les composants de sécurité avancée . Cliquez sur le nom du composant. Dans la section  Paramètres de sécurité avancée , supprimez toutes les valeurs associées à l'utilisateur. Suppression des références utilisateur dans les recherches enregistrées Dans le menu  Imprimantes , cliquez sur  Recherches enregistrées . Cliquez sur une recherche enregistrée. Supprimez toutes les règles de recherche utilisant les valeurs liées à l'utilisateur, comme le nom et l'emplacement du contact. Suppression des références utilisateur dans les mots clés Dans le menu  Imprimantes , cliquez sur  Listes des imprimantes . Supprimez l'attribution de mots clés liés à l'utilisateur dans les imprimantes. Dans le menu  Imprimantes , cliquez sur  Mots clés . Supprimez tous les mots clés utilisant des informations relatives à l'utilisateur. Suppression des références utilisateur dans les événements et les actions Dans le menu  Imprimantes , cliquez sur  Evénements et actions . Supprimez toutes les actions contenant des références de courrier électronique d'utilisateurs. suppression des références et des informations utilisateur informations utilisateur suppression"},{"UUID":"c5ce7313-e24f-48db-a00c-82475bc0805b","title":"Gestion de la fonction SSO","link":"mve-configuration-workflow-adfs-overview-topic.html","desc":"Aperçu Active Directory Federation Services","descFull":"Aperçu Active Directory Federation Services (ADFS) est une solution d'accès aux identités qui fournit aux ordinateurs clients un accès par connexion unique (SSO, Single Sign-On) aux applications ou services protégés. Les utilisateurs peuvent accéder à ces applications ou services même lorsque leurs comptes et applications se trouvent dans des réseaux ou des organisations complètement différents. La solution ADFS s'appuie sur l'authentification SAML (Security Assertion Markup Language) et l'autorisation CBAC (Claims-based Access Control) pour assurer la sécurité des applications qui utilisent l'identité fédérée. Vous devez établir une communication chiffrée entre les serveurs MVE et ADFS. Pour ce faire, l'ADFS doit faire confiance au serveur MVE. La solution ADFS contient également des groupes d'utilisateurs du serveur Active Directory (AD) qui doivent correspondre aux rôles d'utilisateur MVE requis. Lorsque vous configurez le serveur ADFS, les informations suivantes sont requises dans l'application MVE : Identifiants d'approbation des parties de confiance — https://mve-host/mve/saml Point de terminaison ou URL de service SAML 2.0 SSO de la partie de confiance — https://mve-host/mve/adfs/saml Dans les URL, la valeur  mve-host  est l'adresse IP ou le FQDN du serveur MVE. Flux de travail de la configuration MVE pour ADFS présentation"},{"UUID":"f0bc2b03-bf81-4747-a030-c1dd86d684d4","title":"Gestion de la fonction SSO","link":"setting-claim-issuance-policy-grouprule-topic.html","desc":"Définition de la stratégie d'émission","descFull":"Définition de la stratégie d'émission de revendications pour GroupRule Dans la fenêtre  AD FS , cliquez sur  Approbations des parties de confiance , puis cliquez avec le bouton droit de la souris sur l'approbation de partie de confiance applicable. Cliquez sur  Modifier la stratégie d'émission de revendications , puis sur  Ajouter une règle . Dans la liste  Modèle de règle de revendication , sélectionnez  Envoyer les attributs LDAP en tant que revendications . Dans le champ  Nom de règle de revendication , saisissez  GroupRule . Dans la liste  Magasin d'attributs , sélectionnez  Active Directory . Définissez l' Attribut LDAP  sur  Groupes de jetons - Noms non qualifiés , puis définissez le  Type de revendication sortante  sur  MVEGroup . Cliquez sur  Terminer . définition de la stratégie d'émission de revendications GroupRule stratégie d'émission de revendications pour GroupRule configuration"},{"UUID":"ca9b7186-e57f-4ecc-b89d-35f07e2d2193","title":"Gestion de la fonction SSO","link":"setting-claim-issuance-policy-name-id-topic.html","desc":"Définition de la stratégie d'émission","descFull":"Définition de la stratégie d'émission de revendications pour l'ID de nom Dans la fenêtre  AD FS , cliquez sur  Approbations des parties de confiance , puis cliquez avec le bouton droit de la souris sur l'approbation de partie de confiance applicable. Cliquez sur  Modifier la stratégie d'émission de revendications , puis sur  Ajouter une règle . Dans la liste  Modèle de règle de revendication , sélectionnez  Envoyer les attributs LDAP en tant que revendications . Dans le champ  Nom de règle de revendication , saisissez l' ID de nom . Dans la liste  Magasin d'attributs , sélectionnez  Active Directory . Définissez l' Attribut LDAP  sur  SAM-Nom-Compte , puis le  Type de réclamation sortante  sur l' ID de nom . Cliquez sur  Terminer . définition de la stratégie d'émission de revendications ID de nom stratégie d'émission de revendications pour l'ID de nom configuration"},{"UUID":"ec0e1ada-2c62-4d5d-a0a1-0837b4c1357f","title":"Gestion de la fonction SSO","link":"enabling-adfs-server-authentication-topic.html","desc":"Activation de l'authentification de serveur ADFS","descFull":"Activation de l'authentification de serveur ADFS Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  ADFS , puis sélectionnez  Activer l'authentification ADFS . Dans le champ  URL SSO (obligatoire) , saisissez l'URL SSO publiée par le serveur ADFS en tant que Fournisseur d'identité. Dans la section  Mappage de groupes ADFS aux rôles MVE , saisissez les noms des groupes ADFS correspondant aux rôles MVE. Cliquez sur  Enregistrer les modifications . serveur ADFS activer l'authentification activation de l'authentification de serveur ADFS"},{"UUID":"e89dfa65-5726-4517-96c7-0bff561d54f7","title":"Gestion de la fonction SSO","link":"accessing-mve-adfs-topic.html","desc":"Accès à MVE par le","descFull":"Accès à MVE par le biais de l'ADFS Lorsque vous activez l'ADFS, la page de connexion ADFS s'ouvre automatiquement quand vous accédez à MVE. Vous devez vous authentifier sur la page ADFS avant d'être redirigé vers la page d'accueil MVE. Ouvrez un navigateur Web et saisissez  https:// SERVEUR_MVE /mve/ , où  SERVEUR_MVE  est le nom d'hôte ou l'adresse IP du serveur hébergeant MVE. Lorsque la page de connexion ADFS s'ouvre, saisissez vos informations d'identification ADFS, puis cliquez sur  Connexion . Si les utilisateurs rencontrent des problèmes lors de l'accès à MVE via ADFS, les administrateurs peuvent se connecter à MVE à l'aide de leurs informations d'identification localhost et résoudre le problème. Si ADFS n'est pas configuré sur le serveur MVE, les utilisateurs localhost et non localhost seront dirigés vers la page de connexion MVE par défaut. Dans ce cas, ils doivent se connecter à MVE à l'aide des comptes configurés sur le serveur MVE. MVE par le biais de l'ADFS ADSF"},{"UUID":"fe085cf2-9307-477d-87a6-03299c457fc4","title":"Gestion de la fonction SSO","link":"logging-out-mve-adfs-topic.html","desc":"Déconnexion de MVE Si vous","descFull":"Déconnexion de MVE Si vous avez utilisé la fonction ADFS pour accéder à MVE, aucun bouton  Déconnexion  n'apparaît sur la page d'accueil MVE. La session MVE se termine uniquement si vous fermez la page MVE ou si la session MVE est inactive pendant plus de 30 minutes. Si vous essayez d'accéder à l'URL MVE après 30 minutes d'inactivité, vous êtes redirigé vers la page de connexion ADFS. Si vous avez utilisé vos informations d'identification MVE pour accéder à MVE, le bouton  Déconnexion  apparaît toujours sur la page d'accueil MVE. déconnexion de MVE par le biais de l'ADFS"},{"UUID":"bba9f7ef-1acb-4b25-af37-b56d1abd1be1","title":"Questions fréquemment posées","link":"faq-chapter.html","desc":"FAQ Markvision Enterprise Je ne","descFull":"FAQ Markvision Enterprise Je ne peux pas sélectionner plusieurs imprimantes dans la liste des modèles pris en charge lorsque je crée une configuration. Pourquoi ? Les paramètres de configuration et les commandes varient selon les modèles d'imprimantes. Mes recherches enregistrées sont-elles accessibles par d'autres utilisateurs ? Oui. Tous les utilisateurs peuvent accéder aux recherches enregistrées. Où puis-je trouver les fichiers journaux ? Vous trouverez les fichiers journaux d'installation dans le répertoire caché du MVE d'installation de l'utilisateur. Par exemple,  C:\\Users\\Administrator\\AppData\\Local\\Temp\\mveLexmark-install.log . Les fichiers journaux d'application  *.log  se trouvent dans le dossier  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\logs , où  installation_dir  est le dossier d'installation de MVE. Quelle est la différence entre la résolution DNS inverse et du nom de l'hôte ? Le nom de l'hôte est un nom unique attribué à une imprimante d'un réseau. Chaque nom d'hôte correspond à une adresse IP. La résolution DNS inverse permet de déterminer le nom de l'hôte et le nom de domaine désigné d'une adresse IP déterminée. Où trouver la résolution DNS inverse dans MVE ? Vous pouvez trouver la résolution DNS inverse dans les paramètres généraux. Pour plus d'informations, reportez-vous à la section  . Comment puis-je ajouter manuellement des règles au pare-feu Windows ? Exécutez l'invite de commande en tant qu'administrateur, puis saisissez les commandes suivantes : firewall add allowedprogram \" installation_dir /Lexmark/Markvision Enterprise/tomcat/bin/tomcat9.exe\" \"Markvision Enterprise Tomcat\" firewall add portopening UDP 9187 \"Markvision Enterprise NPA UDP\" firewall add portopening UDP 6100 \"Markvision Enterprise LST UDP\" Où  installation_dir  représente le dossier d'installation de MVE. Comment puis-je configurer MVE pour utiliser un port différent du port 443 ? Arrêtez le service Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Arrêter . Ouvrez le fichier  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Où  installation_dir  représente le dossier d'installation de MVE. Remplacez la valeur  Port du connecteur  par un autre port inutilisé. <Connector port=\"443\" protocol=\"org.apache.coyote.http11.Http11NioProtocol\" \nsslImplementationName=\"org.apache.tomcat.util.net.jsse.JSSEImplementation\" \nSSLEnabled=\"true\" scheme=\"https\" secure=\"true\" clientAuth=\"false\" \ncompression=\"on\" compressableMimeType=\"text/html,text/xml,text/plain,text/css,\ntext/javascript,application/javascript,application/json\" maxThreads=\"150\" \nmaxHttpHeaderSize=\"16384\" minSpareThreads=\"25\" enableLookups=\"false\" \nacceptCount=\"100\" connectionTimeout=\"120000\" disableUploadTimeout=\"true\" \nURIEncoding=\"UTF-8\" server=\"Apache\" sslEnabledProtocols=\"TLSv1,TLSv1.1,TLSv1.2\" \nsslProtocol=\"TLS\" keystoreFile=\"C:/Program Files/Lexmark/Markvision Enterprise/\n../mve_truststore.p12\" keystorePass=\"markvision\" keyAlias=\"mve\" keyPass=\"markvision\" \nkeystoreType=\"PKCS12\" ciphers=\"TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256,\nTLS_ECDHE_RSA_WITH_AES_128_CBC_SHA,TLS_RSA_WITH_AES_128_CBC_SHA256,\nTLS_RSA_WITH_AES_128_CBC_SHA\"/> Remplacez la valeur  redirectPort  par le même numéro de port que celui utilisé en tant que port du connecteur. <Connector port=\"9788\" maxHttpHeaderSize=\"16384\" maxThreads=\"150\" minSpareThreads=\"25\" \nenableLookups=\"false\" redirectPort=\"443\" acceptCount=\"100\" connectionTimeout=\"120000\" \ndisableUploadTimeout=\"true\" compression=\"on\" compressableMimeType=\"text/html,text/xml,\ntext/plain,text/css,text/javascript,application/javascript,application/json\" \nURIEncoding=\"UTF-8\" server=\"Apache\"/> Redémarrez le service Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Redémarrer . Accédez à MVE à l'aide du nouveau port. Par exemple, ouvrez un navigateur, puis saisissez  https:// MVE_SERVER : port /mve . Où  MVE_SERVER  est le nom de l'hôte ou l'adresse IP du serveur hébergeant MVE, et où  port  est le numéro du port de connecteur. Comment puis-je personnaliser les chiffrements et les versions TLS utilisés par MVE ? Arrêtez le service Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Arrêter . Ouvrez le fichier  installation_dir \\Lexmark\\Markvision Enterprise\\tomcat\\conf\\server.xml . Où  installation_dir  représente le dossier d'installation de MVE. Configurez les chiffrements et les versions TLS. Pour plus d'informations sur la configuration, consultez les  instructions de configuration SSL/TLS Apache Tomcat . Pour plus d'informations sur les protocoles et valeurs de chiffrement, consultez la  Documentation d'informations sur l'assistance SSL Apache Tomcat . Redémarrez le service Markvision Enterprise. Ouvrez la boîte de dialogue  Exécuter , puis saisissez  services.msc . Cliquez avec le bouton droit de la souris sur  Markvision Enterprise , puis cliquez sur  Redémarrer . Comment gérer les fichiers CRL lors de l'utilisation du CA d'entreprise Microsoft ? Récupérez le fichier CRL sur le serveur CA. Pour le CA d'entreprise Microsoft, le fichier CRL n'est pas automatiquement téléchargé via SCEP. Pour plus d'informations, reportez-vous au  Guide de configuration de l'autorité de certification Microsoft . Enregistrez le fichier CRL dans le dossier  installation_dir \\Lexmark\\Markvision Enterprise\\apps\\library\\crl , où  installation_dir  est le dossier d'installation de MVE. Configurez l'autorité de certification dans MVE. Ce processus est applicable uniquement lorsque le protocole SCEP est utilisé. modèles pris en charge configuration résolution DNS inverse résolution du nom de l'hôte recherche inversée fichiers journaux recherche fichiers de journal d'application recherche fichiers journaux d'installation recherche recherches enregistrées accès pare-feu Windows ajout de règles chiffrement AES256 configuration ports configuration chiffrements personnalisation versions TLS personnalisation CA d'entreprise Microsoft configuration"},{"UUID":"16fda69d-d6c0-48b8-9ed6-d7754b03a500","title":"Dépannage","link":"trb-forgotten-password-mve-topic.html","desc":"L'utilisateur a oublié son mot","descFull":"L'utilisateur a oublié son mot de passe Réinitialisez le mot de passe utilisateur Vous devez disposer des droits administratifs pour réinitialiser le mot de passe. Dans le coin supérieur droit de la page, cliquez sur  . Cliquez sur  Utilisateur , puis sélectionnez un utilisateur. Cliquez sur  Modifier , puis modifiez le mot de passe. Cliquez sur  Enregistrer les modifications . Si vous avez oublié votre mot de passe, effectuez l'une des opérations suivantes : Contactez un autre utilisateur Admin pour réinitialiser votre mot de passe. Contactez le Centre d'assistance client de Lexmark. l'utilisateur a oublié son mot de passe dépannage l'utilisateur a oublié son mot de passe mot de passe réinitialisation"},{"UUID":"79fc6752-444e-4f6f-9af5-8d5841916d39","title":"Dépannage","link":"trb-admin-forgotten-password-mve-topic.html","desc":"L'utilisateur administrateur a oublié son","descFull":"L'utilisateur administrateur a oublié son mot de passe Créer un autre utilisateur administrateur, puis supprimer l'ancien compte Vous pouvez utiliser l'utilitaire de mot de passe Markvision Enterprise pour créer un autre utilisateur administrateur. Accédez au dossier dans lequel Markvision Enterprise est installé. Par exemple,  C:\\Program Files\\ Lancez le fichier  mvepwdutility-windows.exe  dans le répertoire Lexmark\\Markvision Enterprise\\. Sélectionnez une langue, puis cliquez sur  OK Suivant . Sélectionnez  Ajouter un compte d'utilisateur Suivant . Saisissez les informations d'identification d'utilisateur. Cliquez sur  Suivant . Accédez à MVE, puis supprimez l'utilisateur administrateur précédent. Pour plus d'informations, reportez-vous à la section  . l'utilisateur administrateur a oublié son mot de passe dépannage l'utilisateur administrateur a oublié son mot de passe"},{"UUID":"2f7464d5-6a4c-4ee0-88f9-c663c86dc4ab","title":"Dépannage","link":"trb-page-loading-infinitely-topic.html","desc":"La page ne charge pas","descFull":"La page ne charge pas Ce problème peut survenir si vous avez fermé le navigateur Web sans vous déconnecter. Essayez l'une ou plusieurs des solutions suivantes : Effacez le cache et supprimez les cookies de votre navigateur Web Accédez à la page de connexion MVE, puis connectez-vous à l'aide de vos informations d'identification Ouvrez un navigateur Web et saisissez  https:// MVE_SERVER /mve/login , où  MVE_SERVER  est le nom d'hôte ou l'adresse IP du serveur hébergeant MVE. la page charge de manière continue dépannage la page charge de manière continue"},{"UUID":"0725e1fb-3907-419b-ae1c-5119a1c5682a","title":"Dépannage","link":"trb-cannot-discover-network-device-topic.html","desc":"Impossible de détecter une imprimante","descFull":"Impossible de détecter une imprimante réseau Essayez les solutions suivantes : Assurez-vous que l'imprimante est allumée. Vérifiez que le cordon d'alimentation est solidement branché sur l'imprimante et sur une prise de courant correctement mise à la terre. Vérifiez que l'imprimante est connectée au réseau. Redémarrez l'imprimante Assurez-vous que le protocole TCP/IP est activé sur l'imprimante Assurez-vous que les ports utilisés par MVE sont ouverts et que SNMP et mDNS sont activés Pour plus d'informations, reportez-vous à la section  . Contactez votre représentant Lexmark dépannage impossible de détecter une imprimante réseau impossible de détecter une imprimante réseau"},{"UUID":"ce430049-da1e-4bc3-ba27-f1d47bfc8887","title":"Dépannage","link":"trb-incorrect-device-information-topic.html","desc":"Informations d'imprimante incorrectes Effectuez un","descFull":"Informations d'imprimante incorrectes Effectuez un audit Pour plus d'informations, reportez-vous à la section  . informations d'imprimante incorrectes dépannage informations d'imprimante incorrectes"},{"UUID":"c49cd0ba-8c83-4047-bbda-32151411cbce","title":"Dépannage","link":"trb-mve-does-not-recognize-secured-printer-topic.html","desc":"MVE ne reconnaît pas une","descFull":"MVE ne reconnaît pas une imprimante comme imprimante sécurisée Vérifier que l'imprimante est sécurisée Assurez-vous que mDNS est activé et n'est pas bloqué Supprimez l'imprimante, puis relancez la détection d'imprimante Pour plus d'informations, reportez-vous à la section  . MVE ne reconnaît pas une imprimante comme imprimante sécurisée dépannage MVE ne reconnaît pas une imprimante comme imprimante sécurisée"},{"UUID":"13bb8a00-6bbd-4129-8315-230a23a8fe9c","title":"Dépannage","link":"trb-config-enforcement-fails-topic.html","desc":"L'application de configurations avec plusieurs","descFull":"L'application de configurations avec plusieurs applications échoue à la première tentative, mais réussit lors des tentatives suivantes Prolonger les délais Accédez au dossier dans lequel Markvision Enterprise est installé. Par exemple,  C:\\Program Files\\ Accédez au dossier Lexmark\\Markvision Enterprise\\apps\\dm-mve\\WEB-INF\\classes. A l'aide d'un éditeur de texte, ouvrez le fichier  platform.properties . Modifiez la valeur  cdcl.ws.readTimeout . La valeur est en millisecondes. Par exemple, 90 000 millisecondes équivalent à 90 secondes. A l'aide d'un éditeur de texte, ouvrez le fichier  devCom.properties . Modifiez les valeurs  lst.responseTimeoutsRetries . La valeur est en millisecondes. Par exemple, 10 000 millisecondes équivalent à 10 secondes. Par exemple,  lst.responseTimeoutsRetries=10000 15000 20000 . La première tentative de connexion s'exécute au bout de 10 secondes, la deuxième tentative de connexion après 15 secondes et la troisième tentative au bout de 20 secondes. Le cas échéant, lorsque vous utilisez le protocole LDAP GSSAPI, créez un fichier  parameters.properties . Ajoutez le paramètre suivant :  lst.negotiation.timeout=400 La valeur est exprimée en secondes. Enregistrez les modifications. l'application de configurations avec plusieurs applications échoue à la première tentative, mais réussit lors des tentatives suivantes dépannage l'application de configurations avec plusieurs applications échoue à la première tentative, mais réussit lors des tentatives suivantes"},{"UUID":"4fd07cf2-05a0-43be-bfdc-9de4ef34f288","title":"Dépannage","link":"trb-enforcement-printer-cert-fails-topic.html","desc":"Echec de l'application des configurations","descFull":"Echec de l'application des configurations avec un certificat d'imprimante Parfois, aucun nouveau certificat n'est émis pendant l'application. Augmentez le nombre de nouvelles tentatives d'inscription Ajoutez la clé suivante au fichier  platform.properties  : enrol.maxEnrolmentRetry=10 Le nombre tentative doit être supérieur à cinq. échec de l'application des configurations avec un certificat d'imprimante dépannage échec de l'application des configurations avec un certificat d'imprimante"},{"UUID":"0fbad2da-6816-41e8-affa-d452c774e0eb","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Echec de l'émission du certificat","descFull":"Echec de l'émission du certificat à l'aide du serveur CA OpenXPKI Assurez-vous que la clé « signataire pour le compte » dans MVE correspond à la clé de signataire autorisée dans le serveur CA Par exemple : Si la clé  ca.onBehalf.cn  est la suivante dans le fichier  platform.properties  de MVE, ca.onBehalf.cn=Markvision_SQA-2012-23AB.lrdc.lexmark.ds la clé  authorized_signer  doit figurer dans le fichier  generic.yaml  du serveur CA. rule1:\n\t\t\t# Full DN\n\t\t\t\t\tSubject: CN=Markvision_SQA-2012-23AB.lrdc.lexmark.ds Pour plus d'informations sur la configuration du serveur CA OpenXPKI, reportez-vous au  Guide de configuration de l'autorité de certification OpenXPKI . échec de l'émission du certificat à l'aide du serveur CA OpenXPKI dépannage échec de l'émission du certificat à l'aide du serveur CA OpenXPKI"},{"UUID":"77f7fc68-714d-4604-9056-de816b573987","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Une erreur de serveur interne","descFull":"Une erreur de serveur interne s'est produite Installez le paramètre local en_US.utf8 Exécutez la commande  dpkg-reconfigure locales . Installez les paramètres locaux  en_US.utf8  (locale -a | grep en_US). dépannage erreur de serveur interne erreur de serveur interne"},{"UUID":"838f8158-66d3-4566-a4a5-3fb3539c7d05","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"L'invite de connexion n'apparaît pas","descFull":"L'invite de connexion n'apparaît pas Lors de l'accès à  http://yourhost/openxpki/ , vous obtenez uniquement la bannière Open Source Trustcenter, sans invite de connexion. Activez  fcgid Exécutez les commandes suivantes : a2enmod fcgid service apache2 restart dépannage l'invite de connexion n'apparaît pas l'invite de connexion n'apparaît pas"},{"UUID":"131ccf57-2a37-4201-928c-0ab9bffc7840","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Un connecteur imbriqué sans erreur","descFull":"Un connecteur imbriqué sans erreur de classe se produit Une  EXCEPTION : Une erreur de connecteur imbriqué sans classe (scep.scep-server-1.connector.initial)  s'affiche à la ligne 201 /usr/share/perl5/Connector/Multi.pm. Mettez à jour  scep.scep-server-1 Dans  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , remplacez  scep.scep-server-1  par  scep.generic . Remplacez  REALM  par le nom de votre domaine. Par exemple, lorsque vous utilisez le domaine par défaut, utilisez  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial dépannage connecteur imbriqué sans erreur de classe connecteur imbriqué sans erreur de classe"},{"UUID":"51c22e47-7104-4da4-b5b9-313a73778173","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Impossible d'approuver manuellement les certificats","descFull":"Impossible d'approuver manuellement les certificats Le bouton  Approbation manuelle  n'apparaît pas lors de l'approbation manuelle des certificats. Mettez à jour  scep.scep-server-1 Dans  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , remplacez  scep.scep-server-1  par  scep.generic . Remplacez  REALM  par le nom de votre domaine. Par exemple, lorsque vous utilisez le domaine par défaut, utilisez  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial dépannage impossible d'approuver manuellement les certificats impossible d'approuver manuellement les certificats"},{"UUID":"8f2cd778-667f-4bd5-a055-205a00820887","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Une erreur Perl se produit","descFull":"Une erreur Perl se produit lors de l'approbation des demandes d'inscription Mettez à jour  scep.scep-server-1 Dans  /etc/openxpki/config.d/realm/REALM/scep/generic.yaml , remplacez  scep.scep-server-1  par  scep.generic . Remplacez  REALM  par le nom de votre domaine. Par exemple, lorsque vous utilisez le domaine par défaut, utilisez  ca-one . eligible:\n \tinitial:\n\t\t\tvalue@: connector:scep.generic.connector.initial dépannage erreur Perl erreur Perl"},{"UUID":"a36c8ff9-4cd3-4d16-8923-01dfca887815","title":"Autorité de certification OpenXPKI","link":"trb-openxpki-ca-group.html","desc":"Les jetons  ca-signer-1 ","descFull":"Les jetons  ca-signer-1  et  vault-1  sont hors ligne La page  Etat du système  indique que les jetons  ca-signer-1  et  vault-1  sont hors ligne. Essayez les solutions suivantes : Modifiez le mot de passe de la clé de certificat Dans  /etc/openxpki/config.d/realm/ca-one/crypto.yaml , modifiez le mot de passe de la clé de certificat. Créez les liens symboliques corrects et copiez le fichier de clés Pour plus d'informations, reportez-vous à la section  . Assurez-vous que le fichier de clés est lisible par OpenXPKI dépannage ca-signer-1 est hors ligne dépannage vault-1 est hors ligne ca-signer-1 est hors ligne dépannage vault-1 est hors ligne dépannage"},{"UUID":"8309c98a-70de-4bb5-8efb-0c06adcc953d","title":"Accès aux bases de données","link":"differences-supported-databases-data-types-topic.html","desc":"Différences entre les types de","descFull":"Différences entre les types de données des bases de données prises en charge MVE prend en charge Firebird et Microsoft SQL Server. La table suivante présente les types de données Firebird utilisés dans MVE et leurs types de données correspondants dans Microsoft SQL Server. Types de données Firebird Types de données Microsoft SQL Server * Ce type de données est requis pour Microsoft SQL Server. BIGINT Bigint VARCHAR(x) varchar(x) TIMESTAMP Date/heure INTEGER entier SMALLINT/ TINYINT * Bit BLOB SUB_TYPE 0 varbinary(1024) différences entre les types de données des bases de données prises en charge types de données des bases de données prises en charge différences"},{"UUID":"172e9e4d-a4fc-4016-abf2-6391229f0752","title":"Imprimante","link":"config-item-topic.html","desc":"CONFIG_ITEM La table CONFIG_ITEM présente","descFull":"CONFIG_ITEM La table CONFIG_ITEM présente les éléments de configuration ITIL (CI) de l'imprimante. Elle indique l'état des éléments de configuration et l'horodatage de sa création, de sa gestion initiale, de sa dernière détection et d'autres actions. La table ne présente aucune partie physique d'une imprimante ; il s'agit simplement d'une présentation abstraite du périphérique. CONFIG_ITEM Nom du champ Type de données Description CI_ID BIGINT Clé principale. CI_STATE VARCHAR(255) Etat actuel des éléments de configuration. Vous pouvez choisir parmi les options suivantes : NEW, MANAGED, MISSING, FOUND, CHANGED, UNMANAGED et RETIRED. CREATION_DATE TIMESTAMP Date à laquelle l'élément de configuration est entré dans le système pour la première fois. INITIAL_MANAGEMENT_DATE TIMESTAMP Date à laquelle l'élément de configuration est entré en état ou sous-état Géré pour la première fois. LAST_AUDIT_DATE TIMESTAMP Date de la dernière tentative d'audit sur l'élément de configuration (qu'elle ait réussi ou non). PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. LAST_DISCOVERY_DATE TIMESTAMP Date de la dernière tentative de détection sur un élément de configuration (qu'elle ait réussi ou non). LAST_SUCCESSFUL_AUDIT_DATE TIMESTAMP Date du dernier audit réussi de l'élément de configuration. LAST_SUCCESSFUL_DISCOVERY_ DATE TIMESTAMP Date de la dernière détection réussie de l'élément de configuration. DEFAULT_CERT_COMMON_NAME VARCHAR(255) Nom du certificat par défaut. DEFAULT_CERT_ISSUER_NAME VARCHAR(255) Nom de l'émetteur du certificat. DEFAULT_CERT_SIGNING_STATUS VARCHAR(255) Etat de signature du certificat de l'imprimante. Vous pouvez choisir parmi les options suivantes : SIGNED, INVALID_CERT, NO_CA et UNKNOWN. DEFAULT_CERT_VALID_FROM TIMESTAMP Date de début de validité du certificat. DEFAULT_CERT_VALID_TO TIMESTAMP Date de fin de validité du certificat. DEFAULT_CERTIFICATE VARCHAR(8190) Certificat par défaut. DEFAULT_CERT_SERIAL_NUMBER VARCHAR(255) Numéro de série du certificat par défaut. CONFIG_ITEM"},{"UUID":"e872e0a2-05dd-4815-b9c0-a976d1e3d9df","title":"Imprimante","link":"config-item-topic.html","desc":"NETWORK_ADAPTER Cette table représente l'adaptateur","descFull":"NETWORK_ADAPTER Cette table représente l'adaptateur réseau (également appelé serveur d'impression) d'une imprimante physique. NETWORK_ADAPTER Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ADAPTER_TYPE VARCHAR(31) Toujours INA (adaptateur réseau interne). ADAPTER_ID BIGINT Clé principale. FIRMWARE_REVISION VARCHAR(255) Version du microcode réseau actuel. MANUFACTURER VARCHAR(255) N/A. MODEL_NAME VARCHAR(255) N/A. SERIAL_NUMBER VARCHAR(50) N/A. SYSTEM_NAME VARCHAR(255) N/A. RETRIES INTEGER Nombre de tentatives de communication avec une imprimante. SNMP_READ_COMMUNITY_NAME VARCHAR(255) Nom de communauté SNMP pour la lecture. TIMEOUT BIGINT Temps d'attente en millisecondes avant qu'une tentative de communication particulière avec une imprimante aboutisse. CONTACT_LOCATION VARCHAR(255) N/A. CONTACT_NAME VARCHAR(255) N/A. DOMAIN_NAME_SUFFIX VARCHAR(191) Suffixe du nom de domaine associé à cet adaptateur réseau (par exemple, foo.lexmark.com). Associez-le au HOSTNAME pour obtenir le nom de domaine complet (FQDN). HOSTNAME VARCHAR(63) Nom d'hôte associé à cet adaptateur réseau. MVE peut être configuré de manière à récupérer le nom d'hôte dans la table DNS ou par le biais de l'adaptateur réseau lui-même. Associez-le au DOMAIN_NAME_SUFFIX pour obtenir le nom de domaine complet (FQDN). IP_ADDRESS VARCHAR(15) Représentation sous forme d'entier de l'adresse IP de cet adaptateur réseau. Obsolète. IP_ADDRESS_INT INTEGER Représentation sous forme d'entier de l'adresse IP de cet adaptateur réseau. IP_ADDRESS_SUBNET INTEGER Représentation sous forme d'entier du sous-réseau sur lequel se trouve cet adaptateur réseau. MAC_CANONICAL VARCHAR(12) Adresse MAC de l'adaptateur réseau, au format canonique. PORTS INTEGER Nombre de ports pris en charge par l'adaptateur réseau. Toujours 1. RAND_MAC SMALLINT/ TINYINT * Indicateur qui détermine si la valeur actuelle de MAC_CANONICAL a été créée de manière aléatoire. CREDENTIAL_REQUIRED SMALLINT/ TINYINT * Indicateur qui détermine si des informations d'identification sont nécessaires pour communiquer avec l'imprimante associée. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 Cette valeur est chiffrée et ne peut pas être utilisée en dehors de MVE. CREDENTIAL_PIN BLOB SUB_TYPE 0 Cette valeur est chiffrée et ne peut pas être utilisée en dehors de MVE. CREDENTIAL_REALM VARCHAR(64) Domaine d'informations d'identification, s'il est défini. CREDENTIAL_USERNAME VARCHAR(255) Nom d'utilisateur des informations d'identification, s'il est défini. PORT_CONFIG_LST_TCP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_LST_UDP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_MDNS_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_NPA_TCP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_NPA_UDP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_RAW_PRINT_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_SNMP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_XML_TCP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. PORT_CONFIG_XML_UDP_OPEN SMALLINT/ TINYINT * Indicateur qui détermine si ce port de l'imprimante associée est ouvert. SECURE_COMMUNICATION_STATE VARCHAR(255) Etat de la communication. Vous pouvez choisir parmi les options suivantes : UNSECURED, MISSING_CREDENTIALS et SECURED. USER_PASSWORD Sous-type BLOB 0 Partie du nom d'utilisateur des informations d'identification. SNMP_USERNAME VARCHAR(32) Nom d'utilisateur utilisé pour les communications SNMPv3. SNMP_PASSWORD VARCHAR(255) Cette valeur est chiffrée et ne peut pas être utilisée en dehors de MVE. SNMP_MIN_AUTHENTICATION_LEVEL Varchar(50) Niveau d'authentification minimal utilisé pour les communications SNMPv3. SNMP_AUTHENTICATION_HASH VARCHAR(50) Authentification par hachage utilisée pour les communications SNMPv3. SNMP_PRIVACY_ALGORITHM VARCHAR(50) Algorithme de confidentialité utilisé pour les communications SNMPv3. LOGIN_METHOD VARCHAR(256) Méthodes d'authentification utilisée pour la connexion à l'imprimante. LOGIN_METHOD_NAME VARCHAR(256) Si la valeur LOGIN_METHOD est LDAP ou LDAP + GSSAPI, ce champ affiche le nom de la méthode d'authentification. TRACING_SERIAL_NUMBER VARCHAR(64) Méthode d'authentification utilisée pour suivre le numéro de série. NETWORK_ADAPTER"},{"UUID":"91483a00-0d0d-4d29-b7cf-c59180845f01","title":"Imprimante","link":"config-item-topic.html","desc":"NETWORK_PRINTER Cette table présente la","descFull":"NETWORK_PRINTER Cette table présente la portion imprimante réelle de l'imprimante physique. NETWORK_PRINTER Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. PRINTER_ID BIGINT Clé principale. MANUFACTURER VARCHAR(255) L'entreprise qui a fabriqué l'imprimante. Peut différer de DISPLAY_MANUFACTURER. MODEL_NAME VARCHAR(255) Nom du modèle de l’imprimante. SERIAL_NUMBER VARCHAR(50) Numéro de série de cette imprimante. SYSTEM_NAME VARCHAR(255) Nom utilisé pour identifier le périphérique. COPY (COPIE) SMALLINT/ TINYINT * Indicateur qui détermine si l'imprimante prend en charge la copie. DUPLEX SMALLINT/ TINYINT * Indicateur qui détermine si l'imprimante prend en charge l'impression recto verso. ESF SMALLINT/ TINYINT * Indicateur qui détermine si l'imprimante prend en charge les applications eSF. MARKING_TECHNOLOGY VARCHAR(255) Type de technologie de marquage utilisée par l'imprimante (par exemple, Electrophotographique). MEMORY BIGINT Quantité de mémoire, en octets. PROFILE SMALLINT/ TINYINT * Indicateur qui détermine si cette imprimante prend en charge les profils. RECEIVE_FAX SMALLINT/ TINYINT * Indicateur qui détermine si cette imprimante prend en charge la réception de télécopies. SCAN_TO_EMAIL SMALLINT/ TINYINT * Indicateur qui détermine si cette imprimante prend en charge la numérisation vers la messagerie électronique. SCAN_TO_FAX SMALLINT/ TINYINT * Indicateur qui détermine si cette imprimante prend en charge la numérisation vers la télécopie. SCAN_TO_NETWORK SMALLINT/ TINYINT * Indicateur qui détermine si cette imprimante prend en charge la numérisation vers un réseau. VITESSE VARCHAR(255) Nombre de feuilles que l'imprimante peut imprimer par minute. DISPLAY_MANUFACTURER VARCHAR(255) Nom qui apparaît à l'extérieur de l'imprimante. Par exemple, le MANUFACTURER peut être LEXMARK, mais la valeur DISPLAY_MANUFACTURER peut être Dell. FAMILY_ID INTEGER ID de famille NPA. INITIAL_DISCOVERY_TIMESTAMP TIMESTAMP Moment où l'imprimante a été détectée pour la première fois. LIFETIME_PAGE_COUNT BIGINT Historique du nombre de pages. MAINTENANCE_COUNTER BIGINT Compteur de maintenance. ADAPTER_PORT INTEGER Port sur lequel l'imprimante est connectée à l'adaptateur réseau associé. Pour l'instant, les données ont la valeur Toujours 1. PROPERTY_TAG VARCHAR(255) Identification de propriété, du cuivre ou du bien. ADAPTER_ID BIGINT Clé étrangère pour NETWORK_ADAPTER.ADAPTER_ID. RAND_SN SMALLINT/ TINYINT * Indicateur qui détermine si la valeur actuelle de SERIAL_NUMBER a été créée de manière aléatoire. DEV_STATUS_REG_COUNTER INTEGER Nombre d'enregistrements d'état du périphérique. SCANNER_SERIAL_NUMBER VARCHAR(12) Pour les MFP modulaires, numéro de série de la tête de numérisation. DISK_ENCRYPTION VARCHAR(8) Fréquence à laquelle le chiffrement du disque est activé. DISK_WIPING VARCHAR(8) Fréquence à laquelle l'effacement du disque est activé. COULEUR SMALLINT/ TINYINT * Indicateur qui détermine si l'imprimante imprime en couleur. PRINTER_STATUS_SUMMARY SMALLINT/ TINYINT * Indicateur du message d'état de gravité le plus important de l'imprimante. SUPPLY_STATUS_SUMMARY SMALLINT/ TINYINT * Indicateur du message d'état des consommables le plus important de l'imprimante. TLI VARCHAR(255) Indicateur de niveau supérieur (TLI) du modèle d'imprimante. FAX_STATION_NAME VARCHAR(255) Valeur du paramètre de nom du télécopieur sur l'imprimante. FAX_STATION_NUMBER VARCHAR(255) Valeur du paramètre du numéro de télécopie sur l'imprimante. SCANNER_SERIAL_NUMBER VARCHAR(50) Numéro de série du scanner de l'imprimante. TIME_ZONE VARCHAR(255) ID des différents fuseaux horaires pris en charge par l'imprimante. MODULAR_SERIAL_NUMBER VARCHAR(255) Le numéro de série modulaire. TRACING_SERIAL_NUMBER VARCHAR(64) Méthode d'authentification utilisée pour suivre le numéro de série. NETWORK_PRINTER"},{"UUID":"ef6cbd26-a2bb-4be6-9041-f0bcd718ecc8","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_CURRENT_STATUS Cette table présente l'état","descFull":"PRINTER_CURRENT_STATUS Cette table présente l'état de l'imprimante au moment de la collecte des données. Elle comprend une ligne pour chaque condition d'état d'une imprimante donnée, pointant toutes vers le même PRINTER_ID. PRINTER_CURRENT_STATUS Nom du champ Type de données Description STATUS_ID BIGINT Clé principale. STATUS_MESSAGE VARCHAR(255) Texte correspondant à cet état (par exemple, Tiroir 1 bas). STATUS_SEVERITY VARCHAR(255) Gravité de cet état (par exemple, Avertissement). STATUS_TYPE VARCHAR(255) Type de cet état (par exemple, Imprimante ou Consommable). PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PRINTER_CURRENT_STATUS"},{"UUID":"22e419cf-b9a6-46e6-8f88-c0544395131f","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_ESF_APPS Cette table présente les","descFull":"PRINTER_ESF_APPS Cette table présente les applications eSF installées sur les imprimantes au moment de la collecte des données. Elle comprend une ligne pour chaque application eSF actuellement installée sur une imprimante donnée, pointant toutes vers le même PRINTER_ID. PRINTER_ESF_APPS Nom du champ Type de données Description APPLICATION_ID BIGINT Clé principale. NAME VARCHAR(255) Nom de l'application. ETAT VARCHAR(255) Etat actuel. VERSION VARCHAR(255) Version actuelle. PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PRINTER_ESF_APPS"},{"UUID":"f1662e1f-553f-4b8c-810e-894852a45202","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_INPUT_OPTIONS Cette table présente les","descFull":"PRINTER_INPUT_OPTIONS Cette table présente les options d'entrée installées sur les imprimantes au moment de la collecte des données. Elle comprend une ligne pour chaque option d'entrée actuellement installée sur une imprimante donnée, pointant toutes vers le même PRINTER_ID. PRINTER_INPUT_OPTIONS Nom du champ Type de données Description INPUT_OPTION_ID BIGINT Clé principale. NAME VARCHAR(255) Nom de l'option d'entrée (par exemple, Tiroir multifonction). PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PRINTER_INPUT_OPTIONS"},{"UUID":"99c02044-4b27-4fcd-9033-8b74cb172999","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_INPUT_TRAYS Cette table présente les","descFull":"PRINTER_INPUT_TRAYS Cette table présente les tiroirs d'alimentation associés à une option d'alimentation. Elle comprend une ligne pour chaque tiroir d'alimentation associé à une option d'entrée donnée, pointant tous vers le même INPUT_OPTION_ID. PRINTER_INPUT_TRAYS Nom du champ Type de données Description INPUT_OPTION_ID BIGINT Clé étrangère pour PRINTER_INPUT_OPTIONS.INPUT_OPTION_ID. CAPACITY BIGINT Nombre maximal de feuilles que le tiroir peut contenir. FEED_TYPE VARCHAR(255) Manuel ou Auto. FORM_SIZE VARCHAR(255) Format de papier actuel (par exemple, Lettre). FORM_TYPE VARCHAR(255) Type de papier actuel (par exemple, Papier ordinaire). TYPE VARCHAR(255) Type de tiroir d'alimentation (par exemple, Chargeur multifonction). PRINTER_INPUT_TRAYS"},{"UUID":"30add378-94f6-4493-b066-c36dccce5729","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_OPTIONS Cette table présente les","descFull":"PRINTER_OPTIONS Cette table présente les options installées sur les imprimantes au moment de la collecte des données. Elle comprend une ligne pour chaque option actuellement installée sur une imprimante donnée, pointant toutes vers le même PRINTER_ID. En règle générale, l'option est un périphérique de stockage. PRINTER_OPTIONS Nom du champ Type de données Description OPTION_ID BIGINT Clé principale. FREESPACE_ BIGINT Quantité d'espace libre restante sur le périphérique de stockage. NAME VARCHAR(255) Nom de l'option d'imprimante (par exemple, DISK). SIZE_ BIGINT Espace total. PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PRINTER_OPTIONS"},{"UUID":"a6066153-89b8-4084-8648-8d5c987b0ead","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_BINS Cette table présente les","descFull":"PRINTER_OUTPUT_BINS Cette table présente les réceptacles de sortie associés à une option de sortie. Elle comprend une ligne pour chaque réceptacle de sortie associé à une option de sortie donnée, pointant tous vers le même OUTPUT_OPTION_ID. PRINTER_OUTPUT_BINS Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. OUTPUT_OPTION_ID BIGINT Clé étrangère pour PRINTER_OUTPUT_OPTIONS.OUTPU T_OPTION_ID. BINDING SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la reliure. BURSTING SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la mise en rafale. CAPACITY BIGINT Nombre maximal de feuilles que le réceptacle peut contenir. COLLATION SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge l'assemblage. FACE_DOWN SMALLINT/ TINYINT * Indicateur qui détermine si le papier est chargé face à imprimer vers le bas dans ce réceptacle. FACE_UP SMALLINT/ TINYINT * Indicateur qui détermine si le papier est chargé face à imprimer vers le haut dans ce réceptacle. LEVEL_SENSING SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la détection au niveau du papier. PUNCHING SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la perforation. SECURITE SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la sécurité. SEPARATION SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge la séparation. STITICHING SMALLINT/ TINYINT * Indicateur qui détermine si ce réceptacle prend en charge l'agrafage. TYPE VARCHAR(255) Type de réceptacle de sortie d'imprimante (par exemple, Réceptacle standard, Réceptacle 5, etc.) PRINTER_OUTPUT_BINS"},{"UUID":"1e381aff-12e6-4a16-bdff-1586a55f4336","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_OUTPUT_OPTIONS Cette table présente les","descFull":"PRINTER_OUTPUT_OPTIONS Cette table présente les options de sortie installées sur les imprimantes. Elle comprend une ligne pour chaque option de sortie actuellement installée sur une imprimante donnée, pointant toutes vers le même PRINTER_ID. PRINTER_OUTPUT_OPTIONS Nom du champ Type de données Description OUTPUT_OPTION_ID BIGINT Clé principale. NAME VARCHAR(255) Nom de l'option (par exemple, Integrated Hopper, Mailbox et Finisher). PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PRINTER_OUTPUT_OPTIONS"},{"UUID":"b6933782-a77d-4dd2-aba5-776eb6aa0af1","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_STATISTICS Cette table contient les","descFull":"PRINTER_STATISTICS Cette table contient les informations recueillies à partir des données de compteurs et de mesures de l'imprimante. Chaque ligne représente des données pour une imprimante individuelle. Selon le modèle de l'imprimante à laquelle est associé l'enregistrement, toutes les colonnes ne s'appliquent pas. PRINTER_STATISTICS Nom du champ Type de données Description STATISTICS_ID BIGINT Clé principale. COVG_LAST_JOB_BLACK BIGINT Couverture du toner noir du dernier travail d'impression. COVG_LIFETIME_BLACK BIGINT Couverture du toner noir au cours de la durée de vie des travaux d'impression. CART_PAGES_PRINT_BLACK BIGINT Nombre de pages imprimées à avoir utilisé une cartouche de toner noir. BLACK_TONER_LEVEL VARCHAR(255) Niveau actuel de consommable de la cartouche de toner noir. PHOTO_COND_LEVEL_K VARCHAR(255) Niveau actuel de consommable du photoconducteur (noir). BLANK_SAFE_SIDE_COPY BIGINT Nombre de faces vierges d'une copie. BLANK_SAFE_SIDE_FAX BIGINT Nombre de faces vierges d'une télécopie. BLANK_SAFE_SIDE_PRINT BIGINT Nombre de faces vierges d'une impression. PAPER_CHANGE BIGINT Nombre d'événements de remplacement du papier. COVER_OPEN BIGINT Nombre d'événements d'ouverture du capot. COVG_LAST_JOB_CYAN BIGINT Couverture du toner cyan du dernier travail d'impression. COVG_LIFETIME_CYAN BIGINT Couverture du toner cyan au cours de la durée de vie des travaux d'impression. CART_PAGES_PRINT_CYAN BIGINT Nombre de pages imprimées à avoir utilisé une cartouche de toner cyan. CYAN_TONER_LEVEL VARCHAR(255) Niveau actuel de consommable de la cartouche de toner cyan. CYAN_TONER_STATUS VARCHAR(255) Etat des consommables de la cartouche cyan (par exemple, Intermédiaire). YELLOW_TONER_STATUS VARCHAR(255) Etat des consommables de la cartouche jaune (par exemple, Intermédiaire). MAGENTA_TONER_STATUS VARCHAR(255) Etat des consommables de la cartouche magenta (par exemple, Intermédiaire). BLACK_TONER_STATUS VARCHAR(255) Etat des consommables de la cartouche noire (par exemple, Intermédiaire). PHOTO_COND_LEVEL_C VARCHAR(255) Niveau actuel de consommable du photoconducteur (cyan). DEVICE_INSTALL_DATE TIMESTAMP Horodatage de la première installation de l'imprimante. FUSER_CURRENT_LEVEL VARCHAR(255) Niveau actuel de consommable de l'unité de fusion. IMG_SAFE_SIDE_COPY BIGINT Nombre de faces d'images imprimées d'un travail de copie. IMG_SAFE_SIDE_FAX BIGINT Nombre de faces d'images imprimées d'un travail de télécopie. IMG_SAFE_SIDE_PRINT BIGINT Nombre de faces d'images imprimées d'un travail d'impression. LAST_FAX_JOB_DATE TIMESTAMP Horodatage du dernier travail de télécopie. LAST_PRINTED_JOB_DATE TIMESTAMP Horodatage du dernier travail d'impression. LAST_SCAN_JOB_DATE TIMESTAMP Horodatage du dernier travail de numérisation. COVG_LAST_JOB_MAGENTA BIGINT Couverture du toner magenta du dernier travail. COVG_LIFETIME_MAGENTA BIGINT Couverture du toner magenta au cours de la durée de vie des travaux CART_PAGES_PRINT_MAGENTA BIGINT Nombre de pages imprimées à avoir utilisé une cartouche de toner magenta. MAGENTA_TONER_LEVEL VARCHAR(255) Niveau actuel de consommable de la cartouche de toner magenta. PHOTO_COND_LEVEL_M VARCHAR(255) Niveau actuel de consommable du photoconducteur (magenta). MAINT_KIT_LEVEL VARCHAR(255) Niveau actuel de consommable du kit de maintenance. MEDIA_SIZE_TYPE_MONO_SIDE_ SAFE BIGINT Faces monochromes imprimées (sûres). MEDIA_SIZE_TYPE_COLOR_SIDE_ SAFE BIGINT Faces couleur imprimées (sûres). SUPPLY_EVENTS BIGINT Nombre d'événements autres liés aux consommables. PAPER_JAMS BIGINT Nombre d'événements de bourrage papier. PAPER_LOAD BIGINT Nombre d'événements de chargement du papier. PRINT_SHEET_USE_PICKED BIGINT Feuilles imprimées (récupérées). PRINT_SIDE_USE_PICKED BIGINT Faces imprimées (récupérées). Réinitialisation à la mise sous tension BIGINT Nombre de réinitialisations à la mise sous tension. PRINT_AND_HOLD_JOB BIGINT Nombre de travaux imprimer et conserver. SAFE_SHT_COPY BIGINT Feuilles imprimées (sûres) à partir des travaux de copie. SAFE_SHT_FAX BIGINT Feuilles imprimées (sûres) à partir des travaux de télécopie. SAFE_SHT_PRINT BIGINT Feuilles imprimées (sûres) à partir des travaux d'impression. SCAN_PAPER_JAMS BIGINT Nombre d'événements de bourrage scanner. PRINTED_FROM_PRINT_AND_HOLD BIGINT Nombre de travaux imprimer et conserver imprimés. PRINTED_FROM_USB BIGINT Nombre d'impression à partir d'USB. TRANS_BELT_LEVEL VARCHAR(255) Niveau actuel de consommable de la courroie de transfert. USB_DIRECT_JOB BIGINT Nombre d'insertions USB. WASTE_TONER_LEVEL VARCHAR(255) Niveau actuel de la bouteille de récupération de toner. COVG_LAST_JOB_YELLOW BIGINT Couverture du toner jaune du dernier travail. COVG_LIFETIME_YELLOW BIGINT Couverture du toner jaune au cours de la durée de vie des travaux. CART_PAGES_PRINT_YELLOW BIGINT Nombre de pages imprimées à avoir utilisé une cartouche de toner jaune. YELLOW_TONER_LEVEL VARCHAR(255) Niveau actuel de consommable de la cartouche jaune. PHOTO_COND_LEVEL_Y VARCHAR(255) Niveau actuel du photoconducteur (jaune). IMG_SAFE_SIDE_PRINT_MONO BIGINT Nombre de faces d'images monochromes imprimées (sûres) d'un travail d'impression. IMG_SAFE_SIDE_PRINT_COLOR BIGINT Nombre de faces d'images couleur imprimées (sûres) d'un travail d'impression. IMG_SAFE_SIDE_COPY_MONO BIGINT Nombre de faces d'images monochromes imprimées (sûres) d'un travail de copie. IMG_SAFE_SIDE_COPY_COLOR BIGINT Nombre de faces d'images couleur imprimées (sûres) d'un travail de copie. IMG_SAFE_SIDE_FAX_MONO BIGINT Nombre de faces d'images monochromes imprimées (sûres) d'un travail de télécopie. IMG_SAFE_SIDE_FAX_COLOR BIGINT Nombre de faces d'images couleur imprimées (sûres) d'un travail de télécopie. FAX_JOB_RECV BIGINT Nombre de travaux de télécopie reçus. FAX_JOB_SENT BIGINT Nombre de travaux de télécopie envoyés. FAX_PAGE_RECV BIGINT Nombre de pages de télécopie reçues. FAX_PAGE_SENT BIGINT Nombre de pages de télécopie envoyées. SCAN_COPY BIGINT Nombre de numérisations à partir de travaux de copie. SCAN_FAX BIGINT Nombre de numérisations à partir de télécopie. SCAN_LOCAL BIGINT Nombre de numérisations en local. SCAN_NET BIGINT Nombre de numérisations vers le réseau. SCAN_FLAT BIGINT Nombre de numérisations à partir de la vitre du scanner à plat. SCAN_ADF_SIMPLEX BIGINT Nombre de numérisations depuis le DAA (recto). SCAN_ADF_DUPLEX BIGINT Nombre de numérisations depuis le DAA (recto verso). SCAN_USB_DIRECT BIGINT Nombre de numérisations directement vers USB. USB_DIRECT_INSERT BIGINT Nombre d'insertions USB. CART_INST_DATE_CYAN TIMESTAMP Horodatage de l'installation de la cartouche cyan. CART_INST_DATE_YELLOW TIMESTAMP Horodatage de l'installation de la cartouche jaune. CART_INST_DATE_MAGENTA TIMESTAMP Horodatage de l'installation de la cartouche magenta. CART_INST_DATE_BLACK TIMESTAMP Horodatage de l'installation de la cartouche noire. PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. MAINT_KIT_STATUS_100K VARCHAR(255) Niveau du kit de maintenance 100K. MAINT_KIT_STATUS_160K VARCHAR(255) Niveau du kit de maintenance 160K. MAINT_KIT_STATUS_200K VARCHAR(255) Niveau du kit de maintenance 200K. MAINT_KIT_STATUS_300K VARCHAR(255) Niveau du kit de maintenance 300K. MAINT_KIT_STATUS_320K VARCHAR(255) Niveau du kit de maintenance 320K. MAINT_KIT_STATUS_480K VARCHAR(255) Niveau du kit de maintenance 480K. MAINT_KIT_STATUS_600K VARCHAR(255) Niveau du kit de maintenance 600K. PRINTER_STATISTICS"},{"UUID":"0a826c73-8ed1-4b40-8fe8-e3d5cde96214","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_SUPPLIES Cette table présente les","descFull":"PRINTER_SUPPLIES Cette table présente les consommables dans les imprimantes. Elle comprend une ligne pour chaque consommable d'une imprimante donnée, pointant tous vers le même PRINTER_ID. Selon le type, toutes les colonnes ne s'appliquent pas. PRINTER_SUPPLIES Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. SUPPLY_ID BIGINT Clé principale. CAPACITY BIGINT Capacité d'alimentation maximale du consommable. COULEUR VARCHAR(255) Couleur du consommable (par exemple, Noir, Cyan ou NULL). NAME VARCHAR(255) Nom du consommable (par exemple, toner noir, unité de fusion et bouteille de récupération). SMART_CARTRIDGE_PREBATE SMALLINT/ TINYINT * Indicateur qui détermine si ce consommable est une reprise (Prebate) de cartouche Smart. SMART_CARTRIDGE_REFILLED SMALLINT/ TINYINT * Indicateur qui détermine si ce consommable est une recharge de cartouche Smart. SMART_CARTRIDGE_SERIAL_NUM BER VARCHAR(255) Numéro de série de la cartouche Smart TYPE VARCHAR(255) Type de consommable (par exemple, Toner, Courroie de transfert, Unité de fusion, Conteneur ou Unité d'imagerie). PRINTER_ID BIGINT Clé étrangère pour NETWORK_PRINTER.PRINTER_ID. PERCENT_FULL BIGINT Pourcentage restant calculé du consommable. PRINTER_SUPPLIES"},{"UUID":"9114869c-5639-4054-9783-6e7d6ee820af","title":"Imprimante","link":"config-item-topic.html","desc":"CHANGED_SETTINGS Cette table contient des","descFull":"CHANGED_SETTINGS Cette table contient des informations sur les paramètres qui ont été modifiés entre les deux dernières vérifications. CHANGED_SETTINGS Nom du champ Type de données Description ID BIGINT Clé principale. CI_ID BIGINT Fait référence à CONFIG_ITEM.ID. SETTING_NAME VARCHAR(255) Nom du paramètre modifié. CHANGE_TYPE VARCHAR(255) Type de changement. Vous pouvez choisir parmi les options suivantes : ADD, UPDATE et REMOVE. CHANGED_SETTINGS"},{"UUID":"125a5b82-94cc-47b5-8fd4-93558a3f2911","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_PORTS Cette table contient des","descFull":"PRINTER_PORTS Cette table contient des informations sur l'état des ports TCP/UDP de l'imprimante. PRINTER_PORTS Nom du champ Type de données Description PRINTER_PORTS_ID BIGINT Clé principale. PRINTER_ID BIGINT Fait référence à PRINTER.ID. TCP21 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP69 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP79 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP80 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP137 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP161 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP162 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP515 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP631 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP5001 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP5353 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP8000 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9100 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9200 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP9200 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP9300 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP9301 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP9302 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9400 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9500 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9501 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9600 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP9700 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP9000 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP5000 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP443 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP4000 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. UDP6100 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP6100 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP65002 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP65004 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP65004 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP65001 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TCP65003 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. PRINTER_PORTS"},{"UUID":"5597a7b7-39be-476b-be52-f34051c14623","title":"Imprimante","link":"config-item-topic.html","desc":"PRINTER_SECURITY-OPTIONS Cette table contient des","descFull":"PRINTER_SECURITY-OPTIONS Cette table contient des informations relatives aux détails de sécurité de l'imprimante. PRINTER_SECURITY-OPTIONS Nom du champ Type de données Description PRINTER_SECURITY_ID BIGINT Clé principale. PRINTER_ID BIGINT Fait référence à PRINTER.ID. OWASP_CIPHER_CATEGORY VARCHAR(500) Liste des catégories de chiffrement prises en charge par le périphérique. TLS10 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. TLS11 VARCHAR(255) Vous pouvez choisir parmi les options suivantes : OFF, ON, UNKNOWN et NONE. PRINTER_SECURITY-OPTIONS"},{"UUID":"c801a0c0-4862-4106-9538-514428a0e11d","title":"Mots clés","link":"config-item-topic.html","desc":"ASSIGNED_KEYWORDS Cette table présente les","descFull":"ASSIGNED_KEYWORDS Cette table présente les mots clés affectés à leurs éléments de configuration et imprimantes respectifs. ASSIGNED_KEYWORDS Nom du champ Type de données Description KEYWORD_ID BIGINT Clé principale composite et clé étrangère pour KEYWORD.KEYWORD_ID. CI_ID BIGINT Clé principale composite et clé étrangère pour CONFIGURATION_ITEM.CI_ID. ASSIGNED_KEYWORDS"},{"UUID":"4d4698f8-ac78-4f8d-9795-1e275d6a5b89","title":"Mots clés","link":"config-item-topic.html","desc":"KEYWORD Cette table présente tous","descFull":"KEYWORD Cette table présente tous les mots clés définis dans le système. KEYWORD Nom du champ Type de données Description KEYWORD_ID BIGINT Clé principale. KEYWORD_VALUE VARCHAR(255) Nom du mot clé. CATEGORY_ID BIGINT Clé étrangère pour KEYWORD_CATEGORY.CATEGORY_ID. KEYWORD"},{"UUID":"808b8d4f-e802-440d-9250-be6b564f3153","title":"Mots clés","link":"config-item-topic.html","desc":"KEYWORD_CATEGORY Cette table énumère toutes","descFull":"KEYWORD_CATEGORY Cette table énumère toutes les catégories définies dans le système. Elle sert à regrouper les mots clés. KEYWORD_CATEGORY Nom du champ Type de données Description CATEGORY_ID BIGINT Clé principale. CATEGORY_VALUE VARCHAR(255) Nom de la catégorie. KEYWORD_CATEGORY"},{"UUID":"e8bb1362-9f55-4d29-b77d-afb4cf0fc833","title":"Configurations","link":"config-item-topic.html","desc":"CONFIGURATION Cette table présente une","descFull":"CONFIGURATION Cette table présente une configuration d'imprimante au niveau le plus élevé, indiquant le nom et le modèle de l'imprimante, et si elle peut être attribuée. CONFIGURATION Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. CONFIGURATION_ID BIGINT Clé principale. CONFIGURATION_NAME VARCHAR(255) Nom de la configuration. ASSIGNABLE SMALLINT/ TINYINT * Indicateur qui détermine si la configuration peut être attribuée. DESCRIPTION VARCHAR(4000) Description de la configuration saisie par l'utilisateur. LAST_MODIFIED TIMESTAMP Horodatage de la dernière modification de la configuration. MANAGING_DEV_CERTIFICATE BOOLEAN Valeur booléenne par défaut. Ce champ indique si cette configuration gère automatiquement le certificat de périphérique. CONFIGURATION"},{"UUID":"c84619f4-4a27-4fca-911a-31a2c8af6dca","title":"Configurations","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENT Cette table représente un","descFull":"CONFIGURATION_COMPONENT Cette table représente un composant d'une configuration. CONFIGURATION_COMPONENT Nom du champ Type de données Description CONFIGURATION_COMPONENT_ID BIGINT Clé principale. COMPONENT_TYPE VARCHAR(255) Type de composant. Vous pouvez choisir parmi les options suivantes : DEVICE_SETTINGS, SECURITY_CAESAR1, SECURITY_CAESAR2, ESF et FIRMWARE. CREDENTIAL_PASSWORD BLOB SUB_TYPE 0 Mot de passe chiffré des informations d'identification, s'il est défini. CREDENTIAL_PIN BLOB SUB_TYPE 0 Code PIN chiffré des informations d'identification, s'il est défini. CREDENTIAL_REALM VARCHAR(255) Domaine d'informations d'identification, s'il est défini. CREDENTIAL_USERNAME VARCHAR(255) Nom d'utilisateur des informations d'identification, s'il est défini. COMPONENT_NAME VARCHAR(255) Nom du composant. LICENSE_TYPE VARCHAR(255) Type de licence du composant de configuration. Vous pouvez choisir parmi les options suivantes : PRODUCTION, TRIAL et FACTORY. LOGIN_METHOD VARCHAR(256) Méthodes d'authentification utilisée pour la connexion à l'imprimante. MERGE_DATA_PATH VARCHAR(255) Emplacement fichier d'un fichier de paramètres de variable. FLASH_FILE_SHA1 VARCHAR(255) Hachage SHA1 du fichier flash d'un composant de microcode. LOGIN_METHOD_NAME VARCHAR(256) Si la valeur LOGIN_METHOD est LDAP ou LDAP + GSSAPI, ce champ affiche le nom de la méthode de connexion particulière. DESCRIPTION VARCHAR(4000) Ce champ affiche la description si elle est ajoutée à un composant. LAST_MODIFIED TIMESTAMP Horodatage de la dernière modification. ASSIGNABLE Booléen La valeur est true si le composant est affecté à une imprimante. Sinon, la valeur est false. PRE_POPULATED Booléen Ajouté pour identifier les composants de sécurité avancés pré-remplis. CONFIGURATION_COMPONENT"},{"UUID":"63703e8b-f30e-4263-bc22-6aa1a840b2de","title":"Configurations","link":"config-item-topic.html","desc":"CONFIGURATION_COMPONENTS Cette table contient des","descFull":"CONFIGURATION_COMPONENTS Cette table contient des informations sur les différents composants liés à différentes configurations, si cette option est sélectionnée. CONFIGURATION_COMPONENTS Nom du champ Type de données Description CONFIGURATION_ID BIGINT Clé étrangère pour CONFIGURATION.CONFIGURATION_ID. CONFIGURATION_COMPONENT_ID BIGINT Clé étrangère pour CONFIGURATION_COMPONENT. CONFIGURATION_COMPONENT_ID. COMPONENT_TYPE VARCHAR(255) Ajouté pour distinguer le composant de configuration de périphérique de huit autres composants. CONFIGURATION_COMPONENTS"},{"UUID":"74ffdec8-8951-4590-beb3-d5e124d2232a","title":"Configurations","link":"config-item-topic.html","desc":"ASSIGNED_CONFIGURATIONS Cette table présente quelles","descFull":"ASSIGNED_CONFIGURATIONS Cette table présente quelles configurations sont attribuées à quels éléments de configuration et à quelles imprimantes. ASSIGNED_CONFIGURATIONS Nom du champ Type de données Description CI_ID BIGINT Clé principale composite et clé étrangère renvoyées à CONFIGURATION_ITEM.CI_ID. CONFIGURATION_ID BIGINT Clé principale composite et clé étrangère renvoyées à CONFIGURATION.CONFIGURATION_ID. COMPLIANCE_STATE VARCHAR(255) Etat de conformité actuel de la configuration. LAST_COMPLIANCE_CHECK TIMESTAMP Horodatage du dernier contrôle de conformité qui a été exécuté. ASSIGNED_CONFIGURATIONS"},{"UUID":"ae8d34c6-09ad-4bd1-b356-7eee0cce917f","title":"Configurations","link":"config-item-topic.html","desc":"FAILED_COMPONENT Cette table inclut tous","descFull":"FAILED_COMPONENT Cette table inclut tous les composants qui contiennent un paramètre non conforme. FAILED_COMPONENT Nom du champ Type de données Description FAILED_COMPONENT_ID BIGINT Clé principale. CI_ID BIGINT Clé étrangère renvoyée à ASSIGNED_CONFIGURATIONS.CI_ID. CONFIGURATION_ID BIGINT (non null) Clé étrangère renvoyée à ASSIGNED_CONFIGURATIONS.CONFIGURATION_ID. COMPONENT_TYPE VARCHAR(255) Type du composant en échec. COMPONENT_NAME VARCHAR(255) Nom des composants défectueux. FAILED_COMPONENT"},{"UUID":"fc10ddb9-7495-4e97-9e51-0f433f6c92df","title":"Configurations","link":"config-item-topic.html","desc":"FAILED_COMPONENT_SETTINGS Cette table inclut tous","descFull":"FAILED_COMPONENT_SETTINGS Cette table inclut tous les paramètres qui ne sont pas conformes et leurs valeurs. FAILED_COMPONENT_SETTINGS Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. TYPE SMALLINT/ TINYINT * , Valeur par défaut 0 Ajouté pour distinguer les raisons de l'échec de conformité parmi les éléments suivants : Anomalie, Non applicable, Non pris en charge, Ressource absente de la bibliothèque et Impossible de fusionner les paramètres de jeton. FAILED_COMPONENT_ID BIGINT (non null) Clé étrangère renvoyée à FAILED_COMPONENT.FAILED_COMPONENT_ID. SETTING_NAME VARCHAR(255) Nom du paramètre en échec. PRINTER_VALUE dropNotNullConstraint La valeur peut être nulle. COMPONENT_VALUE dropNotNullConstraint La valeur peut être nulle. FAILED_COMPONENT_SETTINGS"},{"UUID":"cf36f3d3-caf7-494b-906d-968e54b12891","title":"Configurations","link":"config-item-topic.html","desc":"FLASHFILE Cette table contient des","descFull":"FLASHFILE Cette table contient des informations sur les ressources de la bibliothèque du microcode MVE. FLASHFILE Nom du champ Type de données Description ID BIGINT Clé principale. FICHIER VARCHAR(256) Nom et emplacement du fichier dans le référentiel MVE. SHA1 VARCHAR(255) Hachage SHA1 du fichier flash. DISPLAY_NAME VARCHAR(255) Identifiant de version du fichier flash. DATE_IMPORTED TIMESTAMP Date d'importation du fichier flash. DESCRIPTION VARCHAR(255) Description du fichier flash. FLASHFILE"},{"UUID":"e66a2a21-f51c-4ccb-b382-c54864f9720d","title":"Configurations","link":"config-item-topic.html","desc":"FLASH_NET_IDS Cette table stocke la","descFull":"FLASH_NET_IDS Cette table stocke la valeur NETFLASH ID qui se trouve en haut de chaque fichier Flash dans la bibliothèque de ressources. FLASH_NET_IDS Nom du champ Type de données Description FLASHNETID BIGINT Clé principale. NET_ID VARCHAR(255) Valeur NETFLASH ID. FLASH_NET_IDS"},{"UUID":"8bac09ae-3d31-4655-bb7d-e94d5446acb0","title":"Configurations","link":"config-item-topic.html","desc":"CERTIFICATES Cette table contient des","descFull":"CERTIFICATES Cette table contient des informations sur les ressources de la bibliothèque du certificat CA MVE. CERTIFICATES Nom du champ Type de données Description CERTIFICATE_ID BIGINT Clé principale. NAME VARCHAR(255) Nom convivial d'un certificat CA. PEM_CERTIFICATE BLOB Représentation PEM d'un certificat CA. DATE_IMPORTED TIMESTAMP Date d'importation du certificat CA dans MVE. PEM_CERTIFICATE_SHA2 VARCHAR (64) Hachage SHA2 de ce certificat CA. DESCRIPTION VARCHAR (255) Description du certificat CA. CERTIFICATES"},{"UUID":"c6947082-94fc-4a49-85dc-a86ab6ef1411","title":"Configurations","link":"config-item-topic.html","desc":"CERTIFICATE_COMP_CERTIFICATES Cette table présente le","descFull":"CERTIFICATE_COMP_CERTIFICATES Cette table présente le lien d'un certificat de la bibliothèque de ressources à un composant de la configuration, et donc à une configuration. CERTIFICATE_COMP_CERTIFICATES Nom du champ Type de données Description CONFIGURATION_COMP ONENT_ID BIGINT Clé étrangère renvoyée à CONFIGURATION_COMPONENT.CONFIGURATION_ COMPONENT_ID. CERTIFICATE_ID BIGINT Clé étrangère renvoyée à CERTIFICATES.CERTIFICATE_ID. CERTIFICATE_COMP_CERTIFICATES"},{"UUID":"f7565269-fec6-4cd0-ab67-81630a6e9da7","title":"Configurations","link":"config-item-topic.html","desc":"COMPONENT_SETTINGS Cette table représente les","descFull":"COMPONENT_SETTINGS Cette table représente les paramètres contenus dans un composant de configuration donné. Elle comprend une ligne pour chaque paramètre associé au composant de la configuration, pointant tous vers le même CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. Les valeurs sont chiffrées et indisponibles hors de MVE. COMPONENT_SETTINGS Nom du champ Type de données Description SETTING_ID BIGINT Clé principale. SETTING_NAME VARCHAR(255) Nom du paramètre. SETTING_VALUE VARCHAR(1280) Valeur chiffrée du paramètre. CONFIGURATION_COMPONENT_ID BIGINT Clé étrangère pour CONFIGURATION_COMPONENT.CONFIG URATION_COMPONENT_ID. DISCRIMINATOR VARCHAR(255) Vous pouvez choisir parmi les options suivantes : SIMPLE_SETTING et TABULAR_SETTING. TABULAR_SETTING_VALUE_ID BIGINT Clé étrangère pour COMPONENT_TAB_SETTING_VALUE.TA BULAR_SETTING_VALUE_ID. COMPONENT_SETTINGS"},{"UUID":"ea695c61-38c3-469d-96aa-b8fd3316d790","title":"Configurations","link":"config-item-topic.html","desc":"COMPONENT_TAB_TABLE Cette table représente les","descFull":"COMPONENT_TAB_TABLE Cette table représente les tables d'autorisations d'impression couleur incluses dans les configurations. COMPONENT_TAB_TABLE Nom du champ Type de données Description TABLE_ID BIGINT Clé principale. TABLE_TYPE VARCHAR(255) Vous pouvez choisir parmi les options suivantes : HOST_TABLE et USER_TABLE. COMPONENT_TAB_TABLE"},{"UUID":"a7cc9a30-31ac-4690-b783-a2c28eea9e09","title":"Configurations","link":"config-item-topic.html","desc":"COMPONENT_TAB_ROW Cette table représente une","descFull":"COMPONENT_TAB_ROW Cette table représente une ligne des tables d'autorisations d'impression couleur. Les valeurs sont chiffrées et ne peuvent pas être utilisées en dehors de MVE. COMPONENT_TAB_ROW Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. TABLE_ID BIGINT Clé étrangère pour COMPONENT_TAB_TABLE.TABLE_ID HOST_NAME VARCHAR(255) Valeur du paramètre  Nom d'hôte  dans le tableau des hôtes. USER_NAME VARCHAR(255) Valeur du paramètre  Nom d'utilisateur  dans le tableau des utilisateurs. ALLOWED_TO_PRINT_COLOR SMALLINT/ TINYINT * Valeur du paramètre  Autoriser l'impression couleur  pour les tableaux des hôtes et des utilisateurs. USER_PERMISSION_OV ERRIDDEN SMALLINT/ TINYINT * Valeur du paramètre  Remplacer l'autorisation d'utilisateur  dans le tableau des hôtes. COMPONENT_TAB_ROW"},{"UUID":"78757503-9964-49cc-bb2f-05dc7bd99fe8","title":"Configurations","link":"config-item-topic.html","desc":"COMPONENT_TAB_SETTING_VALUE Cette table présente la","descFull":"COMPONENT_TAB_SETTING_VALUE Cette table présente la corrélation entre les tables d'autorisations d'impression couleur et les composants, et donc les configurations. COMPONENT_TAB_SETTING_VALUE Nom du champ Type de données Description TABULAR_SETTING_VALUE_ID BIGINT Clé étrangère pour COMPONENT_SETTINGS.TABULAR_SETTING_VALUE_ID. TABLE_ID BIGINT Clé étrangère pour COMPONENT_TAB_TABLE.TABLE_ID. COMPONENT_TAB_SETTING_VALUE"},{"UUID":"14bffe84-e26f-4222-9f81-5bd532b18661","title":"Configurations","link":"config-item-topic.html","desc":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nom du champ","descFull":"CC_SUPPORTED_MODEL_BACKUP CC_SUPPORTED_MODEL_BACKUP Nom du champ Type de données Description ID BIGINT Clé principale. SUPPORTED_MODEL VARCHAR(255) Utilisé pour créer une sauvegarde à partir des valeurs de CONFIGURATION et CONFIGURATION_COMPONENT pour les  Composants de configuration de périphérique . CC_SUPPORTED_MODEL_BACKUP"},{"UUID":"24f0c531-f724-4bff-8b63-b4d1aafb2dc0","title":"Configurations","link":"config-item-topic.html","desc":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nom du champ","descFull":"ESF_COMP_PRODUCTS ESF_COMP_PRODUCTS Nom du champ Type de données Description CONFIGURATION_COMPONENT_ID BIGINT Références de la clé étrangère. Table : CONFIGURATION_COMPONENT Colonne : CONFIGURATION_COMPONENT_ID PART_NUMBER VARCHAR(255) Numéro de référence produit du composant de la solution. ESF_COMP_PRODUCTS"},{"UUID":"8334c241-8830-4b1a-bbca-4f98ecc334ba","title":"Configurations","link":"config-item-topic.html","desc":"VCCFILE VCCFILE Nom du champ","descFull":"VCCFILE VCCFILE Nom du champ Type de données Description ID BIGINT Clé principale. FICHIER VARCHAR(255) Nom du fichier téléchargé. DISPLAY_NAME VARCHAR(255) Nom du fichier VCC affiché dans MVE. DATE_IMPORTED TIMESTAMP Données d'horodatage du téléchargement du fichier. SHA1 VARCHAR(255) Hachage du contenu du fichier. DESCRIPTION VARCHAR(255) Description du fichier VCC. VCCFILE"},{"UUID":"eb0c0328-8826-43d9-9af6-ed4953348fad","title":"Configurations","link":"config-item-topic.html","desc":"UCFFILE UCFFILE Nom du champ","descFull":"UCFFILE UCFFILE Nom du champ Type de données Description ID BIGINT Clé principale. FICHIER VARCHAR(255) Nom du fichier téléchargé. DISPLAY_NAME VARCHAR(255) Nom du fichier UCF affiché dans MVE. DATE_IMPORTED TIMESTAMP Données d'horodatage du téléchargement du fichier. SHA1 VARCHAR(255) Hachage du contenu du fichier. DESCRIPTION VARCHAR(255) Description du fichier UCF. UCFFILE"},{"UUID":"c57cf256-f05f-47da-b3d5-b1e3dbb35ea5","title":"Configurations","link":"config-item-topic.html","desc":"UCF_VCC_RESOURCE_FILES Cette table contient des","descFull":"UCF_VCC_RESOURCE_FILES Cette table contient des informations sur l'état des ports TCP/UDP de l'imprimante. UCF_VCC_RESOURCE_FILES Nom du champ Type de données Description RESOURCE_ID BIGINT Clé principale. SHA1 VARCHAR(255) Hachage du contenu du fichier. RESOURCE_TYPE VARCHAR(255) Type de fichier de ressources. Vous pouvez choisir parmi les options suivantes : UCF_FILE, VCC_FILE et APP_FLS. CONFIGURATION_COMPONENT_ID VARCHAR(255) Clé étrangère de l'ID de la table CONFIGURATION_COMPONENT. UCF_VCC_RESOURCE_FILES"},{"UUID":"cc813099-fda9-40af-8566-0bcebd6d8ddc","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Profils de recherche Les tables","descFull":"Profils de recherche Les tables suivantes sont utilisées pour effectuer un suivi des profils de recherche MVE. DISCOVERY_PROFILE DISCOVERY_PROFILE Nom du champ Type de données Description ID BIGINT Clé principale. NAME VARCHAR(255) Nom fourni par l'utilisateur pour le profil. RETRIES INTEGER Nombre de tentatives de communication avec une imprimante. SNMP_READ_COMMUNITY_NAME VARCHAR(255) Nom de la communauté SNMP à utiliser lors de la lecture. TIMEOUT BIGINT Temps d'attente en millisecondes avant qu'une tentative de communication particulière avec une imprimante aboutisse. SNMP_USERNAME VARCHAR(32) Nom d'utilisateur pour la communication SNMP. SNMP_PASSWORD VARCHAR(32) Mot de passe pour la communication SNMP. SNMP_MIN_AUTHENTICATION_LEVEL VARCHAR(255) Niveau d'authentification minimal pour SNMP. SNMP_AUTHENTICATION_HASH VARCHAR(50) Hachage utilisé pour l'authentification SNMP. SNMP_PRIVACY_ALGORITHM VARCHAR(50) Algorithme utilisé pour la confidentialité SNMP. DISCOVERY_PROFILE_CI Cette table comprend les éléments du profil de recherche spécifiques aux Eléments de configuration (CI). DISCOVERY_PROFILE_CI Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. CI_DP_ID BIGINT Clé principale et clé étrangère pour DISCOVERY_PROFILE.ID. AUTOMANAGE SMALLINT/ TINYINT * Indicateur qui détermine si les CI découverts à l'aide de ce profil doivent être gérés automatiquement. DESCRIPTION VARCHAR(4000) Description du profil de recherche fournie par l'utilisateur. LAST_RUN TIMESTAMP Horodatage de la dernière exécution du profil. CREDENTIAL_USERNAME VARCHAR(255) Nom d'utilisateur des informations d'identification, s'il est défini. CREDENTIAL_REALM VARCHAR(64) Domaine d'informations d'identification, s'il est défini. LOGIN_METHOD VARCHAR(256) Méthodes d'authentification utilisée pour la connexion à l'imprimante. LOGIN_METHOD_NAME VARCHAR(256) Nom de la méthode d'authentification si la valeur LOGIN_METHOD est LDAP ou LDAP + GSSAPI. CREDENTIAL_PASSWORD BLOB Cette valeur est chiffrée et ne peut pas être utilisée en dehors de MVE. CREDENTIAL_PIN BLOB Cette valeur est chiffrée et ne peut pas être utilisée en dehors de MVE. ASSIGN_KEYWORD_IDS VARCHAR(512) Mots clés attribués dans un profil de recherche. EXCLUDE_PROFILE_ITEM Cette table représente la liste d' Exclusion  pour un profil. Chaque élément exclu constitue une ligne de cette table. EXCLUDE_PROFILE_ITEM Nom du champ Type de données Description DISCOVERY_PROFILE_ID BIGINT Clé principale composite et clé étrangère pour DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) Clé principale composite. Ce champ définit les éléments à exclure. INCLUDE_PROFILE_ITEM Cette table représente la liste d' Inclusion  pour un profil. Chaque élément inclus constitue une ligne de cette table. INCLUDE_PROFILE_ITEM Nom du champ Type de données Description DISCOVERY_PROFILE_ID BIGINT Clé principale composite et clé étrangère pour DISCOVERY_PROFILE.ID. VALUE_ VARCHAR(255) Clé principale composite. Ce champ définit les éléments à inclure. DISCOVERY_PROFILE_MODEL_CONFIG Cette table représente la partie  Attribuer des configurations  d'un profil de recherche. DISCOVERY_PROFILE_MODEL_CONFIG Nom du champ Type de données Description ID BIGINT Clé principale. MODEL VARCHAR(255) Nom du modèle des imprimantes auxquelles la configuration est affectée. DISCOVERY_PROFILE_ID BIGINT Clé étrangère pour DISCOVERY_PROFILE.ID. CI_CONFIGURATION_ID BIGINT Clé étrangère pour CONFIGURATION.CONFIGURATION_ID. Profils de recherche"},{"UUID":"97ae0680-a445-426a-95ac-b51927917cf6","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"ESF ESF_APPLICATION Cette table contient","descFull":"ESF ESF_APPLICATION Cette table contient toutes les applications eSF dans tous les packages eSF déployables. Chaque package déployable peut contenir de nombreuses applications eSF. ESF_APPLICATION Nom du champ Type de données Description ESF_APP_ID BIGINT Clé principale. ESF_DP_ID BIGINT Clé étrangère renvoyée à ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. APP_ID VARCHAR(255) ID d'application des applications eSF. VERSION VARCHAR(255) Versions de l'application eSF. DESCRIPTION_URI VARCHAR(255) Description URI de l'application eSF. FLS_URI VARCHAR(255) URI vers le fichier flash. ESF_APPLICATION_LOCALE Cette table contient le nom et la description de chaque application eSF dans toutes les langues prises en charge par MVE. ESF_APPLICATION_LOCALE Nom du champ Type de données Description ESF_APP_LOCALE_ID BIGINT Clé principale. ESF_APP_ID BIGINT Clé étrangère pour ESF_APPLICATION.ESF_APP_ID. LOCALE VARCHAR(255) Code de langue à deux caractères. NAME VARCHAR(255) Nom de l'application eSF dans la langue indiquée dans le paramètre LOCALE. DESCRIPTION VARCHAR(510) Description de l'application eSF dans la langue indiquée dans le paramètre LOCALE. ESF_COMP_DEPLOYABLE_PACKAGE Cette table contient une ligne pour chaque package déployable compatible avec une configuration MVE. ESF_COMP_DEPLOYABLE_PACKAGE Nom du champ Type de données Description ESF_COMPONENT_ID BIGINT Clé étrangère pour CONFIGURATION_COMPONENT.CONFIGURATION_COMPONENT_ID. ESF_DP_ID VARCHAR(255) Clé étrangère pour ESF_DEPLOYABLE_PACKAGE.ESF_DP_ID. ESF_DEPLOYABLE_PACKAGE Cette table présente tous les packages déployables téléchargés dans la bibliothèque MVE. ESF_DEPLOYABLE_PACKAGE Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ESF_DP_ID BIGINT Clé principale. NAME VARCHAR(255) Nom des packages déployables. PART_NUMBER VARCHAR(255) Référence du package déployable. PART_REVISION VARCHAR(255) Révision partielle du package déployable. LICENSE_REQUIRED SMALLINT/ TINYINT * Indicateur qui détermine si une licence est requise pour le package déployable. URI VARCHAR(255) URI du package déployable. DATE_IMPORTED TIMESTAMP Date d'importation du package déployable. VERSION VARCHAR(255) Version du package déployable. DESCRIPTION VARCHAR(255) Description du package déployable. ESF_DEPLOYABLE_PACKAGE_LOCALE Cette table contient le nom et la description de chaque package déployable dans toutes les langues prises en charge par MVE. ESF_DEPLOYABLE_PACKAGE_LOCALE Nom du champ Type de données Description ESF_DP_LOCALE_ID BIGINT Clé principale. ESF_DP_ID BIGINT Clé étrangère pour ESF_DEPLOYABLE_PACKAGE.ESF_ DP_ID. LOCALE VARCHAR(255) Code de langue à deux caractères. NAME VARCHAR(255) Nom de du package déployable dans la langue indiquée dans le paramètre LOCALE. DESCRIPTION VARCHAR(2048) Longueur de description augmentée, de 510 à 2048 caractères. ESF_DP_SUPPORTED MODELS Cette table contient une ligne pour chaque modèle pris en charge par un package déployable dans la bibliothèque MVE. ESF_DP_SUPPORTED MODELS Nom du champ Type de données Description ESF_DP_ID BIGINT Clé étrangère renvoyée à ESF_DEPLOYABLE_PACKA GE.ESF_DP_ID. SUPPORTED_MODEL VARCHAR(255) Nom du modèle de l'imprimante prise en charge par le package déployable. ESF_LICENSE Cette table présente les licences pour les applications eSF disponibles dans la bibliothèque MVE. ESF_LICENSE Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ESF_LICENSE_ID BIGINT Clé principale. PRINTER_SERIAL VARCHAR(255) Numéro de série de l'imprimante à laquelle la licence est liée. PART_NUMBER VARCHAR(255) Numéro de référence du package auquel la licence est liée. PART_REVISION VARCHAR(255) Révision partielle du package auquel la licence est liée. LICENSE_TYPE VARCHAR(255) Vous pouvez choisir parmi les options suivantes : TRIAL et PRODUCTION. FILE_NAME VARCHAR(255) Nom de fichier du fichier binaire de licence. DEPLOYED SMALLINT/ TINYINT * Indicateur qui détermine si la licence a été déployée. RAWESFAPPFILE Cette table présente les détails du fichier d'application eSF brut disponible dans la bibliothèque MVE. RAWESFAPPFILE Nom du champ Type de données Description ID BIGINT Clé principale. FICHIER VARCHAR(255) Nom du fichier de package. DISPLAY_NAME VARCHAR(255) Nom d'affichage du fichier de package. DATE_IMPORTED TIMESTAMP Horodatage de l'importation du package. SHA1 VARCHAR(255) Hachage SHA1 du package. DESCRIPTION VARCHAR(255) Description du package. APP_ID VARCHAR(255) ID d'application du package. VERSION VARCHAR(255) Version du package. APP_FLS_RESOURCE_FILES Cette table présente l'association du fichier d'applications eSF disponible dans la bibliothèque MVE avec la configuration. APP_FLS_RESOURCE_FILES Nom du champ Type de données Description RESOURCE_ID BIGINT Clé principale. SHA1 VARCHAR(255) Hachage SHA1 du package. RESOURCE_TYPE VARCHAR(255) Type de fichier de ressources. Vous pouvez choisir parmi les options suivantes : UCF_FILE, VCC_FILE et APP_FLS. CONFIGURATION_COMPONENT_ID BIGINT Clé étrangère de la colonne ID de la table CONFIGURATION_COMPONENT. ESF"},{"UUID":"a4fc49e8-29ce-4c09-87f3-42fbe12b021e","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Gestion des certificats Vous trouverez","descFull":"Gestion des certificats Vous trouverez ci-après la liste des certifications à vérifier. ENROLLMENT_STATUS La table suivante répertorie les certificats émis. ENROLLMENT_STATUS Nom du champ Type de données Description ENROLLMENT_STATUS_ID BIGINT Clé principale. CERTIFICATE_ENROL_STATUS VARCHAR(255) Etat de l'inscription du certificat. Les options sont Emis, En attente et Echec. CERT_ENROL_TRANSACTION_ID VARCHAR(2048) Réponse du certificat en attente pour EST. Parfois, ce champ affiche l'ID transaction de l'inscription du certificat. CERT_SUBJECT_IDENTITY VARCHAR(255) Identité d'objet du certificat. CERT_SERIAL_NUMBER VARCHAR(255) Numéro de série du certificat émis. PRINTER_ID BIGINT Imprimante de référence. DEFAULT_CERT_REVISION_NO VARCHAR(255) Numéro de révision du certificat qui a été renouvelé. DEFAULT_CERT_RENEWAL_DATE VARCHAR(255) Date de renouvellement du certificat. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) Nom convivial du certificat. CERTIFICATE_USED_FOR VARCHAR(255) Association du certificat nommé. Vous pouvez choisir parmi les options suivantes : DEFAULT, HTTPS, WIRELESS, IPSEC et UNASSIGNED. CA_CERT_REVOCATION_COMP_LIST La table suivante répertorie les informations concernant les certificats révoqués. CA_CERT_REVOCATION_COMP_LIST Nom du champ Type de données Description ID BIGINT Identifiant unique. SERIAL_NUMBER VARCHAR(255) Numéro de série du certificat présent dans la clé principale de la liste de révocation. CERTIFICATE_SUBJECT VARCHAR(255) Objet du certificat révoqué. REVOCATION_DATE TIMESTAMP Date à laquelle le certificat est révoqué. ISSUER VARCHAR(255) Emetteur du certificat révoqué. REVOCATION_REASON VARCHAR(255) Motif de révocation. NAMED_CERTIFICATE_SETTINGS La table suivante répertorie le nom et l'association du certificat nommé. NAMED_CERTIFICATE_SETTINGS Nom du champ Type de données Description CERT_SETTING_ID BIGINT Identifiant unique. FRIENDLY_NAME VARCHAR(255) Nom convivial du certificat nommé. CERT_USED_FOR VARCHAR(255) Association du certificat nommé. Vous pouvez choisir parmi les options suivantes : DEFAULT, HTTPS, WIRELESS, IPSEC et UNASSIGNED. CONFIGURATION_COMPONENT_ID BIGINT Clé étrangère associée à l'ID de la table CONFIGURATION_COMPONENT. TEMPLATE_ID BIGINT ID du modèle associé. PRINTER_CERTIFICATE La table suivante présente les détails du certificat nommé. PRINTER_CERTIFICATE Nom du champ Type de données Description CERTIFICATE_ID BIGINT Identifiant unique. CERTIFICATE_FRIENDLY_NAME VARCHAR(255) Nom convivial du certificat. CERTIFICATE_COMMON_NAME VARCHAR(255) Nom commun du certificat. CERTIFICATE_ISSUER_NAME VARCHAR(255) Nom de l'émetteur du certificat. CERTIFICATE_SIGNING_STATUS VARCHAR(255) Etat de signature du certificat. Vous pouvez choisir parmi les options suivantes : SIGNED, INVALID_CERT, NO_CA, REVOKED et UNKNOWN. CERTIFICATE_VALID_FROM TIMESTAMP Heure de début de validité du certificat. CERTIFICATE_VALID_TO TIMESTAMP Heure de fin de validité du certificat. CERTIFICATE_SIGNATURE VARCHAR(8190) Signature du certificat. CERTIFICATE_SERIAL_NUMBER VARCHAR(255) Numéro de série du certificat. TYPE VARCHAR(255) Type de certificat. Vous pouvez choisir parmi les options suivantes : DEFAULT, HTTPS, WIRELESS, IPSEC et UNASSIGNED. PRINTER_ID BIGINT Clé étrangère associée à l'ID de la table CONFIGURATION_COMPONENT. ENROLLED_CERTIFICATE_TYPE La table suivante indique la relation entre le certificat et l'état de l'inscription. ENROLLED_CERTIFICATE_TYPE Nom du champ Type de données Description TYPE_ID BIGINT Identifiant unique. ENROLLMENT_STATUS_ID BIGINT Clé étrangère de la colonne ID de la table ENROLLMENT_STATUS. TYPE VARCHAR(255) Type de certificat. Vous pouvez choisir parmi les options suivantes : DEFAULT, HTTPS, WIRELESS, IPSEC et UNASSIGNED. CA_TEMPLATE La table suivante affiche les détails des modèles sélectionnés lors de la configuration du serveur MSCA à l'aide du protocole MSCEWS. CA_TEMPLATE Nom du champ Type de données Description TEMPLATE_ID BIGINT Identifiant unique des modèles pour le serveur MSCA avec MSCEWS (ne peut pas être nul). TEMPLATE_NAME VARCHAR(255) Nom des modèles sur le serveur CEP. TEMPLATE_OID VARCHAR(255) Chemin MIB SNMP correspondant. Gestion des certificats"},{"UUID":"0ef329d7-ae38-4971-96c6-f39ad10f2b6d","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Authentification et autorisation Les tables","descFull":"Authentification et autorisation Les tables suivantes sont utilisées dans le mécanisme d'authentification et d'autorisation de l'utilisateur de MVE. MASTER_ROLE Cette table comprend tous les rôles pris en charge par MVE. MASTER_ROLE Nom du champ Type de données Description ID BIGINT Clé principale. ROLE_NAME VARCHAR(255) Nom du rôle. USERS Cette table énumère tous les comptes utilisateur internes de MVE. USERS Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ID BIGINT Clé principale. USER_NAME VARCHAR(15) Nom d'utilisateur fourni par l'utilisateur. USER_PASS VARCHAR(1024) Mot de passe fourni par l'utilisateur. ENABLED SMALLINT/ TINYINT * Indicateur qui détermine si ce compte est activé. NAME VARCHAR(255) Nom complet de l'utilisateur. LAST_LOGIN TIMESTAMP Horodatage de la dernière tentative de connexion. LOGIN_ATTEMPT BIGINT Nombre actuel de tentatives effectuées pour une connexion réussie. REFRESH_TOKEN VARCHAR(1024) Jeton d'authentification lorsque l'utilisateur se connecte. USER_ROLE Cette table décrit l'association des utilisateurs aux rôles. USER_ROLE Nom du champ Type de données Description ID BIGINT Clé principale. USER_NAME VARCHAR(15) Clé étrangère renvoyée à USERS.USER_NAME. ROLE_NAME VARCHAR(30) Clé étrangère renvoyée à MASTER_ROLE.ROLE_NAME. authentification et autorisation"},{"UUID":"8aaebb0b-de59-477a-8dbb-2a97a79831a8","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Paramètres de sécurité Les tables","descFull":"Paramètres de sécurité Les tables suivantes décrivent les paramètres de sécurité d'une configuration. Les informations de configuration de sécurité sont chiffrées pour préserver la sécurité des données. Elles sont indisponibles en dehors de MVE et inutiles dans le cadre du présent document. Les détails des tables suivantes ne sont donc pas mentionnés. SEC_ACCESS_CONTROL SEC_AUTH_GROUP SEC_BUILDING_BLOCK SEC_BUILDING_BLOCK_SETTINGS SEC_COMPONENT_MISC_SETTINGS SEC_INTERNAL_ACCOUNT SEC_INTERNAL_ACCOUNT_GROUPS SEC_INTERNAL_ACCOUNT_SETTINGS SEC_SECURITY_TEMPLATE SEC_SECURTY_TEMPLATE_BBS SEC_SECURITY_TEMPLATE_GROUPS CAESAR2_LOCAL_ACCOUNTS CAESAR2_MISC_SETTINGS CAESAR2_KRB_SETUP CAESAR2_COMP_LOCAL_ACCTS CAESAR2_LOCAL_ACCOUNT_GROUPS CAESAR2_GROUPS CAESAR2_COMP_GROUPS CAESAR2_GROUP_PERMISSIONS CAESAR2_KRB_SETUP_PERMISSIONS CAESAR2_COMP_PUBLIC_PERMS CAESAR2_LDAP_SETUPS CAESAR2_COMP_LDAP_SETUPS CAESAR2_LDAP_SEARCH_OBJECTS CAESAR2_LDAP_SETUP_GROUPS CAESAR2_LDAP_SERVER_INFO CAESAR2_LDAP_DEVICE_CREDS CAESAR2_SOLUTION_ACCTS CAESAR2_LDAP_ADDRESS_BOOKS CAESAR2_LDAP_SEARCH_ATTRS CAESAR2_COMP_SOLN_ACCTS CAESAR2_SOLUTION_ACCT_GROUPS CAESAR2_MISC_SETTINGS CAESAR2_MISC_SETTINGS Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. MINIMUM_PASSWORD_LENGTH SMALLINT/ TINYINT * Ajout d'un nouveau paramètre divers sous le composant de sécurité avancé. PROTECTED_FEATURES VARCHAR(255) PRINT_PERMISSION_PRINT VARCHAR(255) PRINT_PERMISSION_BROWSER VARCHAR(255) PRINT_PERMISSION_CONTROL_PAN EL VARCHAR(255) Paramètres de sécurité"},{"UUID":"5b3e5863-ecba-425c-9b74-476bab9709be","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Vues et exportation de données","descFull":"Vues et exportation de données Les tables suivantes décrivent les Vues dans MVE et les champs inclus dans chaque vue. DATA_EXPORT_TEMPLATE Cette table contient des informations sur les Vues dans MVE. DATA_EXPORT_TEMPLATE Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. DATA_EXPORT_ID BIGINT Clé principale. NAME VARCHAR(255) Nom de la vue. DEFAULT_TEMPLATE SMALLINT/ TINYINT * Si, lors de la première connexion, c'est le modèle par défaut qui s'affiche, une seule vue peut avoir cette valeur définie sur  True . LANGUAGE_CODE VARCHAR(255) Obsolète. INCLUDE_HEADER SMALLINT/ TINYINT * Obsolète. WRAP_FIELDS SMALLINT/ TINYINT * Obsolète. DESCRIPTION VARCHAR(4000) Description de la vue. IS_SYSTEM SMALLINT/ TINYINT * Ce champ indique si le modèle est une vue système, qui ne peut être ni modifiée ni supprimée. IDENTIFIER_FIELD VARCHAR(255) Champ d'identifiant choisi pour cette vue. DATA_EXPORT_FIELDS Cette table contient les champs inclus dans chaque vue. DATA_EXPORT_FIELDS Nom du champ Type de données Description FIELD_INDEX Entier Clé principale. FIELD VARCHAR(255) Nom du champ à inclure dans la vue. DATA_EXPORT_ID BIGINT Clé étrangère pour DATA_EXPORT_TEMPLATE.DATA_EXP ORT_ID. Vues et exportation de données"},{"UUID":"f093abd1-7aa6-41b2-8b5e-16b215534d79","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Gestionnaire d'événements Les tables suivantes","descFull":"Gestionnaire d'événements Les tables suivantes concernent les informations relatives à la création et à la gestion des événements. ALERTE Cette table comprend toutes les alertes prises en charge par MVE. ALERTE Nom du champ Type de données Description ID BIGINT Clé principale NAME VARCHAR(255) Nom textuel de l'alerte. Exemple « Alerte de consommables » SEVERITY VARCHAR(255) Par exemple, « ERROR ». CATEGORIE VARCHAR(255) Par exemple, « SUPPLIES ». ASSIGNED_EVENTS Cette table lie les événements aux éléments de configuration qui leur sont assignés. ASSIGNED_EVENTS Nom du champ Type de données Description CI_ID BIGINT Clé principale composite. Fait référence à CONFIG_ITEM.CI_ID. EVENT_ID BIGINT Clé principale composite. Fait référence à EVENT.EVENT_ID. EVENT_REGISTRATION_STATE VARCHAR(255) Vous pouvez choisir parmi les options suivantes : REGISTERED et NOT_REGISTERED. DESTINATION Cette table présente une action au sein du module Gestionnaire d'événements. DESTINATION Nom du champ Type de données Description ID BIGINT Clé principale. DESTINATION_TYPE VARCHAR(31) Type de destination, actuellement par courrier électronique ou commande shell. Selon le type, toutes les colonnes ne s'appliquent pas. NAME VARCHAR(255) Nom de la destination, fourni par l'utilisateur EMAIL_BODY VARCHAR(255) Texte du corps du courrier électronique. EMAIL_CC VARCHAR(255) Liste CC du courrier électronique. EMAIL_FROM VARCHAR(255) Texte du champ Expéditeur du courrier électronique. EMAIL_SUBJECT VARCHAR(255) Texte du champ Objet du courrier électronique. EMAIL_TO VARCHAR(255) Texte du champ Destinataire du courrier électronique. COMMAND_PATH VARCHAR(255) Chemin complet de la commande. COMMAND_PARAMS VARCHAR(255) Tout paramètre à envoyer à la commande. DESCRIPTION VARCHAR(4000) Description facultative de l'action, fournie par l'utilisateur. LAST_MODIFIED Horodatage Date de la dernière modification de l'action. EVENEMENT Cette table comprend les événements créés par l'utilisateur, constitués d'un nom, d'une description et des alertes à inclure. EVENEMENT Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. NAME VARCHAR(255) Nom de l'événement, fourni par l'utilisateur. DESCRIPTION VARCHAR(255) Description de l'événement, fournie par l'utilisateur. EVENT_ID BIGINT Clé principale. TRIGGER_DESTINATIONS VARCHAR(255) Déclencheur de destination de l'événement. Vous pouvez choisir parmi les options suivantes : on_active_only et on_active_and_clear. GRACE_PERIOD_ENABLED SMALLINT/ TINYINT * Indicateur qui détermine si un délai de grâce est activé. GRACE_PERIOD_MINUTES INTEGER Période de grâce en minutes. LAST_MODIFIED TIMESTAMP Heure de la dernière modification de l'événement. EVENT_ALERTS Cette table relie un événement à la collection d'alertes qu'il inclut. EVENT_ALERTS Nom du champ Type de données Description EVENT_ID BIGINT Clé principale composite. Fait référence à EVENT.EVENT_ID. ALERT_ID BIGINT Clé principale composite. Fait référence à ALERT.ALERT_ID. EVENT_DESTINATIONS Cette table relie un événement à une action associée. EVENT_DESTINATIONS Nom du champ Type de données Description EVENT_ID BIGINT Clé principale composite. Fait référence à EVENT.EVENT_ID. DESTINATION_ID BIGINT Clé principale composite. Fait référence à DESTINATION.DESTINATION_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Cette table présente les conditions ou alertes actives pour les imprimantes ainsi que les événements qui déclenchent cette condition ou alerte. Plusieurs conditions sont représentées sur plusieurs lignes, pointant toutes vers le même PRINTER_ID. PRINTER_EVENT_ACTIVE_CONDITIONS Nom du champ Type de données Description ACTIVE_CONDITION_ID BIGINT Clé principale. LOCATION VARCHAR(255) Par exemple, « Tiroir 1 ». MESSAGE VARCHAR(255) Par exemple, « Tiroir manquant ». TYPE VARCHAR(255) Par exemple, « Intervention requise ». CI_ID BIGINT Fait référence à CONFIG_ITEM.ID. DESTINATION_TASK_ID VARCHAR(80) Clé étrangère renvoyée à SYSTEM_LOG.TASK_ID. Gestionnaire d'événements"},{"UUID":"4d9a22e2-76e6-492f-b2fe-8f2dcb76338a","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Divers Les tables suivantes sont","descFull":"Divers Les tables suivantes sont utiles pour le stockage mais ne correspondent à aucune des catégories de tables précédentes. APPLICATION_SETTINGS Cette table contient actuellement tous les paramètres système MVE. Les valeurs sont chiffrées et indisponibles hors de MVE. APPLICATION_SETTINGS Nom du champ Type de données Description ID BIGINT Clé principale. SETTING_KEY VARCHAR(255) Nom de préférence. SETTING_VALUE VARCHAR(8190) Valeur de préférence. BOOKMARK Cette table contient toutes les recherches enregistrées de MVE. Elles sont actuellement stockées en tant que BLOB ; par conséquent, elles ne peuvent pas être éditées en dehors de MVE. BOOKMARK Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ID BIGINT Clé principale. DEFAULT_SEARCH SMALLINT/ TINYINT * Indicateur qui détermine si ce signet est l'un des paramètres par défaut fournis avec MVE. NAME VARCHAR(255) Nom du signet, fourni par l'utilisateur. SEARCH_CRITERIA BLOB SUB_TYPE 0 Représentation binaire du signet. DESERIALIZABLE SMALLINT/ TINYINT * Indique si la recherche enregistrée est désérialisable. DESCRIPTION VARCHAR(4000) Description facultative de la recherche enregistrée saisie par l'utilisateur. Tables Liquibase et Hibernation Liquibase et Hibernation sont des bibliothèques tierces que MVE utilise pour assurer la gestion de la base de données. Ces bibliothèques utilisent les tables suivantes. Ces tables ne contenant pas de données importantes sur l'imprimante, leur contenu n'est pas détaillé ici. DATABASECHANGELOG DATABASECHANGELOGLOCK Toutes les tables dont les noms commencent par  HT_ . HIBERNATESEQUENCE SMTP_CONFIGURATION Cette table contient la configuration pour le protocole SMTP (Simple Mail Transfer Protocol), qui permet aux utilisateurs de MVE d'envoyer des courriers électroniques. SMTP_CONFIGURATION Nom du champ Type de données Description * Ce type de données est requis pour Microsoft SQL Server. ID BIGINT Clé principale. FROM_ADDRESS VARCHAR(255) Adresse e-mail de l’expéditeur. LOGIN_ID VARCHAR(255) ID utilisateur pour le serveur SMTP. LOGIN_PASSWORD VARCHAR(255) Mot de passe associé à l'ID utilisateur pour le serveur SMTP. LOGIN_REQ SMALLINT/ TINYINT * Indicateur qui détermine si le serveur SMTP requiert une connexion. SMTP_PORT BIGINT Port du serveur SMTP. SMTP_SERVER VARCHAR(255) Nom d'hôte ou adresse IP du serveur SMTP. SMTP_ENABLE SMALLINT/ TINYINT * Indicateur qui détermine si SMTP est activé. EMAIL_ENCRYPTION VARCHAR(64) Fait référence aux types de chiffrement pris en charge. La valeur par défaut est null. SYSTEM_LOG Cette table contient tous les messages liés au journal système qui sont produits lorsque MVE exécute ses tâches. Cette table peut être extrêmement grande. SYSTEM_LOG Nom du champ Type de données Description LOG_ID BIGINT Clé principale. TIMESTAMP_ TIMESTAMP Heure à laquelle le message a été consigné. TASKID BIGINT Instance de tâche qui a produit le message. TASKNAME VARCHAR(50) Tâche qui a produit le message LEVEL_ INTEGER Vous pouvez choisir parmi les options suivantes : DEBUG, INFO, etc. MESSAGE_ VARCHAR(8000) Message consigné actuel USER_NAME VARCHAR(255) Nom de l'utilisateur qui a exécuté l'action. IP_ADDRESS VARCHAR(50) Adresse IP du client. Divers"},{"UUID":"376cbacf-9f71-4520-8f04-0a24866a7ff0","title":"Tables FRAMEWORK et noms du champ","link":"config-item-topic.html","desc":"Quartz DB QRTZ_FIRED_TRIGGERS Nom du","descFull":"Quartz DB QRTZ_FIRED_TRIGGERS Nom du champ Type de données Description SCHED_TIME BIGINT Nouvelle colonne ajoutée pour l'heure programmée. Quartz DB"},{"UUID":"e037dc65-d7ad-47dc-ac0f-b9512f3eb8aa","title":"Annexe","link":"understanding-ports-and-protocols-topic.html","desc":"Présentation des ports et protocoles","descFull":"Présentation des ports et protocoles MVE utilise différents ports et protocoles pour différents types de communication réseau, comme illustré dans le diagramme ci-dessous : Les ports sont bidirectionnels et doivent être ouverts ou actifs pour que MVE puisse fonctionner correctement. Vérifiez que tous les ports d'imprimante sont activés. Certaines communications requièrent l'utilisation d'un port éphémère (gamme allouée de ports disponibles sur le serveur). Lorsqu'un client demande une session de communication temporaire, le serveur lui attribue un port dynamique. Le port n'est valide que pour une courte durée et peut redevenir disponible lorsque la session précédente expire. Communication du serveur vers les imprimantes Ports et protocoles utilisés pour la communication entre le serveur MVE et les imprimantes réseau Protocole serveur MVE Imprimante Utilisé pour Network Printing Alliance Protocol (NPAP) UDP 9187 UDP 9300 Communication avec les imprimantes réseau Lexmark. Communication avec les imprimantes réseau. XML Network Transport (XMLNT) UDP 9187 UDP 6000 Communication avec certaines imprimantes réseau Lexmark. Communication avec certaines imprimantes réseau. Lexmark Secure Transport (LST) UDP 6100 Port TCP (Transmission Control Protocol) éphémère (signaux de reconnaissance) UDP 6100 TCP 6110 (signaux de reconnaissance) Communication sécurisée avec certaines imprimantes réseau Lexmark. Communication sécurisée avec certaines imprimantes réseau. Multicast Domain Name System (mDNS) Port UDP (User Datagram Protocol) éphémère UDP 5353 Détection des imprimantes réseau Lexmark et détermination des fonctions de sécurité des imprimantes. Détection de certaines imprimantes réseau et détermination des fonctions de sécurité des imprimantes. ce port est nécessaire pour permettre à MVE de communiquer avec les imprimantes sécurisées. Simple Network Management Protocol (SNMP) Port UDP éphémère UDP 161 Détection et communication avec des imprimantes réseau Lexmark et tierces. Détection et communication avec des imprimantes réseau. FTP (File Transfer Protocol) Port TCP éphémère TCP 21 TCP 20 Déploiement de fichiers. Hypertext Transfer Protocol (HTTP) Port TCP éphémère TCP 80 Déploiement de fichiers ou mise en œuvre de configurations. TCP 443 Déploiement de fichiers ou mise en œuvre de configurations. Hypertext Transfer Protocol over SSL (HTTPS) Port TCP éphémère TCP 161 TCP 443 Déploiement de fichiers ou mise en œuvre de configurations. RAW Port TCP éphémère TCP 9100 Déploiement de fichiers ou mise en œuvre de configurations. Communication des imprimantes vers le serveur Port et protocole utilisés pour la communication entre les imprimantes réseau et le serveur MVE Protocole Imprimante serveur MVE Utilisé pour NPAP UDP 9300 UDP 9187 Génération et réception d'alertes Communication serveur vers base de données Ports et protocoles utilisés pour la communication entre le serveur MVE et les bases de données serveur MVE Base de données Utilisé pour Port TCP éphémère Port défini par l'utilisateur. Le port par défaut est TCP 1433. Communication avec une base de données SQL Server. Port TCP éphémère TCP 3050 Communication avec une base de données Firebird. Communication des clients vers le serveur Port et protocole utilisés pour la communication entre le client navigateur et le serveur MVE Protocole Client navigateur serveur MVE Hypertext Transfer Protocol over SSL (HTTPs) Port TCP TCP 443 Communication du serveur vers le serveur de messagerie Port et protocole utilisés pour la communication entre le serveur MVE et un serveur de messagerie électronique Protocole serveur MVE Serveur SMTP Utilisé pour Simple Mail Transfer Protocol (SMTP) Port TCP éphémère Port défini par l'utilisateur. Le port par défaut est TCP 25. Fonction de courrier électronique permettant de recevoir des alertes des imprimantes. Communication du serveur vers le serveur LDAP Ports et les protocoles utilisés pour la communication entre le serveur MVE et un serveur LDAP mettant en jeu les groupes d'utilisateurs et l'authentification Protocole serveur MVE serveur LDAP Utilisé pour Lightweight Directory Access Protocol (LDAP) Port TCP éphémère Port défini par l'utilisateur. Le port par défaut est TCP 389. Authentification des utilisateurs MVE via un serveur LDAP. Lightweight Directory Access Protocol over TLS (LDAPS) Port TCP éphémère Port défini par l'utilisateur. Le port par défaut est TCP 636. Authentification des utilisateurs MVE via un serveur LDAP sur TLS. Kerberos Port UDP éphémère Port défini par l'utilisateur. Le port par défaut est UDP 88. Authentification des utilisateurs MVE via Kerberos. ports présentation protocoles présentation"},{"UUID":"68e62a9c-71ad-4826-82d1-75bb7100b34b","title":"Annexe","link":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html","desc":"Activation de l'approbation automatique des","descFull":"Activation de l'approbation automatique des demandes de certificat dans l'autorité de certification Microsoft Par défaut, tous les serveurs CA sont en mode En attente et vous devez approuver manuellement chaque demande de certificat signée. Etant donné que cette méthode n'est pas possible pour les demandes groupées, activez l'approbation automatique des certificats signés. Dans Server Manager, cliquez sur  Outils  Autorité de certification . Dans le panneau de gauche, cliquez avec le bouton droit de la souris sur l'autorité de certification, puis cliquez sur  Propriétés  Module de stratégie . Dans l'onglet  Traitement des demandes , cliquez sur  Suivre les paramètres du modèle de certificat, le cas échéant , puis cliquez sur  OK . Si l'option  Définir l'état de la demande de certificat sur En attente  est sélectionnée, vous devez approuver manuellement le certificat. Redémarrez le service d'autorité de certification. activation de l'approbation automatique des demandes de certificat dans l'autorité de certification Microsoft approbation automatique des demandes de certificat activation dans l'autorité de certification Microsoft demandes de certificat dans l'autorité de certification Microsoft approbation automatique"},{"UUID":"9cedf042-ae3c-4893-9e99-c851fccab599","title":"Annexe","link":"revoking-certificates-topic.html","desc":"Révocation des certificats Avant de","descFull":"Révocation des certificats Avant de commencer, vérifiez que le serveur d'autorité de certification est configuré pour les CRL et qu'ils sont disponibles. Depuis le serveur d'autorité de certification, ouvrez  Autorité de certification . Dans le panneau de gauche, développez l'autorité de certification, puis cliquez sur  Certificats fournis . Cliquez avec le bouton droit de la souris sur un certificat à révoquer, puis cliquez sur  Toutes les tâches  Révoquer le certificat . Sélectionnez un code de motif, ainsi que la date et l'heure de la révocation, puis cliquez sur  Oui . Dans le panneau de gauche, cliquez avec le bouton droit de la souris sur  Certificats révoqués , puis cliquez sur  Toutes les tâches  Publier . Vérifiez que le certificat que vous avez révoqué se trouve dans  Certificats révoqués . Vous pouvez voir le numéro de série du certificat révoqué dans le fichier CRL. révocation des certificats certificats révocation"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{attrs:{"id":"divd0e8"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('div',{attrs:{"id":"divd0e18169"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"MarkVision Enterprise"}},[_vm._v("\n    MarkVision Enterprise\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"change-history.html#change-history_fr","title":"Historique des modifications"}},[_vm._v("\n    Historique des modifications\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-chapter_fr","title":"Aper&ccedil;u"}},[_vm._v("\n    Aperçu\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e260"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-chapter.html#overview-markvision-enterprise_fr","title":"Comprendre Markvision Enterprise"}},[_vm._v("\n     Comprendre Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"getting-started-chapter.html#getting-started-chapter_fr","title":"Mise en route"}},[_vm._v("\n    Mise en route\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e289"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"best-practices-topic.html#best-practices_fr","title":"Meilleures pratiques"}},[_vm._v("\n     Meilleures pratiques\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"system-requirements-topic.html#system-requirements_fr","title":"Configuration requise"}},[_vm._v("\n     Configuration requise\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-languages-topic.html#supported-languages_fr","title":"Langues prises en charge"}},[_vm._v("\n     Langues prises en charge\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-printer-models-topic.html#supported-printer-models_fr","title":"Mod&egrave;les d'imprimante pris en charge"}},[_vm._v("\n     Modèles d'imprimante pris en charge\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-database-topic.html#setting-up-database_fr","title":"Configuration de la base de donn&eacute;es"}},[_vm._v("\n     Configuration de la base de données\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-mve-run-as-user-topic.html#d0e1132","title":"Configuration d'une ex&eacute;cution en tant qu'utilisateur"}},[_vm._v("\n     Configuration d'une exécution en tant qu'utilisateur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-markvision-topic.html#installing-markvision_fr","title":"Installation de MVE"}},[_vm._v("\n     Installation de MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-mve-silently-topic.html#installing-mve-silently_fr","title":"Installation silencieuse de MVE"}},[_vm._v("\n     Installation silencieuse de MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-topic.html#accessing-mve_fr","title":"Acc&egrave;s &agrave; MVE"}},[_vm._v("\n     Accès à MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-language-topic.html#changing-language_fr","title":"Modification de la langue"}},[_vm._v("\n     Modification de la langue\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-your-password-topic.html#changing-your-password_fr","title":"Modification de votre mot de passe"}},[_vm._v("\n     Modification de votre mot de passe\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-application-chapter.html#maintaining-application-chapter_fr","title":"Maintenance de l'application"}},[_vm._v("\n    Maintenance de l'application\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1715"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"upgrading-to-latest-version-topic.html#upgrading-to-latest-version_fr","title":"Mise &agrave; niveau vers MVE&nbsp;4.3"}},[_vm._v("\n     Mise à niveau vers MVE 4.3\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_fr","title":"Sauvegarde et restauration de la base de donn&eacute;es"}},[_vm._v("\n     Sauvegarde et restauration de la base de données\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-installer-settings-topic.html#changing-installer-settings_fr","title":"Mise &agrave; jour des param&egrave;tres du programme d'installation apr&egrave;s l'installation"}},[_vm._v("\n     Mise à jour des paramètres du programme d'installation après l'installation\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-user-access-chapter.html#setting-user-access-chapter_fr","title":"Configuration de l'acc&egrave;s utilisateur"}},[_vm._v("\n    Configuration de l'accès utilisateur\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1987"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-user-access-overview-topic.html#setting-up-user-access-overview_fr","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-user-roles-topic.html#understanding-user-roles_fr","title":"Pr&eacute;sentation des r&ocirc;les utilisateur"}},[_vm._v("\n     Présentation des rôles utilisateur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-users-topic.html#managing-users_fr","title":"Gestion des utilisateurs"}},[_vm._v("\n     Gestion des utilisateurs\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_fr","title":"Activation de l'authentification de serveur&nbsp;LDAP"}},[_vm._v("\n     Activation de l'authentification de serveur LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_fr","title":"Installation de certificats de serveur LDAP"}},[_vm._v("\n     Installation de certificats de serveur LDAP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_fr","title":"Ajout d'un certificat CA racine dans le magasin d'approbation Java"}},[_vm._v("\n     Ajout d'un certificat CA racine dans le magasin d'approbation Java\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"discovering-devices-chapter.html#discovering-devices-chapter_fr","title":"D&eacute;tection des imprimantes"}},[_vm._v("\n    Détection des imprimantes\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2401"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-discovery-profile-topic.html#creating-discovery-profile_fr","title":"Cr&eacute;ation d'un profil de recherche"}},[_vm._v("\n     Création d'un profil de recherche\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-discovery-profiles-topic.html#managing-discovery-profiles_fr","title":"Gestion des profils de recherche"}},[_vm._v("\n     Gestion des profils de recherche\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_fr","title":"Exemple de sc&eacute;nario&nbsp;: D&eacute;tection des imprimantes"}},[_vm._v("\n     Exemple de scénario : Détection des imprimantes\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_fr","title":"Gestion du tableau de bord de s&eacute;curit&eacute;"}},[_vm._v("\n    Gestion du tableau de bord de sécurité\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2657"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"overview-security-dashboard-topic.html#overview-security-dashboard_fr","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-dashboard-topic.html#accessing-dashboard_fr","title":"Acc&egrave;s au tableau de bord de s&eacute;curit&eacute;"}},[_vm._v("\n     Accès au tableau de bord de sécurité\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-security-information-topic.html#managing-device-security-information_fr","title":"Gestion de la page Informations de s&eacute;curit&eacute; du p&eacute;riph&eacute;rique"}},[_vm._v("\n     Gestion de la page Informations de sécurité du périphérique\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-device-conformance-check-topic.html#managing-device-conformance-check_fr","title":"Gestion de la page Contr&ocirc;le de conformit&eacute; d'un p&eacute;riph&eacute;rique"}},[_vm._v("\n     Gestion de la page Contrôle de conformité d'un périphérique\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"finding-devices-chapter.html#finding-devices-chapter_fr","title":"Affichage des imprimantes"}},[_vm._v("\n    Affichage des imprimantes\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e2766"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-printer-list-topic.html#viewing-printer-list_fr","title":"Affichage de la liste des imprimantes"}},[_vm._v("\n     Affichage de la liste des imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-device-information-topic.html#viewing-device-information_fr","title":"Affichage des informations de l'imprimante"}},[_vm._v("\n     Affichage des informations de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-data-topic.html#exporting-data_fr","title":"Exportation des donn&eacute;es de l'imprimante"}},[_vm._v("\n     Exportation des données de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-views-topic.html#managing-views_fr","title":"Gestion des vues"}},[_vm._v("\n     Gestion des vues\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-printer-listing-view-topic.html#changing-printer-listing-view_fr","title":"Modification de la vue Liste des imprimantes"}},[_vm._v("\n     Modification de la vue Liste des imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_fr","title":"Filtrage des imprimantes via la barre de recherche"}},[_vm._v("\n     Filtrage des imprimantes via la barre de recherche\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-keywords-topic.html#managing-keywords_fr","title":"Gestion des mots cl&eacute;s"}},[_vm._v("\n     Gestion des mots clés\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-device-life-cycle-states-topic.html#d0e3226","title":"Utilisation des recherches enregistr&eacute;es"}},[_vm._v("\n     Utilisation des recherches enregistrées\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_fr","title":"Exemple de sc&eacute;nario&nbsp;: Surveillance des niveaux de toner de votre parc"}},[_vm._v("\n     Exemple de scénario : Surveillance des niveaux de toner de votre parc\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-devices-chapter.html#securing-devices-chapter_fr","title":"S&eacute;curisation des communications avec l'imprimante"}},[_vm._v("\n    Sécurisation des communications avec l'imprimante\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4163"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-security-status-topic.html#understanding-security-status_fr","title":"Pr&eacute;sentation des &eacute;tats de s&eacute;curit&eacute; de l'imprimante"}},[_vm._v("\n     Présentation des états de sécurité de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-using-default-config-topic.html#securing-printers-using-default-config_fr","title":"S&eacute;curisation des imprimantes &agrave; l'aide des configurations par d&eacute;faut"}},[_vm._v("\n     Sécurisation des imprimantes à l'aide des configurations par défaut\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-fac-permissions-topic.html#understanding-fac-permissions_fr","title":"Pr&eacute;sentation des autorisations et des contr&ocirc;les d'acc&egrave;s aux fonctions"}},[_vm._v("\n     Présentation des autorisations et des contrôles d'accès aux fonctions\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-device-security-topic.html#configuring-device-security_fr","title":"Configuration de la s&eacute;curit&eacute; d'une imprimante"}},[_vm._v("\n     Configuration de la sécurité d'une imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_fr","title":"S&eacute;curisation des communications avec les imprimantes de votre parc"}},[_vm._v("\n     Sécurisation des communications avec les imprimantes de votre parc\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"securing-printers-topic.html#securing-printers_fr","title":"Autres m&eacute;thodes de s&eacute;curisation de vos imprimantes"}},[_vm._v("\n     Autres méthodes de sécurisation de vos imprimantes\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-assets-chapter.html#managing-assets-chapter_fr","title":"Gestion des imprimantes"}},[_vm._v("\n    Gestion des imprimantes\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e4527"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restarting-printer-topic.html#restarting-printer_fr","title":"Red&eacute;marrage de l'imprimante"}},[_vm._v("\n     Redémarrage de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-ews-topic.html#viewing-ews_fr","title":"Affichage de l'Embedded Web Server de l'imprimante"}},[_vm._v("\n     Affichage de l'Embedded Web Server de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"auditing-devices-topic.html#auditing-devices_fr","title":"Audit d'imprimantes"}},[_vm._v("\n     Audit d'imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-status-topic.html#updating-printer-status_fr","title":"Mise &agrave; jour de l'&eacute;tat de l'imprimante"}},[_vm._v("\n     Mise à jour de l'état de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-device-state-topic.html#setting-device-state_fr","title":"R&eacute;glage de l'&eacute;tat de l'imprimante"}},[_vm._v("\n     Réglage de l'état de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_fr","title":"Attribution de configurations &agrave; des imprimantes"}},[_vm._v("\n     Attribution de configurations à des imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"unassigning-configurations-topic.html#unassigning-configurations_fr","title":"Annulation de l'attribution de configurations"}},[_vm._v("\n     Annulation de l'attribution de configurations\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enforcing-configurations-topic.html#enforcing-configurations_fr","title":"Mise en &oelig;uvre de configurations"}},[_vm._v("\n     Mise en œuvre de configurations\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-device-conformance-topic.html#checking-device-conformance_fr","title":"V&eacute;rification de la conformit&eacute; d'une imprimante avec une configuration"}},[_vm._v("\n     Vérification de la conformité d'une imprimante avec une configuration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"deploying-files-to-printers-topic.html#deploying-files-to-printers_fr","title":"D&eacute;ploiement de fichiers sur des imprimantes"}},[_vm._v("\n     Déploiement de fichiers sur des imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"updating-printer-firmware-topic.html#updating-printer-firmware_fr","title":"Mise &agrave; jour du microcode de l'imprimante"}},[_vm._v("\n     Mise à jour du microcode de l'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_fr","title":"D&eacute;sinstallation d'applications pr&eacute;sentes sur les imprimantes"}},[_vm._v("\n     Désinstallation d'applications présentes sur les imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-events-to-device-topic.html#assigning-events-to-device_fr","title":"Attribution d'&eacute;v&eacute;nements &agrave; des imprimantes"}},[_vm._v("\n     Attribution d'événements à des imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"assigning-keyword-topic.html#assigning-keyword_fr","title":"Attribution de mots-cl&eacute;s aux imprimantes"}},[_vm._v("\n     Attribution de mots-clés aux imprimantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_fr","title":"Saisie des informations d'identification pour les imprimantes s&eacute;curis&eacute;es"}},[_vm._v("\n     Saisie des informations d'identification pour les imprimantes sécurisées\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_fr","title":"Configuration manuelle des certificats d'imprimante par d&eacute;faut"}},[_vm._v("\n     Configuration manuelle des certificats d'imprimante par défaut\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-printers-topic.html#removing-printers_fr","title":"Suppression d'imprimantes"}},[_vm._v("\n     Suppression d'imprimantes\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-configurations-chapter.html#managing-configurations-chapter_fr","title":"Gestion des configurations"}},[_vm._v("\n    Gestion des configurations\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5133"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-configurations-overview-topic.html#managing-configurations-overview_fr","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-topic.html#creating-configuration_fr","title":"Cr&eacute;ation d'une configuration"}},[_vm._v("\n     Création d'une configuration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-configuration-from-printer-topic.html#creating-configuration-from-printer_fr","title":"Cr&eacute;ation d'une configuration &agrave; partir d'une imprimante"}},[_vm._v("\n     Création d'une configuration à partir d'une imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_fr","title":"Exemple de sc&eacute;nario&nbsp;: clonage d'une configuration"}},[_vm._v("\n     Exemple de scénario : clonage d'une configuration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-advanced-security-component-topic.html#creating-advanced-security-component_fr","title":"Cr&eacute;ation d'un composant de s&eacute;curit&eacute; avanc&eacute;e &agrave; partir d'une imprimante"}},[_vm._v("\n     Création d'un composant de sécurité avancée à partir d'une imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"generating-printable-version-topic.html#generating-printable-version_fr","title":"G&eacute;n&eacute;ration d'une version imprimable des param&egrave;tres de configuration"}},[_vm._v("\n     Génération d'une version imprimable des paramètres de configuration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-dynamic-settings-topic.html#understanding-dynamic-settings_fr","title":"Comprendre les param&egrave;tres dynamiques"}},[_vm._v("\n     Comprendre les paramètres dynamiques\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-variable-settings-topic.html#understanding-variable-settings_fr","title":"Pr&eacute;sentation des param&egrave;tres de variable"}},[_vm._v("\n     Présentation des paramètres de variable\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-color-permissions-topic.html#configuring-color-permissions_fr","title":"Configuration des autorisations d'impression couleur"}},[_vm._v("\n     Configuration des autorisations d'impression couleur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-applications-package-topic.html#creating-applications-package_fr","title":"Cr&eacute;ation d'un package d'applications"}},[_vm._v("\n     Création d'un package d'applications\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_fr","title":"Importation ou exportation d'une configuration"}},[_vm._v("\n     Importation ou exportation d'une configuration\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"importing-files-to-resource-library-topic.html#importing-files-to-resource-library_fr","title":"Importation de fichiers vers la biblioth&egrave;que de ressources"}},[_vm._v("\n     Importation de fichiers vers la bibliothèque de ressources\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_fr","title":"Gestion des certificats"}},[_vm._v("\n    Gestion des certificats\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5644"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-MVE-manage-certificates-automatically-group.html#d0e5647","title":"Configuration de MVE pour g&eacute;rer automatiquement les certificats"}},[_vm._v("\n     Configuration de MVE pour gérer automatiquement les certificats\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-SCEP-group.html#d0e5973","title":"Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via SCEP"}},[_vm._v("\n     Gestion des certificats à l'aide de l'autorité de certification Microsoft via SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-MSCEWS-group.html#d0e6695","title":"Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via MSCEWS"}},[_vm._v("\n     Gestion des certificats à l'aide de l'autorité de certification Microsoft via MSCEWS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-OpenXPKI-CA-group.html#d0e7680","title":"Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via SCEP"}},[_vm._v("\n     Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via SCEP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-certificates-using-EST-group.html#d0e8747","title":"Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via EST"}},[_vm._v("\n     Gestion des certificats à l'aide de l'autorité de certification OpenXPKI via EST\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-device-alerts-chapter.html#managing-device-alerts-chapter_fr","title":"Gestion des alertes d'imprimante"}},[_vm._v("\n    Gestion des alertes d'imprimante\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9832"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_fr","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-action-topic.html#creating-action_fr","title":"Cr&eacute;ation d'une action"}},[_vm._v("\n     Création d'une action\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-action-placeholders-topic.html#understanding-action-placeholders_fr","title":"Compr&eacute;hension des espaces r&eacute;serv&eacute;s d'action"}},[_vm._v("\n     Compréhension des espaces réservés d'action\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-actions-topic.html#managing-actions_fr","title":"Gestion des actions"}},[_vm._v("\n     Gestion des actions\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-event-topic.html#creating-event_fr","title":"Cr&eacute;ation d'un &eacute;v&eacute;nement"}},[_vm._v("\n     Création d'un événement\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-printer-alerts-topic.html#understanding-printer-alerts_fr","title":"Pr&eacute;sentation des alertes d'imprimante"}},[_vm._v("\n     Présentation des alertes d'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-events-topic.html#managing-events_fr","title":"Gestion des &eacute;v&eacute;nements"}},[_vm._v("\n     Gestion des événements\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"viewing-tasks-chapter.html#viewing-tasks-chapter_fr","title":"Affichage de l'&eacute;tat et de l'historique d'une t&acirc;che"}},[_vm._v("\n    Affichage de l'état et de l'historique d'une tâche\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10464"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_fr","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-task-status-topic.html#viewing-task-status_fr","title":"Affichage de l'&eacute;tat de la t&acirc;che"}},[_vm._v("\n     Affichage de l'état de la tâche\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stopping-tasks-topic.html#stopping-tasks_fr","title":"Arr&ecirc;t des t&acirc;ches"}},[_vm._v("\n     Arrêt des tâches\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-logs-topic.html#viewing-logs_fr","title":"Affichage des journaux"}},[_vm._v("\n     Affichage des journaux\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-logs-topic.html#clearing-logs_fr","title":"Effacement des journaux"}},[_vm._v("\n     Effacement des journaux\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"exporting-logs-topic.html#exporting-logs_fr","title":"Exporter les journaux"}},[_vm._v("\n     Exporter les journaux\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"scheduling-tasks.html#scheduling-tasks_fr","title":"Planification de t&acirc;ches"}},[_vm._v("\n    Planification de tâches\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10572"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-schedule-topic.html#creating-schedule_fr","title":"Cr&eacute;ation d'une programmation"}},[_vm._v("\n     Création d'une programmation\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"managing-schedules-topic.html#managing-schedules_fr","title":"Gestion des t&acirc;ches planifi&eacute;es"}},[_vm._v("\n     Gestion des tâches planifiées\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"admin-tasks-chapter.html#admin-tasks-chapter_fr","title":"Autres t&acirc;ches administratives"}},[_vm._v("\n    Autres tâches administratives\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10714"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-system-settings-topic.html#configuring-system-settings_fr","title":"Configuration des param&egrave;tres g&eacute;n&eacute;raux"}},[_vm._v("\n     Configuration des paramètres généraux\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-email-settings-topic.html#configuring-email-settings_fr","title":"Configuration des param&egrave;tres de courrier &eacute;lectronique"}},[_vm._v("\n     Configuration des paramètres de courrier électronique\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adding-login-disclaimer-topic.html#adding-login-disclaimer_fr","title":"Ajout d'un avertissement de connexion"}},[_vm._v("\n     Ajout d'un avertissement de connexion\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"signing-mve-certificate-topic.html#signing-mve-certificate_fr","title":"Signature du certificat&nbsp;MVE"}},[_vm._v("\n     Signature du certificat MVE\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"removing-user-information-topic.html#removing-user-information_fr","title":"Suppression des r&eacute;f&eacute;rences et des informations utilisateur"}},[_vm._v("\n     Suppression des références et des informations utilisateur\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"managing-SSO-chapter.html#managing-SSO-chapter_fr","title":"Gestion de la fonction SSO"}},[_vm._v("\n    Gestion de la fonction SSO\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10972"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"mve-configuration-workflow-adfs-overview-topic.html#d0e10977","title":"Aper&ccedil;u"}},[_vm._v("\n     Aperçu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_fr","title":"D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour GroupRule"}},[_vm._v("\n     Définition de la stratégie d'émission de revendications pour GroupRule\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_fr","title":"D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour l'ID de nom"}},[_vm._v("\n     Définition de la stratégie d'émission de revendications pour l'ID de nom\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_fr","title":"Activation de l'authentification de serveur&nbsp;ADFS"}},[_vm._v("\n     Activation de l'authentification de serveur ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"accessing-mve-adfs-topic.html#accessing-mve-adfs_fr","title":"Acc&egrave;s &agrave; MVE par le biais de l'ADFS"}},[_vm._v("\n     Accès à MVE par le biais de l'ADFS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"logging-out-mve-adfs-topic.html#logging-out-mve-adfs_fr","title":"D&eacute;connexion de MVE"}},[_vm._v("\n     Déconnexion de MVE\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faq-chapter.html#faq-chapter_fr","title":"Questions fr&eacute;quemment pos&eacute;es"}},[_vm._v("\n    Questions fréquemment posées\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11142"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"faq-chapter.html#frequently-asked-questions_fr","title":"FAQ Markvision Enterprise"}},[_vm._v("\n     FAQ Markvision Enterprise\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_fr","title":"D&eacute;pannage"}},[_vm._v("\n    Dépannage\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11336"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_fr","title":"L'utilisateur a oubli&eacute; son mot de passe"}},[_vm._v("\n     L'utilisateur a oublié son mot de passe\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_fr","title":"L'utilisateur administrateur a oubli&eacute; son mot de passe"}},[_vm._v("\n     L'utilisateur administrateur a oublié son mot de passe\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_fr","title":"La page ne charge pas"}},[_vm._v("\n     La page ne charge pas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_fr","title":"Impossible de d&eacute;tecter une imprimante r&eacute;seau"}},[_vm._v("\n     Impossible de détecter une imprimante réseau\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-incorrect-device-information-topic.html#trb-incorrect-device-information_fr","title":"Informations d'imprimante incorrectes"}},[_vm._v("\n     Informations d'imprimante incorrectes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_fr","title":"MVE ne reconna&icirc;t pas une imprimante comme imprimante s&eacute;curis&eacute;e"}},[_vm._v("\n     MVE ne reconnaît pas une imprimante comme imprimante sécurisée\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_fr","title":"L'application de configurations avec plusieurs applications &eacute;choue &agrave; la premi&egrave;re tentative, mais r&eacute;ussit lors des tentatives suivantes"}},[_vm._v("\n     L'application de configurations avec plusieurs applications échoue à la première tentative, mais réussit lors des tentatives suivantes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_fr","title":"Echec de l'application des configurations avec un certificat d'imprimante"}},[_vm._v("\n     Echec de l'application des configurations avec un certificat d'imprimante\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-openxpki-ca-group.html#d0e11553","title":"Autorit&eacute; de certification OpenXPKI"}},[_vm._v("\n     Autorité de certification OpenXPKI\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"database-access-chapter.html#database-access-chapter_fr","title":"Acc&egrave;s aux bases de donn&eacute;es"}},[_vm._v("\n    Accès aux bases de données\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e11723"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_fr","title":"Diff&eacute;rences entre les types de donn&eacute;es des bases de donn&eacute;es prises en charge"}},[_vm._v("\n     Différences entre les types de données des bases de données prises en charge\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"config-item-topic.html#d0e11784","title":"Tables FRAMEWORK et noms du champ"}},[_vm._v("\n     Tables FRAMEWORK et noms du champ\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"appendix-chapter.html#appendix-chapter_fr","title":"Annexe"}},[_vm._v("\n    Annexe\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e17724"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_fr","title":"Pr&eacute;sentation des ports et protocoles"}},[_vm._v("\n     Présentation des ports et protocoles\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_fr","title":"Activation de l'approbation automatique des demandes de certificat dans l'autorit&eacute; de certification Microsoft"}},[_vm._v("\n     Activation de l'approbation automatique des demandes de certificat dans l'autorité de certification Microsoft\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"revoking-certificates-topic.html#revoking-certificates_fr","title":"R&eacute;vocation des certificats"}},[_vm._v("\n     Révocation des certificats\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"leap_notices.html#leap_notices_fr","title":"Avis"}},[_vm._v("\n    Avis\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18100"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18103","title":"Note d'&eacute;dition"}},[_vm._v("\n     Note d'édition\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#d0e18139","title":"Marques commerciales"}},[_vm._v("\n     Marques commerciales\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#us-government-rights_fr","title":"GOVERNMENT END USERS"}},[_vm._v("\n     GOVERNMENT END USERS\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#jmdns-license_fr","title":"JmDNS License"}},[_vm._v("\n     JmDNS License\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"leap_notices.html#licensing-notices-program-folder_fr","title":"Avis relatifs &agrave; l'accord de licence"}},[_vm._v("\n     Avis relatifs à l'accord de licence\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"glossary.html#glossary_fr","title":"Glossaire"}},[_vm._v("\n    Glossaire\n   ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js